import { defineComponent, useSlots, renderSlot, mergeProps, unref, createElementVNode, toRefs, normalizeProps, guardReactiveProps, ref, openBlock, createElementBlock, createVNode, withCtx, createCommentVNode, effectScope, getCurrentScope, onScopeDispose, onMounted, onBeforeUnmount, isRef, shallowRef, watch, reactive, watchEffect, createBlock, computed, toDisplayString, normalizeClass, createTextVNode, Fragment, renderList, onBeforeMount, useAttrs, withModifiers, h as h$2, onUnmounted } from "vue";
import { I18n, Hub, Auth, Amplify, Logger } from "aws-amplify";
import { appendToCognitoUserAgent } from "@aws-amplify/auth";
const _sfc_main$y = /* @__PURE__ */ defineComponent({
  __name: "base-field-set",
  setup(__props) {
    let mySlots = useSlots();
    return (_ctx, _cache) => {
      return renderSlot(_ctx.$slots, "fieldSetI", mergeProps(_ctx.$attrs, {
        slotData: unref(mySlots).default && unref(mySlots).default()
      }), () => [
        createElementVNode("fieldset", mergeProps(_ctx.$attrs, { "data-amplify-fieldset": "" }), [
          renderSlot(_ctx.$slots, "default")
        ], 16)
      ]);
    };
  }
});
const _hoisted_1$b = ["type", "data-fullwidth", "data-size", "data-fontWeight", "data-variation", "data-loading", "data-disabled", "disabled"];
const _sfc_main$x = /* @__PURE__ */ defineComponent({
  __name: "amplify-button",
  props: {
    type: null,
    fullWidth: { type: [Boolean, String] },
    size: null,
    variation: null,
    fontWeight: null,
    loading: { type: [Boolean, String] },
    disabled: { type: [Boolean, String] }
  },
  setup(__props) {
    const props = __props;
    const { type, fullWidth, size, variation, fontWeight } = toRefs(props);
    return (_ctx, _cache) => {
      return renderSlot(_ctx.$slots, "buttont", normalizeProps(guardReactiveProps(_ctx.$attrs)), () => [
        createElementVNode("button", mergeProps({
          class: ["amplify-button", {
            [`amplify-button--${unref(variation)}`]: unref(variation),
            [`amplify-button--${unref(size)}`]: unref(size),
            "amplify-button--fullwidth": unref(fullWidth),
            "amplify-button--loading": __props.loading,
            "amplify-button--disabled": __props.disabled
          }],
          type: unref(type),
          style: { fontWeight: unref(fontWeight) },
          "data-fullwidth": unref(fullWidth),
          "data-size": unref(size),
          "data-fontWeight": unref(fontWeight),
          "data-variation": unref(variation),
          "data-loading": __props.loading,
          "data-disabled": __props.disabled,
          disabled: __props.disabled
        }, _ctx.$attrs, { "data-amplify-button": "" }), [
          renderSlot(_ctx.$slots, "default")
        ], 16, _hoisted_1$b)
      ]);
    };
  }
});
const t$1 = (t2) => {
  var o2;
  return null === (o2 = t2.context.actorRef) || void 0 === o2 ? void 0 : o2.getSnapshot();
}, o$a = (o2) => {
  var n2;
  return null === (n2 = t$1(o2)) || void 0 === n2 ? void 0 : n2.context;
};
var o$9, e$g;
!function(o2) {
  o2.Apple = "SignInWithApple", o2.Amazon = "LoginWithAmazon", o2.Facebook = "Facebook", o2.Google = "Google";
}(o$9 || (o$9 = {})), function(o2) {
  o2.Email = "email", o2.PhoneNumber = "phone_number";
}(e$g || (e$g = {}));
const e$f = ["birthdate", "email", "family_name", "given_name", "middle_name", "name", "nickname", "phone_number", "preferred_username", "profile", "website"], a$4 = ["username", "email", "phone_number"], r$5 = [...a$4, ...e$f, "confirmation_code", "password", "confirm_password"], i$5 = (e2) => r$5.includes(e2);
var e$e;
!function(e2) {
  e2.Alert = "amplify-alert", e2.AlertIcon = "amplify-alert__icon", e2.AlertHeading = "amplify-alert__heading", e2.AlertBody = "amplify-alert__body", e2.AlertDismiss = "amplify-alert__dismiss", e2.Autocomplete = "amplify-autocomplete", e2.AutocompleteMenu = "amplify-autocomplete__menu", e2.AutocompleteMenuEmpty = "amplify-autocomplete__menu--empty", e2.AutocompleteMenuFooter = "amplify-autocomplete__menu__footer", e2.AutocompleteMenuHeader = "amplify-autocomplete__menu__header", e2.AutocompleteMenuLoading = "amplify-autocomplete__menu--loading", e2.AutocompleteMenuOption = "amplify-autocomplete__menu__option", e2.AutocompleteMenuOptions = "amplify-autocomplete__menu__options", e2.Badge = "amplify-badge", e2.Button = "amplify-button", e2.ButtonGroup = "amplify-buttongroup", e2.ButtonLoaderWrapper = "amplify-button__loader-wrapper", e2.Card = "amplify-card", e2.Checkbox = "amplify-checkbox", e2.CheckboxButton = "amplify-checkbox__button", e2.CheckboxIcon = "amplify-checkbox__icon", e2.CheckboxInput = "amplify-checkbox__input", e2.CheckboxLabel = "amplify-checkbox__label", e2.CheckboxField = "amplify-checkboxfield", e2.Collection = "amplify-collection", e2.CollectionItems = "amplify-collection-items", e2.CollectionSearch = "amplify-collection-search", e2.CollectionPagination = "amplify-collection-pagination", e2.CountryCodeSelect = "amplify-countrycodeselect", e2.DialCodeSelect = "amplify-dialcodeselect", e2.Divider = "amplify-divider", e2.DividerLabel = "amplify-divider--label", e2.Expander = "amplify-expander", e2.ExpanderContent = "amplify-expander__content", e2.ExpanderContentText = "amplify-expander__content__text", e2.ExpanderHeader = "amplify-expander__header", e2.ExpanderIcon = "amplify-expander__icon", e2.ExpanderItem = "amplify-expander__item", e2.ExpanderTrigger = "amplify-expander__trigger", e2.Field = "amplify-field", e2.FieldDescription = "amplify-field__description", e2.FieldErrorMessage = "amplify-field__error-message", e2.FieldGroup = "amplify-field-group", e2.FieldGroupControl = "amplify-field-group__control", e2.FieldGroupOuterEnd = "amplify-field-group__outer-end", e2.FieldGroupOuterStart = "amplify-field-group__outer-start", e2.FieldGroupInnerEnd = "amplify-field-group__inner-end", e2.FieldGroupInnerStart = "amplify-field-group__inner-start", e2.FieldGroupIcon = "amplify-field-group__icon", e2.FieldGroupIconButton = "amplify-field-group__icon-button", e2.FieldGroupHasInnerEnd = "amplify-field-group--has-inner-end", e2.FieldGroupHasInnerStart = "amplify-field-group--has-inner-start", e2.FieldShowPassword = "amplify-field__show-password", e2.FieldGroupFieldWrapper = "amplify-field-group__field-wrapper", e2.FileUploaderDropZone = "amplify-fileuploader__dropzone", e2.FileUploaderDropZoneIcon = "amplify-fileuploader__dropzone__icon", e2.FileUploaderDropZoneText = "amplify-fileuploader__dropzone__text", e2.FileUploaderDropZoneButton = "amplify-fileuploader__dropzone__button", e2.FileUploaderFile = "amplify-fileuploader__file", e2.FileUploaderFileWrapper = "amplify-fileuploader__file__wrapper", e2.FileUploaderFileName = "amplify-fileuploader__file__name", e2.FileUploaderFileSize = "amplify-fileuploader__file__size", e2.FileUploaderFileInfo = "amplify-fileuploader__file__info", e2.FileUploaderFileImage = "amplify-fileuploader__file__image", e2.FileUploaderFileMain = "amplify-fileuploader__file__main", e2.FileUploaderFileStatus = "amplify-fileuploader__file__status", e2.FileUploaderLoader = "amplify-fileuploader__loader", e2.FileUploaderPreviewer = "amplify-fileuploader__previewer", e2.FileUploaderPreviewerText = "amplify-fileuploader__previewer__text", e2.FileUploaderPreviewerBody = "amplify-fileuploader__previewer__body", e2.FileUploaderPreviewerFooter = "amplify-fileuploader__previewer__footer", e2.FileUploaderPreviewerFooterActions = "amplify-fileuploader__previewer__footer__actions", e2.Flex = "amplify-flex", e2.Grid = "amplify-grid", e2.Heading = "amplify-heading", e2.HighlightMatch = "amplify-highlightmatch", e2.HighlightMatchHighlighted = "amplify-highlightmatch__highlighted", e2.Icon = "amplify-icon", e2.Image = "amplify-image", e2.Input = "amplify-input", e2.Label = "amplify-label", e2.Link = "amplify-link", e2.Loader = "amplify-loader", e2.LoaderDeterminate = "amplify-loader--determinate", e2.LoaderPercentageText = "amplify-loader__percentage-text", e2.MenuContent = "amplify-menu-content", e2.MenuContentWrapper = "amplify-menu-content-wrapper", e2.MenuItem = "amplify-menu-content__item", e2.MenuTrigger = "amplify-menu-trigger", e2.Pagination = "amplify-pagination", e2.PaginationItemButton = "amplify-pagination__item-button", e2.PaginationItemCurrent = "amplify-pagination__item-current", e2.PaginationItemEllipsis = "amplify-pagination__item-ellipsis", e2.PasswordField = "amplify-passwordfield", e2.PhoneNumberField = "amplify-phonenumberfield", e2.Placeholder = "amplify-placeholder", e2.Radio = "amplify-radio", e2.RadioButton = "amplify-radio__button", e2.RadioInput = "amplify-radio__input", e2.RadioLabel = "amplify-radio__label", e2.RadioGroupField = "amplify-radiogroupfield", e2.RadioGroup = "amplify-radiogroup", e2.Rating = "amplify-rating", e2.ScrollView = "amplify-scrollview", e2.SearchField = "amplify-searchfield", e2.SearchFieldClear = "amplify-searchfield__clear", e2.SearchFieldSearch = "amplify-searchfield__search", e2.Select = "amplify-select", e2.SelectField = "amplify-selectfield", e2.SelectWrapper = "amplify-select__wrapper", e2.SelectIconWrapper = "amplify-select__icon-wrapper", e2.SliderField = "amplify-sliderfield", e2.SliderFieldGroup = "amplify-sliderfield__group", e2.SliderFieldLabel = "amplify-sliderfield__label", e2.SliderFieldRange = "amplify-sliderfield__range", e2.SliderFieldRoot = "amplify-sliderfield__root", e2.SliderFieldThumb = "amplify-sliderfield__thumb", e2.SliderFieldTrack = "amplify-sliderfield__track", e2.StepperField = "amplify-stepperfield", e2.StepperFieldButtonDecrease = "amplify-stepperfield__button--decrease", e2.StepperFieldButtonIncrease = "amplify-stepperfield__button--increase", e2.StepperFieldInput = "amplify-stepperfield__input", e2.SwitchField = "amplify-switchfield", e2.SwitchLabel = "amplify-switch-label", e2.SwitchThumb = "amplify-switch-thumb", e2.SwitchTrack = "amplify-switch-track", e2.SwitchWrapper = "amplify-switch__wrapper", e2.Table = "amplify-table", e2.TableCaption = "amplify-table__caption", e2.TableBody = "amplify-table__body", e2.TableTd = "amplify-table__td", e2.TableTh = "amplify-table__th", e2.TableFoot = "amplify-table__foot", e2.TableHead = "amplify-table__head", e2.TableRow = "amplify-table__row", e2.Tabs = "amplify-tabs", e2.TabItems = "amplify-tabs-item", e2.Text = "amplify-text", e2.Textarea = "amplify-textarea", e2.TextAreaField = "amplify-textareafield", e2.TextField = "amplify-textfield", e2.ToggleButton = "amplify-togglebutton", e2.ToggleButtonGroup = "amplify-togglebuttongroup", e2.VisuallyHidden = "amplify-visually-hidden";
}(e$e || (e$e = {}));
const i$4 = (t2) => {
  var i2;
  const s2 = null === (i2 = null == t2 ? void 0 : t2.context.config) || void 0 === i2 ? void 0 : i2.loginMechanisms, [n2] = null != s2 ? s2 : ["username"];
  return n2;
};
const r$4 = (e2) => {
  const t2 = (t3) => (r2) => e2({ type: t3, data: r2 });
  return { initializeMachine: t2("INIT"), resendCode: t2("RESEND"), signOut: t2("SIGN_OUT"), submitForm: t2("SUBMIT"), updateForm: t2("CHANGE"), updateBlur: t2("BLUR"), toFederatedSignIn: t2("FEDERATED_SIGN_IN"), toResetPassword: t2("RESET_PASSWORD"), toSignIn: t2("SIGN_IN"), toSignUp: t2("SIGN_UP"), skipVerification: t2("SKIP") };
}, n$5 = (r2) => {
  var n2, s2, i2, a2, o2;
  const c2 = null !== (n2 = o$a(r2)) && void 0 !== n2 ? n2 : {}, { codeDeliveryDetails: u2, remoteError: d2, unverifiedContactMethods: l2, validationError: m2, totpSecretCode: h2 = null } = c2, { socialProviders: v2 } = null !== (i2 = null === (s2 = r2.context) || void 0 === s2 ? void 0 : s2.config) && void 0 !== i2 ? i2 : {}, g2 = null !== (a2 = null == c2 ? void 0 : c2.user) && void 0 !== a2 ? a2 : null === (o2 = r2.context) || void 0 === o2 ? void 0 : o2.user, f2 = m2 && Object.keys(m2).length > 0, p2 = t$1(r2), S = r2.hasTag("pending") || (null == p2 ? void 0 : p2.hasTag("pending")), I = (() => {
    switch (true) {
      case r2.matches("idle"):
        return "idle";
      case r2.matches("setup"):
        return "setup";
      case r2.matches("signOut"):
        return "signOut";
      case r2.matches("authenticated"):
        return "authenticated";
      case (null == p2 ? void 0 : p2.matches("confirmSignUp")):
        return "confirmSignUp";
      case (null == p2 ? void 0 : p2.matches("confirmSignIn")):
        return "confirmSignIn";
      case (null == p2 ? void 0 : p2.matches("setupTOTP.edit")):
      case (null == p2 ? void 0 : p2.matches("setupTOTP.submit")):
        return "setupTOTP";
      case (null == p2 ? void 0 : p2.matches("signIn")):
        return "signIn";
      case (null == p2 ? void 0 : p2.matches("signUp")):
        return "signUp";
      case (null == p2 ? void 0 : p2.matches("forceNewPassword")):
        return "forceNewPassword";
      case (null == p2 ? void 0 : p2.matches("resetPassword")):
        return "resetPassword";
      case (null == p2 ? void 0 : p2.matches("confirmResetPassword")):
        return "confirmResetPassword";
      case (null == p2 ? void 0 : p2.matches("verifyUser")):
        return "verifyUser";
      case (null == p2 ? void 0 : p2.matches("confirmVerifyUser")):
        return "confirmVerifyUser";
      case (null == p2 ? void 0 : p2.matches("setupTOTP.getTotpSecretCode")):
      case r2.matches("signIn.runActor"):
        return "transition";
      default:
        return console.debug("Cannot infer `route` from Authenticator state:", r2.value), null;
    }
  })(), P2 = ((e2) => {
    switch (e2) {
      case "idle":
      case "setup":
        return "configuring";
      case "authenticated":
        return "authenticated";
      default:
        return "unauthenticated";
    }
  })(I);
  return { authStatus: P2, codeDeliveryDetails: u2, error: d2, hasValidationErrors: f2, isPending: S, route: I, socialProviders: v2, totpSecretCode: h2, unverifiedContactMethods: l2, user: g2, validationErrors: m2 };
}, s$4 = ({ send: e2, state: t2 }) => {
  const s2 = r$4(e2), i2 = n$5(t2);
  return Object.assign(Object.assign({}, s2), i2);
};
const o$8 = ["+1", "+7", "+20", "+27", "+30", "+31", "+32", "+33", "+34", "+36", "+39", "+40", "+41", "+43", "+44", "+45", "+46", "+47", "+48", "+49", "+51", "+52", "+53", "+54", "+55", "+56", "+57", "+58", "+60", "+61", "+62", "+63", "+64", "+65", "+66", "+81", "+82", "+84", "+86", "+90", "+91", "+92", "+93", "+94", "+95", "+98", "+212", "+213", "+216", "+218", "+220", "+221", "+222", "+223", "+224", "+225", "+226", "+227", "+228", "+229", "+230", "+231", "+232", "+233", "+234", "+235", "+236", "+237", "+238", "+239", "+240", "+241", "+242", "+243", "+244", "+245", "+246", "+248", "+249", "+250", "+251", "+252", "+253", "+254", "+255", "+256", "+257", "+258", "+260", "+261", "+262", "+263", "+264", "+265", "+266", "+267", "+268", "+269", "+290", "+291", "+297", "+298", "+299", "+345", "+350", "+351", "+352", "+353", "+354", "+355", "+356", "+357", "+358", "+359", "+370", "+371", "+372", "+373", "+374", "+375", "+376", "+377", "+378", "+379", "+380", "+381", "+382", "+385", "+386", "+387", "+389", "+420", "+421", "+423", "+500", "+501", "+502", "+503", "+504", "+505", "+506", "+507", "+508", "+509", "+537", "+590", "+591", "+593", "+594", "+595", "+596", "+597", "+598", "+599", "+670", "+672", "+673", "+674", "+675", "+676", "+677", "+678", "+679", "+680", "+681", "+682", "+683", "+685", "+686", "+687", "+688", "+689", "+690", "+691", "+692", "+850", "+852", "+853", "+855", "+856", "+872", "+880", "+886", "+960", "+961", "+962", "+963", "+964", "+965", "+966", "+967", "+968", "+970", "+971", "+972", "+973", "+974", "+975", "+976", "+977", "+992", "+993", "+994", "+995", "+996", "+998"];
const e$d = { "Account recovery requires verified contact information": "Zur\xFCcksetzen des Account ben\xF6tigt einen verifizierten Account", "Back to Sign In": "Zur\xFCck zur Anmeldung", "Change Password": "Passwort \xE4ndern", Changing: "\xC4ndern von", Code: "Code", "Confirm Password": "Passwort best\xE4tigen", "Confirm Sign Up": "Registrierung best\xE4tigen", "Confirm SMS Code": "SMS-Code best\xE4tigen", "Confirm TOTP Code": "TOTP-Code best\xE4tigen", Confirm: "Best\xE4tigen", "Confirmation Code": "Best\xE4tigungs-Code", Confirming: "Wird best\xE4tigt", "Create a new account": "Einen neuen Account erstellen", "Create Account": "Account erstellen", "Creating Account": "Account wird erstellt", "Dismiss alert": "Warnung verwerfen", Email: "Email", "Enter your code": "Geben Sie Ihren Code ein", "Enter your email": "Geben Sie Ihre Email ein", "Enter your phone number": "Geben Sie Ihre Telefonnummer ein", "Enter your username": "Geben Sie Ihren Benutzernamen ein", "Forgot your password?": "Passwort vergessen? ", "Hide password": "Passwort verbergen", "It may take a minute to arrive": "Es kann eine Minute dauern, bis er ankommt", Loading: "Wird geladen", "New password": "Neues Passwort", or: "oder", Password: "Passwort", "Phone Number": "Telefonnummer", "Resend Code": "Code erneut senden", "Reset your Password": "Zur\xFCcksetzen des Passwort", "Reset your password": "Zur\xFCcksetzen des passwort", "Send code": "Code senden", "Send Code": "Code senden", Sending: "Wird gesendet", "Setup TOTP": "TOTP einrichten", "Show password": "Passwort anzeigen", "Sign in to your account": "Melden Sie sich mit Ihrem Account an", "Sign In with Amazon": "Mit Amazon anmelden", "Sign In with Apple": "Mit Apple anmelden", "Sign In with Facebook": "Mit Facebook anmelden", "Sign In with Google": "Mit Google anmelden", "Sign in": "Anmelden", "Sign In": "Anmelden", "Signing in": "Wird angemeldet", Skip: "\xDCberspringen", Submit: "Abschicken", Submitting: "Wird gesendet", Username: "Benutzername", "Verify Contact": "Kontakt verifizieren", Verify: "Verifizieren", "We Sent A Code": "Wir haben einen Code gesendet", "We Texted You": "Wir haben Ihnen eine SMS-Textur", "Your code is on the way. To log in, enter the code we sent you": "Ihr Code ist unterwegs. Um sich anzumelden, geben Sie den Code ein, den wir Ihnen gesendet haben", "An account with the given email already exists.": "Ein Account mit dieser Email existiert bereits.", "Confirm a Code": "Code best\xE4tigen", "Confirm Sign In": "Anmeldung best\xE4tigen", "Create account": "Hier registrieren", "Enter your password": "Geben Sie Ihr Passwort ein", "Enter your Password": "Geben Sie Ihre Passwort ein", "Enter your Email": "Geben Sie Ihre E-Mail", "Sign Up with Facebook": "Mit Facebook registrieren", "Sign Up with Google": "Mit Google registrieren", "Forgot Password": "Passwort vergessen", "Have an account? ": "Schon registriert? ", "Incorrect username or password": "Falscher Benutzername oder falsches Passwort", "Invalid password format": "Ung\xFCltiges Passwort-Format", "Invalid phone number format": "Ung\xFCltiges Telefonummern-Format. Benutze eine Nummer im Format: +12345678900", "It may take a minute to arrive.": "Es k\xF6nnte eine Minute dauern, bis der Code eintrifft.", "Lost your code? ": "Code verloren? ", "New Password": "Neues Passwort", "No account? ": "Kein Account? ", "Password attempts exceeded": "Die maximale Anzahl der fehlerhaften Anmeldeversuche wurde erreicht", "Reset password": "Passwort zur\xFCcksetzen", "Sign Out": "Abmelden", "Sign Up": "Registrieren", "User already exists": "Dieser Benutzer existiert bereits", "User does not exist": "Dieser Benutzer existiert nicht", "Username cannot be empty": "Benutzername darf nicht leer sein", "We Emailed You": "Email wurde versendet", "Your code is on the way. To log in, enter the code we emailed to": "Ihr Best\xE4tigungscode ist unterwegs. Um sich einzuloggen geben Sie den Code ein, den wir verschickt haben an", "Your code is on the way. To log in, enter the code we texted to": "Ihr Best\xE4tigungscode ist unterwegs. Um sich einzuloggen geben Sie den Code ein, den wir verschickt haben an" };
const e$c = { "Account recovery requires verified contact information": "Account recovery requires verified contact information", "Add your Profile": "Add your Profile", "Add your Website": "Add your Website", "Back to Sign In": "Back to Sign In", "Change Password": "Change Password", Changing: "Changing", Code: "Code", "Confirm Password": "Confirm Password", "Confirm Sign Up": "Confirm Sign Up", "Confirm SMS Code": "Confirm SMS Code", "Confirm TOTP Code": "Confirm TOTP Code", Confirm: "Confirm", "Confirmation Code": "Confirmation Code", Confirming: "Confirming", "Create a new account": "Create a new account", "Create Account": "Create Account", "Creating Account": "Creating Account", "Dismiss alert": "Dismiss alert", Email: "Email", "Enter your Birthdate": "Enter your Birthdate", "Enter your code": "Enter your code", "Enter your Confirmation Code": "Enter your Confirmation Code", "Enter your email": "Enter your email", "Enter your Family Name": "Enter your Family Name", "Enter your Given Name": "Enter your Given Name", "Enter your Middle Name": "Enter your Middle Name", "Enter your Name": "Enter your Name", "Enter your Nickname": "Enter your Nickname", "Enter your Password": "Enter your Password", "Enter your phone number": "Enter your phone number", "Enter your Preferred Username": "Enter your Preferred Username", "Enter your username": "Enter your username", "Forgot password?": "Forgot password?", "Forgot your password?": "Forgot your password?", "Hide password": "Hide password", "It may take a minute to arrive": "It may take a minute to arrive", Loading: "Loading", "New password": "New password", or: "or", Password: "Password", "Phone Number": "Phone Number", "Please confirm your Password": "Please confirm your Password", "Resend Code": "Resend Code", "Reset your password": "Reset your password", "Reset your Password": "Reset your Password", "Send code": "Send code", "Send Code": "Send Code", Sending: "Sending", "Setup TOTP": "Setup TOTP", "Show password": "Show password", "Sign in to your account": "Sign in to your account", "Sign In with Amazon": "Sign In with Amazon", "Sign In with Apple": "Sign In with Apple", "Sign In with Facebook": "Sign In with Facebook", "Sign In with Google": "Sign In with Google", "Sign in": "Sign in", "Sign In": "Sign In", "Signing in": "Signing in", Skip: "Skip", Submit: "Submit", Submitting: "Submitting", Username: "Username", "Verify Contact": "Verify Contact", Verify: "Verify", "We Emailed You": "We Emailed You", "We Sent A Code": "We Sent A Code", "We Texted You": "We Texted You", "Your code is on the way. To log in, enter the code we emailed to": "Your code is on the way. To log in, enter the code we emailed to", "Your code is on the way. To log in, enter the code we sent you": "Your code is on the way. To log in, enter the code we sent you", "Your code is on the way. To log in, enter the code we texted to": "Your code is on the way. To log in, enter the code we texted to" };
const e$b = { "Account recovery requires verified contact information": "La recuperaci\xF3n de la cuenta requiere informaci\xF3n de contacto verificada", "Back to Sign In": "Volver a inicio de sesi\xF3n", "Change Password": "Cambiar contrase\xF1a", Changing: "Cambiando", Code: "C\xF3digo", "Confirm Password": "Confirmar contrase\xF1a", "Confirm Sign Up": "Confirmar registro", "Confirm SMS Code": "Confirmar el c\xF3digo de SMS", "Confirm TOTP Code": "Confirmar c\xF3digo TOTP", Confirm: "Confirmar", "Confirmation Code": "C\xF3digo de confirmaci\xF3n", Confirming: "Confirmando", "Create a new account": "Crear una cuenta nueva", "Create Account": "Crear cuenta", "Creating Account": "Creando cuenta", "Dismiss alert": "Descartar alerta", Email: "Email", "Enter your code": "Ingrese el c\xF3digo", "Enter your email": "Escriba su Email", "Enter your phone number": "Ingrese el n\xFAmero de tel\xE9fono", "Enter your username": "Ingrese el nombre de usuario", "Forgot your password?": "\xBFOlvid\xF3 su contrase\xF1a?", "Hide password": "Ocultar contrase\xF1a", "It may take a minute to arrive": "Es posible que tarde un minuto en llegar", Loading: "Cargando", "New password": "Nueva contrase\xF1a", or: "o", Password: "Contrase\xF1a", "Phone Number": "N\xFAmero de tel\xE9fono", "Resend Code": "Reenviar c\xF3digo", "Reset your password": "Restablecer su contrase\xF1a", "Reset your Password": "Restablecer su Contrase\xF1a", "Send code": "Enviar c\xF3digo", "Send Code": "Enviar c\xF3digo", Sending: "Enviando", "Setup TOTP": "Configurar TOTP", "Show password": "Mostrar contrase\xF1a", "Sign in to your account": "Iniciar sesi\xF3n en tu cuenta", "Sign In with Amazon": "Iniciar Sesi\xF3n con Amazon", "Sign In with Apple": "Iniciar Sesi\xF3n con Apple", "Sign In with Facebook": "Iniciar Sesi\xF3n con Facebook", "Sign In with Google": "Iniciar Sesi\xF3n con Google", "Sign in": "Iniciar sesi\xF3n", "Sign In": "Iniciar Sesi\xF3n", "Signing in": "Iniciando sesi\xF3n", Skip: "Omitir", Submit: "Enviar", Submitting: "Enviando", Username: "Nombre de usuario", "Verify Contact": "Verificar contacto", Verify: "Verificar", "We Emailed You": "Le hemos enviado un correo electr\xF3nico", "We Sent A Code": "Hemos enviado un c\xF3digo", "We Texted You": "Le hemos enviado un mensaje de texto", "Your code is on the way. To log in, enter the code we emailed to": "El c\xF3digo est\xE1 en camino. Para iniciar sesi\xF3n, escriba el c\xF3digo que hemos enviado por correo electr\xF3nico a", "Your code is on the way. To log in, enter the code we sent you": "El c\xF3digo est\xE1 en camino. Para iniciar sesi\xF3n, escriba el c\xF3digo que le hemos enviado", "Your code is on the way. To log in, enter the code we texted to": "El c\xF3digo est\xE1 en camino. Para iniciar sesi\xF3n, escriba el c\xF3digo que hemos enviado por mensaje de texto a", "An account with the given email already exists.": "Ya existe una cuenta con el correo ingresado.", "Confirm a Code": "Confirmar un c\xF3digo", "Confirm Sign In": "Confirmar inicio de sesi\xF3n", "Forgot Password": "Olvid\xE9 mi contrase\xF1a", "Incorrect username or password.": "Nombre de usuario o contrase\xF1a incorrecta", "Invalid password format": "Formato de contrase\xF1a inv\xE1lido", "Invalid phone number format": "Formato de n\xFAmero de tel\xE9fono inv\xE1lido", "Loading...": "Cargando...", "New Password": "Nueva contrase\xF1a", "Resend a Code": "Reenviar un c\xF3digo", "Sign Out": "Cerrar sesi\xF3n", "Sign Up with Amazon": "Crear cuenta con Amazon", "Sign Up with Apple": "Crear cuenta con Apple", "Sign Up with Facebook": "Crear cuenta con Facebook", "Sign Up with Google": "Crear cuenta con Google", "Sign Up": "Crear cuenta", "User already exists": "El usuario ya existe", "User does not exist": "El usuario no existe", "Username cannot be empty": "El nombre de usuario no puede estar vac\xEDo", "Your passwords must match": "Las contrase\xF1as deben coincidir" };
const e$a = { "Account recovery requires verified contact information": "La r\xE9cup\xE9ration du compte n\xE9cessite des informations de contact v\xE9rifi\xE9es", "Back to Sign In": "Retour \xE0 la connexion", "Change Password": "Modifier le mot de passe", Changing: "Modification en cours", Code: "Code", "Confirm Password": "Confirmez le mot de passe", "Confirm Sign Up": "Confirmer l'inscription", "Confirm SMS Code": "Confirmer le code SMS", "Confirm TOTP Code": "Confirmer le code TOTP", Confirm: "Confirmer", "Confirmation Code": "Code de confirmation", Confirming: "Confirmation", "Create a new account": "Cr\xE9er un nouveau compte", "Create Account": "Cr\xE9er un compte", "Creating Account": "Cr\xE9ation d'un compte", "Dismiss alert": "Supprimer l'alerte", Email: "Email", "Enter your code": "Saisissez cotre code de confirmation", "Enter your email": "Saisissez votre adresse email", "Enter your phone number": "Saisissez votre num\xE9ro de t\xE9l\xE9phone", "Enter your username": "Saisissez votre nom d'utilisateur", "Forgot your password?": "Mot de passe oubli\xE9 ? ", "Hide password": "Masquer le mot de passe", "It may take a minute to arrive": "Cela peut prendre une minute", Loading: "Chargement en cours", "New password": "Nouveau mot de passe", or: "ou", Password: "Mot de passe", "Phone Number": "Num\xE9ro de t\xE9l\xE9phone", "Resend Code": "Renvoyer le code", "Reset your Password": "R\xE9initialiser votre mot de passe", "Reset your password": "R\xE9initialisez votre mot de passe", "Send code": "Envoyer le code", "Send Code": "M'envoyer un code", Sending: "Envoi en cours", "Setup TOTP": "Configuration de TOTP", "Show password": "Afficher le mot de passe", "Sign in to your account": "Connexion \xE0 votre compte", "Sign In with Amazon": "Se connecter avec Amazon", "Sign In with Apple": "Se connecter avec Apple", "Sign In with Facebook": "Se connecter avec Facebook", "Sign In with Google": "Se connecter avec Google", "Sign in": "Se connecter", "Sign In": "Se connecter", "Signing in": "Connexion en cours", Skip: "Passer", Submit: "Soumettre", Submitting: "Envoi en cours", Username: "Nom d'utilisateur", "Verify Contact": "V\xE9rifier le contact", Verify: "V\xE9rifier", "We Sent A Code": "Nous avons envoy\xE9 un code", "We Texted You": "Nous vous avons envoy\xE9 un SMS", "Your code is on the way. To log in, enter the code we sent you": "Votre code est en cours d'envoi. Pour vous connecter, saisissez le code que nous vous avons envoy\xE9", "An account with the given email already exists.": "Un utilisateur avec cette adresse email existe d\xE9j\xE0.", Change: "Modifier", "Confirm a Code": "Confirmer un code", "Confirm Sign In": "Confirmer la connexion", "Create account": "Cr\xE9er un compte", "Enter your password": "Saisissez votre mot de passe", "Forgot Password": "Mot de passe oubli\xE9", "Have an account? ": "D\xE9j\xE0 un compte ? ", Hello: "Bonjour", "Incorrect username or password": "Identifiant ou mot de passe incorrect", "Invalid password format": "Format de mot de passe invalide", "Invalid phone number format": "Format de num\xE9ro de t\xE9l\xE9phone invalide. Veuillez utiliser un format +12345678900", "Loading...": "Chargement...", "Lost your code? ": "Vous avez perdu votre code ? ", "Network error": "Erreur r\xE9seau", "New Password": "Nouveau mot de passe", "No account? ": "Pas de compte ? ", "Resend a Code": "Renvoyer un code", "Reset password": "R\xE9initialisez votre mot de passe", Send: "Envoyer", "Sign In with AWS": "Se connecter avec AWS", "Sign Out": "D\xE9connexion", "Sign Up": "S'inscrire", SMS: "SMS", "User already exists": "L'utilisateur existe d\xE9j\xE0", "User does not exist": "L'utilisateur n'existe pas", "Username cannot be empty": "Le nom d'utilisateur doit \xEAtre renseign\xE9", "Username/client id combination not found.": "L'utilisateur n'existe pas", "We Emailed You": "Nous vous avons envoy\xE9 un code", "Your code is on the way. To log in, enter the code we emailed to": "Votre code est en route. Pour vous connecter entrez le code re\xE7u sur cette adresse email", "Your code is on the way. To log in, enter the code we texted to": "Votre code est en route. Pour vous connecter entrez le code re\xE7u sur ce num\xE9ro de t\xE9l\xE9phone", "It may take a minute to arrive.": "Cela peut prendre quelques minutes." };
const o$7 = { "Account recovery requires verified contact information": "Il ripristino dell'account richiede informazioni di contatto verificate", "Back to Sign In": "Torna alla schermata di accesso", "Change Password": "Cambia la password", Changing: "Modifica in corso", Code: "Codice", "Confirm Password": "Conferma la password", "Confirm Sign Up": "Conferma registrazione", "Confirm SMS Code": "Conferma codice SMS", "Confirm TOTP Code": "Conferma codice TOTP", Confirm: "Conferma", "Confirmation Code": "Codice di verifica", Confirming: "Conferma in corso", "Create a new account": "Crea un nuovo account", "Create Account": "Crea Account", "Creating Account": "Creazione account in corso", "Dismiss alert": "Ignora l'avviso", Email: "Email", "Enter your code": "Inserisci il tuo codice", "Enter your email": "Inserisci la tua e-mail", "Enter your phone number": 'Inserisci il tuo numero di telefono"', "Enter your username": "Inserisci il tuo nome utente", "Forgot your password?": "Password dimenticata?", "Hide password": "Nascondi password", "It may take a minute to arrive": "L'arrivo potrebbe richiedere qualche minuto", Loading: "Caricamento in corso", "New password": "Nuova password", or: "oppure", Password: "Password", "Phone Number": "Numero di telefono", "Resend Code": "Invia nuovamente il codice", "Reset your Password": "Reimposta la tua Password", "Reset your password": "Reimposta la tua password", "Send code": "Invia codice", "Send Code": "Invia codice", Sending: "Invio in corso", "Setup TOTP": "Configura TOTP", "Show password": "Mostra password", "Sign in to your account": "Accedi al tuo account", "Sign In with Amazon": "Accedi con Amazon", "Sign In with Apple": "Accedi con Apple", "Sign In with Facebook": "Accedi con Facebook", "Sign In with Google": "Accedi con Google", "Sign in": "Accedi", "Sign In": "Accedi", "Signing in": "Accesso in corso", Skip: "Salta", Submit: "Invia", Submitting: "Invio in corso", Username: "Nome utente", "Verify Contact": "Verifica contatto", Verify: "Verifica", "We Emailed You": "Ti abbiamo inviato un'e-mail", "We Sent A Code": "Ti abbiamo inviato un codice", "We Texted You": "Ti abbiamo inviato un SMS", "Your code is on the way. To log in, enter the code we emailed to": "Il codice \xE8 in arrivo. Per effettuare l'accesso, immetti il codice che ti abbiamo inviato via e-mail", "Your code is on the way. To log in, enter the code we sent you": "Il codice \xE8 in arrivo. Per accedere, immetti il codice che ti abbiamo inviato", "Your code is on the way. To log in, enter the code we texted to": "Il codice \xE8 in arrivo. Per accedere, immetti il codice che abbiamo inviato tramite SMS", "An account with the given email already exists.": "Questa email \xE8 gi\xE0 utilizzata da un altro account.", "Confirm a Code": "Conferma un codice", "Confirm Sign In": "Conferma l'accesso", "Create account": "Crea account", "Enter your password": "Inserisci la tua password", "Forgot Password?": "Password dimenticata?", "Have an account? ": "Gi\xE0 registrato?", "Incorrect username or password": "Nome utente o password errati", "Invalid password format": "Formato della password non valido", "Invalid phone number format": "Formato del numero di telefono non valido", "Lost your code?": "Codice smarrito?", "New Password": "Nuova password", "No account? ": "Non hai un account?", "Password attempts exceeded": "Il numero massimo di tentativi di accesso falliti \xE8 stato raggiunto", "Reset password": "Reimposta password", "Sign Out": "Esci", "Sign Up": "Registrati", "User already exists": "Utente gi\xE0 esistente", "User does not exist": "Utente inesistente", "Username cannot be empty": "Il nome utente non pu\xF2 essere vuoto" };
const e$9 = { "Account recovery requires verified contact information": "\u30A2\u30AB\u30A6\u30F3\u30C8\u306E\u5FA9\u65E7\u306B\u306F\u78BA\u8A8D\u6E08\u307F\u306E\u9023\u7D61\u5148\u304C\u5FC5\u8981\u3067\u3059", "Back to Sign In": "\u30B5\u30A4\u30F3\u30A4\u30F3\u306B\u623B\u308B", "Change Password": "\u30D1\u30B9\u30EF\u30FC\u30C9\u3092\u5909\u3048\u308B ", Changing: "\u5909\u66F4\u4E2D", Code: "\u30B3\u30FC\u30C9", "Confirm Password": "\u30D1\u30B9\u30EF\u30FC\u30C9\u306E\u78BA\u8A8D", "Confirm Sign Up": "\u767B\u9332\u3059\u308B", "Confirm SMS Code": "SMS \u30B3\u30FC\u30C9\u3092\u78BA\u8A8D", "Confirm TOTP Code": "TOTP \u30B3\u30FC\u30C9\u3092\u78BA\u8A8D", Confirm: "\u78BA\u5B9A", "Confirmation Code": "\u78BA\u8A8D\u30B3\u30FC\u30C9", Confirming: "\u78BA\u8A8D\u4E2D", "Create a new account": "\u65B0\u3057\u3044\u30A2\u30AB\u30A6\u30F3\u30C8\u3092\u4F5C\u308B", "Create Account": "\u30A2\u30AB\u30A6\u30F3\u30C8\u3092\u4F5C\u308B", "Creating Account": "\u30A2\u30AB\u30A6\u30F3\u30C8\u306E\u4F5C\u6210\u4E2D", "Dismiss alert": "\u30A2\u30E9\u30FC\u30C8\u3092\u9589\u3058\u308B", Email: "\u30E1\u30FC\u30EB\u30A2\u30C9\u30EC\u30B9", "Enter your code": "\u30B3\u30FC\u30C9\u3092\u5165\u529B", "Enter your email": "\u30E1\u30FC\u30EB\u30A2\u30C9\u30EC\u30B9\u3092\u5165\u529B", "Enter your phone number": "\u96FB\u8A71\u756A\u53F7\u3092\u5165\u529B", "Enter your username": "\u30E6\u30FC\u30B6\u30FC\u540D\u3092\u5165\u529B ", "Forgot your password?": "\u30D1\u30B9\u30EF\u30FC\u30C9\u3092\u5FD8\u308C\u307E\u3057\u305F\u304B\uFF1F ", "Hide password": "\u30D1\u30B9\u30EF\u30FC\u30C9\u3092\u975E\u8868\u793A", "It may take a minute to arrive": "\u5230\u7740\u3059\u308B\u307E\u3067\u306B 1 \u5206\u304B\u304B\u308B\u3053\u3068\u304C\u3042\u308A\u307E\u3059\u3002", Loading: "\u30ED\u30FC\u30C9\u4E2D", "New password": "\u65B0\u3057\u3044\u30D1\u30B9\u30EF\u30FC\u30C9", or: "\u53C8\u306F", Password: "\u30D1\u30B9\u30EF\u30FC\u30C9 ", "Phone Number": "\u96FB\u8A71\u756A\u53F7", "Resend Code": "\u30B3\u30FC\u30C9\u3092\u518D\u9001\u4FE1", "Reset your Password": "\u30D1\u30B9\u30EF\u30FC\u30C9\u3092\u30EA\u30BB\u30C3\u30C8", "Reset your password": "\u30D1\u30B9\u30EF\u30FC\u30C9\u3092\u30EA\u30BB\u30C3\u30C8\u3059\u308B", "Send code": "\u30B3\u30FC\u30C9\u3092\u9001\u4FE1", "Send Code": "\u30B3\u30FC\u30C9\u3092\u9001\u4FE1", Sending: "\u9001\u4FE1\u4E2D", "Setup TOTP": "TOTP \u3092\u30BB\u30C3\u30C8\u30A2\u30C3\u30D7", "Show password": "\u30D1\u30B9\u30EF\u30FC\u30C9\u3092\u8868\u793A", "Sign in to your account": "\u30A2\u30AB\u30A6\u30F3\u30C8\u306B\u30B5\u30A4\u30F3\u30A4\u30F3 ", "Sign In with Amazon": "Amazon\u3067\u30B5\u30A4\u30F3\u30A4\u30F3", "Sign In with Apple": "Apple \u3067\u30B5\u30A4\u30F3\u30A4\u30F3", "Sign In with Facebook": "Facebook\u3067\u30B5\u30A4\u30F3\u30A4\u30F3", "Sign In with Google": "Google\u3067\u30B5\u30A4\u30F3\u30A4\u30F3", "Sign In": "\u30B5\u30A4\u30F3\u30A4\u30F3 ", "Sign in": "\u30B5\u30A4\u30F3\u30A4\u30F3", "Signing in": "\u30B5\u30A4\u30F3\u30A4\u30F3\u4E2D", Skip: "\u30B9\u30AD\u30C3\u30D7", Submit: "\u9001\u4FE1", Submitting: "\u9001\u4FE1\u4E2D", Username: "\u30E6\u30FC\u30B6\u30FC\u540D ", "Verify Contact": "\u9023\u7D61\u5148\u3092\u78BA\u8A8D", Verify: "\u78BA\u8A8D", "We Sent A Code": "\u30B3\u30FC\u30C9\u304C\u9001\u4FE1\u3055\u308C\u307E\u3057\u305F", "We Texted You": "\u30C6\u30AD\u30B9\u30C8\u304C\u9001\u4FE1\u3055\u308C\u307E\u3057\u305F", "Your code is on the way. To log in, enter the code we sent you": "\u30B3\u30FC\u30C9\u304C\u9014\u4E2D\u3067\u3059\u3002\u30ED\u30B0\u30A4\u30F3\u3059\u308B\u306B\u306F\u3001\u9001\u4FE1\u3057\u305F\u30B3\u30FC\u30C9\u3092\u5165\u529B\u3057\u3066\u304F\u3060\u3055\u3044\u3002", "An account with the given email already exists.": "\u5165\u529B\u3055\u308C\u305F\u30E1\u30FC\u30EB\u30A2\u30C9\u30EC\u30B9\u306E\u30A2\u30AB\u30A6\u30F3\u30C8\u304C\u65E2\u306B\u5B58\u5728\u3057\u307E\u3059", "Confirm a Code": "\u30B3\u30FC\u30C9\u3092\u78BA\u8A8D", "Confirm Sign In": "\u30B5\u30A4\u30F3\u30A4\u30F3\u3059\u308B", "Create account": "\u30A2\u30AB\u30A6\u30F3\u30C8\u3092\u4F5C\u308B ", "Enter your Email": "\u30E1\u30FC\u30EB\u30A2\u30C9\u30EC\u30B9\u3092\u5165\u529B", "Enter your password": "\u30D1\u30B9\u30EF\u30FC\u30C9\u3092\u5165\u529B ", "Enter your Password": "\u30D1\u30B9\u30EF\u30FC\u30C9\u3092\u5165\u529B", "Please confirm your Password": "\u30D1\u30B9\u30EF\u30FC\u30C9\u3092\u5165\u529B", "Forgot Password": "\u30D1\u30B9\u30EF\u30FC\u30C9\u3092\u5FD8\u308C\u305F ", "Have an account? ": "\u30A2\u30AB\u30A6\u30F3\u30C8\u3092\u6301\u3063\u3066\u3044\u307E\u3059\u304B\uFF1F", "Incorrect username or password": "\u30E6\u30FC\u30B6\u30FC\u540D\u304B\u30D1\u30B9\u30EF\u30FC\u30C9\u304C\u7570\u306A\u308A\u307E\u3059 ", "Invalid password format": "\u30D1\u30B9\u30EF\u30FC\u30C9\u306E\u5F62\u5F0F\u304C\u7121\u52B9\u3067\u3059 ", "Invalid phone number format": "\u4E0D\u6B63\u306A\u96FB\u8A71\u756A\u53F7\u306E\u5F62\u5F0F\u3067\u3059\u3002\n+12345678900 \u306E\u5F62\u5F0F\u3067\u5165\u529B\u3057\u3066\u304F\u3060\u3055\u3044", "It may take a minute to arrive.": "\u30B3\u30FC\u30C9\u3092\u53D7\u4FE1\u3059\u308B\u307E\u3067\u6570\u5206\u304B\u304B\u308B\u5834\u5408\u304C\u3042\u308A\u307E\u3059\u3002", "Lost your code? ": "\u30B3\u30FC\u30C9\u3092\u5931\u304F\u3057\u307E\u3057\u305F\u304B\uFF1F", "New Password": "\u65B0\u3057\u3044\u30D1\u30B9\u30EF\u30FC\u30C9", "No account? ": "\u30A2\u30AB\u30A6\u30F3\u30C8\u304C\u7121\u3044\u3068\u304D ", "Password attempts exceeded": "\u30B5\u30A4\u30F3\u30A4\u30F3\u306E\u8A66\u884C\u56DE\u6570\u304C\u4E0A\u9650\u306B\u9054\u3057\u307E\u3057\u305F", "Reset password": "\u30D1\u30B9\u30EF\u30FC\u30C9\u3092\u30EA\u30BB\u30C3\u30C8 ", "Reset Password": "\u30D1\u30B9\u30EF\u30FC\u30C9\u3092\u30EA\u30BB\u30C3\u30C8", "Sign Out": "\u30B5\u30A4\u30F3\u30A2\u30A6\u30C8 ", "Sign Up": "\u767B\u9332 ", "User already exists": "\u65E2\u306B\u30E6\u30FC\u30B6\u30FC\u304C\u5B58\u5728\u3057\u3066\u3044\u307E\u3059 ", "User does not exist": "\u30E6\u30FC\u30B6\u30FC\u304C\u5B58\u5728\u3057\u307E\u305B\u3093 ", "Username cannot be empty": "\u30E6\u30FC\u30B6\u30FC\u540D\u306F\u5165\u529B\u5FC5\u9808\u3067\u3059", "We Emailed You": "\u30B3\u30FC\u30C9\u3092\u9001\u4FE1\u3057\u307E\u3057\u305F", "Your code is on the way. To log in, enter the code we emailed to": "\u30ED\u30B0\u30A4\u30F3\u3059\u308B\u306B\u306F\u3001\u30E1\u30FC\u30EB\u306B\u8A18\u8F09\u3055\u308C\u305F\u30B3\u30FC\u30C9\u3092\u5165\u529B\u3057\u3066\u304F\u3060\u3055\u3044\u3002\u9001\u4FE1\u5148:", "Your code is on the way. To log in, enter the code we texted to": "\u30ED\u30B0\u30A4\u30F3\u3059\u308B\u306B\u306F\u3001\u30C6\u30AD\u30B9\u30C8\u30E1\u30C3\u30BB\u30FC\u30B8\u306B\u8A18\u8F09\u3055\u308C\u305F\u30B3\u30FC\u30C9\u3092\u5165\u529B\u3057\u3066\u304F\u3060\u3055\u3044\u3002\u9001\u4FE1\u5148:" };
const e$8 = { "Account recovery requires verified contact information": "\uACC4\uC815 \uBCF5\uAD6C\uB97C \uC704\uD574 \uC5F0\uB77D\uCC98 \uD655\uC778\uC774 \uD544\uC694\uD569\uB2C8\uB2E4", "Back to Sign In": "\uB85C\uADF8\uC778\uC73C\uB85C \uB3CC\uC544\uAC00\uAE30", "Change Password": "\uBE44\uBC00\uBC88\uD638 \uBCC0\uACBD\uD558\uAE30", Changing: "\uBCC0\uACBD\uC911", Code: "\uCF54\uB4DC", "Confirm Password": "\uBE44\uBC00\uBC88\uD638 \uC7AC\uD655\uC778", "Confirm Sign Up": "\uD68C\uC6D0\uAC00\uC785 \uD655\uC778", "Confirm SMS Code": "\uD734\uB300\uD3F0 \uBCF8\uC778 \uD655\uC778", "Confirm TOTP Code": "TOTP \uC778\uC99D\uBC88\uD638 \uD655\uC778", Confirm: "\uD655\uC778", "Confirmation Code": "\uC778\uC99D\uBC88\uD638", Confirming: "\uD655\uC778\uC911", "Create a new account": "\uD68C\uC6D0\uAC00\uC785", "Create Account": "\uD68C\uC6D0\uAC00\uC785", "Creating Account": "\uD68C\uC6D0\uAC00\uC785\uC911", "Dismiss alert": "\uC54C\uB9BC \uBB34\uC2DC", Email: "\uC774\uBA54\uC77C", "Enter your code": "\uC778\uC99D\uBC88\uD638\uB97C \uC785\uB825\uD574\uC8FC\uC138\uC694", "Enter your email": "\uC774\uBA54\uC77C \uC785\uB825", "Enter your phone number": "\uC804\uD654\uBC88\uD638 \uC785\uB825", "Enter your username": "\uC544\uC774\uB514\uB97C \uC785\uB825\uD574\uC8FC\uC138\uC694", "Hide password": "\uBE44\uBC00\uBC88\uD638 \uC228\uAE30\uAE30", "It may take a minute to arrive": "\uB3C4\uCC29\uD558\uB294 \uB370 1\uBD84 \uC815\uB3C4 \uAC78\uB9B4 \uC218 \uC788\uC2B5\uB2C8\uB2E4", Loading: "\uB85C\uB529\uC911", "New password": "\uC0C8 \uBE44\uBC00\uBC88\uD638", or: "\uB610\uB294", Password: "\uBE44\uBC00\uBC88\uD638", "Phone Number": "\uC804\uD654\uBC88\uD638", "Resend Code": "\uC778\uC99D\uBC88\uD638 \uC7AC\uC804\uC1A1", "Reset your password": "\uBE44\uBC00\uBC88\uD638 \uC7AC\uC124\uC815", "Reset your Password": "\uBE44\uBC00\uBC88\uD638 \uC7AC\uC124\uC815", "Send code": "\uC778\uC99D\uCF54\uB4DC \uBCF4\uB0B4\uAE30", "Send Code": "\uCF54\uB4DC \uC804\uC1A1", Sending: "\uC804\uC1A1\uC911", "Setup TOTP": "TOTP \uC124\uC815\uD558\uAE30", "Show password": "\uBE44\uBC00\uBC88\uD638 \uBCF4\uC774\uAE30", "Sign in to your account": "\uB85C\uADF8\uC778", "Sign In with Amazon": "Amazon \uB85C\uADF8\uC778", "Sign In with Apple": "Apple \uB85C\uADF8\uC778", "Sign In with Facebook": "Facebook \uB85C\uADF8\uC778", "Sign In with Google": "Google \uB85C\uADF8\uC778", "Sign in": "\uB85C\uADF8\uC778", "Sign In": "\uB85C\uADF8\uC778", "Signing in": "\uB85C\uADF8\uC778\uC911", Skip: "\uB2E4\uC74C\uC5D0 \uD558\uAE30", Submit: "\uD655\uC778", Submitting: "\uD655\uC778\uC911", Username: "\uC544\uC774\uB514", "Verify Contact": "\uC5F0\uB77D\uCC98 \uD655\uC778", Verify: "\uC778\uC99D", "We Emailed You": "\uC774\uBA54\uC77C\uC744 \uBCF4\uB0C4", "We Sent A Code": "\uCF54\uB4DC\uB97C \uBCF4\uB0C4", "We Texted You": "\uBB38\uC790 \uBA54\uC2DC\uC9C0\uB97C \uBCF4\uB0C4", "Your code is on the way. To log in, enter the code we emailed to": "\uCF54\uB4DC\uAC00 \uC804\uC1A1 \uC911\uC785\uB2C8\uB2E4. \uB85C\uADF8\uC778\uD558\uB824\uBA74 \uC774\uBA54\uC77C\uB85C \uC804\uC1A1\uD55C \uCF54\uB4DC\uB97C \uC785\uB825\uD558\uC138\uC694", "Your code is on the way. To log in, enter the code we sent you": "\uCF54\uB4DC\uAC00 \uC804\uC1A1 \uC911\uC785\uB2C8\uB2E4. \uB85C\uADF8\uC778\uD558\uB824\uBA74 \uC804\uC1A1\uD55C \uCF54\uB4DC\uB97C \uC785\uB825\uD558\uC138\uC694", "Your code is on the way. To log in, enter the code we texted to": "\uCF54\uB4DC\uAC00 \uC804\uC1A1 \uC911\uC785\uB2C8\uB2E4. \uB85C\uADF8\uC778\uD558\uB824\uBA74 \uBB38\uC790 \uBA54\uC2DC\uC9C0\uB85C \uC804\uC1A1\uD55C \uCF54\uB4DC\uB97C \uC785\uB825\uD558\uC138\uC694", Birthdate: "\uC0DD\uB144\uC6D4\uC77C", "Family Name": "\uC131", "Forgot your password?": "\uBE44\uBC00\uBC88\uD638\uB97C \uC78A\uC73C\uC168\uB098\uC694?", "Given Name": "\uC774\uB984", Name: "\uC131\uD568", Nickname: "\uB2C9\uB124\uC784", "Preferred Username": "\uB2C9\uB124\uC784", Profile: "\uD504\uB85C\uD544", "Reset Password": "\uBE44\uBC00\uBC88\uD638 \uC7AC\uC124\uC815", Website: "\uC6F9\uC0AC\uC774\uD2B8" };
const e$7 = { "Account recovery requires verified contact information": "Accountherstel vereist geverifieerde contactgegevens", "Back to Sign In": "Terug naar inloggen", "Change Password": "Wachtwoord wijzigen", Changing: "Wordt aangepast", Code: "Code", "Confirm Password": "Bevestig Wachtwoord", "Confirm Sign Up": "Bevestig inschrijving", "Confirm SMS Code": "Bevestig SMS Code", "Confirm TOTP Code": "Bevestig TOTP Code", Confirm: "Bevestig", "Confirmation Code": "Bevestigingscode", Confirming: "Bevestigen", "Create a new account": "Nieuw account aanmaken", "Create Account": "Account aanmaken", "Creating Account": "Account wordt aangemaakt", "Dismiss alert": "Waarschuwing sluiten", Email: "E-mail", "Enter your code": "Vul je code in", "Enter your email": "Vul je e-mail in", "Enter your Password": "Vul je wachtwoord in", "Enter your phone number": "Vul je telefoonnummer in", "Enter your username": "Vul je gebruikersnaam in", "Enter your Username": "Vul je gebruikersnaam in", "Forgot your password?": "Wachtwoord vergeten? ", "Hide password": "Verberg wachtwoord", "It may take a minute to arrive": "Het kan even duren voordat deze aankomt", Loading: "Laden", "New password": "Nieuw wachtwoord", "New Password": "Nieuw Wachtwoord", or: "of", Password: "Wachtwoord", "Phone Number": "Telefoonnummer", "Please confirm your Password": "Bevestig je wachtwoord", "Resend Code": "Verstuur code nogmaals", "Reset Password": "Wachtwoord resetten", "Reset your password": "Reset je wachtwoord", "Reset your Password": "Wachtwoord resetten", "Send code": "Verstuur code", "Send Code": "Verstuur Code", Sending: "Versturen", "Setup TOTP": "TOTP Instellingen", "Show password": "Toon wachtwoord", "Sign in to your account": "Inloggen op je account", "Sign In with Amazon": "Inloggen met Amazon", "Sign In with Apple": "Inloggen met Apple", "Sign In with Facebook": "Inloggen met Facebook", "Sign In with Google": "Inloggen met Google", "Sign in": "Inloggen", "Sign In": "Inloggen", "Signing in": "Inloggen", Skip: "Overslaan", Submit: "Versturen", Submitting: "Wordt verstuurd", Username: "Gebruikersnaam", "Verify Contact": "Verifieer Contact", Verify: "Verifieer", "We Emailed You": "We hebben u een e-mail gestuurd", "We Sent A Code": "We hebben een code gestuurd", "We Texted You": "We hebben u een sms gestuurd", "Your code is on the way. To log in, enter the code we emailed to": "Uw code is onderweg. Om in te loggen, voer de code in die we gemaild hebben naar", "Your code is on the way. To log in, enter the code we sent you": "Uw code is onderweg. Om in te loggen, voer de code in die we u hebben gestuurd", "Your code is on the way. To log in, enter the code we texted to": "Uw code is onderweg. Om in te loggen, voer de code in die we hebben gestuurd naar", "Your passwords must match": "Je wachtwoorden moeten overeenkomen" };
const o$6 = { "Account recovery requires verified contact information": "Odzyskanie konta wymaga zweryfikowanych danych kontaktowych", "Back to Sign In": "Powr\xF3t do logowania", "Change Password": "Zmie\u0144 has\u0142o", Changing: "Zmienianie", Code: "Kod", "Confirm Password": "Potwierd\u017A Has\u0142o", "Confirm Sign Up": "Potwierd\u017A rejestracj\u0119", "Confirm SMS Code": "Potwierd\u017A kod SMS", "Confirm TOTP Code": "Potwierd\u017A has\u0142o jednorazowe", Confirm: "Potwierd\u017A", "Confirmation Code": "Kod potwierdzenia", Confirming: "Potwierdzanie", "Create a new account": "Utw\xF3rz nowe konto", "Create Account": "Utw\xF3rz konto", "Creating Account": "Tworzenie konta", "Dismiss alert": "Odrzu\u0107 alert", Email: "E-mail", "Enter your code": "Wprowad\u017A sw\xF3j kod", "Enter your email": "Wpisz sw\xF3j adres e-mail", "Enter your phone number": "Wpisz sw\xF3j numer telefonu", "Enter your username": "Wprowad\u017A swoj\u0105 nazw\u0119 u\u017Cytkownika", "Forgot your password?": "Zapomnia\u0142e\u015B has\u0142a? ", "Hide password": "Ukryj has\u0142o", "It may take a minute to arrive": "Mo\u017Ce to chwil\u0119 potrwa\u0107", Loading: "\u0141adowanie", "New password": "Nowe has\u0142o", or: "albo", Password: "Has\u0142o", "Phone Number": "Numer telefonu", "Resend Code": "Wy\u015Blij kod ponownie", "Reset your password": "Zresetuj swoje has\u0142o", "Reset your Password": "Zresetuj swoje has\u0142o", "Send code": "Wy\u015Blij kod", "Send Code": "Zresetuj has\u0142o", Sending: "Wysy\u0142anie", "Setup TOTP": "Konfiguruj TOTP", "Show password": "Poka\u017C has\u0142o", "Sign in to your account": "Zaloguj si\u0119 na swoje konto", "Sign In with Amazon": "Zaloguj z Amazon", "Sign In with Apple": "Zaloguj z Apple", "Sign In with Facebook": "Zaloguj z Facebook", "Sign In with Google": "Zaloguj z Google", "Sign In": "Logowanie", "Sign in": "Zaloguj", "Signing in": "Logowanie", Skip: "Pomi\u0144", Submit: "Wy\u015Blij", Submitting: "Wysy\u0142anie", Username: "Nazwa u\u017Cytkownika", "Verify Contact": "Weryfikacja danych kontaktowych", Verify: "Zweryfikuj", Birthdate: "Data urodzenia", "Family Name": "Nazwisko", "Given Name": "Pierwsze imi\u0119", "Middle Name": "Drugie imi\u0119", Name: "Imi\u0119 i nazwisko", Nickname: "Pseudonim", "Preferred Username": "Preferowana nazwa u\u017Cytkownika", Profile: "Profil", Website: "Strona internetowa", "We Emailed You": "Wys\u0142ali\u015Bmy Ci wiadomo\u015B\u0107 e-mail", "We Sent A Code": "Wys\u0142ali\u015Bmy kod", "We Texted You": "Wys\u0142ali\u015Bmy Ci wiadomo\u015B\u0107 SMS", "Your code is on the way. To log in, enter the code we emailed to": "Tw\xF3j kod zosta\u0142 wys\u0142any. Aby si\u0119 zalogowa\u0107, wprowad\u017A kod wys\u0142any na adres e-mail", "Your code is on the way. To log in, enter the code we sent you": "Tw\xF3j kod zosta\u0142 wys\u0142any. Aby si\u0119 zalogowa\u0107, wprowad\u017A wys\u0142any do Ciebie kod", "Your code is on the way. To log in, enter the code we texted to": "Tw\xF3j kod zosta\u0142 wys\u0142any. Aby si\u0119 zalogowa\u0107, wprowad\u017A kod wys\u0142any do Ciebie w wiadomo\u015Bci SMS pod numer" };
const o$5 = { "Account recovery requires verified contact information": "A recupera\xE7\xE3o da conta requer informa\xE7\xF5es de contato verificadas", "Back to Sign In": "Voltar para Entrar", "Change Password": "Mudar senha", Changing: "Mudando", Code: "C\xF3digo", "Confirm Password": "Confirme a Senha", "Confirm Sign Up": "Confirmar inscri\xE7\xE3o", "Confirm SMS Code": "Confirme o c\xF3digo SMS", "Confirm TOTP Code": "Confirme o c\xF3digo TOTP", Confirm: "confirme", "Confirmation Code": "C\xF3digo de confirma\xE7\xE3o", Confirming: "Confirmando", "Create a new account": "Criar uma nova conta", "Create Account": "Criar Conta", "Creating Account": "Criando conta", "Dismiss alert": "Descartar alerta", Email: "O email", "Enter your code": "Insira seu c\xF3digo", "Enter your email": "Digite seu e-mail", "Enter your phone number": "Digite seu n\xFAmero de telefone", "Enter your username": "entre com seu nome de usu\xE1rio", "Forgot your password?": "Esqueceu sua senha? ", "Hide password": "Esconder a senha", "It may take a minute to arrive": "Pode levar um minuto para chegar", Loading: "Carregando", "New password": "Nova Senha", or: "ou", Password: "Senha", "Phone Number": "N\xFAmero de telefone", "Resend Code": "Reenviar c\xF3digo", "Reset your password": "Redefina sua senha", "Reset your Password": "Redefina sua senha", "Send code": "Enviar c\xF3digo", "Send Code": "Enviar c\xF3digo", Sending: "Enviando", "Setup TOTP": "Configurar TOTP", "Show password": "Mostrar senha", "Sign in to your account": "Fa\xE7a login em sua conta", "Sign In with Amazon": "Entrar com a Amazon", "Sign In with Apple": "Entrar com a Apple", "Sign In with Facebook": "Entrar com o Facebook", "Sign In with Google": "Fa\xE7a login no Google", "Sign in": "Entrar", "Sign In": "Entrar", "Signing in": "Entrando", Skip: "Pular", Submit: "Enviar", Submitting: "Enviando", Username: "Nome do usu\xE1rio", "Verify Contact": "Verificar contato", Verify: "Verificar", "We Emailed You": "Enviamos um e-mail para voc\xEA", "We Sent A Code": "Enviamos um c\xF3digo", "We Texted You": "Enviamos um SMS para voc\xEA", "Your code is on the way. To log in, enter the code we emailed to": "Seu c\xF3digo est\xE1 a caminho. Para fazer login, insira o c\xF3digo para o qual enviamos um e-mail", "Your code is on the way. To log in, enter the code we sent you": "Seu c\xF3digo est\xE1 a caminho. Para fazer login, insira o c\xF3digo que enviamos para voc\xEA", "Your code is on the way. To log in, enter the code we texted to": "Seu c\xF3digo est\xE1 a caminho. Para fazer login, insira o c\xF3digo para o qual enviamos uma mensagem de texto" };
const e$6 = { "Account recovery requires verified contact information": "\u8D26\u6237\u6062\u590D\u9700\u8981\u9A8C\u8BC1\u8FC7\u7684\u8054\u7CFB\u65B9\u5F0F", "Back to Sign In": "\u56DE\u5230\u767B\u5F55", "Change Password": "\u66F4\u6539\u5BC6\u7801", Changing: "\u6B63\u5728\u4FEE\u6539", Code: "\u786E\u8BA4\u7801", "Confirm Password": "\u786E\u8BA4\u5BC6\u7801", "Confirm Sign Up": "\u786E\u8BA4\u6CE8\u518C", "Confirm SMS Code": "\u786E\u8BA4\u77ED\u4FE1\u9A8C\u8BC1\u7801", "Confirm TOTP Code": "\u786E\u8BA4 TOTP \u4EE3\u7801", Confirm: "\u786E\u8BA4", "Confirmation Code": "\u786E\u8BA4\u7801", Confirming: "\u6B63\u5728\u786E\u8BA4", "Create a new account": "\u521B\u5EFA\u65B0\u8D26\u6237", "Create Account": "\u521B\u5EFA\u8D26\u6237", "Creating Account": "\u6B63\u5728\u521B\u5EFA\u8D26\u6237", "Dismiss alert": "\u5173\u95ED\u8B66\u62A5", Email: "\u90AE\u7BB1", "Enter your code": "\u8F93\u5165\u9A8C\u8BC1\u7801", "Enter your email": "\u8F93\u5165\u7535\u5B50\u90AE\u4EF6", "Enter your phone number": "\u8F93\u5165\u7535\u8BDD\u53F7\u7801", "Enter your username": "\u8F93\u5165\u7528\u6237\u540D", "Forgot your password?": "\u5FD8\u8BB0\u5BC6\u7801\u4E86\uFF1F", "Hide password": "\u9690\u85CF\u5BC6\u7801", "It may take a minute to arrive": "\u53EF\u80FD\u9700\u8981\u4E00\u5206\u949F\u624D\u80FD\u5230\u8FBE", Loading: "\u6B63\u5728\u52A0\u8F7D", "New password": "\u65B0\u5BC6\u7801", or: "\u6216\u8005", Password: "\u5BC6\u7801", "Phone Number": "\u7535\u8BDD", "Resend Code": "\u91CD\u53D1\u9A8C\u8BC1\u7801", "Reset your password": "\u91CD\u7F6E\u5BC6\u7801", "Reset your Password": "\u91CD\u7F6E\u5BC6\u7801", "Send Code": "\u53D1\u9001\u786E\u8BA4\u7801", "Send code": "\u53D1\u9001\u9A8C\u8BC1\u7801", Sending: "\u6B63\u5728\u53D1\u9001", "Setup TOTP": "\u8BBE\u7F6E TOTP", "Show password": "\u663E\u793A\u5BC6\u7801", "Sign in to your account": "\u767B\u5F55\u8D26\u6237", "Sign In with Amazon": "\u901A\u8FC7 Amazon \u767B\u5F55", "Sign In with Apple": "\u901A\u8FC7 Apple \u767B\u5F55", "Sign In with Facebook": "\u901A\u8FC7 Facebook \u767B\u5F55", "Sign In with Google": "\u901A\u8FC7 Google \u767B\u5F55", "Sign in": "\u767B\u5F55", "Sign In": "\u767B\u5F55", "Signing in": "\u6B63\u5728\u767B\u5F55", Skip: "\u8DF3\u8FC7", Submit: "\u63D0\u4EA4", Submitting: "\u6B63\u5728\u63D0\u4EA4", Username: "\u7528\u6237\u540D", "Verify Contact": "\u9A8C\u8BC1\u8054\u7CFB\u65B9\u5F0F", Verify: "\u9A8C\u8BC1", "We Emailed You": "\u6211\u4EEC\u7ED9\u60A8\u53D1\u9001\u4E86\u7535\u5B50\u90AE\u4EF6", "We Sent A Code": "\u6211\u4EEC\u53D1\u9001\u4E86\u4EE3\u7801", "We Texted You": "\u6211\u4EEC\u7ED9\u60A8\u53D1\u9001\u4E86\u77ED\u4FE1", "Your code is on the way. To log in, enter the code we emailed to": "\u60A8\u7684\u4EE3\u7801\u6B63\u5728\u53D1\u9001\u4E2D\u3002\u8981\u767B\u5F55\uFF0C\u8BF7\u8F93\u5165\u6211\u4EEC\u901A\u8FC7\u7535\u5B50\u90AE\u4EF6\u53D1\u9001\u7ED9\u4EE5\u4E0B\u4EBA\u5458\u7684\u4EE3\u7801\uFF1A", "Your code is on the way. To log in, enter the code we sent you": "\u60A8\u7684\u4EE3\u7801\u6B63\u5728\u53D1\u9001\u4E2D\u3002\u8981\u767B\u5F55\uFF0C\u8BF7\u8F93\u5165\u6211\u4EEC\u53D1\u9001\u7ED9\u60A8\u7684\u4EE3\u7801", "Your code is on the way. To log in, enter the code we texted to": "\u60A8\u7684\u4EE3\u7801\u6B63\u5728\u53D1\u9001\u4E2D\u3002\u8981\u767B\u5F55\uFF0C\u8BF7\u8F93\u5165\u6211\u4EEC\u901A\u8FC7\u77ED\u4FE1\u53D1\u9001\u7ED9\u4EE5\u4E0B\u4EBA\u5458\u7684\u4EE3\u7801\uFF1A", "Confirm a Code": "\u786E\u8BA4\u7801", "Confirm Sign In": "\u786E\u8BA4\u767B\u5F55", "Forgot Password": "\u5FD8\u8BB0\u5BC6\u7801", "Incorrect username or password": "\u7528\u6237\u540D\u6216\u5BC6\u7801\u9519\u8BEF", "Invalid password format": "\u5BC6\u7801\u683C\u5F0F\u9519\u8BEF", "Invalid phone number format": "\u7535\u8BDD\u683C\u5F0F\u9519\u8BEF\uFF0C\u8BF7\u4F7F\u7528\u683C\u5F0F +12345678900", "New Password": "\u65B0\u5BC6\u7801", "Resend a Code": "\u91CD\u53D1\u786E\u8BA4\u7801", "Sign Out": "\u9000\u51FA", "Sign Up": "\u6CE8\u518C", "User already exists": "\u7528\u6237\u5DF2\u7ECF\u5B58\u5728", "User does not exist": "\u7528\u6237\u4E0D\u5B58\u5728" };
const e$5 = { "Account recovery requires verified contact information": "F\xF6r att \xE5terst\xE4lla kontot beh\xF6ver du ett verifierat konto", "Back to Sign In": "Tillbaka till inloggningen", "Change Password": "Byt l\xF6senord", Changing: "\xC4ndra", Code: "Kod", "Confirm Password": "Bekr\xE4fta l\xF6senord", "Confirm Sign Up": "Bekr\xE4fta registrering", "Confirm SMS Code": "Bekr\xE4fta SMS-kod", "Confirm TOTP Code": "Bekr\xE4fta TOTP-kod", Confirm: "Bekr\xE4fta", "Confirmation Code": "Verifikationskod", Confirming: "Bekr\xE4ftar", "Create a new account": "Skapa ett nytt konto", "Create Account": "Skapa konto", "Creating Account": "Skapar konto", "Dismiss alert": "Avvisa varning", Email: "E-post", "Enter your code": "Skriv din kod", "Enter your email": "Fyll i din e-post", "Enter your phone number": "Ange ditt telefonnummer", "Enter your username": "Ange ditt anv\xE4ndarnamn", "Forgot your password?": "Gl\xF6mt ditt l\xF6senord? ", "Hide password": "D\xF6lj l\xF6senord", "It may take a minute to arrive": "Det kan ta en minut att komma fram", Loading: "Laddar", "New password": "Nytt l\xF6senord", or: "eller", Password: "L\xF6senord", "Phone Number": "Telefonnummer", "Resend Code": "Skicka koden igen", "Reset your password": "\xC5terst\xE4ll ditt l\xF6senord", "Reset your Password": "\xC5terst\xE4ll ditt l\xF6senord", "Send code": "Skicka kod", "Send Code": "Skicka kod", Sending: "Skickar", "Setup TOTP": "Konfigurera TOTP", "Show password": "Visa l\xF6senord", "Sign in to your account": "Logga in till ditt konto", "Sign In with Amazon": "Logga in med Amazon", "Sign In with Apple": "Logga in med Apple", "Sign In with Facebook": "Logga in med Facebook", "Sign In with Google": "Logga in med Google", "Sign in": "Logga in", "Sign In": "Logga in", "Signing in": "Loggar in", Skip: "Hoppa \xF6ver", Submit: "Skicka", Submitting: "Skickar in", Username: "Anv\xE4ndarnamn", "Verify Contact": "Verifiera kontakt", Verify: "Verifiera", "We Sent A Code": "Vi skickade en kod", "We Texted You": "Vi sms:ade dig", "Your code is on the way. To log in, enter the code we emailed to": "Din kod \xE4r p\xE5 v\xE4g. F\xF6r att logga in, ange koden vi mejlade till", "Your code is on the way. To log in, enter the code we sent you": "Din kod \xE4r p\xE5 v\xE4g. F\xF6r att logga in, ange koden vi skickade till dig", "Your code is on the way. To log in, enter the code we texted to": "Din kod \xE4r p\xE5 v\xE4g. F\xF6r att logga in, ange koden vi sms:ade till", "An account with the given email already exists.": "Det finns redan ett konto med denna e-postadress", "Confirm a Code": "Bekr\xE4fta koden", "Confirm Sign In": "Bekr\xE4fta inloggning", "Create account": "Skapa konto", "Enter your password": "Ange ditt l\xF6senord", "Forgot Password": "Gl\xF6mt l\xF6senordet", "Have an account? ": "Redan registrerad? ", "Incorrect username or password": "Felaktigt anv\xE4ndarnamn eller l\xF6senord", "Invalid password format": "Ogiltigt l\xF6senordsformat", "Invalid phone number format": "Ogiltigt format f\xF6r telefonnummer", "Lost your code? ": "F\xF6rlorat koden? ", "New Password": "Nytt l\xF6senord", "No account? ": "Inget konto? ", "Password attempts exceeded": "Maximalt antal felaktiga inloggningsf\xF6rs\xF6k har uppn\xE5tts", "Reset password": "\xC5terst\xE4ll l\xF6senord", "Sign Out": "Logga ut", "Sign Up": "Registrering", "User already exists": "Anv\xE4ndaren finns redan", "User does not exist": "Anv\xE4ndaren finns inte", "Username cannot be empty": "Anv\xE4ndarnamnet kan inte vara tomt", "We Emailed You": "Vi har skickat e-post till dig" };
const a$3 = { "Account recovery requires verified contact information": "Pemulihan akun memerlukan informasi kontak terverifikasi", "Back to Sign In": "Kembali ke Masuk", "Change Password": "Ubah kata sandi", Changing: "Mengubah", Code: "Kode", "Confirm Password": "Konfirmasi kata sandi", "Confirm Sign Up": "Konfirmasi Pendaftaran", "Confirm SMS Code": "Konfirmasi Kode SMS", "Confirm TOTP Code": "Konfirmasi Kode TOTP", Confirm: "Konfirmasi", "Confirmation Code": "Kode Konfirmasi", Confirming: "Mengkonfirmasi", "Create a new account": "Buat akun baru", "Create Account": "Buat Akun", "Creating Account": "Membuat Akun", "Dismiss alert": "Hentikan pemberitahuan", Email: "Email", "Enter your code": "Masukkan kode anda", "Enter your email": "Masukkan email anda", "Enter your phone number": "Masukkan nomor telepon anda", "Enter your username": "Masukkan nama akun anda", "Forgot your password?": "Lupa kata sandi? ", "Hide password": "Sembunyikan kata sandi", "It may take a minute to arrive": "Mungkin perlu waktu satu menit untuk tiba", Loading: "Memuat", "New password": "Kata sandi baru", or: "atau", Password: "Kata sandi", "Phone Number": "Nomor telepon", "Resend Code": "Kirim ulang kodenya", "Reset your Password": "Reset Kata Sandi", "Reset your password": "Ubah kata sandi anda", "Send code": "Kirim kode", "Send Code": "Kirim Kode", Sending: "Mengirim", "Setup TOTP": "Siapkan TOTP", "Show password": "Tampilkan kata sandi", "Sign in to your account": "Masuk akun anda", "Sign In with Amazon": "Masuk dengan Amazon", "Sign In with Apple": "Masuk dengan Apple", "Sign In with Facebook": "Masuk dengan Facebook", "Sign In with Google": "Masuk dengan Google", "Sign in": "Masuk", "Sign In": "Masuk", "Signing in": "Memasuki", Skip: "Lewati", Submit: "Ajukan", Submitting: "Mengajukan", Username: "Nama akun", "Verify Contact": "Verifikasi Kontak", Verify: "Verifikasi", "We Sent A Code": "Kami Mengirim Kode", "We Texted You": "Kami mengirim SMS kepada Anda", "Your code is on the way. To log in, enter the code we sent you": "Kode Anda segera hadir. Untuk masuk, masukkan kode yang kami kirimkan kepada Anda", "An account with the given email already exists.": "Akun dengan email tersebut sudah terdaftar.", "Attempt limit exceeded, please try after some time.": "Batas percobaan terlampaui, mohon coba lagi setelah beberapa waktu.", "Cannot reset password for the user as there is no registered/verified email or phone_number": "Tidak dapat mengatur ulang kata sandi karena tidak ada email terdaftar / terverifikasi atau nomor telepon", Change: "Ubah", "Confirm a Code": "Konfirmasi kode", "Create account": "Buat akun", "Enter your password": "Masukkan kata sandi anda", "Forgot Password": "Lupa kata sandi", "Have an account? ": "Sudah punya akun? ", Hello: "Halo", "Incorrect username or password.": "Nama akun atau kata sandi salah.", "Invalid phone number format": "Nomor telepon tidak sesuai dengan format.", "Invalid verification code provided, please try again.": "Kode verifikasi tidak sesuai, mohon coba lagi.", "It may take a minute to arrive.": "Mungkin perlu beberapa waktu untuk tiba.", "Lost your code? ": "Kode anda hilang?", Name: "Nama", "Network error": "Galat jaringan", "No account? ": "Tidak ada akun?", "Password did not conform with policy: Password not long enough": "Kata sandi tidak sesuai dengan aturan: Kata sandi kurang panjang", "Resend a Code": "Renvoyer un code", "Reset password": "Ubah kata sandi anda", Send: "Kirim", "Sign In with AWS": "Masuk dengan AWS", "Sign Up with Amazon": "Daftar dengan Amazon", "Sign Up with AWS": "Daftar dengan AWS", "Sign Up with Facebook": "Daftar dengan Facebook", "Sign Up with Google": "Daftar dengan Google", SMS: "SMS", "User already exists": "Akun sudah terdaftar", "User does not exist.": "Akun tidak terdaftar.", "User is disabled.": "Akun dinonaktifkan.", "Username cannot be empty": "Nama akun tidak boleh kosong", "Username/client id combination not found.": "Nama akun atau id tidak ditemukan.", "We Emailed You": "Kami mengirimkanmu email", "Your code is on the way. To log in, enter the code we emailed to": "Kode anda dalam pengiriman. Untuk masuk, masukkan kode yang kami emailkan ke", "Your code is on the way. To log in, enter the code we texted to": "Kode anda dalam pengiriman. Untuk masuk, masukkan kode yang kami tuliskan ke", "Your passwords must match": "Kata sandi harus sama" };
const e$4 = { "Account recovery requires verified contact information": "Hesap kurtarma, do\u011Frulanm\u0131\u015F ileti\u015Fim bilgilerini gerektirir", "Back to Sign In": "Oturum A\xE7maya Geri D\xF6n", "Change Password": "\u015Eifreyi De\u011Fi\u015Ftir", Changing: "De\u011Fi\u015Ftiriliyor", Code: "Kod", "Confirm Password": "\u015Eifreyi Do\u011Frula", "Confirm Sign Up": "Kay\u0131t \u0130\u015Flemini Do\u011Frula", "Confirm SMS Code": "SMS Kodunu Do\u011Frula", "Confirm TOTP Code": "Tek Kullan\u0131ml\u0131k \u015Eifreyi Do\u011Frula", Confirm: "Do\u011Frula", "Confirmation Code": "Do\u011Frulama Kodu", Confirming: "Do\u011Frulan\u0131yor", "Create a new account": "Yeni bir hesap olu\u015Ftur", "Create Account": "Hesap Olu\u015Ftur", "Creating Account": "Hesap Olu\u015Fturuluyor", "Dismiss alert": "Uyar\u0131y\u0131 reddet", Email: "E-posta", "Enter your code": "Kodu girin", "Enter your email": "E-posta adresinizi girin", "Enter your phone number": "Telefon numaran\u0131z\u0131 girin", "Enter your username": "Kullan\u0131c\u0131 ad\u0131n\u0131z\u0131 girin", "Forgot your password?": "\u015Eifrenizi mi unuttunuz?", "Hide password": "\u015Eifreyi gizle", "It may take a minute to arrive": "Kodun gelmesi bir dakika s\xFCrebilir", Loading: "Y\xFCkleniyor", "New password": "Yeni \u015Fifre", or: "veya", Password: "\u015Eifre", "Phone Number": "Telefon Numaras\u0131", "Resend Code": "Kodu Yeniden G\xF6nder", "Reset your password": "\u015Eifrenizi s\u0131f\u0131rlay\u0131n", "Reset your Password": "\u015Eifrenizi S\u0131f\u0131rlay\u0131n", "Send code": "Kod g\xF6nder", "Send Code": "Kod G\xF6nder", Sending: "G\xF6nderiliyor", "Setup TOTP": "Tek kullan\u0131ml\u0131k \u015Fifre kurulumu yap", "Show password": "\u015Eifreyi g\xF6ster", "Sign in to your account": "Hesab\u0131n\u0131zda oturum a\xE7\u0131n", "Sign In with Amazon": "Amazon ile Oturum A\xE7", "Sign In with Apple": "Apple ile Oturum A\xE7", "Sign In with Facebook": "Facebook ile Oturum A\xE7", "Sign In with Google": "Google ile Oturum A\xE7", "Sign in": "Oturum a\xE7", "Sign In": "Oturum A\xE7", "Signing in": "Oturum a\xE7\u0131l\u0131yor", Skip: "Atla", Submit: "G\xF6nder", Submitting: "G\xF6nderiliyor", Username: "Kullan\u0131c\u0131 ad\u0131", "Verify Contact": "Ki\u015Fiyi Do\u011Frula", Verify: "Do\u011Frula", "We Emailed You": "Size E-posta G\xF6nderdik", "We Sent A Code": "Bir Kod G\xF6nderdik", "We Texted You": "Size Mesaj G\xF6nderdik", "Your code is on the way. To log in, enter the code we emailed to": "Kodunuz yolda. Oturum a\xE7mak i\xE7in, g\xF6nderdi\u011Fimiz e-postadaki kodu girin", "Your code is on the way. To log in, enter the code we sent you": "Kodunuz yolda. Oturum a\xE7mak i\xE7in, size g\xF6nderdi\u011Fimiz kodu girin", "Your code is on the way. To log in, enter the code we texted to": "Kodunuz yolda. Oturum a\xE7mak i\xE7in, g\xF6nderdi\u011Fimiz mesajdaki kodu girin", "An account with the given email already exists.": "Bu e-postaya ait zaten bir hesap var.", "Confirm Sign In": "Oturum A\xE7may\u0131 Do\u011Frula", "Have an account? ": "Hesab\u0131n\u0131z var m\u0131? ", "Incorrect username or password": "Yanl\u0131\u015F kullan\u0131c\u0131 ad\u0131 ya da \u015Fifre", "Invalid password format": "Ge\xE7ersiz parola format\u0131", "Invalid phone number format": "Ge\xE7ersiz telefon numaras\u0131 format\u0131", "Lost your code? ": "Kodu mu kaybettiniz? ", "No account? ": "Hesab\u0131n\u0131z yok mu? ", "Password attempts exceeded": "Maksimum oturum a\xE7ma giri\u015Fimi a\u015F\u0131ld\u0131", "Sign Out": "\xC7\u0131k\u0131\u015F yap", "Sign Up": "Kay\u0131t Ol", "User already exists": "Bu kullan\u0131c\u0131 zaten var", "User does not exist": "B\xF6yle bir kullan\u0131c\u0131 mevcut de\u011Fil", "Username cannot be empty": "Kullan\u0131c\u0131 ad\u0131 bo\u015F olamaz" };
const e$3 = { "Account recovery requires verified contact information": "\u0412\u043E\u0441\u0441\u0442\u0430\u043D\u043E\u0432\u043B\u0435\u043D\u0438\u0435 \u0443\u0447\u0435\u0442\u043D\u043E\u0439 \u0437\u0430\u043F\u0438\u0441\u0438 \u0442\u0440\u0435\u0431\u0443\u0435\u0442 \u043F\u0440\u043E\u0432\u0435\u0440\u043A\u0438 \u043A\u043E\u043D\u0442\u0430\u043A\u0442\u043D\u043E\u0439 \u0438\u043D\u0444\u043E\u0440\u043C\u0430\u0446\u0438\u0438", "Back to Sign In": "\u041D\u0430\u0437\u0430\u0434, \u0447\u0442\u043E\u0431\u044B \u0432\u043E\u0439\u0442\u0438", "Change Password": "\u0438\u0437\u043C\u0435\u043D\u044F\u0442\u044C \u043F\u0430\u0440\u043E\u043B\u044C", Changing: "\u0418\u0437\u043C\u0435\u043D\u0435\u043D\u0438\u0435", Code: "\u041A\u043E\u0434", "Confirm Password": "\u041F\u043E\u0434\u0442\u0432\u0435\u0440\u0436\u0434\u0435\u043D\u0438\u0435 \u043F\u0430\u0440\u043E\u043B\u044F", "Confirm Sign Up": "\u041F\u043E\u0434\u0442\u0432\u0435\u0440\u0436\u0434\u0435\u043D\u0438\u0435 \u0437\u0430\u0440\u0435\u0433\u0438\u0441\u0442\u0440\u0438\u0440\u043E\u0432\u0430\u0442\u044C\u0441\u044F", "Confirm SMS Code": "\u041F\u043E\u0434\u0442\u0432\u0435\u0440\u0436\u0434\u0435\u043D\u0438\u0435 CMC-\u041A\u043E\u0434", "Confirm TOTP Code": "\u041F\u043E\u0434\u0442\u0432\u0435\u0440\u0436\u0434\u0435\u043D\u0438\u0435 TOTP-\u041A\u043E\u0434", Confirm: "\u041F\u043E\u0434\u0442\u0432\u0435\u0440\u0436\u0434\u0430\u0442\u044C", "Confirmation Code": "\u043A\u043E\u0434 \u043F\u043E\u0434\u0442\u0432\u0435\u0440\u0436\u0434\u0435\u043D\u0438\u044F", Confirming: "\u043F\u043E\u0434\u0442\u0432\u0435\u0440\u0436\u0434\u0435\u043D\u0438\u0435", "Create a new account": "\u0421\u043E\u0437\u0434\u0430\u0432\u0430\u0442\u044C \u043D\u043E\u0432\u0443\u044E \u0443\u0447\u0435\u0442\u043D\u0443\u044E \u0437\u0430\u043F\u0438\u0441\u044C", "Create Account": "\u0421\u043E\u0437\u0434\u0430\u0442\u044C \u0443\u0447\u0435\u0442\u043D\u0443\u044E \u0437\u0430\u043F\u0438\u0441\u044C", "Creating Account": "\u0441\u043E\u0437\u0434\u0430\u043D\u0438\u0435 \u0443\u0447\u0435\u0442\u043D\u0430\u044F \u0437\u0430\u043F\u0438\u0441\u044C", "Dismiss alert": "\u0417\u0430\u043A\u0440\u044B\u0442\u044C \u043E\u043F\u043E\u0432\u0435\u0449\u0435\u043D\u0438\u0435", Email: "\u044D\u043B\u0435\u043A\u0442\u0440\u043E\u043D\u043D\u0430\u044F \u043F\u043E\u0447\u0442\u0430", "Enter your code": "\u0432\u0432\u0435\u0441\u0442\u0438 \u0432\u0430\u0448 \u041A\u043E\u0434", "Enter your email": "\u0432\u0432\u0435\u0441\u0442\u0438 \u0432\u0430\u0448 \u044D\u043B\u0435\u043A\u0442\u0440\u043E\u043D\u043D\u0430\u044F \u043F\u043E\u0447\u0442\u0430", "Enter your phone number": "\u0432\u0432\u0435\u0441\u0442\u0438 \u0432\u0430\u0448 \u043D\u043E\u043C\u0435\u0440 \u0442\u0435\u043B\u0435\u0444\u043E\u043D\u0430", "Enter your username": "\u0432\u0432\u0435\u0441\u0442\u0438 \u0432\u0430\u0448 \u0438\u043C\u044F \u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044F", "Forgot your password?": "\u0417\u0430\u0431\u044B\u043B\u0438 \u0432\u0430\u0448 \u043F\u0430\u0440\u043E\u043B\u044C?", "Hide password": "\u0421\u043A\u0440\u044B\u0432\u0430\u0442\u044C \u043F\u0430\u0440\u043E\u043B\u044C", "It may take a minute to arrive": "\u0414\u043E\u0441\u0442\u0430\u0432\u043A\u0430 \u043C\u043E\u0436\u0435\u0442 \u0437\u0430\u043D\u044F\u0442\u044C \u043D\u0435\u043A\u043E\u0442\u043E\u0440\u043E\u0435 \u0432\u0440\u0435\u043C\u044F", Loading: "\u0417\u0430\u0433\u0440\u0443\u0437\u043A\u0430", "New password": "\u041D\u043E\u0432\u044B\u0439 \u043F\u0430\u0440\u043E\u043B\u044C", or: "\u0438\u043B\u0438", Password: "\u041F\u0430\u0440\u043E\u043B\u044C", "Phone Number": "\u041D\u043E\u043C\u0435\u0440 \u0442\u0435\u043B\u0435\u0444\u043E\u043D\u0430", "Resend Code": "\u041E\u0442\u043F\u0440\u0430\u0432\u044C \u0435\u0449\u0435 \u0440\u0430\u0437 \u041A\u043E\u0434", "Reset your password": "\u0441\u0431\u0440\u043E\u0441 \u0432\u0430\u0448 \u043F\u0430\u0440\u043E\u043B\u044C", "Reset your Password": "\u0441\u0431\u0440\u043E\u0441 \u0432\u0430\u0448 \u041F\u0430\u0440\u043E\u043B\u044C", "Send code": "\u041E\u0442\u043F\u0440\u0430\u0432\u043B\u044F\u0442\u044C \u041A\u043E\u0434", "Send Code": "\u041E\u0442\u043F\u0440\u0430\u0432\u043B\u044F\u0442\u044C \u041A\u043E\u0434", Sending: "\u043E\u0442\u043F\u0440\u0430\u0432\u043A\u0430", "Setup TOTP": "\u041D\u0430\u0441\u0442\u0440\u0430\u0438\u0432\u0430\u0442\u044C TOTP", "Show password": "\u041F\u043E\u043A\u0430\u0437\u044B\u0432\u0430\u0442\u044C \u043F\u0430\u0440\u043E\u043B\u044C", "Sign in to your account": "\u0437\u043D\u0430\u043A \u0432 \u0441\u0432\u043E\u0439 \u0430\u043A\u043A\u0430\u0443\u043D\u0442", "Sign In with Amazon": "\u0437\u043D\u0430\u043A \u0432 \u0441 Amazon", "Sign In with Apple": "\u0437\u043D\u0430\u043A \u0432 \u0441 Apple", "Sign In with Facebook": "\u0437\u043D\u0430\u043A \u0432 \u0441 Facebook", "Sign In with Google": "\u0437\u043D\u0430\u043A \u0432 \u0441 Google", "Sign in": "\u0437\u043D\u0430\u043A \u0432", "Sign In": "\u0437\u043D\u0430\u043A \u0432", "Signing in": "\u043F\u043E\u0434\u043F\u0438\u0441\u0430\u043D\u0438\u0435 \u0432", Skip: "\u041F\u0440\u043E\u043F\u0443\u0441\u043A\u0430\u0442\u044C", Submit: "\u041F\u0440\u0435\u0434\u0441\u0442\u0430\u0432\u043B\u044F\u0442\u044C \u043D\u0430 \u0440\u0430\u0441\u0441\u043C\u043E\u0442\u0440\u0435\u043D\u0438\u0435", Submitting: "\u041F\u0440\u0435\u0434\u0441\u0442\u0430\u0432\u0438\u0432", Username: "\u0418\u043C\u044F \u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044F", "Verify Contact": "\u041F\u0440\u043E\u0432\u0435\u0440\u0438\u0442\u044C \u043A\u043E\u043D\u0442\u0430\u043A\u0442", Verify: "\u041F\u0440\u043E\u0432\u0435\u0440\u0438\u0442\u044C", "We Emailed You": "\u041C\u044B \u043E\u0442\u043F\u0440\u0430\u0432\u0438\u043B\u0438 \u0432\u0430\u043C \u044D\u043B\u0435\u043A\u0442\u0440\u043E\u043D\u043D\u043E\u0435 \u043F\u0438\u0441\u044C\u043C\u043E", "We Sent A Code": "\u041C\u044B \u043E\u0442\u043F\u0440\u0430\u0432\u0438\u043B\u0438 \u043A\u043E\u0434", "We Texted You": "\u041C\u044B \u043E\u0442\u043F\u0440\u0430\u0432\u0438\u043B\u0438 \u0432\u0430\u043C \u0442\u0435\u043A\u0441\u0442\u043E\u0432\u043E\u0435 \u0441\u043E\u043E\u0431\u0449\u0435\u043D\u0438\u0435", "Your code is on the way. To log in, enter the code we emailed to": "\u0412\u0430\u0448 \u043A\u043E\u0434 \u043E\u0442\u043F\u0440\u0430\u0432\u043B\u0435\u043D. \u0427\u0442\u043E\u0431\u044B \u0432\u043E\u0439\u0442\u0438 \u0432 \u0441\u0438\u0441\u0442\u0435\u043C\u0443, \u0432\u0432\u0435\u0434\u0438\u0442\u0435 \u043A\u043E\u0434, \u043A\u043E\u0442\u043E\u0440\u044B\u0439 \u043C\u044B \u043E\u0442\u043F\u0440\u0430\u0432\u0438\u043B\u0438 \u043F\u043E \u044D\u043B\u0435\u043A\u0442\u0440\u043E\u043D\u043D\u043E\u0439 \u043F\u043E\u0447\u0442\u0435", "Your code is on the way. To log in, enter the code we sent you": "\u0412\u0430\u0448 \u043A\u043E\u0434 \u043E\u0442\u043F\u0440\u0430\u0432\u043B\u0435\u043D. \u0427\u0442\u043E\u0431\u044B \u0432\u043E\u0439\u0442\u0438 \u0432 \u0441\u0438\u0441\u0442\u0435\u043C\u0443, \u0432\u0432\u0435\u0434\u0438\u0442\u0435 \u043A\u043E\u0434, \u043A\u043E\u0442\u043E\u0440\u044B\u0439 \u043C\u044B \u043F\u043E\u0441\u043B\u0430\u043B\u0438 \u0432\u0430\u043C", "Your code is on the way. To log in, enter the code we texted to": "\u0412\u0430\u0448 \u043A\u043E\u0434 \u043E\u0442\u043F\u0440\u0430\u0432\u043B\u0435\u043D. \u0427\u0442\u043E\u0431\u044B \u0432\u043E\u0439\u0442\u0438 \u0432 \u0441\u0438\u0441\u0442\u0435\u043C\u0443, \u0432\u0432\u0435\u0434\u0438\u0442\u0435 \u043A\u043E\u0434, \u043A\u043E\u0442\u043E\u0440\u044B\u0439 \u043C\u044B \u043E\u0442\u043F\u0440\u0430\u0432\u0438\u043B\u0438 \u0442\u0435\u043A\u0441\u0442\u043E\u0432\u044B\u043C \u0441\u043E\u043E\u0431\u0449\u0435\u043D\u0438\u0435\u043C" };
const n$4 = { "Account recovery requires verified contact information": "\u05E9\u05D7\u05D6\u05D5\u05E8 \u05DC\u05E7\u05D5\u05D7 \u05D3\u05D5\u05E8\u05E9 \u05E2\u05D5\u05D3 \u05DE\u05D9\u05D3\u05E2", "Back to Sign In": "\u05D7\u05D6\u05D5\u05E8 \u05DC\u05D4\u05E8\u05E9\u05DE\u05D4", "Change Password": "\u05E2\u05D3\u05DB\u05D5\u05DF \u05E1\u05D9\u05E1\u05DE\u05D0", Changing: "\u05DE\u05E2\u05D3\u05DB\u05DF", Code: "\u05E7\u05D5\u05D3", "Confirm Password": "\u05D0\u05E9\u05E8 \u05E1\u05D9\u05E1\u05DE\u05D0", "Confirm Sign Up": "\u05D0\u05E9\u05E8 \u05D4\u05E8\u05E9\u05DE\u05D4", "Confirm SMS Code": "\u05D0\u05E9\u05E8 sms \u05E7\u05D5\u05D3", "Confirm TOTP Code": "\u05D0\u05E9\u05E8 totp \u05E7\u05D5\u05D3", Confirm: "\u05D0\u05D9\u05E9\u05D5\u05E8", "Confirmation Code": "\u05D0\u05D9\u05E9\u05D5\u05E8 \u05E7\u05D5\u05D3", Confirming: "\u05DE\u05D0\u05E9\u05E8", "Create a new account": "\u05E6\u05D5\u05E8 \u05DE\u05E9\u05EA\u05DE\u05E9 \u05D7\u05D3\u05E9", "Create Account": "\u05E6\u05D5\u05E8 \u05DE\u05E9\u05EA\u05DE\u05E9", "Creating Account": "\u05D9\u05E6\u05D9\u05E8\u05EA \u05DE\u05E9\u05EA\u05DE\u05E9", "Dismiss alert": "\u05D4\u05E1\u05E8 \u05D4\u05EA\u05E8\u05D0\u05D4", Email: "\u05D0\u05D9\u05DE\u05D9\u05D9\u05DC", "Enter your code": "\u05D4\u05DB\u05E0\u05E1 \u05D0\u05EA \u05D4\u05E7\u05D5\u05D3", "Enter your email": "\u05D4\u05DB\u05E0\u05E1 \u05D0\u05EA \u05D4\u05DE\u05D9\u05D9\u05DC \u05E9\u05DC\u05DA", "Enter your phone number": "\u05D4\u05DB\u05E0\u05E1 \u05D0\u05EA \u05DE\u05E1\u05E4\u05E8 \u05D4\u05D8\u05DC\u05E4\u05D5\u05DF \u05E9\u05DC\u05DA", "Enter your username": "\u05D4\u05DB\u05E0\u05E1 \u05D0\u05EA \u05E9\u05DD \u05D4\u05DE\u05EA\u05DE\u05E9 \u05E9\u05DC\u05DA", "Forgot your password?": "\u05E9\u05D7\u05DB\u05EA \u05E1\u05D9\u05E1\u05DE\u05D0 ?", "Hide password": "\u05D4\u05E1\u05EA\u05E8 \u05E1\u05D9\u05E1\u05DE\u05D0", Loading: "\u05D8\u05D5\u05E2\u05DF", "New password": "\u05E1\u05D9\u05E1\u05DE\u05D0 \u05D7\u05D3\u05E9\u05D4", or: "\u05D0\u05D5\u05B9", Password: "\u05E1\u05D9\u05E1\u05DE\u05D0", "Phone Number": "\u05DE\u05E1\u05E4\u05E8 \u05D8\u05DC\u05E4\u05D5\u05DF", "Resend Code": "\u05E9\u05DC\u05D7 \u05E7\u05D5\u05D3 \u05E9\u05D5\u05D1", "Reset your password": "\u05D0\u05E4\u05E1 \u05E1\u05D9\u05E1\u05DE\u05D0", "Reset your Password": "\u05D0\u05E4\u05E1 \u05E1\u05D9\u05E1\u05DE\u05D0", "Send code": "\u05E9\u05DC\u05D7 \u05E7\u05D5\u05D3", "Send Code": "\u05E9\u05DC\u05D7 \u05E7\u05D5\u05D3", Sending: "\u05E9\u05D5\u05DC\u05D7", "Setup TOTP": "Setup TOTP", "Show password": "\u05D4\u05E6\u05D2 \u05E1\u05D9\u05E1\u05DE\u05D0", "Sign in to your account": "\u05D4\u05EA\u05D7\u05D1\u05E8 \u05DC\u05D7\u05E9\u05D1\u05D5\u05DF \u05E9\u05DC\u05DA", "Sign In with Amazon": "Sign In with Amazon", "Sign In with Apple": "Sign In with Apple", "Sign In with Facebook": "Sign In with Facebook", "Sign In with Google": "Sign In with Google", "Sign in": "\u05D4\u05EA\u05D7\u05D1\u05E8", "Sign In": "\u05D4\u05EA\u05D7\u05D1\u05E8", "Signing in": "\u05DE\u05EA\u05D7\u05D1\u05E8", Skip: "\u05D3\u05DC\u05D2", Submit: "\u05E9\u05DC\u05D7", Submitting: "\u05E9\u05D5\u05DC\u05D7", Username: "\u05E9\u05DD \u05DE\u05E9\u05EA\u05DE\u05E9", "Verify Contact": "\u05D0\u05DE\u05EA \u05D0\u05D9\u05E9 \u05E7\u05E9\u05E8", Verify: "\u05D0\u05DE\u05EA" };
const e$2 = { "Account recovery requires verified contact information": "\u0412\u0456\u0434\u043D\u043E\u0432\u043B\u0435\u043D\u043D\u044F \u043E\u0431\u043B\u0456\u043A\u043E\u0432\u043E\u0433\u043E \u0437\u0430\u043F\u0438\u0441\u0443 \u043F\u043E\u0442\u0440\u0435\u0431\u0443\u0454 \u043A\u043E\u043D\u0442\u0430\u043A\u0442\u043D\u043E\u0457 \u0456\u043D\u0444\u043E\u0440\u043C\u0430\u0446\u0456\u0457", "Back to Sign In": "\u041D\u0430\u0437\u0430\u0434 \u043D\u0430 \u0441\u0442\u043E\u0440\u0456\u043D\u043A\u0443 \u0432\u0445\u043E\u0434\u0443", "Change Password": "\u0417\u043C\u0456\u043D\u0438\u0442\u0438 \u043F\u0430\u0440\u043E\u043B\u044C", Changing: "\u0417\u043C\u0456\u043D\u044E\u0454\u043C\u043E", Code: "\u041A\u043E\u0434", "Confirm Password": "\u041F\u0456\u0434\u0442\u0432\u0435\u0440\u0434\u0456\u0442\u044C \u043F\u0430\u0440\u043E\u043B\u044C", "Confirm Sign Up": "\u041F\u0456\u0434\u0442\u0432\u0435\u0440\u0434\u0456\u0442\u044C \u0440\u0435\u0454\u0441\u0442\u0440\u0430\u0446\u0456\u044E", "Confirm SMS Code": "\u041F\u0456\u0434\u0442\u0432\u0435\u0440\u0434\u0456\u0442\u044C SMS \u043A\u043E\u0434", "Confirm TOTP Code": "\u041F\u0456\u0434\u0442\u0432\u0435\u0440\u0434\u0456\u0442\u044C TOTP \u043A\u043E\u0434", Confirm: "\u041F\u0456\u0434\u0442\u0432\u0435\u0440\u0434\u0438\u0442\u0438", "Confirmation Code": "\u041A\u043E\u0434 \u043F\u0456\u0434\u0442\u0432\u0435\u0440\u0434\u0436\u0435\u043D\u043D\u044F", Confirming: "\u041F\u0456\u0434\u0442\u0432\u0435\u0440\u0434\u0436\u0443\u0454\u043C\u043E", "Create a new account": "\u0417\u0430\u0440\u0435\u0454\u0441\u0442\u0440\u0443\u0432\u0430\u0442\u0438\u0441\u044F", "Create Account": "\u0417\u0430\u0440\u0435\u0454\u0441\u0442\u0440\u0443\u0432\u0430\u0442\u0438\u0441\u044F", "Creating Account": "\u0420\u0435\u0454\u0441\u0442\u0440\u0443\u0454\u043C\u043E", "Dismiss alert": "\u0412\u0456\u0434\u0445\u0438\u043B\u0438\u0442\u0438 \u0441\u043F\u043E\u0432\u0456\u0449\u0435\u043D\u043D\u044F", Email: "Email", "Enter your code": "\u0412\u0432\u0435\u0434\u0456\u0442\u044C \u043A\u043E\u0434", "Enter your email": "\u0412\u0432\u0435\u0434\u0456\u0442\u044C \u0432\u0430\u0448 email", "Enter your phone number": "\u0412\u0432\u0435\u0434\u0456\u0442\u044C \u0432\u0430\u0448 \u043D\u043E\u043C\u0435\u0440 \u0442\u0435\u043B\u0435\u0444\u043E\u043D\u0443", "Enter your username": "\u0412\u0432\u0435\u0434\u0456\u0442\u044C \u0432\u0430\u0448\u0435 \u0456\u043C\u02BC\u044F \u043A\u043E\u0440\u0438\u0441\u0442\u0443\u0432\u0430\u0447\u0430", "Forgot password?": "\u0417\u0430\u0431\u0443\u043B\u0438 \u043F\u0430\u0440\u043E\u043B\u044C?", "Forgot your password?": "\u0417\u0430\u0431\u0443\u043B\u0438 \u0432\u0430\u0448 \u043F\u0430\u0440\u043E\u043B\u044C?", "Hide password": "\u0421\u0445\u043E\u0432\u0430\u0442\u0438 \u043F\u0430\u0440\u043E\u043B\u044C", "It may take a minute to arrive": "\u0414\u043E\u0441\u0442\u0430\u0432\u043A\u0430 \u043C\u043E\u0436\u0435 \u0442\u0440\u0438\u0432\u0430\u0442\u0438 \u0445\u0432\u0438\u043B\u0438\u043D\u0443", Loading: "\u0417\u0430\u0433\u0440\u0443\u0436\u0430\u0454\u043C\u043E", "New password": "\u041D\u043E\u0432\u0438\u0439 \u043F\u0430\u0440\u043E\u043B\u044C", or: "\u0430\u0431\u043E", Password: "\u041F\u0430\u0440\u043E\u043B\u044C", "Phone Number": "\u041D\u043E\u043C\u0435\u0440 \u0422\u0435\u043B\u0435\u0444\u043E\u043D\u0443", "Resend Code": "\u0412\u0456\u0434\u043F\u0440\u0430\u0432\u0438\u0442\u0438 \u043A\u043E\u0434 \u043F\u043E\u0432\u0442\u043E\u0440\u043D\u043E", "Reset your password": "\u0421\u043A\u0438\u043D\u0443\u0442\u0438 \u043F\u0430\u0440\u043E\u043B\u044C", "Reset your Password": "\u0421\u043A\u0438\u043D\u0443\u0442\u0438 \u043F\u0430\u0440\u043E\u043B\u044C", "Send code": "\u0412\u0456\u0434\u043F\u0440\u0430\u0432\u0438\u0442\u0438 \u043A\u043E\u0434", "Send Code": "\u0412\u0456\u0434\u043F\u0440\u0430\u0432\u0438\u0442\u0438 \u043A\u043E\u0434", Sending: "\u0412\u0456\u0434\u043F\u0440\u0430\u0432\u043B\u044F\u0454\u043C\u043E", "Setup TOTP": "\u041D\u0430\u043B\u0430\u0448\u0442\u0443\u0432\u0430\u0442\u0438 TOTP", "Show password": "\u041F\u043E\u043A\u0430\u0437\u0430\u0442\u0438 \u043F\u0430\u0440\u043E\u043B\u044C", "Sign in to your account": "\u0423\u0432\u0456\u0439\u0442\u0438 \u0443 \u0432\u0430\u0448 \u043E\u0431\u043B\u0456\u043A\u043E\u0432\u0438\u0439 \u0437\u0430\u043F\u0438\u0441", "Sign In with Amazon": "\u0423\u0432\u0456\u0439\u0442\u0438 \u0437 Amazon", "Sign In with Apple": "\u0423\u0432\u0456\u0439\u0442\u0438 \u0437 Apple", "Sign In with Facebook": "\u0423\u0432\u0456\u0439\u0442\u0438 \u0437 Facebook", "Sign In with Google": "\u0423\u0432\u0456\u0439\u0442\u0438 \u0437 Google", "Sign in": "\u0423\u0432\u0456\u0439\u0442\u0438", "Sign In": "\u0423\u0432\u0456\u0439\u0442\u0438", "Signing in": "\u0412\u0445\u043E\u0434\u0438\u043C\u043E", Skip: "\u041F\u0440\u043E\u043F\u0443\u0441\u0442\u0438\u0442\u0438", Submit: "\u0412\u0456\u0434\u043F\u0440\u0430\u0432\u0438\u0442\u0438", Submitting: "\u0412\u0456\u0434\u043F\u0440\u0430\u0432\u043B\u044F\u0454\u043C\u043E", Username: "\u0406\u043C\u02BC\u044F \u043A\u043E\u0440\u0438\u0441\u0442\u0443\u0432\u0430\u0447\u0430", "Verify Contact": "\u041F\u0456\u0434\u0442\u0432\u0435\u0440\u0434\u0438\u0442\u0438 \u041A\u043E\u043D\u0442\u0430\u043A\u0442", Verify: "\u041F\u0456\u0434\u0442\u0432\u0435\u0440\u0434\u0438\u0442\u0438", "We Emailed You": "\u041C\u0438 \u0432\u0456\u0434\u043F\u0440\u0430\u0432\u0438\u043B\u0438 \u0432\u0430\u043C Email", "We Sent A Code": "\u041C\u0438 \u0432\u0456\u0434\u043F\u0440\u0430\u0432\u0438\u043B\u0438 \u043A\u043E\u0434", "We Texted You": "\u041C\u0438 \u0432\u0456\u0434\u043F\u0440\u0430\u0432\u0438\u043B\u0438 \u0432\u0430\u043C \u0442\u0435\u043A\u0441\u0442\u043E\u0432\u0435 \u043F\u043E\u0432\u0456\u0434\u043E\u043C\u043B\u0435\u043D\u043D\u044F", "Your code is on the way. To log in, enter the code we emailed to": "\u0412\u0430\u0448 \u043A\u043E\u0434 \u0432\u0436\u0435 \u0432 \u0434\u043E\u0440\u043E\u0437\u0456. \u0429\u043E\u0431 \u0443\u0432\u0456\u0439\u0442\u0438, \u0432\u0432\u0435\u0434\u0456\u0442\u044C \u043A\u043E\u0434, \u0449\u043E \u043C\u0438 \u0432\u0456\u0434\u043F\u0440\u0430\u0432\u0438\u043B\u0438 \u0432\u0430\u043C \u043D\u0430 Email", "Your code is on the way. To log in, enter the code we sent you": "\u0412\u0430\u0448 \u043A\u043E\u0434 \u0432\u0436\u0435 \u0432 \u0434\u043E\u0440\u043E\u0437\u0456. \u0429\u043E\u0431 \u0443\u0432\u0456\u0439\u0442\u0438, \u0432\u0432\u0435\u0434\u0456\u0442\u044C \u043A\u043E\u0434, \u0449\u043E \u043C\u0438 \u0432\u0430\u043C \u0432\u0456\u0434\u043F\u0440\u0430\u0432\u0438\u043B\u0438", "Your code is on the way. To log in, enter the code we texted to": "\u0412\u0430\u0448 \u043A\u043E\u0434 \u0432\u0436\u0435 \u0432 \u0434\u043E\u0440\u043E\u0437\u0456. \u0429\u043E\u0431 \u0443\u0432\u0456\u0439\u0442\u0438, \u0432\u0432\u0435\u0434\u0456\u0442\u044C \u043A\u043E\u0434, \u0449\u043E \u043C\u0438 \u0432\u0456\u0434\u043F\u0440\u0430\u0432\u0438\u043B\u0438 \u0432\u0430\u043C \u0442\u0435\u043A\u0441\u0442\u043E\u0432\u0438\u043C \u043F\u043E\u0432\u0456\u0434\u043E\u043C\u043B\u0435\u043D\u043D\u044F\u043C", "An account with the given email already exists.": "\u041E\u0431\u043B\u0456\u043A\u043E\u0432\u0438\u0439 \u0437\u0430\u043F\u0438\u0441 \u0437 \u0446\u0438\u043C Email \u0432\u0436\u0435 \u0456\u0441\u043D\u0443\u0454.", "Confirm a Code": "\u041F\u0456\u0434\u0442\u0432\u0435\u0440\u0434\u0456\u0442\u044C \u043A\u043E\u0434", "Confirm Sign In": "\u041F\u0456\u0434\u0442\u0432\u0435\u0440\u0434\u0456\u0442\u044C \u0432\u0445\u0456\u0434", "Forgot Password": "\u0417\u0430\u0431\u0443\u043B\u0438 \u043F\u0430\u0440\u043E\u043B\u044C", "Incorrect username or password.": "\u041D\u0435\u0432\u0456\u0440\u043D\u0435 \u0456\u043C\u02BC\u044F \u043A\u043E\u0440\u0438\u0441\u0442\u0443\u0432\u0430\u0447\u0430 \u0430\u0431\u043E \u043F\u0430\u0440\u043E\u043B\u044C", "Invalid password format": "\u041D\u0435\u0432\u0456\u0440\u043D\u0438\u0439 \u0444\u043E\u0440\u043C\u0430\u0442 \u043F\u0430\u0440\u043E\u043B\u044E", "Invalid phone number format": "\u041D\u0435\u0432\u0456\u0440\u043D\u0438\u0439 \u0444\u043E\u0440\u043C\u0430\u0442 \u043D\u043E\u043C\u0435\u0440\u0443 \u0442\u0435\u043B\u0435\u0444\u043E\u043D\u0443", "Loading...": "\u0417\u0430\u0433\u0440\u0443\u0436\u0430\u0454\u043C\u043E...", "New Password": "\u041D\u043E\u0432\u0438\u0439 \u043F\u0430\u0440\u043E\u043B\u044C", "Resend a Code": "\u0412\u0456\u0434\u043F\u0440\u0430\u0432\u0438\u0442\u0438 \u043A\u043E\u0434 \u043F\u043E\u0432\u0442\u043E\u0440\u043D\u043E", "Reset Password": "\u0421\u043A\u0438\u043D\u0443\u0442\u0438 \u043F\u0430\u0440\u043E\u043B\u044C", "Sign Out": "\u0412\u0438\u0439\u0442\u0438", "Sign Up with Amazon": "\u0417\u0430\u0440\u0435\u0454\u0441\u0442\u0440\u0443\u0432\u0430\u0442\u0438\u0441\u044F \u0437 Amazon", "Sign Up with Apple": "\u0417\u0430\u0440\u0435\u0454\u0441\u0442\u0440\u0443\u0432\u0430\u0442\u0438\u0441\u044F \u0437 Apple", "Sign Up with Facebook": "\u0417\u0430\u0440\u0435\u0454\u0441\u0442\u0440\u0443\u0432\u0430\u0442\u0438\u0441\u044F \u0437 Facebook", "Sign Up with Google": "\u0417\u0430\u0440\u0435\u0454\u0441\u0442\u0440\u0443\u0432\u0430\u0442\u0438\u0441\u044F \u0437 Google", "Sign Up": "\u0417\u0430\u0440\u0435\u0454\u0441\u0442\u0440\u0443\u0432\u0430\u0442\u0438\u0441\u044F", "User already exists": "\u041A\u043E\u0440\u0438\u0441\u0442\u0443\u0432\u0430\u0447 \u0432\u0436\u0435 \u0456\u0441\u043D\u0443\u0454", "User does not exist": "\u0422\u0430\u043A\u0438\u0439 \u043A\u043E\u0440\u0438\u0441\u0442\u0443\u0432\u0430\u0447 \u043D\u0435 \u0456\u0441\u043D\u0443\u0454", "Username cannot be empty": "\u0406\u043C\u02BC\u044F \u043A\u043E\u0440\u0438\u0441\u0442\u0443\u0432\u0430\u0447\u0430 \u043D\u0435 \u043C\u043E\u0436\u0435 \u0431\u0443\u0442\u0438 \u043F\u0443\u0441\u0442\u0438\u043C", "Your passwords must match": "\u041F\u0430\u0440\u043E\u043B\u0456 \u043C\u0430\u044E\u0442\u044C \u0437\u0431\u0456\u0433\u0430\u0442\u0438\u0441\u044F" };
const E$2 = { ADD_PROFILE: "Add your Profile", ADD_WEBSITE: "Add your Website", BACK_SIGN_IN: "Back to Sign In", BIRTHDATE: "Birthdate", CHANGE_PASSWORD: "Change Password", CHANGING_PASSWORD: "Changing", CODE: "Code", CODE_ARRIVAL: "It may take a minute to arrive", CODE_EMAILED: "Your code is on the way. To log in, enter the code we emailed to", CODE_SENT: "Your code is on the way. To log in, enter the code we sent you", CODE_TEXTED: "Your code is on the way. To log in, enter the code we texted to", CONFIRM_PASSWORD: "Confirm Password", CONFIRM_PASSWORD_PLACEHOLDER: "Please confirm your Password", CONFIRM_RESET_PASSWORD_HEADING: "Reset your Password", CONFIRM_SIGNUP_HEADING: "Confirm Sign Up", CONFIRM_SMS: "Confirm SMS Code", CONFIRM_TOTP: "Confirm TOTP Code", CONFIRM: "Confirm", CONFIRMATION_CODE: "Confirmation Code", CONFIRMING: "Confirming", CREATE_ACCOUNT: "Create Account", CREATING_ACCOUNT: "Creating Account", EMAIL_ADDRESS: "Email", ENTER_BIRTHDATE: "Enter your Birthdate", ENTER_CODE: "Enter your code", ENTER_CONFIRMATION_CODE: "Enter your Confirmation Code", ENTER_EMAIL: "Enter your Email", ENTER_FAMILY_NAME: "Enter your Family Name", ENTER_GIVEN_NAME: "Enter your Given Name", ENTER_MIDDLE_NAME: "Enter your Middle Name", ENTER_NAME: "Enter your Name", ENTER_NICK_NAME: "Enter your Nickname", ENTER_PASSWORD: "Enter your Password", ENTER_PHONE_NUMBER: "Enter your Phone Number", ENTER_PREFERRED_USERNAME: "Enter your Preferred Username", ENTER_USERNAME: "Enter your username", FAMILY_NAME: "Family Name", GIVEN_NAME: "Given Name", FORGOT_PASSWORD: "Forgot Password?", FORGOT_YOUR_PASSWORD: "Forgot your password?", HIDE_PASSWORD: "Hide password", LOADING: "Loading", LOGIN_NAME: "Username", MIDDLE_NAME: "Middle Name", NAME: "Name", NICKNAME: "Nickname", NEW_PASSWORD: "New password", OR: "or", PASSWORD: "Password", PHONE_NUMBER: "Phone Number", PREFERRED_USERNAME: "Preferred Username", PROFILE: "Profile", RESEND_CODE: "Resend Code", RESET_PASSWORD_HEADING: "Reset your password", RESET_PASSWORD: "Reset Password", SEND_CODE: "Send code", SENDING: "Sending", SETUP_TOTP: "Setup TOTP", SHOW_PASSWORD: "Show password", SIGN_IN_BUTTON: "Sign in", SIGN_IN_TAB: "Sign In", SIGN_IN_WITH_AMAZON: "Sign In with Amazon", SIGN_IN_WITH_APPLE: "Sign In with Apple", SIGN_IN_WITH_FACEBOOK: "Sign In with Facebook", SIGN_IN_WITH_GOOGLE: "Sign In with Google", SIGN_IN: "Sign in to your account", SIGN_UP_BUTTON: "Create a new account", SIGNING_IN_BUTTON: "Signing in", SKIP: "Skip", SUBMIT: "Submit", SUBMITTING: "Submitting", UPPERCASE_COPY: "COPY", VERIFY_CONTACT: "Verify Contact", VERIFY_HEADING: "Account recovery requires verified contact information", VERIFY: "Verify", WE_EMAILED: "We Emailed You", WE_SENT_CODE: "We Sent A Code", WE_TEXTED: "We Texted You", WEBSITE: "Website" };
const D$1 = Object.assign({}, e$d), d$2 = Object.assign({}, e$c), l$2 = Object.assign({}, e$b), x$1 = Object.assign({}, e$a), k$1 = Object.assign({}, o$7), v$2 = Object.assign({}, e$9), z = Object.assign({}, e$8), T$1 = Object.assign({}, e$7), q$1 = Object.assign({}, o$6), w$2 = Object.assign({}, o$5), y$2 = Object.assign({}, e$6), A$1 = Object.assign({}, e$5), B = Object.assign({}, a$3), C$1 = Object.assign({}, e$4), E$1 = Object.assign({}, e$3), F$1 = Object.assign({}, n$4), G = Object.assign({}, e$2), H = Object.assign({}, E$2);
const x = Object.assign({}, H);
function b$2(r2) {
  return I18n.get(r2);
}
const w$1 = { de: D$1, en: d$2, es: l$2, fr: x$1, id: B, it: k$1, ja: v$2, kr: z, ko: z, nl: T$1, pl: q$1, pt: w$2, zh: y$2, sv: A$1, tr: C$1, ru: E$1, he: F$1, ua: G };
const r$3 = { birthdate: { label: "Birthdate", placeholder: "Enter your Birthdate", type: "date", autocomplete: "bday", isRequired: true }, confirmation_code: { label: "Confirmation Code", placeholder: "Enter your Confirmation Code", type: "number", autocomplete: "one-time-code", isRequired: true }, confirm_password: { label: "Confirm Password", placeholder: "Please confirm your Password", type: "password", autocomplete: "new-password", isRequired: true }, email: { label: "Email", placeholder: "Enter your Email", type: "email", autocomplete: "username", isRequired: true }, family_name: { label: "Family Name", placeholder: "Enter your Family Name", type: "text", autocomplete: "family-name", isRequired: true }, given_name: { label: "Given Name", placeholder: "Enter your Given Name", type: "text", autocomplete: "given-name", isRequired: true }, middle_name: { label: "Middle Name", placeholder: "Enter your Middle Name", type: "text", autocomplete: "additional-name", isRequired: true }, name: { label: "Name", placeholder: "Enter your Name", type: "text", autocomplete: "name", isRequired: true }, nickname: { label: "Nickname", placeholder: "Enter your Nickname", type: "text", autocomplete: "tel", isRequired: true }, password: { label: "Password", placeholder: "Enter your Password", type: "password", autocomplete: "new-password", isRequired: true }, phone_number: { label: "Phone Number", placeholder: "Enter your Phone Number", type: "tel", autocomplete: "tel", dialCode: "+1", dialCodeList: o$8, isRequired: true }, preferred_username: { label: "Preferred Username", placeholder: "Enter your Preferred Username", type: "text", isRequired: true }, profile: { label: "Profile", placeholder: "Add your Profile", type: "url", autocomplete: "url", isRequired: true }, website: { label: "Website", placeholder: "Add your Website", type: "url", autocomplete: "url", isRequired: true }, username: { label: "Username", placeholder: "Enter your Username", type: "text", autocomplete: "username", isRequired: true } }, a$2 = ["^", "$", "*", ".", "[", "]", "{", "}", "(", ")", "?", '"', "!", "@", "#", "%", "&", "/", "\\", ",", ">", "<", "'", ":", ";", "|", "_", "~", "`", "=", "+", "-", " "];
const t = (r2) => {
  const t2 = new FormData(r2.target);
  return Object.fromEntries(t2);
}, o$4 = (t2) => r$5.includes(t2), s$3 = (r2) => {
  return r2 ? (t2 = r2, Array.isArray(t2) ? r2 : [r2]) : null;
  var t2;
};
function __rest$2(s2, e2) {
  var t2 = {};
  for (var p2 in s2)
    if (Object.prototype.hasOwnProperty.call(s2, p2) && e2.indexOf(p2) < 0)
      t2[p2] = s2[p2];
  if (s2 != null && typeof Object.getOwnPropertySymbols === "function")
    for (var i2 = 0, p2 = Object.getOwnPropertySymbols(s2); i2 < p2.length; i2++) {
      if (e2.indexOf(p2[i2]) < 0 && Object.prototype.propertyIsEnumerable.call(s2, p2[i2]))
        t2[p2[i2]] = s2[p2[i2]];
    }
  return t2;
}
function __awaiter(thisArg, _arguments, P2, generator) {
  function adopt(value) {
    return value instanceof P2 ? value : new P2(function(resolve) {
      resolve(value);
    });
  }
  return new (P2 || (P2 = Promise))(function(resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e2) {
        reject(e2);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e2) {
        reject(e2);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
}
var commonjsGlobal = typeof globalThis !== "undefined" ? globalThis : typeof window !== "undefined" ? window : typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : {};
var waitFor$1 = {};
var _tslib$1 = {};
(function(exports) {
  Object.defineProperty(exports, "__esModule", { value: true });
  /*! *****************************************************************************
  Copyright (c) Microsoft Corporation.
  
  Permission to use, copy, modify, and/or distribute this software for any
  purpose with or without fee is hereby granted.
  
  THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
  REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
  AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
  INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
  LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
  OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
  PERFORMANCE OF THIS SOFTWARE.
  ***************************************************************************** */
  exports.__assign = function() {
    exports.__assign = Object.assign || function __assign2(t2) {
      for (var s2, i2 = 1, n2 = arguments.length; i2 < n2; i2++) {
        s2 = arguments[i2];
        for (var p2 in s2)
          if (Object.prototype.hasOwnProperty.call(s2, p2))
            t2[p2] = s2[p2];
      }
      return t2;
    };
    return exports.__assign.apply(this, arguments);
  };
  function __rest2(s2, e2) {
    var t2 = {};
    for (var p2 in s2)
      if (Object.prototype.hasOwnProperty.call(s2, p2) && e2.indexOf(p2) < 0)
        t2[p2] = s2[p2];
    if (s2 != null && typeof Object.getOwnPropertySymbols === "function")
      for (var i2 = 0, p2 = Object.getOwnPropertySymbols(s2); i2 < p2.length; i2++) {
        if (e2.indexOf(p2[i2]) < 0 && Object.prototype.propertyIsEnumerable.call(s2, p2[i2]))
          t2[p2[i2]] = s2[p2[i2]];
      }
    return t2;
  }
  function __values2(o2) {
    var s2 = typeof Symbol === "function" && Symbol.iterator, m2 = s2 && o2[s2], i2 = 0;
    if (m2)
      return m2.call(o2);
    if (o2 && typeof o2.length === "number")
      return {
        next: function() {
          if (o2 && i2 >= o2.length)
            o2 = void 0;
          return { value: o2 && o2[i2++], done: !o2 };
        }
      };
    throw new TypeError(s2 ? "Object is not iterable." : "Symbol.iterator is not defined.");
  }
  function __read2(o2, n2) {
    var m2 = typeof Symbol === "function" && o2[Symbol.iterator];
    if (!m2)
      return o2;
    var i2 = m2.call(o2), r2, ar = [], e2;
    try {
      while ((n2 === void 0 || n2-- > 0) && !(r2 = i2.next()).done)
        ar.push(r2.value);
    } catch (error2) {
      e2 = { error: error2 };
    } finally {
      try {
        if (r2 && !r2.done && (m2 = i2["return"]))
          m2.call(i2);
      } finally {
        if (e2)
          throw e2.error;
      }
    }
    return ar;
  }
  function __spreadArray2(to, from, pack) {
    if (pack || arguments.length === 2)
      for (var i2 = 0, l2 = from.length, ar; i2 < l2; i2++) {
        if (ar || !(i2 in from)) {
          if (!ar)
            ar = Array.prototype.slice.call(from, 0, i2);
          ar[i2] = from[i2];
        }
      }
    return to.concat(ar || Array.prototype.slice.call(from));
  }
  exports.__read = __read2;
  exports.__rest = __rest2;
  exports.__spreadArray = __spreadArray2;
  exports.__values = __values2;
})(_tslib$1);
Object.defineProperty(waitFor$1, "__esModule", { value: true });
var _tslib = _tslib$1;
var defaultWaitForOptions = {
  timeout: 1e4
};
function waitFor(actorRef, predicate, options) {
  var resolvedOptions = _tslib.__assign(_tslib.__assign({}, defaultWaitForOptions), options);
  return new Promise(function(res, rej) {
    var done2 = false;
    var handle = resolvedOptions.timeout === Infinity ? void 0 : setTimeout(function() {
      sub.unsubscribe();
      rej(new Error("Timeout of ".concat(resolvedOptions.timeout, " ms exceeded")));
    }, resolvedOptions.timeout);
    var dispose = function() {
      clearTimeout(handle);
      done2 = true;
      sub === null || sub === void 0 ? void 0 : sub.unsubscribe();
    };
    var sub = actorRef.subscribe({
      next: function(emitted) {
        if (predicate(emitted)) {
          dispose();
          res(emitted);
        }
      },
      error: function(err) {
        dispose();
        rej(err);
      },
      complete: function() {
        dispose();
        rej(new Error("Actor terminated without satisfying predicate"));
      }
    });
    if (done2) {
      sub.unsubscribe();
    }
  });
}
var waitFor_2 = waitFor$1.waitFor = waitFor;
const s$2 = ({ packageName: t2, version: e2 }) => {
  appendToCognitoUserAgent(`${t2}/${e2}`);
}, l$1 = (e2) => __awaiter(void 0, void 0, void 0, function* () {
  try {
    yield waitFor_2(e2, (t2) => t$1(t2).matches("autoSignIn"));
  } catch (t2) {
  }
}), d$1 = (e2, a2) => __awaiter(void 0, void 0, void 0, function* () {
  const { send: t2 } = a2, n2 = a2.getSnapshot();
  switch (e2.payload.event) {
    case "tokenRefresh":
      n2.matches("authenticated.idle") && t2("TOKEN_REFRESH");
      break;
    case "autoSignIn":
      if (!n2.matches("authenticated")) {
        yield l$1(a2);
        const n3 = t$1(a2.getSnapshot());
        (null == n3 ? void 0 : n3.matches("autoSignIn")) && t2({ type: "AUTO_SIGN_IN", data: e2.payload.data });
      }
      break;
    case "autoSignIn_failure": {
      yield l$1(a2);
      const n3 = t$1(a2.getSnapshot());
      (null == n3 ? void 0 : n3.matches("autoSignIn")) && t2({ type: "AUTO_SIGN_IN_FAILURE", data: e2.payload.data });
      break;
    }
    case "signOut":
    case "tokenRefresh_failure":
      n2.matches("authenticated.idle") && t2("SIGN_OUT");
  }
}), u$1 = (t2, a2 = d$1) => Hub.listen("auth", ((t3, e2) => (a3) => {
  e2(a3, t3);
})(t2, a2), "authenticator-hub-handler"), h$1 = (t2) => a$2.some((e2) => t2.includes(e2)), m$2 = (t2, e2, a2) => encodeURI(`otpauth://totp/${t2}:${e2}?secret=${a2}&issuer=${t2}`);
function p$2(t2, ...e2) {
  return Object.entries(t2).reduce((t3, [a2, n2]) => Object.assign(Object.assign({}, t3), { [a2]: e2.includes(a2) ? n2 : null == n2 ? void 0 : n2.trim() }), {});
}
const n$3 = (s2, r2) => {
  const { country_code: t2 } = o$a(s2);
  let n2 = r$3[r2];
  const { type: a2 } = n2;
  return "tel" === a2 && (n2 = Object.assign(Object.assign({}, n2), { dialCode: t2 })), n2;
}, a$1 = (o2) => {
  const s2 = i$4(o2);
  return Object.assign(Object.assign({}, n$3(o2, s2)), { autocomplete: "username" });
}, c$2 = (o2) => ({ confirmation_code: Object.assign(Object.assign({}, n$3(o2, "confirmation_code")), { label: "Code *", placeholder: "Code" }) }), i$3 = { signIn: (o2) => ({ username: Object.assign({}, a$1(o2)), password: Object.assign(Object.assign({}, n$3(o2, "password")), { autocomplete: "current-password" }) }), signUp: (o2) => {
  const { loginMechanisms: s2, signUpAttributes: e2 } = o2.context.config, c2 = i$4(o2), i2 = Array.from(/* @__PURE__ */ new Set([...s2, "password", "confirm_password", ...e2])), d2 = {};
  for (const s3 of i2)
    if (o$4(s3)) {
      const e3 = s3 === c2 ? a$1(o2) : n$3(o2, s3);
      d2[s3] = Object.assign({}, e3);
    } else
      console.debug(`Authenticator does not have a default implementation for ${s3}. Customize SignUp FormFields to add your own.`);
  return d2;
}, confirmSignUp: (o2) => ({ confirmation_code: Object.assign(Object.assign({}, n$3(o2, "confirmation_code")), { placeholder: "Enter your code" }) }), confirmSignIn: c$2, forceNewPassword: (o2) => {
  const e2 = t$1(o2), { requiredAttributes: r2 } = e2.context, a2 = Array.from(/* @__PURE__ */ new Set(["password", "confirm_password", ...r2])), c2 = {};
  for (const s2 of a2)
    o$4(s2) ? c2[s2] = Object.assign({}, n$3(o2, s2)) : console.debug(`Authenticator does not have a default implementation for ${s2}. Customize ForceNewPassword FormFields to add your own.`);
  return c2;
}, resetPassword: (o2) => {
  const s2 = i$4(o2), { label: t2 } = r$3[s2];
  return { username: Object.assign(Object.assign({}, a$1(o2)), { label: `Enter your ${t2.toLowerCase()}`, placeholder: `Enter your ${t2.toLowerCase()}` }) };
}, confirmResetPassword: (o2) => Object.assign(Object.assign({}, c$2(o2)), { password: Object.assign(Object.assign({}, n$3(o2, "password")), { label: "New Password", placeholder: "New Password" }), confirm_password: Object.assign(Object.assign({}, n$3(o2, "confirm_password")), { label: "Confirm Password", placeholder: "Confirm Password" }) }), confirmVerifyUser: c$2, setupTOTP: c$2 };
const r$2 = (r2) => {
  const o2 = Object.assign({}, r2);
  for (const [t2, s2] of Object.entries(r2)) {
    const { label: r3, placeholder: n2 } = s2;
    o2[t2] = Object.assign(Object.assign({}, s2), { label: r3 ? b$2(r3) : void 0, placeholder: n2 ? b$2(n2) : void 0 });
  }
  return o2;
}, o$3 = (e2) => Object.entries(e2).sort((e3, r2) => (e3[1].order || Number.MAX_VALUE) - (r2[1].order || Number.MAX_VALUE)).filter((e3) => void 0 !== e3[1]);
const a = (s2, t2) => (0, i$3[s2])(t2), c$1 = (r2, i2) => {
  var o2, a2;
  const c2 = null === (a2 = null === (o2 = o$a(i2)) || void 0 === o2 ? void 0 : o2.formFields) || void 0 === a2 ? void 0 : a2[r2];
  return c2 && 0 !== Object.keys(c2).length ? Object.entries(c2).reduce((t2, [o3, a3]) => {
    if ("signIn" !== r2 && "resetPassword" !== r2 || "username" !== o3) {
      if (i$5(o3)) {
        const s2 = r$3[o3], r3 = Object.assign(Object.assign({}, s2), a3);
        return Object.assign(Object.assign({}, t2), { [o3]: r3 });
      }
      return Object.assign(Object.assign({}, t2), { [o3]: a3 });
    }
    {
      const s2 = a$1(i2), e2 = Object.assign(Object.assign({}, s2), a3);
      return Object.assign(Object.assign({}, t2), { [o3]: e2 });
    }
  }, {}) : {};
}, m$1 = (s2, t2) => {
  const e2 = a(s2, t2), r2 = c$1(s2, t2), n2 = Object.assign(Object.assign({}, e2), r2);
  return delete n2.QR, r$2(n2);
}, j$2 = (s2) => s2.map((s3) => [s3[0], Object.assign(Object.assign({}, s3[1]), { order: void 0 })]), b$1 = (s2, t2) => {
  const e2 = m$1(s2, t2);
  return j$2(o$3(e2));
};
const T = { amazon: "Amazon", apple: "Apple", facebook: "Facebook", google: "Google" }, n$2 = { getBackToSignInText: () => b$2(x.BACK_SIGN_IN), getChangePasswordText: () => b$2(x.CHANGE_PASSWORD), getChangingText: () => b$2(x.CHANGING_PASSWORD), getConfirmText: () => b$2(x.CONFIRM), getConfirmingText: () => b$2(x.CONFIRMING), getCopyText: () => b$2(x.UPPERCASE_COPY), getHidePasswordText: () => b$2(x.HIDE_PASSWORD), getLoadingText: () => b$2(x.LOADING), getOrText: () => b$2(x.OR), getResendCodeText: () => b$2(x.RESEND_CODE), getSendCodeText: () => b$2(x.SEND_CODE), getSendingText: () => b$2(x.SENDING), getShowPasswordText: () => b$2(x.SHOW_PASSWORD), getSubmitText: () => b$2(x.SUBMIT), getSubmittingText: () => b$2(x.SUBMITTING), getSignInTabText: () => b$2(x.SIGN_IN_TAB), getSignUpTabText: () => b$2(x.CREATE_ACCOUNT), getForgotPasswordText: (T2) => b$2(T2 ? x.FORGOT_PASSWORD : x.FORGOT_YOUR_PASSWORD), getSigningInText: () => b$2(x.SIGNING_IN_BUTTON), getSignInText: () => b$2(x.SIGN_IN_BUTTON), getCreatingAccountText: () => b$2(x.CREATING_ACCOUNT), getCreateAccountText: () => b$2(x.CREATE_ACCOUNT), getDeliveryMessageText: (T2) => {
  const { DeliveryMedium: n2, Destination: g2 } = null != T2 ? T2 : {}, S = "EMAIL" === n2, o2 = "SMS" === n2, i2 = b$2(x.CODE_ARRIVAL);
  if (!S && !o2)
    return `${b$2(x.CODE_SENT)}. ${i2}.`;
  return `${b$2(S ? x.CODE_EMAILED : x.CODE_TEXTED)} ${g2}. ${i2}.`;
}, getDeliveryMethodText: (T2) => {
  const { DeliveryMedium: n2 } = null != T2 ? T2 : {}, g2 = "EMAIL" === n2;
  return b$2(g2 || "SMS" !== n2 ? g2 ? x.WE_EMAILED : x.WE_TEXTED : x.WE_SENT_CODE);
}, getChallengeText: (T2) => {
  switch (T2) {
    case "SMS_MFA":
      return b$2(x.CONFIRM_SMS);
    case "SOFTWARE_TOKEN_MFA":
      return b$2(x.CONFIRM_TOTP);
    default:
      throw new Error(`${b$2("Unexpected challengeName encountered in ConfirmSignIn:")} ${T2}`);
  }
}, getResetYourPasswordText: () => b$2(x.RESET_PASSWORD), getSetupTOTPText: () => b$2(x.SETUP_TOTP), getSetupTOTPInstructionsText: () => b$2("Copy and paste the secret key below into an authenticator app and then enter the code in the text field below."), getCopiedText: () => b$2("COPIED"), getSignInWithFederationText: (t2, n2) => b$2(`Sign ${"signIn" === t2 ? "In" : "Up"} with ${T[n2]}`), getSkipText: () => b$2(x.SKIP), getVerifyText: () => b$2(x.VERIFY), getVerifyContactText: () => b$2(x.VERIFY_CONTACT), getAccountRecoveryInfoText: () => b$2(x.VERIFY_HEADING) };
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
var __assign$1 = function() {
  __assign$1 = Object.assign || function __assign2(t2) {
    for (var s2, i2 = 1, n2 = arguments.length; i2 < n2; i2++) {
      s2 = arguments[i2];
      for (var p2 in s2)
        if (Object.prototype.hasOwnProperty.call(s2, p2))
          t2[p2] = s2[p2];
    }
    return t2;
  };
  return __assign$1.apply(this, arguments);
};
function __rest$1(s2, e2) {
  var t2 = {};
  for (var p2 in s2)
    if (Object.prototype.hasOwnProperty.call(s2, p2) && e2.indexOf(p2) < 0)
      t2[p2] = s2[p2];
  if (s2 != null && typeof Object.getOwnPropertySymbols === "function")
    for (var i2 = 0, p2 = Object.getOwnPropertySymbols(s2); i2 < p2.length; i2++) {
      if (e2.indexOf(p2[i2]) < 0 && Object.prototype.propertyIsEnumerable.call(s2, p2[i2]))
        t2[p2[i2]] = s2[p2[i2]];
    }
  return t2;
}
function __values(o2) {
  var s2 = typeof Symbol === "function" && Symbol.iterator, m2 = s2 && o2[s2], i2 = 0;
  if (m2)
    return m2.call(o2);
  if (o2 && typeof o2.length === "number")
    return {
      next: function() {
        if (o2 && i2 >= o2.length)
          o2 = void 0;
        return { value: o2 && o2[i2++], done: !o2 };
      }
    };
  throw new TypeError(s2 ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function __read(o2, n2) {
  var m2 = typeof Symbol === "function" && o2[Symbol.iterator];
  if (!m2)
    return o2;
  var i2 = m2.call(o2), r2, ar = [], e2;
  try {
    while ((n2 === void 0 || n2-- > 0) && !(r2 = i2.next()).done)
      ar.push(r2.value);
  } catch (error2) {
    e2 = { error: error2 };
  } finally {
    try {
      if (r2 && !r2.done && (m2 = i2["return"]))
        m2.call(i2);
    } finally {
      if (e2)
        throw e2.error;
    }
  }
  return ar;
}
function __spreadArray(to, from, pack) {
  if (pack || arguments.length === 2)
    for (var i2 = 0, l2 = from.length, ar; i2 < l2; i2++) {
      if (ar || !(i2 in from)) {
        if (!ar)
          ar = Array.prototype.slice.call(from, 0, i2);
        ar[i2] = from[i2];
      }
    }
  return to.concat(ar || Array.prototype.slice.call(from));
}
var ActionTypes;
(function(ActionTypes2) {
  ActionTypes2["Start"] = "xstate.start";
  ActionTypes2["Stop"] = "xstate.stop";
  ActionTypes2["Raise"] = "xstate.raise";
  ActionTypes2["Send"] = "xstate.send";
  ActionTypes2["Cancel"] = "xstate.cancel";
  ActionTypes2["NullEvent"] = "";
  ActionTypes2["Assign"] = "xstate.assign";
  ActionTypes2["After"] = "xstate.after";
  ActionTypes2["DoneState"] = "done.state";
  ActionTypes2["DoneInvoke"] = "done.invoke";
  ActionTypes2["Log"] = "xstate.log";
  ActionTypes2["Init"] = "xstate.init";
  ActionTypes2["Invoke"] = "xstate.invoke";
  ActionTypes2["ErrorExecution"] = "error.execution";
  ActionTypes2["ErrorCommunication"] = "error.communication";
  ActionTypes2["ErrorPlatform"] = "error.platform";
  ActionTypes2["ErrorCustom"] = "xstate.error";
  ActionTypes2["Update"] = "xstate.update";
  ActionTypes2["Pure"] = "xstate.pure";
  ActionTypes2["Choose"] = "xstate.choose";
})(ActionTypes || (ActionTypes = {}));
var SpecialTargets;
(function(SpecialTargets2) {
  SpecialTargets2["Parent"] = "#_parent";
  SpecialTargets2["Internal"] = "#_internal";
})(SpecialTargets || (SpecialTargets = {}));
var start$1 = ActionTypes.Start;
var stop$1 = ActionTypes.Stop;
var raise$1 = ActionTypes.Raise;
var send$1 = ActionTypes.Send;
var cancel$1 = ActionTypes.Cancel;
var nullEvent = ActionTypes.NullEvent;
var assign$2 = ActionTypes.Assign;
var after$1 = ActionTypes.After;
var doneState = ActionTypes.DoneState;
var log$1 = ActionTypes.Log;
var init = ActionTypes.Init;
var invoke = ActionTypes.Invoke;
var errorExecution = ActionTypes.ErrorExecution;
var errorPlatform = ActionTypes.ErrorPlatform;
var error$1 = ActionTypes.ErrorCustom;
var update = ActionTypes.Update;
var choose$1 = ActionTypes.Choose;
var pure$1 = ActionTypes.Pure;
var actionTypes = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  after: after$1,
  assign: assign$2,
  cancel: cancel$1,
  choose: choose$1,
  doneState,
  error: error$1,
  errorExecution,
  errorPlatform,
  init,
  invoke,
  log: log$1,
  nullEvent,
  pure: pure$1,
  raise: raise$1,
  send: send$1,
  start: start$1,
  stop: stop$1,
  update
}, Symbol.toStringTag, { value: "Module" }));
var STATE_DELIMITER = ".";
var EMPTY_ACTIVITY_MAP = {};
var DEFAULT_GUARD_TYPE = "xstate.guard";
var TARGETLESS_KEY = "";
var IS_PRODUCTION = true;
var _a;
function matchesState(parentStateId, childStateId, delimiter) {
  if (delimiter === void 0) {
    delimiter = STATE_DELIMITER;
  }
  var parentStateValue = toStateValue(parentStateId, delimiter);
  var childStateValue = toStateValue(childStateId, delimiter);
  if (isString(childStateValue)) {
    if (isString(parentStateValue)) {
      return childStateValue === parentStateValue;
    }
    return false;
  }
  if (isString(parentStateValue)) {
    return parentStateValue in childStateValue;
  }
  return Object.keys(parentStateValue).every(function(key) {
    if (!(key in childStateValue)) {
      return false;
    }
    return matchesState(parentStateValue[key], childStateValue[key]);
  });
}
function getEventType(event) {
  try {
    return isString(event) || typeof event === "number" ? "".concat(event) : event.type;
  } catch (e2) {
    throw new Error("Events must be strings or objects with a string event.type property.");
  }
}
function toStatePath(stateId, delimiter) {
  try {
    if (isArray$a(stateId)) {
      return stateId;
    }
    return stateId.toString().split(delimiter);
  } catch (e2) {
    throw new Error("'".concat(stateId, "' is not a valid state path."));
  }
}
function isStateLike(state) {
  return typeof state === "object" && "value" in state && "context" in state && "event" in state && "_event" in state;
}
function toStateValue(stateValue, delimiter) {
  if (isStateLike(stateValue)) {
    return stateValue.value;
  }
  if (isArray$a(stateValue)) {
    return pathToStateValue(stateValue);
  }
  if (typeof stateValue !== "string") {
    return stateValue;
  }
  var statePath = toStatePath(stateValue, delimiter);
  return pathToStateValue(statePath);
}
function pathToStateValue(statePath) {
  if (statePath.length === 1) {
    return statePath[0];
  }
  var value = {};
  var marker = value;
  for (var i2 = 0; i2 < statePath.length - 1; i2++) {
    if (i2 === statePath.length - 2) {
      marker[statePath[i2]] = statePath[i2 + 1];
    } else {
      marker[statePath[i2]] = {};
      marker = marker[statePath[i2]];
    }
  }
  return value;
}
function mapValues(collection, iteratee) {
  var result = {};
  var collectionKeys = Object.keys(collection);
  for (var i2 = 0; i2 < collectionKeys.length; i2++) {
    var key = collectionKeys[i2];
    result[key] = iteratee(collection[key], key, collection, i2);
  }
  return result;
}
function mapFilterValues(collection, iteratee, predicate) {
  var e_1, _a2;
  var result = {};
  try {
    for (var _b = __values(Object.keys(collection)), _c = _b.next(); !_c.done; _c = _b.next()) {
      var key = _c.value;
      var item = collection[key];
      if (!predicate(item)) {
        continue;
      }
      result[key] = iteratee(item, key, collection);
    }
  } catch (e_1_1) {
    e_1 = {
      error: e_1_1
    };
  } finally {
    try {
      if (_c && !_c.done && (_a2 = _b.return))
        _a2.call(_b);
    } finally {
      if (e_1)
        throw e_1.error;
    }
  }
  return result;
}
var path = function(props) {
  return function(object) {
    var e_2, _a2;
    var result = object;
    try {
      for (var props_1 = __values(props), props_1_1 = props_1.next(); !props_1_1.done; props_1_1 = props_1.next()) {
        var prop = props_1_1.value;
        result = result[prop];
      }
    } catch (e_2_1) {
      e_2 = {
        error: e_2_1
      };
    } finally {
      try {
        if (props_1_1 && !props_1_1.done && (_a2 = props_1.return))
          _a2.call(props_1);
      } finally {
        if (e_2)
          throw e_2.error;
      }
    }
    return result;
  };
};
function nestedPath(props, accessorProp) {
  return function(object) {
    var e_3, _a2;
    var result = object;
    try {
      for (var props_2 = __values(props), props_2_1 = props_2.next(); !props_2_1.done; props_2_1 = props_2.next()) {
        var prop = props_2_1.value;
        result = result[accessorProp][prop];
      }
    } catch (e_3_1) {
      e_3 = {
        error: e_3_1
      };
    } finally {
      try {
        if (props_2_1 && !props_2_1.done && (_a2 = props_2.return))
          _a2.call(props_2);
      } finally {
        if (e_3)
          throw e_3.error;
      }
    }
    return result;
  };
}
function toStatePaths(stateValue) {
  if (!stateValue) {
    return [[]];
  }
  if (isString(stateValue)) {
    return [[stateValue]];
  }
  var result = flatten(Object.keys(stateValue).map(function(key) {
    var subStateValue = stateValue[key];
    if (typeof subStateValue !== "string" && (!subStateValue || !Object.keys(subStateValue).length)) {
      return [[key]];
    }
    return toStatePaths(stateValue[key]).map(function(subPath) {
      return [key].concat(subPath);
    });
  }));
  return result;
}
function flatten(array) {
  var _a2;
  return (_a2 = []).concat.apply(_a2, __spreadArray([], __read(array), false));
}
function toArrayStrict(value) {
  if (isArray$a(value)) {
    return value;
  }
  return [value];
}
function toArray(value) {
  if (value === void 0) {
    return [];
  }
  return toArrayStrict(value);
}
function mapContext(mapper, context, _event) {
  var e_5, _a2;
  if (isFunction$4(mapper)) {
    return mapper(context, _event.data);
  }
  var result = {};
  try {
    for (var _b = __values(Object.keys(mapper)), _c = _b.next(); !_c.done; _c = _b.next()) {
      var key = _c.value;
      var subMapper = mapper[key];
      if (isFunction$4(subMapper)) {
        result[key] = subMapper(context, _event.data);
      } else {
        result[key] = subMapper;
      }
    }
  } catch (e_5_1) {
    e_5 = {
      error: e_5_1
    };
  } finally {
    try {
      if (_c && !_c.done && (_a2 = _b.return))
        _a2.call(_b);
    } finally {
      if (e_5)
        throw e_5.error;
    }
  }
  return result;
}
function isBuiltInEvent(eventType) {
  return /^(done|error)\./.test(eventType);
}
function isPromiseLike(value) {
  if (value instanceof Promise) {
    return true;
  }
  if (value !== null && (isFunction$4(value) || typeof value === "object") && isFunction$4(value.then)) {
    return true;
  }
  return false;
}
function isBehavior(value) {
  return value !== null && typeof value === "object" && "transition" in value && typeof value.transition === "function";
}
function partition(items, predicate) {
  var e_6, _a2;
  var _b = __read([[], []], 2), truthy = _b[0], falsy = _b[1];
  try {
    for (var items_1 = __values(items), items_1_1 = items_1.next(); !items_1_1.done; items_1_1 = items_1.next()) {
      var item = items_1_1.value;
      if (predicate(item)) {
        truthy.push(item);
      } else {
        falsy.push(item);
      }
    }
  } catch (e_6_1) {
    e_6 = {
      error: e_6_1
    };
  } finally {
    try {
      if (items_1_1 && !items_1_1.done && (_a2 = items_1.return))
        _a2.call(items_1);
    } finally {
      if (e_6)
        throw e_6.error;
    }
  }
  return [truthy, falsy];
}
function updateHistoryStates(hist, stateValue) {
  return mapValues(hist.states, function(subHist, key) {
    if (!subHist) {
      return void 0;
    }
    var subStateValue = (isString(stateValue) ? void 0 : stateValue[key]) || (subHist ? subHist.current : void 0);
    if (!subStateValue) {
      return void 0;
    }
    return {
      current: subStateValue,
      states: updateHistoryStates(subHist, subStateValue)
    };
  });
}
function updateHistoryValue(hist, stateValue) {
  return {
    current: stateValue,
    states: updateHistoryStates(hist, stateValue)
  };
}
function updateContext(context, _event, assignActions, state) {
  var updatedContext = context ? assignActions.reduce(function(acc, assignAction) {
    var e_7, _a2;
    var assignment = assignAction.assignment;
    var meta = {
      state,
      action: assignAction,
      _event
    };
    var partialUpdate = {};
    if (isFunction$4(assignment)) {
      partialUpdate = assignment(acc, _event.data, meta);
    } else {
      try {
        for (var _b = __values(Object.keys(assignment)), _c = _b.next(); !_c.done; _c = _b.next()) {
          var key = _c.value;
          var propAssignment = assignment[key];
          partialUpdate[key] = isFunction$4(propAssignment) ? propAssignment(acc, _event.data, meta) : propAssignment;
        }
      } catch (e_7_1) {
        e_7 = {
          error: e_7_1
        };
      } finally {
        try {
          if (_c && !_c.done && (_a2 = _b.return))
            _a2.call(_b);
        } finally {
          if (e_7)
            throw e_7.error;
        }
      }
    }
    return Object.assign({}, acc, partialUpdate);
  }, context) : context;
  return updatedContext;
}
var warn = function() {
};
function isArray$a(value) {
  return Array.isArray(value);
}
function isFunction$4(value) {
  return typeof value === "function";
}
function isString(value) {
  return typeof value === "string";
}
function toGuard(condition, guardMap) {
  if (!condition) {
    return void 0;
  }
  if (isString(condition)) {
    return {
      type: DEFAULT_GUARD_TYPE,
      name: condition,
      predicate: guardMap ? guardMap[condition] : void 0
    };
  }
  if (isFunction$4(condition)) {
    return {
      type: DEFAULT_GUARD_TYPE,
      name: condition.name,
      predicate: condition
    };
  }
  return condition;
}
function isObservable(value) {
  try {
    return "subscribe" in value && isFunction$4(value.subscribe);
  } catch (e2) {
    return false;
  }
}
var symbolObservable = /* @__PURE__ */ function() {
  return typeof Symbol === "function" && Symbol.observable || "@@observable";
}();
_a = {}, _a[symbolObservable] = function() {
  return this;
}, _a[Symbol.observable] = function() {
  return this;
}, _a;
function isMachine(value) {
  return !!value && "__xstatenode" in value;
}
function isActor$1(value) {
  return !!value && typeof value.send === "function";
}
var uniqueId = /* @__PURE__ */ function() {
  var currentId = 0;
  return function() {
    currentId++;
    return currentId.toString(16);
  };
}();
function toEventObject(event, payload) {
  if (isString(event) || typeof event === "number") {
    return __assign$1({
      type: event
    }, payload);
  }
  return event;
}
function toSCXMLEvent(event, scxmlEvent) {
  if (!isString(event) && "$$type" in event && event.$$type === "scxml") {
    return event;
  }
  var eventObject = toEventObject(event);
  return __assign$1({
    name: eventObject.type,
    data: eventObject,
    $$type: "scxml",
    type: "external"
  }, scxmlEvent);
}
function toTransitionConfigArray(event, configLike) {
  var transitions = toArrayStrict(configLike).map(function(transitionLike) {
    if (typeof transitionLike === "undefined" || typeof transitionLike === "string" || isMachine(transitionLike)) {
      return {
        target: transitionLike,
        event
      };
    }
    return __assign$1(__assign$1({}, transitionLike), {
      event
    });
  });
  return transitions;
}
function normalizeTarget(target) {
  if (target === void 0 || target === TARGETLESS_KEY) {
    return void 0;
  }
  return toArray(target);
}
function evaluateGuard(machine, guard, context, _event, state) {
  var guards = machine.options.guards;
  var guardMeta = {
    state,
    cond: guard,
    _event
  };
  if (guard.type === DEFAULT_GUARD_TYPE) {
    return ((guards === null || guards === void 0 ? void 0 : guards[guard.name]) || guard.predicate)(context, _event.data, guardMeta);
  }
  var condFn = guards === null || guards === void 0 ? void 0 : guards[guard.type];
  if (!condFn) {
    throw new Error("Guard '".concat(guard.type, "' is not implemented on machine '").concat(machine.id, "'."));
  }
  return condFn(context, _event.data, guardMeta);
}
function toInvokeSource$1(src) {
  if (typeof src === "string") {
    return {
      type: src
    };
  }
  return src;
}
function toObserver$1(nextHandler, errorHandler, completionHandler) {
  var noop2 = function() {
  };
  var isObserver = typeof nextHandler === "object";
  var self2 = isObserver ? nextHandler : null;
  return {
    next: ((isObserver ? nextHandler.next : nextHandler) || noop2).bind(self2),
    error: ((isObserver ? nextHandler.error : errorHandler) || noop2).bind(self2),
    complete: ((isObserver ? nextHandler.complete : completionHandler) || noop2).bind(self2)
  };
}
function createInvokeId(stateNodeId, index2) {
  return "".concat(stateNodeId, ":invocation[").concat(index2, "]");
}
var initEvent = /* @__PURE__ */ toSCXMLEvent({
  type: init
});
function getActionFunction(actionType, actionFunctionMap) {
  return actionFunctionMap ? actionFunctionMap[actionType] || void 0 : void 0;
}
function toActionObject(action, actionFunctionMap) {
  var actionObject;
  if (isString(action) || typeof action === "number") {
    var exec = getActionFunction(action, actionFunctionMap);
    if (isFunction$4(exec)) {
      actionObject = {
        type: action,
        exec
      };
    } else if (exec) {
      actionObject = exec;
    } else {
      actionObject = {
        type: action,
        exec: void 0
      };
    }
  } else if (isFunction$4(action)) {
    actionObject = {
      type: action.name || action.toString(),
      exec: action
    };
  } else {
    var exec = getActionFunction(action.type, actionFunctionMap);
    if (isFunction$4(exec)) {
      actionObject = __assign$1(__assign$1({}, action), {
        exec
      });
    } else if (exec) {
      var actionType = exec.type || action.type;
      actionObject = __assign$1(__assign$1(__assign$1({}, exec), action), {
        type: actionType
      });
    } else {
      actionObject = action;
    }
  }
  return actionObject;
}
var toActionObjects = function(action, actionFunctionMap) {
  if (!action) {
    return [];
  }
  var actions = isArray$a(action) ? action : [action];
  return actions.map(function(subAction) {
    return toActionObject(subAction, actionFunctionMap);
  });
};
function toActivityDefinition(action) {
  var actionObject = toActionObject(action);
  return __assign$1(__assign$1({
    id: isString(action) ? action : actionObject.id
  }, actionObject), {
    type: actionObject.type
  });
}
function raise(event) {
  if (!isString(event)) {
    return send(event, {
      to: SpecialTargets.Internal
    });
  }
  return {
    type: raise$1,
    event
  };
}
function resolveRaise(action) {
  return {
    type: raise$1,
    _event: toSCXMLEvent(action.event)
  };
}
function send(event, options) {
  return {
    to: options ? options.to : void 0,
    type: send$1,
    event: isFunction$4(event) ? event : toEventObject(event),
    delay: options ? options.delay : void 0,
    id: options && options.id !== void 0 ? options.id : isFunction$4(event) ? event.name : getEventType(event)
  };
}
function resolveSend(action, ctx, _event, delaysMap) {
  var meta = {
    _event
  };
  var resolvedEvent = toSCXMLEvent(isFunction$4(action.event) ? action.event(ctx, _event.data, meta) : action.event);
  var resolvedDelay;
  if (isString(action.delay)) {
    var configDelay = delaysMap && delaysMap[action.delay];
    resolvedDelay = isFunction$4(configDelay) ? configDelay(ctx, _event.data, meta) : configDelay;
  } else {
    resolvedDelay = isFunction$4(action.delay) ? action.delay(ctx, _event.data, meta) : action.delay;
  }
  var resolvedTarget = isFunction$4(action.to) ? action.to(ctx, _event.data, meta) : action.to;
  return __assign$1(__assign$1({}, action), {
    to: resolvedTarget,
    _event: resolvedEvent,
    event: resolvedEvent.data,
    delay: resolvedDelay
  });
}
function sendParent(event, options) {
  return send(event, __assign$1(__assign$1({}, options), {
    to: SpecialTargets.Parent
  }));
}
function sendTo(actor, event, options) {
  return send(event, __assign$1(__assign$1({}, options), {
    to: actor
  }));
}
function sendUpdate$1() {
  return sendParent(update);
}
function respond(event, options) {
  return send(event, __assign$1(__assign$1({}, options), {
    to: function(_2, __, _a2) {
      var _event = _a2._event;
      return _event.origin;
    }
  }));
}
var defaultLogExpr = function(context, event) {
  return {
    context,
    event
  };
};
function log(expr, label) {
  if (expr === void 0) {
    expr = defaultLogExpr;
  }
  return {
    type: log$1,
    label,
    expr
  };
}
var resolveLog = function(action, ctx, _event) {
  return __assign$1(__assign$1({}, action), {
    value: isString(action.expr) ? action.expr : action.expr(ctx, _event.data, {
      _event
    })
  });
};
var cancel = function(sendId) {
  return {
    type: cancel$1,
    sendId
  };
};
function start(activity) {
  var activityDef = toActivityDefinition(activity);
  return {
    type: ActionTypes.Start,
    activity: activityDef,
    exec: void 0
  };
}
function stop(actorRef) {
  var activity = isFunction$4(actorRef) ? actorRef : toActivityDefinition(actorRef);
  return {
    type: ActionTypes.Stop,
    activity,
    exec: void 0
  };
}
function resolveStop(action, context, _event) {
  var actorRefOrString = isFunction$4(action.activity) ? action.activity(context, _event.data) : action.activity;
  var resolvedActorRef = typeof actorRefOrString === "string" ? {
    id: actorRefOrString
  } : actorRefOrString;
  var actionObject = {
    type: ActionTypes.Stop,
    activity: resolvedActorRef
  };
  return actionObject;
}
var assign$1 = function(assignment) {
  return {
    type: assign$2,
    assignment
  };
};
function isActionObject(action) {
  return typeof action === "object" && "type" in action;
}
function after(delayRef, id) {
  var idSuffix = id ? "#".concat(id) : "";
  return "".concat(ActionTypes.After, "(").concat(delayRef, ")").concat(idSuffix);
}
function done(id, data) {
  var type = "".concat(ActionTypes.DoneState, ".").concat(id);
  var eventObject = {
    type,
    data
  };
  eventObject.toString = function() {
    return type;
  };
  return eventObject;
}
function doneInvoke(id, data) {
  var type = "".concat(ActionTypes.DoneInvoke, ".").concat(id);
  var eventObject = {
    type,
    data
  };
  eventObject.toString = function() {
    return type;
  };
  return eventObject;
}
function error(id, data) {
  var type = "".concat(ActionTypes.ErrorPlatform, ".").concat(id);
  var eventObject = {
    type,
    data
  };
  eventObject.toString = function() {
    return type;
  };
  return eventObject;
}
function pure(getActions) {
  return {
    type: ActionTypes.Pure,
    get: getActions
  };
}
function forwardTo$1(target, options) {
  return send(function(_2, event) {
    return event;
  }, __assign$1(__assign$1({}, options), {
    to: target
  }));
}
function escalate(errorData, options) {
  return sendParent(function(context, event, meta) {
    return {
      type: error$1,
      data: isFunction$4(errorData) ? errorData(context, event, meta) : errorData
    };
  }, __assign$1(__assign$1({}, options), {
    to: SpecialTargets.Parent
  }));
}
function choose(conds) {
  return {
    type: ActionTypes.Choose,
    conds
  };
}
var pluckAssigns = function(actionBlocks) {
  var e_1, _a2;
  var assignActions = [];
  try {
    for (var actionBlocks_1 = __values(actionBlocks), actionBlocks_1_1 = actionBlocks_1.next(); !actionBlocks_1_1.done; actionBlocks_1_1 = actionBlocks_1.next()) {
      var block = actionBlocks_1_1.value;
      var i2 = 0;
      while (i2 < block.length) {
        if (block[i2].type === assign$2) {
          assignActions.push(block[i2]);
          block.splice(i2, 1);
          continue;
        }
        i2++;
      }
    }
  } catch (e_1_1) {
    e_1 = {
      error: e_1_1
    };
  } finally {
    try {
      if (actionBlocks_1_1 && !actionBlocks_1_1.done && (_a2 = actionBlocks_1.return))
        _a2.call(actionBlocks_1);
    } finally {
      if (e_1)
        throw e_1.error;
    }
  }
  return assignActions;
};
function resolveActions(machine, currentState, currentContext, _event, actionBlocks, predictableExec, preserveActionOrder) {
  if (preserveActionOrder === void 0) {
    preserveActionOrder = false;
  }
  var assignActions = preserveActionOrder ? [] : pluckAssigns(actionBlocks);
  var updatedContext = assignActions.length ? updateContext(currentContext, _event, assignActions, currentState) : currentContext;
  var preservedContexts = preserveActionOrder ? [currentContext] : void 0;
  var deferredToBlockEnd = [];
  function handleAction(actionObject) {
    var _a2;
    switch (actionObject.type) {
      case raise$1: {
        return resolveRaise(actionObject);
      }
      case send$1:
        var sendAction = resolveSend(actionObject, updatedContext, _event, machine.options.delays);
        if (predictableExec && sendAction.to !== SpecialTargets.Internal) {
          deferredToBlockEnd.push(sendAction);
        }
        return sendAction;
      case log$1: {
        var resolved = resolveLog(actionObject, updatedContext, _event);
        predictableExec === null || predictableExec === void 0 ? void 0 : predictableExec(resolved, updatedContext, _event);
        return resolved;
      }
      case choose$1: {
        var chooseAction = actionObject;
        var matchedActions = (_a2 = chooseAction.conds.find(function(condition) {
          var guard = toGuard(condition.cond, machine.options.guards);
          return !guard || evaluateGuard(machine, guard, updatedContext, _event, !predictableExec ? currentState : void 0);
        })) === null || _a2 === void 0 ? void 0 : _a2.actions;
        if (!matchedActions) {
          return [];
        }
        var _b = __read(resolveActions(machine, currentState, updatedContext, _event, [toActionObjects(toArray(matchedActions), machine.options.actions)], predictableExec, preserveActionOrder), 2), resolvedActionsFromChoose = _b[0], resolvedContextFromChoose = _b[1];
        updatedContext = resolvedContextFromChoose;
        preservedContexts === null || preservedContexts === void 0 ? void 0 : preservedContexts.push(updatedContext);
        return resolvedActionsFromChoose;
      }
      case pure$1: {
        var matchedActions = actionObject.get(updatedContext, _event.data);
        if (!matchedActions) {
          return [];
        }
        var _c = __read(resolveActions(machine, currentState, updatedContext, _event, [toActionObjects(toArray(matchedActions), machine.options.actions)], predictableExec, preserveActionOrder), 2), resolvedActionsFromPure = _c[0], resolvedContext = _c[1];
        updatedContext = resolvedContext;
        preservedContexts === null || preservedContexts === void 0 ? void 0 : preservedContexts.push(updatedContext);
        return resolvedActionsFromPure;
      }
      case stop$1: {
        var resolved = resolveStop(actionObject, updatedContext, _event);
        predictableExec === null || predictableExec === void 0 ? void 0 : predictableExec(resolved, currentContext, _event);
        return resolved;
      }
      case assign$2: {
        updatedContext = updateContext(updatedContext, _event, [actionObject], !predictableExec ? currentState : void 0);
        preservedContexts === null || preservedContexts === void 0 ? void 0 : preservedContexts.push(updatedContext);
        break;
      }
      default:
        var resolvedActionObject = toActionObject(actionObject, machine.options.actions);
        var exec_1 = resolvedActionObject.exec;
        if (predictableExec) {
          predictableExec(resolvedActionObject, updatedContext, _event);
        } else if (exec_1 && preservedContexts) {
          var contextIndex_1 = preservedContexts.length - 1;
          resolvedActionObject = __assign$1(__assign$1({}, resolvedActionObject), {
            exec: function(_ctx) {
              var args = [];
              for (var _i = 1; _i < arguments.length; _i++) {
                args[_i - 1] = arguments[_i];
              }
              exec_1.apply(void 0, __spreadArray([preservedContexts[contextIndex_1]], __read(args), false));
            }
          });
        }
        return resolvedActionObject;
    }
  }
  function processBlock(block) {
    var e_2, _a2;
    var resolvedActions2 = [];
    try {
      for (var block_1 = __values(block), block_1_1 = block_1.next(); !block_1_1.done; block_1_1 = block_1.next()) {
        var action = block_1_1.value;
        var resolved = handleAction(action);
        if (resolved) {
          resolvedActions2 = resolvedActions2.concat(resolved);
        }
      }
    } catch (e_2_1) {
      e_2 = {
        error: e_2_1
      };
    } finally {
      try {
        if (block_1_1 && !block_1_1.done && (_a2 = block_1.return))
          _a2.call(block_1);
      } finally {
        if (e_2)
          throw e_2.error;
      }
    }
    deferredToBlockEnd.forEach(function(action2) {
      predictableExec(action2, updatedContext, _event);
    });
    deferredToBlockEnd.length = 0;
    return resolvedActions2;
  }
  var resolvedActions = flatten(actionBlocks.map(processBlock));
  return [resolvedActions, updatedContext];
}
var r$1 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  actionTypes,
  after,
  assign: assign$1,
  cancel,
  choose,
  done,
  doneInvoke,
  error,
  escalate,
  forwardTo: forwardTo$1,
  getActionFunction,
  initEvent,
  isActionObject,
  log,
  pure,
  raise,
  resolveActions,
  resolveLog,
  resolveRaise,
  resolveSend,
  resolveStop,
  respond,
  send,
  sendParent,
  sendTo,
  sendUpdate: sendUpdate$1,
  start,
  stop,
  toActionObject,
  toActionObjects,
  toActivityDefinition
}, Symbol.toStringTag, { value: "Module" }));
var serviceStack = [];
var provide = function(service2, fn) {
  serviceStack.push(service2);
  var result = fn(service2);
  serviceStack.pop();
  return result;
};
var consume = function(fn) {
  return fn(serviceStack[serviceStack.length - 1]);
};
function createNullActor(id) {
  var _a2;
  return _a2 = {
    id,
    send: function() {
      return void 0;
    },
    subscribe: function() {
      return {
        unsubscribe: function() {
          return void 0;
        }
      };
    },
    getSnapshot: function() {
      return void 0;
    },
    toJSON: function() {
      return {
        id
      };
    }
  }, _a2[symbolObservable] = function() {
    return this;
  }, _a2;
}
function createInvocableActor(invokeDefinition, machine, context, _event) {
  var _a2;
  var invokeSrc = toInvokeSource$1(invokeDefinition.src);
  var serviceCreator = (_a2 = machine === null || machine === void 0 ? void 0 : machine.options.services) === null || _a2 === void 0 ? void 0 : _a2[invokeSrc.type];
  var resolvedData = invokeDefinition.data ? mapContext(invokeDefinition.data, context, _event) : void 0;
  var tempActor = serviceCreator ? createDeferredActor(serviceCreator, invokeDefinition.id, resolvedData) : createNullActor(invokeDefinition.id);
  tempActor.meta = invokeDefinition;
  return tempActor;
}
function createDeferredActor(entity, id, data) {
  var tempActor = createNullActor(id);
  tempActor.deferred = true;
  if (isMachine(entity)) {
    var initialState_1 = tempActor.state = provide(void 0, function() {
      return (data ? entity.withContext(data) : entity).initialState;
    });
    tempActor.getSnapshot = function() {
      return initialState_1;
    };
  }
  return tempActor;
}
function isActor(item) {
  try {
    return typeof item.send === "function";
  } catch (e2) {
    return false;
  }
}
function isSpawnedActor(item) {
  return isActor(item) && "id" in item;
}
function toActorRef(actorRefLike) {
  var _a2;
  return __assign$1((_a2 = {
    subscribe: function() {
      return {
        unsubscribe: function() {
          return void 0;
        }
      };
    },
    id: "anonymous",
    getSnapshot: function() {
      return void 0;
    }
  }, _a2[symbolObservable] = function() {
    return this;
  }, _a2), actorRefLike);
}
var isLeafNode = function(stateNode) {
  return stateNode.type === "atomic" || stateNode.type === "final";
};
function getAllChildren(stateNode) {
  return Object.keys(stateNode.states).map(function(key) {
    return stateNode.states[key];
  });
}
function getChildren(stateNode) {
  return getAllChildren(stateNode).filter(function(sn) {
    return sn.type !== "history";
  });
}
function getAllStateNodes(stateNode) {
  var stateNodes = [stateNode];
  if (isLeafNode(stateNode)) {
    return stateNodes;
  }
  return stateNodes.concat(flatten(getChildren(stateNode).map(getAllStateNodes)));
}
function getConfiguration(prevStateNodes, stateNodes) {
  var e_1, _a2, e_2, _b, e_3, _c, e_4, _d;
  var prevConfiguration = new Set(prevStateNodes);
  var prevAdjList = getAdjList(prevConfiguration);
  var configuration = new Set(stateNodes);
  try {
    for (var configuration_1 = __values(configuration), configuration_1_1 = configuration_1.next(); !configuration_1_1.done; configuration_1_1 = configuration_1.next()) {
      var s2 = configuration_1_1.value;
      var m2 = s2.parent;
      while (m2 && !configuration.has(m2)) {
        configuration.add(m2);
        m2 = m2.parent;
      }
    }
  } catch (e_1_1) {
    e_1 = {
      error: e_1_1
    };
  } finally {
    try {
      if (configuration_1_1 && !configuration_1_1.done && (_a2 = configuration_1.return))
        _a2.call(configuration_1);
    } finally {
      if (e_1)
        throw e_1.error;
    }
  }
  var adjList = getAdjList(configuration);
  try {
    for (var configuration_2 = __values(configuration), configuration_2_1 = configuration_2.next(); !configuration_2_1.done; configuration_2_1 = configuration_2.next()) {
      var s2 = configuration_2_1.value;
      if (s2.type === "compound" && (!adjList.get(s2) || !adjList.get(s2).length)) {
        if (prevAdjList.get(s2)) {
          prevAdjList.get(s2).forEach(function(sn) {
            return configuration.add(sn);
          });
        } else {
          s2.initialStateNodes.forEach(function(sn) {
            return configuration.add(sn);
          });
        }
      } else {
        if (s2.type === "parallel") {
          try {
            for (var _e = (e_3 = void 0, __values(getChildren(s2))), _f = _e.next(); !_f.done; _f = _e.next()) {
              var child = _f.value;
              if (!configuration.has(child)) {
                configuration.add(child);
                if (prevAdjList.get(child)) {
                  prevAdjList.get(child).forEach(function(sn) {
                    return configuration.add(sn);
                  });
                } else {
                  child.initialStateNodes.forEach(function(sn) {
                    return configuration.add(sn);
                  });
                }
              }
            }
          } catch (e_3_1) {
            e_3 = {
              error: e_3_1
            };
          } finally {
            try {
              if (_f && !_f.done && (_c = _e.return))
                _c.call(_e);
            } finally {
              if (e_3)
                throw e_3.error;
            }
          }
        }
      }
    }
  } catch (e_2_1) {
    e_2 = {
      error: e_2_1
    };
  } finally {
    try {
      if (configuration_2_1 && !configuration_2_1.done && (_b = configuration_2.return))
        _b.call(configuration_2);
    } finally {
      if (e_2)
        throw e_2.error;
    }
  }
  try {
    for (var configuration_3 = __values(configuration), configuration_3_1 = configuration_3.next(); !configuration_3_1.done; configuration_3_1 = configuration_3.next()) {
      var s2 = configuration_3_1.value;
      var m2 = s2.parent;
      while (m2 && !configuration.has(m2)) {
        configuration.add(m2);
        m2 = m2.parent;
      }
    }
  } catch (e_4_1) {
    e_4 = {
      error: e_4_1
    };
  } finally {
    try {
      if (configuration_3_1 && !configuration_3_1.done && (_d = configuration_3.return))
        _d.call(configuration_3);
    } finally {
      if (e_4)
        throw e_4.error;
    }
  }
  return configuration;
}
function getValueFromAdj(baseNode, adjList) {
  var childStateNodes = adjList.get(baseNode);
  if (!childStateNodes) {
    return {};
  }
  if (baseNode.type === "compound") {
    var childStateNode = childStateNodes[0];
    if (childStateNode) {
      if (isLeafNode(childStateNode)) {
        return childStateNode.key;
      }
    } else {
      return {};
    }
  }
  var stateValue = {};
  childStateNodes.forEach(function(csn) {
    stateValue[csn.key] = getValueFromAdj(csn, adjList);
  });
  return stateValue;
}
function getAdjList(configuration) {
  var e_5, _a2;
  var adjList = /* @__PURE__ */ new Map();
  try {
    for (var configuration_4 = __values(configuration), configuration_4_1 = configuration_4.next(); !configuration_4_1.done; configuration_4_1 = configuration_4.next()) {
      var s2 = configuration_4_1.value;
      if (!adjList.has(s2)) {
        adjList.set(s2, []);
      }
      if (s2.parent) {
        if (!adjList.has(s2.parent)) {
          adjList.set(s2.parent, []);
        }
        adjList.get(s2.parent).push(s2);
      }
    }
  } catch (e_5_1) {
    e_5 = {
      error: e_5_1
    };
  } finally {
    try {
      if (configuration_4_1 && !configuration_4_1.done && (_a2 = configuration_4.return))
        _a2.call(configuration_4);
    } finally {
      if (e_5)
        throw e_5.error;
    }
  }
  return adjList;
}
function getValue$2(rootNode, configuration) {
  var config = getConfiguration([rootNode], configuration);
  return getValueFromAdj(rootNode, getAdjList(config));
}
function has(iterable, item) {
  if (Array.isArray(iterable)) {
    return iterable.some(function(member) {
      return member === item;
    });
  }
  if (iterable instanceof Set) {
    return iterable.has(item);
  }
  return false;
}
function nextEvents(configuration) {
  return __spreadArray([], __read(new Set(flatten(__spreadArray([], __read(configuration.map(function(sn) {
    return sn.ownEvents;
  })), false)))), false);
}
function isInFinalState(configuration, stateNode) {
  if (stateNode.type === "compound") {
    return getChildren(stateNode).some(function(s2) {
      return s2.type === "final" && has(configuration, s2);
    });
  }
  if (stateNode.type === "parallel") {
    return getChildren(stateNode).every(function(sn) {
      return isInFinalState(configuration, sn);
    });
  }
  return false;
}
function getMeta(configuration) {
  if (configuration === void 0) {
    configuration = [];
  }
  return configuration.reduce(function(acc, stateNode) {
    if (stateNode.meta !== void 0) {
      acc[stateNode.id] = stateNode.meta;
    }
    return acc;
  }, {});
}
function getTagsFromConfiguration(configuration) {
  return new Set(flatten(configuration.map(function(sn) {
    return sn.tags;
  })));
}
function stateValuesEqual(a2, b2) {
  if (a2 === b2) {
    return true;
  }
  if (a2 === void 0 || b2 === void 0) {
    return false;
  }
  if (isString(a2) || isString(b2)) {
    return a2 === b2;
  }
  var aKeys = Object.keys(a2);
  var bKeys = Object.keys(b2);
  return aKeys.length === bKeys.length && aKeys.every(function(key) {
    return stateValuesEqual(a2[key], b2[key]);
  });
}
function isStateConfig(state) {
  if (typeof state !== "object" || state === null) {
    return false;
  }
  return "value" in state && "_event" in state;
}
function bindActionToState(action, state) {
  var exec = action.exec;
  var boundAction = __assign$1(__assign$1({}, action), {
    exec: exec !== void 0 ? function() {
      return exec(state.context, state.event, {
        action,
        state,
        _event: state._event
      });
    } : void 0
  });
  return boundAction;
}
var State = /* @__PURE__ */ function() {
  function State2(config) {
    var _this = this;
    var _a2;
    this.actions = [];
    this.activities = EMPTY_ACTIVITY_MAP;
    this.meta = {};
    this.events = [];
    this.value = config.value;
    this.context = config.context;
    this._event = config._event;
    this._sessionid = config._sessionid;
    this.event = this._event.data;
    this.historyValue = config.historyValue;
    this.history = config.history;
    this.actions = config.actions || [];
    this.activities = config.activities || EMPTY_ACTIVITY_MAP;
    this.meta = getMeta(config.configuration);
    this.events = config.events || [];
    this.matches = this.matches.bind(this);
    this.toStrings = this.toStrings.bind(this);
    this.configuration = config.configuration;
    this.transitions = config.transitions;
    this.children = config.children;
    this.done = !!config.done;
    this.tags = (_a2 = Array.isArray(config.tags) ? new Set(config.tags) : config.tags) !== null && _a2 !== void 0 ? _a2 : /* @__PURE__ */ new Set();
    this.machine = config.machine;
    Object.defineProperty(this, "nextEvents", {
      get: function() {
        return nextEvents(_this.configuration);
      }
    });
  }
  State2.from = function(stateValue, context) {
    if (stateValue instanceof State2) {
      if (stateValue.context !== context) {
        return new State2({
          value: stateValue.value,
          context,
          _event: stateValue._event,
          _sessionid: null,
          historyValue: stateValue.historyValue,
          history: stateValue.history,
          actions: [],
          activities: stateValue.activities,
          meta: {},
          events: [],
          configuration: [],
          transitions: [],
          children: {}
        });
      }
      return stateValue;
    }
    var _event = initEvent;
    return new State2({
      value: stateValue,
      context,
      _event,
      _sessionid: null,
      historyValue: void 0,
      history: void 0,
      actions: [],
      activities: void 0,
      meta: void 0,
      events: [],
      configuration: [],
      transitions: [],
      children: {}
    });
  };
  State2.create = function(config) {
    return new State2(config);
  };
  State2.inert = function(stateValue, context) {
    if (stateValue instanceof State2) {
      if (!stateValue.actions.length) {
        return stateValue;
      }
      var _event = initEvent;
      return new State2({
        value: stateValue.value,
        context,
        _event,
        _sessionid: null,
        historyValue: stateValue.historyValue,
        history: stateValue.history,
        activities: stateValue.activities,
        configuration: stateValue.configuration,
        transitions: [],
        children: {}
      });
    }
    return State2.from(stateValue, context);
  };
  State2.prototype.toStrings = function(stateValue, delimiter) {
    var _this = this;
    if (stateValue === void 0) {
      stateValue = this.value;
    }
    if (delimiter === void 0) {
      delimiter = ".";
    }
    if (isString(stateValue)) {
      return [stateValue];
    }
    var valueKeys = Object.keys(stateValue);
    return valueKeys.concat.apply(valueKeys, __spreadArray([], __read(valueKeys.map(function(key) {
      return _this.toStrings(stateValue[key], delimiter).map(function(s2) {
        return key + delimiter + s2;
      });
    })), false));
  };
  State2.prototype.toJSON = function() {
    var _a2 = this;
    _a2.configuration;
    _a2.transitions;
    var tags = _a2.tags;
    _a2.machine;
    var jsonValues = __rest$1(_a2, ["configuration", "transitions", "tags", "machine"]);
    return __assign$1(__assign$1({}, jsonValues), {
      tags: Array.from(tags)
    });
  };
  State2.prototype.matches = function(parentStateValue) {
    return matchesState(parentStateValue, this.value);
  };
  State2.prototype.hasTag = function(tag) {
    return this.tags.has(tag);
  };
  State2.prototype.can = function(event) {
    var _a2;
    if (IS_PRODUCTION) {
      warn(!!this.machine);
    }
    var transitionData = (_a2 = this.machine) === null || _a2 === void 0 ? void 0 : _a2.getTransitionData(this, event);
    return !!(transitionData === null || transitionData === void 0 ? void 0 : transitionData.transitions.length) && transitionData.transitions.some(function(t2) {
      return t2.target !== void 0 || t2.actions.length;
    });
  };
  return State2;
}();
var defaultOptions = {
  deferEvents: false
};
var Scheduler = /* @__PURE__ */ function() {
  function Scheduler2(options) {
    this.processingEvent = false;
    this.queue = [];
    this.initialized = false;
    this.options = __assign$1(__assign$1({}, defaultOptions), options);
  }
  Scheduler2.prototype.initialize = function(callback) {
    this.initialized = true;
    if (callback) {
      if (!this.options.deferEvents) {
        this.schedule(callback);
        return;
      }
      this.process(callback);
    }
    this.flushEvents();
  };
  Scheduler2.prototype.schedule = function(task) {
    if (!this.initialized || this.processingEvent) {
      this.queue.push(task);
      return;
    }
    if (this.queue.length !== 0) {
      throw new Error("Event queue should be empty when it is not processing events");
    }
    this.process(task);
    this.flushEvents();
  };
  Scheduler2.prototype.clear = function() {
    this.queue = [];
  };
  Scheduler2.prototype.flushEvents = function() {
    var nextCallback = this.queue.shift();
    while (nextCallback) {
      this.process(nextCallback);
      nextCallback = this.queue.shift();
    }
  };
  Scheduler2.prototype.process = function(callback) {
    this.processingEvent = true;
    try {
      callback();
    } catch (e2) {
      this.clear();
      throw e2;
    } finally {
      this.processingEvent = false;
    }
  };
  return Scheduler2;
}();
var children = /* @__PURE__ */ new Map();
var sessionIdIndex = 0;
var registry = {
  bookId: function() {
    return "x:".concat(sessionIdIndex++);
  },
  register: function(id, actor) {
    children.set(id, actor);
    return id;
  },
  get: function(id) {
    return children.get(id);
  },
  free: function(id) {
    children.delete(id);
  }
};
function getGlobal() {
  if (typeof globalThis !== "undefined") {
    return globalThis;
  }
  if (typeof self !== "undefined") {
    return self;
  }
  if (typeof window !== "undefined") {
    return window;
  }
  if (typeof global !== "undefined") {
    return global;
  }
}
function getDevTools() {
  var global2 = getGlobal();
  if (global2 && "__xstate__" in global2) {
    return global2.__xstate__;
  }
  return void 0;
}
function registerService(service2) {
  if (!getGlobal()) {
    return;
  }
  var devTools = getDevTools();
  if (devTools) {
    devTools.register(service2);
  }
}
function spawnBehavior(behavior, options) {
  if (options === void 0) {
    options = {};
  }
  var state = behavior.initialState;
  var observers = /* @__PURE__ */ new Set();
  var mailbox = [];
  var flushing = false;
  var flush = function() {
    if (flushing) {
      return;
    }
    flushing = true;
    while (mailbox.length > 0) {
      var event_1 = mailbox.shift();
      state = behavior.transition(state, event_1, actorCtx);
      observers.forEach(function(observer) {
        return observer.next(state);
      });
    }
    flushing = false;
  };
  var actor = toActorRef({
    id: options.id,
    send: function(event) {
      mailbox.push(event);
      flush();
    },
    getSnapshot: function() {
      return state;
    },
    subscribe: function(next, handleError, complete) {
      var observer = toObserver$1(next, handleError, complete);
      observers.add(observer);
      observer.next(state);
      return {
        unsubscribe: function() {
          observers.delete(observer);
        }
      };
    }
  });
  var actorCtx = {
    parent: options.parent,
    self: actor,
    id: options.id || "anonymous",
    observers
  };
  state = behavior.start ? behavior.start(actorCtx) : state;
  return actor;
}
var DEFAULT_SPAWN_OPTIONS = {
  sync: false,
  autoForward: false
};
var InterpreterStatus;
(function(InterpreterStatus2) {
  InterpreterStatus2[InterpreterStatus2["NotStarted"] = 0] = "NotStarted";
  InterpreterStatus2[InterpreterStatus2["Running"] = 1] = "Running";
  InterpreterStatus2[InterpreterStatus2["Stopped"] = 2] = "Stopped";
})(InterpreterStatus || (InterpreterStatus = {}));
var Interpreter = /* @__PURE__ */ function() {
  function Interpreter2(machine, options) {
    if (options === void 0) {
      options = Interpreter2.defaultOptions;
    }
    var _this = this;
    this.machine = machine;
    this.delayedEventsMap = {};
    this.listeners = /* @__PURE__ */ new Set();
    this.contextListeners = /* @__PURE__ */ new Set();
    this.stopListeners = /* @__PURE__ */ new Set();
    this.doneListeners = /* @__PURE__ */ new Set();
    this.eventListeners = /* @__PURE__ */ new Set();
    this.sendListeners = /* @__PURE__ */ new Set();
    this.initialized = false;
    this.status = InterpreterStatus.NotStarted;
    this.children = /* @__PURE__ */ new Map();
    this.forwardTo = /* @__PURE__ */ new Set();
    this._outgoingQueue = [];
    this.init = this.start;
    this.send = function(event, payload) {
      if (isArray$a(event)) {
        _this.batch(event);
        return _this.state;
      }
      var _event = toSCXMLEvent(toEventObject(event, payload));
      if (_this.status === InterpreterStatus.Stopped) {
        return _this.state;
      }
      if (_this.status !== InterpreterStatus.Running && !_this.options.deferEvents) {
        throw new Error('Event "'.concat(_event.name, '" was sent to uninitialized service "').concat(
          _this.machine.id,
          '". Make sure .start() is called for this service, or set { deferEvents: true } in the service options.\nEvent: '
        ).concat(JSON.stringify(_event.data)));
      }
      _this.scheduler.schedule(function() {
        _this.forward(_event);
        var nextState = _this._nextState(_event);
        _this.update(nextState, _event);
      });
      return _this._state;
    };
    this.sendTo = function(event, to, immediate) {
      var isParent = _this.parent && (to === SpecialTargets.Parent || _this.parent.id === to);
      var target = isParent ? _this.parent : isString(to) ? _this.children.get(to) || registry.get(to) : isActor$1(to) ? to : void 0;
      if (!target) {
        if (!isParent) {
          throw new Error("Unable to send event to child '".concat(to, "' from service '").concat(_this.id, "'."));
        }
        return;
      }
      if ("machine" in target) {
        if (_this.status !== InterpreterStatus.Stopped || _this.parent !== target || _this.state.done) {
          var scxmlEvent = __assign$1(__assign$1({}, event), {
            name: event.name === error$1 ? "".concat(error(_this.id)) : event.name,
            origin: _this.sessionId
          });
          if (!immediate && _this.machine.config.predictableActionArguments) {
            _this._outgoingQueue.push([target, scxmlEvent]);
          } else {
            target.send(scxmlEvent);
          }
        }
      } else {
        if (!immediate && _this.machine.config.predictableActionArguments) {
          _this._outgoingQueue.push([target, event.data]);
        } else {
          target.send(event.data);
        }
      }
    };
    this._exec = function(action, context, _event, actionFunctionMap) {
      if (actionFunctionMap === void 0) {
        actionFunctionMap = _this.machine.options.actions;
      }
      var actionOrExec = action.exec || getActionFunction(action.type, actionFunctionMap);
      var exec = isFunction$4(actionOrExec) ? actionOrExec : actionOrExec ? actionOrExec.exec : action.exec;
      if (exec) {
        try {
          return exec(context, _event.data, !_this.machine.config.predictableActionArguments ? {
            action,
            state: _this.state,
            _event
          } : {
            action,
            _event
          });
        } catch (err) {
          if (_this.parent) {
            _this.parent.send({
              type: "xstate.error",
              data: err
            });
          }
          throw err;
        }
      }
      switch (action.type) {
        case send$1:
          var sendAction = action;
          if (typeof sendAction.delay === "number") {
            _this.defer(sendAction);
            return;
          } else {
            if (sendAction.to) {
              _this.sendTo(sendAction._event, sendAction.to, _event === initEvent);
            } else {
              _this.send(sendAction._event);
            }
          }
          break;
        case cancel$1:
          _this.cancel(action.sendId);
          break;
        case start$1: {
          if (_this.status !== InterpreterStatus.Running) {
            return;
          }
          var activity = action.activity;
          if (!_this.machine.config.predictableActionArguments && !_this.state.activities[activity.id || activity.type]) {
            break;
          }
          if (activity.type === ActionTypes.Invoke) {
            var invokeSource = toInvokeSource$1(activity.src);
            var serviceCreator = _this.machine.options.services ? _this.machine.options.services[invokeSource.type] : void 0;
            var id2 = activity.id, data = activity.data;
            var autoForward = "autoForward" in activity ? activity.autoForward : !!activity.forward;
            if (!serviceCreator) {
              return;
            }
            var resolvedData = data ? mapContext(data, context, _event) : void 0;
            if (typeof serviceCreator === "string") {
              return;
            }
            var source = isFunction$4(serviceCreator) ? serviceCreator(context, _event.data, {
              data: resolvedData,
              src: invokeSource,
              meta: activity.meta
            }) : serviceCreator;
            if (!source) {
              return;
            }
            var options2 = void 0;
            if (isMachine(source)) {
              source = resolvedData ? source.withContext(resolvedData) : source;
              options2 = {
                autoForward
              };
            }
            _this.spawn(source, id2, options2);
          } else {
            _this.spawnActivity(activity);
          }
          break;
        }
        case stop$1: {
          _this.stopChild(action.activity.id);
          break;
        }
        case log$1:
          var label = action.label, value = action.value;
          if (label) {
            _this.logger(label, value);
          } else {
            _this.logger(value);
          }
          break;
      }
    };
    var resolvedOptions = __assign$1(__assign$1({}, Interpreter2.defaultOptions), options);
    var clock = resolvedOptions.clock, logger = resolvedOptions.logger, parent = resolvedOptions.parent, id = resolvedOptions.id;
    var resolvedId = id !== void 0 ? id : machine.id;
    this.id = resolvedId;
    this.logger = logger;
    this.clock = clock;
    this.parent = parent;
    this.options = resolvedOptions;
    this.scheduler = new Scheduler({
      deferEvents: this.options.deferEvents
    });
    this.sessionId = registry.bookId();
  }
  Object.defineProperty(Interpreter2.prototype, "initialState", {
    get: function() {
      var _this = this;
      if (this._initialState) {
        return this._initialState;
      }
      return provide(this, function() {
        _this._initialState = _this.machine.initialState;
        return _this._initialState;
      });
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(Interpreter2.prototype, "state", {
    get: function() {
      return this._state;
    },
    enumerable: false,
    configurable: true
  });
  Interpreter2.prototype.execute = function(state, actionsConfig) {
    var e_1, _a2;
    try {
      for (var _b = __values(state.actions), _c = _b.next(); !_c.done; _c = _b.next()) {
        var action = _c.value;
        this.exec(action, state, actionsConfig);
      }
    } catch (e_1_1) {
      e_1 = {
        error: e_1_1
      };
    } finally {
      try {
        if (_c && !_c.done && (_a2 = _b.return))
          _a2.call(_b);
      } finally {
        if (e_1)
          throw e_1.error;
      }
    }
  };
  Interpreter2.prototype.update = function(state, _event) {
    var e_2, _a2, e_3, _b, e_4, _c, e_5, _d;
    var _this = this;
    state._sessionid = this.sessionId;
    this._state = state;
    if ((!this.machine.config.predictableActionArguments || _event === initEvent) && this.options.execute) {
      this.execute(this.state);
    } else {
      var item = void 0;
      while (item = this._outgoingQueue.shift()) {
        item[0].send(item[1]);
      }
    }
    this.children.forEach(function(child) {
      _this.state.children[child.id] = child;
    });
    if (this.devTools) {
      this.devTools.send(_event.data, state);
    }
    if (state.event) {
      try {
        for (var _e = __values(this.eventListeners), _f = _e.next(); !_f.done; _f = _e.next()) {
          var listener = _f.value;
          listener(state.event);
        }
      } catch (e_2_1) {
        e_2 = {
          error: e_2_1
        };
      } finally {
        try {
          if (_f && !_f.done && (_a2 = _e.return))
            _a2.call(_e);
        } finally {
          if (e_2)
            throw e_2.error;
        }
      }
    }
    try {
      for (var _g = __values(this.listeners), _h = _g.next(); !_h.done; _h = _g.next()) {
        var listener = _h.value;
        listener(state, state.event);
      }
    } catch (e_3_1) {
      e_3 = {
        error: e_3_1
      };
    } finally {
      try {
        if (_h && !_h.done && (_b = _g.return))
          _b.call(_g);
      } finally {
        if (e_3)
          throw e_3.error;
      }
    }
    try {
      for (var _j = __values(this.contextListeners), _k = _j.next(); !_k.done; _k = _j.next()) {
        var contextListener = _k.value;
        contextListener(this.state.context, this.state.history ? this.state.history.context : void 0);
      }
    } catch (e_4_1) {
      e_4 = {
        error: e_4_1
      };
    } finally {
      try {
        if (_k && !_k.done && (_c = _j.return))
          _c.call(_j);
      } finally {
        if (e_4)
          throw e_4.error;
      }
    }
    if (this.state.done) {
      var finalChildStateNode = state.configuration.find(function(sn) {
        return sn.type === "final" && sn.parent === _this.machine;
      });
      var doneData = finalChildStateNode && finalChildStateNode.doneData ? mapContext(finalChildStateNode.doneData, state.context, _event) : void 0;
      try {
        for (var _l = __values(this.doneListeners), _m = _l.next(); !_m.done; _m = _l.next()) {
          var listener = _m.value;
          listener(doneInvoke(this.id, doneData));
        }
      } catch (e_5_1) {
        e_5 = {
          error: e_5_1
        };
      } finally {
        try {
          if (_m && !_m.done && (_d = _l.return))
            _d.call(_l);
        } finally {
          if (e_5)
            throw e_5.error;
        }
      }
      this._stop();
      this._stopChildren();
    }
  };
  Interpreter2.prototype.onTransition = function(listener) {
    this.listeners.add(listener);
    if (this.status === InterpreterStatus.Running) {
      listener(this.state, this.state.event);
    }
    return this;
  };
  Interpreter2.prototype.subscribe = function(nextListenerOrObserver, _2, completeListener) {
    var _this = this;
    var observer = toObserver$1(nextListenerOrObserver, _2, completeListener);
    this.listeners.add(observer.next);
    if (this.status !== InterpreterStatus.NotStarted) {
      observer.next(this.state);
    }
    var completeOnce = function() {
      _this.doneListeners.delete(completeOnce);
      _this.stopListeners.delete(completeOnce);
      observer.complete();
    };
    if (this.status === InterpreterStatus.Stopped) {
      observer.complete();
    } else {
      this.onDone(completeOnce);
      this.onStop(completeOnce);
    }
    return {
      unsubscribe: function() {
        _this.listeners.delete(observer.next);
        _this.doneListeners.delete(completeOnce);
        _this.stopListeners.delete(completeOnce);
      }
    };
  };
  Interpreter2.prototype.onEvent = function(listener) {
    this.eventListeners.add(listener);
    return this;
  };
  Interpreter2.prototype.onSend = function(listener) {
    this.sendListeners.add(listener);
    return this;
  };
  Interpreter2.prototype.onChange = function(listener) {
    this.contextListeners.add(listener);
    return this;
  };
  Interpreter2.prototype.onStop = function(listener) {
    this.stopListeners.add(listener);
    return this;
  };
  Interpreter2.prototype.onDone = function(listener) {
    this.doneListeners.add(listener);
    return this;
  };
  Interpreter2.prototype.off = function(listener) {
    this.listeners.delete(listener);
    this.eventListeners.delete(listener);
    this.sendListeners.delete(listener);
    this.stopListeners.delete(listener);
    this.doneListeners.delete(listener);
    this.contextListeners.delete(listener);
    return this;
  };
  Interpreter2.prototype.start = function(initialState) {
    var _this = this;
    if (this.status === InterpreterStatus.Running) {
      return this;
    }
    this.machine._init();
    registry.register(this.sessionId, this);
    this.initialized = true;
    this.status = InterpreterStatus.Running;
    var resolvedState = initialState === void 0 ? this.initialState : provide(this, function() {
      return isStateConfig(initialState) ? _this.machine.resolveState(initialState) : _this.machine.resolveState(State.from(initialState, _this.machine.context));
    });
    if (this.options.devTools) {
      this.attachDev();
    }
    this.scheduler.initialize(function() {
      _this.update(resolvedState, initEvent);
    });
    return this;
  };
  Interpreter2.prototype._stopChildren = function() {
    this.children.forEach(function(child) {
      if (isFunction$4(child.stop)) {
        child.stop();
      }
    });
    this.children.clear();
  };
  Interpreter2.prototype._stop = function() {
    var e_6, _a2, e_7, _b, e_8, _c, e_9, _d, e_10, _e;
    try {
      for (var _f = __values(this.listeners), _g = _f.next(); !_g.done; _g = _f.next()) {
        var listener = _g.value;
        this.listeners.delete(listener);
      }
    } catch (e_6_1) {
      e_6 = {
        error: e_6_1
      };
    } finally {
      try {
        if (_g && !_g.done && (_a2 = _f.return))
          _a2.call(_f);
      } finally {
        if (e_6)
          throw e_6.error;
      }
    }
    try {
      for (var _h = __values(this.stopListeners), _j = _h.next(); !_j.done; _j = _h.next()) {
        var listener = _j.value;
        listener();
        this.stopListeners.delete(listener);
      }
    } catch (e_7_1) {
      e_7 = {
        error: e_7_1
      };
    } finally {
      try {
        if (_j && !_j.done && (_b = _h.return))
          _b.call(_h);
      } finally {
        if (e_7)
          throw e_7.error;
      }
    }
    try {
      for (var _k = __values(this.contextListeners), _l = _k.next(); !_l.done; _l = _k.next()) {
        var listener = _l.value;
        this.contextListeners.delete(listener);
      }
    } catch (e_8_1) {
      e_8 = {
        error: e_8_1
      };
    } finally {
      try {
        if (_l && !_l.done && (_c = _k.return))
          _c.call(_k);
      } finally {
        if (e_8)
          throw e_8.error;
      }
    }
    try {
      for (var _m = __values(this.doneListeners), _o = _m.next(); !_o.done; _o = _m.next()) {
        var listener = _o.value;
        this.doneListeners.delete(listener);
      }
    } catch (e_9_1) {
      e_9 = {
        error: e_9_1
      };
    } finally {
      try {
        if (_o && !_o.done && (_d = _m.return))
          _d.call(_m);
      } finally {
        if (e_9)
          throw e_9.error;
      }
    }
    if (!this.initialized) {
      return this;
    }
    this.initialized = false;
    this.status = InterpreterStatus.Stopped;
    this._initialState = void 0;
    try {
      for (var _p = __values(Object.keys(this.delayedEventsMap)), _q = _p.next(); !_q.done; _q = _p.next()) {
        var key = _q.value;
        this.clock.clearTimeout(this.delayedEventsMap[key]);
      }
    } catch (e_10_1) {
      e_10 = {
        error: e_10_1
      };
    } finally {
      try {
        if (_q && !_q.done && (_e = _p.return))
          _e.call(_p);
      } finally {
        if (e_10)
          throw e_10.error;
      }
    }
    this.scheduler.clear();
    this.scheduler = new Scheduler({
      deferEvents: this.options.deferEvents
    });
  };
  Interpreter2.prototype.stop = function() {
    var _this = this;
    var scheduler = this.scheduler;
    this._stop();
    scheduler.schedule(function() {
      var _event = toSCXMLEvent({
        type: "xstate.stop"
      });
      var nextState = provide(_this, function() {
        var exitActions = flatten(__spreadArray([], __read(_this.state.configuration), false).sort(function(a2, b2) {
          return b2.order - a2.order;
        }).map(function(stateNode) {
          return toActionObjects(stateNode.onExit, _this.machine.options.actions);
        }));
        var _a2 = __read(resolveActions(_this.machine, _this.state, _this.state.context, _event, [exitActions], _this.machine.config.predictableActionArguments ? _this._exec : void 0, _this.machine.config.predictableActionArguments || _this.machine.config.preserveActionOrder), 2), resolvedActions = _a2[0], updatedContext = _a2[1];
        var newState = new State({
          value: _this.state.value,
          context: updatedContext,
          _event,
          _sessionid: _this.sessionId,
          historyValue: void 0,
          history: _this.state,
          actions: resolvedActions.filter(function(action) {
            return action.type !== raise$1 && (action.type !== send$1 || !!action.to && action.to !== SpecialTargets.Internal);
          }),
          activities: {},
          events: [],
          configuration: [],
          transitions: [],
          children: {},
          done: _this.state.done,
          tags: _this.state.tags,
          machine: _this.machine
        });
        newState.changed = true;
        return newState;
      });
      _this.update(nextState, _event);
      _this._stopChildren();
      registry.free(_this.sessionId);
    });
    return this;
  };
  Interpreter2.prototype.batch = function(events) {
    var _this = this;
    if (this.status === InterpreterStatus.NotStarted && this.options.deferEvents)
      ;
    else if (this.status !== InterpreterStatus.Running) {
      throw new Error(
        "".concat(events.length, ' event(s) were sent to uninitialized service "').concat(this.machine.id, '". Make sure .start() is called for this service, or set { deferEvents: true } in the service options.')
      );
    }
    if (!events.length) {
      return;
    }
    var exec = !!this.machine.config.predictableActionArguments && this._exec;
    this.scheduler.schedule(function() {
      var e_11, _a2;
      var nextState = _this.state;
      var batchChanged = false;
      var batchedActions = [];
      var _loop_1 = function(event_12) {
        var _event = toSCXMLEvent(event_12);
        _this.forward(_event);
        nextState = provide(_this, function() {
          return _this.machine.transition(nextState, _event, void 0, exec || void 0);
        });
        batchedActions.push.apply(batchedActions, __spreadArray([], __read(_this.machine.config.predictableActionArguments ? nextState.actions : nextState.actions.map(function(a2) {
          return bindActionToState(a2, nextState);
        })), false));
        batchChanged = batchChanged || !!nextState.changed;
      };
      try {
        for (var events_1 = __values(events), events_1_1 = events_1.next(); !events_1_1.done; events_1_1 = events_1.next()) {
          var event_1 = events_1_1.value;
          _loop_1(event_1);
        }
      } catch (e_11_1) {
        e_11 = {
          error: e_11_1
        };
      } finally {
        try {
          if (events_1_1 && !events_1_1.done && (_a2 = events_1.return))
            _a2.call(events_1);
        } finally {
          if (e_11)
            throw e_11.error;
        }
      }
      nextState.changed = batchChanged;
      nextState.actions = batchedActions;
      _this.update(nextState, toSCXMLEvent(events[events.length - 1]));
    });
  };
  Interpreter2.prototype.sender = function(event) {
    return this.send.bind(this, event);
  };
  Interpreter2.prototype._nextState = function(event, exec) {
    var _this = this;
    if (exec === void 0) {
      exec = !!this.machine.config.predictableActionArguments && this._exec;
    }
    var _event = toSCXMLEvent(event);
    if (_event.name.indexOf(errorPlatform) === 0 && !this.state.nextEvents.some(function(nextEvent) {
      return nextEvent.indexOf(errorPlatform) === 0;
    })) {
      throw _event.data.data;
    }
    var nextState = provide(this, function() {
      return _this.machine.transition(_this.state, _event, void 0, exec || void 0);
    });
    return nextState;
  };
  Interpreter2.prototype.nextState = function(event) {
    return this._nextState(event, false);
  };
  Interpreter2.prototype.forward = function(event) {
    var e_12, _a2;
    try {
      for (var _b = __values(this.forwardTo), _c = _b.next(); !_c.done; _c = _b.next()) {
        var id = _c.value;
        var child = this.children.get(id);
        if (!child) {
          throw new Error("Unable to forward event '".concat(event, "' from interpreter '").concat(this.id, "' to nonexistant child '").concat(id, "'."));
        }
        child.send(event);
      }
    } catch (e_12_1) {
      e_12 = {
        error: e_12_1
      };
    } finally {
      try {
        if (_c && !_c.done && (_a2 = _b.return))
          _a2.call(_b);
      } finally {
        if (e_12)
          throw e_12.error;
      }
    }
  };
  Interpreter2.prototype.defer = function(sendAction) {
    var _this = this;
    this.delayedEventsMap[sendAction.id] = this.clock.setTimeout(function() {
      if (sendAction.to) {
        _this.sendTo(sendAction._event, sendAction.to, true);
      } else {
        _this.send(sendAction._event);
      }
    }, sendAction.delay);
  };
  Interpreter2.prototype.cancel = function(sendId) {
    this.clock.clearTimeout(this.delayedEventsMap[sendId]);
    delete this.delayedEventsMap[sendId];
  };
  Interpreter2.prototype.exec = function(action, state, actionFunctionMap) {
    if (actionFunctionMap === void 0) {
      actionFunctionMap = this.machine.options.actions;
    }
    this._exec(action, state.context, state._event, actionFunctionMap);
  };
  Interpreter2.prototype.removeChild = function(childId) {
    var _a2;
    this.children.delete(childId);
    this.forwardTo.delete(childId);
    (_a2 = this.state) === null || _a2 === void 0 ? true : delete _a2.children[childId];
  };
  Interpreter2.prototype.stopChild = function(childId) {
    var child = this.children.get(childId);
    if (!child) {
      return;
    }
    this.removeChild(childId);
    if (isFunction$4(child.stop)) {
      child.stop();
    }
  };
  Interpreter2.prototype.spawn = function(entity, name, options) {
    if (this.status !== InterpreterStatus.Running) {
      return createDeferredActor(entity, name);
    }
    if (isPromiseLike(entity)) {
      return this.spawnPromise(Promise.resolve(entity), name);
    } else if (isFunction$4(entity)) {
      return this.spawnCallback(entity, name);
    } else if (isSpawnedActor(entity)) {
      return this.spawnActor(entity, name);
    } else if (isObservable(entity)) {
      return this.spawnObservable(entity, name);
    } else if (isMachine(entity)) {
      return this.spawnMachine(entity, __assign$1(__assign$1({}, options), {
        id: name
      }));
    } else if (isBehavior(entity)) {
      return this.spawnBehavior(entity, name);
    } else {
      throw new Error('Unable to spawn entity "'.concat(name, '" of type "').concat(typeof entity, '".'));
    }
  };
  Interpreter2.prototype.spawnMachine = function(machine, options) {
    var _this = this;
    if (options === void 0) {
      options = {};
    }
    var childService = new Interpreter2(machine, __assign$1(__assign$1({}, this.options), {
      parent: this,
      id: options.id || machine.id
    }));
    var resolvedOptions = __assign$1(__assign$1({}, DEFAULT_SPAWN_OPTIONS), options);
    if (resolvedOptions.sync) {
      childService.onTransition(function(state) {
        _this.send(update, {
          state,
          id: childService.id
        });
      });
    }
    var actor = childService;
    this.children.set(childService.id, actor);
    if (resolvedOptions.autoForward) {
      this.forwardTo.add(childService.id);
    }
    childService.onDone(function(doneEvent) {
      _this.removeChild(childService.id);
      _this.send(toSCXMLEvent(doneEvent, {
        origin: childService.id
      }));
    }).start();
    return actor;
  };
  Interpreter2.prototype.spawnBehavior = function(behavior, id) {
    var actorRef = spawnBehavior(behavior, {
      id,
      parent: this
    });
    this.children.set(id, actorRef);
    return actorRef;
  };
  Interpreter2.prototype.spawnPromise = function(promise, id) {
    var _a2;
    var _this = this;
    var canceled = false;
    var resolvedData;
    promise.then(function(response) {
      if (!canceled) {
        resolvedData = response;
        _this.removeChild(id);
        _this.send(toSCXMLEvent(doneInvoke(id, response), {
          origin: id
        }));
      }
    }, function(errorData) {
      if (!canceled) {
        _this.removeChild(id);
        var errorEvent = error(id, errorData);
        try {
          _this.send(toSCXMLEvent(errorEvent, {
            origin: id
          }));
        } catch (error2) {
          if (_this.devTools) {
            _this.devTools.send(errorEvent, _this.state);
          }
          if (_this.machine.strict) {
            _this.stop();
          }
        }
      }
    });
    var actor = (_a2 = {
      id,
      send: function() {
        return void 0;
      },
      subscribe: function(next, handleError, complete) {
        var observer = toObserver$1(next, handleError, complete);
        var unsubscribed = false;
        promise.then(function(response) {
          if (unsubscribed) {
            return;
          }
          observer.next(response);
          if (unsubscribed) {
            return;
          }
          observer.complete();
        }, function(err) {
          if (unsubscribed) {
            return;
          }
          observer.error(err);
        });
        return {
          unsubscribe: function() {
            return unsubscribed = true;
          }
        };
      },
      stop: function() {
        canceled = true;
      },
      toJSON: function() {
        return {
          id
        };
      },
      getSnapshot: function() {
        return resolvedData;
      }
    }, _a2[symbolObservable] = function() {
      return this;
    }, _a2);
    this.children.set(id, actor);
    return actor;
  };
  Interpreter2.prototype.spawnCallback = function(callback, id) {
    var _a2;
    var _this = this;
    var canceled = false;
    var receivers = /* @__PURE__ */ new Set();
    var listeners = /* @__PURE__ */ new Set();
    var emitted;
    var receive = function(e2) {
      emitted = e2;
      listeners.forEach(function(listener) {
        return listener(e2);
      });
      if (canceled) {
        return;
      }
      _this.send(toSCXMLEvent(e2, {
        origin: id
      }));
    };
    var callbackStop;
    try {
      callbackStop = callback(receive, function(newListener) {
        receivers.add(newListener);
      });
    } catch (err) {
      this.send(error(id, err));
    }
    if (isPromiseLike(callbackStop)) {
      return this.spawnPromise(callbackStop, id);
    }
    var actor = (_a2 = {
      id,
      send: function(event) {
        return receivers.forEach(function(receiver) {
          return receiver(event);
        });
      },
      subscribe: function(next) {
        var observer = toObserver$1(next);
        listeners.add(observer.next);
        return {
          unsubscribe: function() {
            listeners.delete(observer.next);
          }
        };
      },
      stop: function() {
        canceled = true;
        if (isFunction$4(callbackStop)) {
          callbackStop();
        }
      },
      toJSON: function() {
        return {
          id
        };
      },
      getSnapshot: function() {
        return emitted;
      }
    }, _a2[symbolObservable] = function() {
      return this;
    }, _a2);
    this.children.set(id, actor);
    return actor;
  };
  Interpreter2.prototype.spawnObservable = function(source, id) {
    var _a2;
    var _this = this;
    var emitted;
    var subscription = source.subscribe(function(value) {
      emitted = value;
      _this.send(toSCXMLEvent(value, {
        origin: id
      }));
    }, function(err) {
      _this.removeChild(id);
      _this.send(toSCXMLEvent(error(id, err), {
        origin: id
      }));
    }, function() {
      _this.removeChild(id);
      _this.send(toSCXMLEvent(doneInvoke(id), {
        origin: id
      }));
    });
    var actor = (_a2 = {
      id,
      send: function() {
        return void 0;
      },
      subscribe: function(next, handleError, complete) {
        return source.subscribe(next, handleError, complete);
      },
      stop: function() {
        return subscription.unsubscribe();
      },
      getSnapshot: function() {
        return emitted;
      },
      toJSON: function() {
        return {
          id
        };
      }
    }, _a2[symbolObservable] = function() {
      return this;
    }, _a2);
    this.children.set(id, actor);
    return actor;
  };
  Interpreter2.prototype.spawnActor = function(actor, name) {
    this.children.set(name, actor);
    return actor;
  };
  Interpreter2.prototype.spawnActivity = function(activity) {
    var implementation = this.machine.options && this.machine.options.activities ? this.machine.options.activities[activity.type] : void 0;
    if (!implementation) {
      return;
    }
    var dispose = implementation(this.state.context, activity);
    this.spawnEffect(activity.id, dispose);
  };
  Interpreter2.prototype.spawnEffect = function(id, dispose) {
    var _a2;
    this.children.set(id, (_a2 = {
      id,
      send: function() {
        return void 0;
      },
      subscribe: function() {
        return {
          unsubscribe: function() {
            return void 0;
          }
        };
      },
      stop: dispose || void 0,
      getSnapshot: function() {
        return void 0;
      },
      toJSON: function() {
        return {
          id
        };
      }
    }, _a2[symbolObservable] = function() {
      return this;
    }, _a2));
  };
  Interpreter2.prototype.attachDev = function() {
    var global2 = getGlobal();
    if (this.options.devTools && global2) {
      if (global2.__REDUX_DEVTOOLS_EXTENSION__) {
        var devToolsOptions = typeof this.options.devTools === "object" ? this.options.devTools : void 0;
        this.devTools = global2.__REDUX_DEVTOOLS_EXTENSION__.connect(__assign$1(__assign$1({
          name: this.id,
          autoPause: true,
          stateSanitizer: function(state) {
            return {
              value: state.value,
              context: state.context,
              actions: state.actions
            };
          }
        }, devToolsOptions), {
          features: __assign$1({
            jump: false,
            skip: false
          }, devToolsOptions ? devToolsOptions.features : void 0)
        }), this.machine);
        this.devTools.init(this.state);
      }
      registerService(this);
    }
  };
  Interpreter2.prototype.toJSON = function() {
    return {
      id: this.id
    };
  };
  Interpreter2.prototype[symbolObservable] = function() {
    return this;
  };
  Interpreter2.prototype.getSnapshot = function() {
    if (this.status === InterpreterStatus.NotStarted) {
      return this.initialState;
    }
    return this._state;
  };
  Interpreter2.defaultOptions = {
    execute: true,
    deferEvents: true,
    clock: {
      setTimeout: function(fn, ms) {
        return setTimeout(fn, ms);
      },
      clearTimeout: function(id) {
        return clearTimeout(id);
      }
    },
    logger: /* @__PURE__ */ console.log.bind(console),
    devTools: false
  };
  Interpreter2.interpret = interpret;
  return Interpreter2;
}();
var resolveSpawnOptions = function(nameOrOptions) {
  if (isString(nameOrOptions)) {
    return __assign$1(__assign$1({}, DEFAULT_SPAWN_OPTIONS), {
      name: nameOrOptions
    });
  }
  return __assign$1(__assign$1(__assign$1({}, DEFAULT_SPAWN_OPTIONS), {
    name: uniqueId()
  }), nameOrOptions);
};
function spawn(entity, nameOrOptions) {
  var resolvedOptions = resolveSpawnOptions(nameOrOptions);
  return consume(function(service2) {
    if (service2) {
      return service2.spawn(entity, resolvedOptions.name, resolvedOptions);
    } else {
      return createDeferredActor(entity, resolvedOptions.name);
    }
  });
}
function interpret(machine, options) {
  var interpreter = new Interpreter(machine, options);
  return interpreter;
}
function toInvokeSource(src) {
  if (typeof src === "string") {
    var simpleSrc = {
      type: src
    };
    simpleSrc.toString = function() {
      return src;
    };
    return simpleSrc;
  }
  return src;
}
function toInvokeDefinition(invokeConfig) {
  return __assign$1(__assign$1({
    type: invoke
  }, invokeConfig), {
    toJSON: function() {
      invokeConfig.onDone;
      invokeConfig.onError;
      var invokeDef = __rest$1(invokeConfig, ["onDone", "onError"]);
      return __assign$1(__assign$1({}, invokeDef), {
        type: invoke,
        src: toInvokeSource(invokeConfig.src)
      });
    }
  });
}
var NULL_EVENT = "";
var STATE_IDENTIFIER = "#";
var WILDCARD = "*";
var EMPTY_OBJECT = {};
var isStateId = function(str) {
  return str[0] === STATE_IDENTIFIER;
};
var createDefaultOptions = function() {
  return {
    actions: {},
    guards: {},
    services: {},
    activities: {},
    delays: {}
  };
};
var StateNode = /* @__PURE__ */ function() {
  function StateNode2(config, options, _context, _stateInfo) {
    if (_context === void 0) {
      _context = "context" in config ? config.context : void 0;
    }
    var _this = this;
    var _a2;
    this.config = config;
    this._context = _context;
    this.order = -1;
    this.__xstatenode = true;
    this.__cache = {
      events: void 0,
      relativeValue: /* @__PURE__ */ new Map(),
      initialStateValue: void 0,
      initialState: void 0,
      on: void 0,
      transitions: void 0,
      candidates: {},
      delayedTransitions: void 0
    };
    this.idMap = {};
    this.tags = [];
    this.options = Object.assign(createDefaultOptions(), options);
    this.parent = _stateInfo === null || _stateInfo === void 0 ? void 0 : _stateInfo.parent;
    this.key = this.config.key || (_stateInfo === null || _stateInfo === void 0 ? void 0 : _stateInfo.key) || this.config.id || "(machine)";
    this.machine = this.parent ? this.parent.machine : this;
    this.path = this.parent ? this.parent.path.concat(this.key) : [];
    this.delimiter = this.config.delimiter || (this.parent ? this.parent.delimiter : STATE_DELIMITER);
    this.id = this.config.id || __spreadArray([this.machine.key], __read(this.path), false).join(this.delimiter);
    this.version = this.parent ? this.parent.version : this.config.version;
    this.type = this.config.type || (this.config.parallel ? "parallel" : this.config.states && Object.keys(this.config.states).length ? "compound" : this.config.history ? "history" : "atomic");
    this.schema = this.parent ? this.machine.schema : (_a2 = this.config.schema) !== null && _a2 !== void 0 ? _a2 : {};
    this.description = this.config.description;
    this.initial = this.config.initial;
    this.states = this.config.states ? mapValues(this.config.states, function(stateConfig, key) {
      var _a3;
      var stateNode = new StateNode2(stateConfig, {}, void 0, {
        parent: _this,
        key
      });
      Object.assign(_this.idMap, __assign$1((_a3 = {}, _a3[stateNode.id] = stateNode, _a3), stateNode.idMap));
      return stateNode;
    }) : EMPTY_OBJECT;
    var order = 0;
    function dfs(stateNode) {
      var e_1, _a3;
      stateNode.order = order++;
      try {
        for (var _b = __values(getAllChildren(stateNode)), _c = _b.next(); !_c.done; _c = _b.next()) {
          var child = _c.value;
          dfs(child);
        }
      } catch (e_1_1) {
        e_1 = {
          error: e_1_1
        };
      } finally {
        try {
          if (_c && !_c.done && (_a3 = _b.return))
            _a3.call(_b);
        } finally {
          if (e_1)
            throw e_1.error;
        }
      }
    }
    dfs(this);
    this.history = this.config.history === true ? "shallow" : this.config.history || false;
    this._transient = !!this.config.always || (!this.config.on ? false : Array.isArray(this.config.on) ? this.config.on.some(function(_a3) {
      var event = _a3.event;
      return event === NULL_EVENT;
    }) : NULL_EVENT in this.config.on);
    this.strict = !!this.config.strict;
    this.onEntry = toArray(this.config.entry || this.config.onEntry).map(function(action) {
      return toActionObject(action);
    });
    this.onExit = toArray(this.config.exit || this.config.onExit).map(function(action) {
      return toActionObject(action);
    });
    this.meta = this.config.meta;
    this.doneData = this.type === "final" ? this.config.data : void 0;
    this.invoke = toArray(this.config.invoke).map(function(invokeConfig, i2) {
      var _a3, _b;
      if (isMachine(invokeConfig)) {
        var invokeId = createInvokeId(_this.id, i2);
        _this.machine.options.services = __assign$1((_a3 = {}, _a3[invokeId] = invokeConfig, _a3), _this.machine.options.services);
        return toInvokeDefinition({
          src: invokeId,
          id: invokeId
        });
      } else if (isString(invokeConfig.src)) {
        var invokeId = invokeConfig.id || createInvokeId(_this.id, i2);
        return toInvokeDefinition(__assign$1(__assign$1({}, invokeConfig), {
          id: invokeId,
          src: invokeConfig.src
        }));
      } else if (isMachine(invokeConfig.src) || isFunction$4(invokeConfig.src)) {
        var invokeId = invokeConfig.id || createInvokeId(_this.id, i2);
        _this.machine.options.services = __assign$1((_b = {}, _b[invokeId] = invokeConfig.src, _b), _this.machine.options.services);
        return toInvokeDefinition(__assign$1(__assign$1({
          id: invokeId
        }, invokeConfig), {
          src: invokeId
        }));
      } else {
        var invokeSource = invokeConfig.src;
        return toInvokeDefinition(__assign$1(__assign$1({
          id: createInvokeId(_this.id, i2)
        }, invokeConfig), {
          src: invokeSource
        }));
      }
    });
    this.activities = toArray(this.config.activities).concat(this.invoke).map(function(activity) {
      return toActivityDefinition(activity);
    });
    this.transition = this.transition.bind(this);
    this.tags = toArray(this.config.tags);
  }
  StateNode2.prototype._init = function() {
    if (this.__cache.transitions) {
      return;
    }
    getAllStateNodes(this).forEach(function(stateNode) {
      return stateNode.on;
    });
  };
  StateNode2.prototype.withConfig = function(options, context) {
    var _a2 = this.options, actions = _a2.actions, activities = _a2.activities, guards = _a2.guards, services = _a2.services, delays = _a2.delays;
    return new StateNode2(this.config, {
      actions: __assign$1(__assign$1({}, actions), options.actions),
      activities: __assign$1(__assign$1({}, activities), options.activities),
      guards: __assign$1(__assign$1({}, guards), options.guards),
      services: __assign$1(__assign$1({}, services), options.services),
      delays: __assign$1(__assign$1({}, delays), options.delays)
    }, context !== null && context !== void 0 ? context : this.context);
  };
  StateNode2.prototype.withContext = function(context) {
    return new StateNode2(this.config, this.options, context);
  };
  Object.defineProperty(StateNode2.prototype, "context", {
    get: function() {
      return isFunction$4(this._context) ? this._context() : this._context;
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(StateNode2.prototype, "definition", {
    get: function() {
      return {
        id: this.id,
        key: this.key,
        version: this.version,
        context: this.context,
        type: this.type,
        initial: this.initial,
        history: this.history,
        states: mapValues(this.states, function(state) {
          return state.definition;
        }),
        on: this.on,
        transitions: this.transitions,
        entry: this.onEntry,
        exit: this.onExit,
        activities: this.activities || [],
        meta: this.meta,
        order: this.order || -1,
        data: this.doneData,
        invoke: this.invoke,
        description: this.description,
        tags: this.tags
      };
    },
    enumerable: false,
    configurable: true
  });
  StateNode2.prototype.toJSON = function() {
    return this.definition;
  };
  Object.defineProperty(StateNode2.prototype, "on", {
    get: function() {
      if (this.__cache.on) {
        return this.__cache.on;
      }
      var transitions = this.transitions;
      return this.__cache.on = transitions.reduce(function(map, transition) {
        map[transition.eventType] = map[transition.eventType] || [];
        map[transition.eventType].push(transition);
        return map;
      }, {});
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(StateNode2.prototype, "after", {
    get: function() {
      return this.__cache.delayedTransitions || (this.__cache.delayedTransitions = this.getDelayedTransitions(), this.__cache.delayedTransitions);
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(StateNode2.prototype, "transitions", {
    get: function() {
      return this.__cache.transitions || (this.__cache.transitions = this.formatTransitions(), this.__cache.transitions);
    },
    enumerable: false,
    configurable: true
  });
  StateNode2.prototype.getCandidates = function(eventName) {
    if (this.__cache.candidates[eventName]) {
      return this.__cache.candidates[eventName];
    }
    var transient = eventName === NULL_EVENT;
    var candidates = this.transitions.filter(function(transition) {
      var sameEventType = transition.eventType === eventName;
      return transient ? sameEventType : sameEventType || transition.eventType === WILDCARD;
    });
    this.__cache.candidates[eventName] = candidates;
    return candidates;
  };
  StateNode2.prototype.getDelayedTransitions = function() {
    var _this = this;
    var afterConfig = this.config.after;
    if (!afterConfig) {
      return [];
    }
    var mutateEntryExit = function(delay, i2) {
      var delayRef = isFunction$4(delay) ? "".concat(_this.id, ":delay[").concat(i2, "]") : delay;
      var eventType = after(delayRef, _this.id);
      _this.onEntry.push(send(eventType, {
        delay
      }));
      _this.onExit.push(cancel(eventType));
      return eventType;
    };
    var delayedTransitions = isArray$a(afterConfig) ? afterConfig.map(function(transition, i2) {
      var eventType = mutateEntryExit(transition.delay, i2);
      return __assign$1(__assign$1({}, transition), {
        event: eventType
      });
    }) : flatten(Object.keys(afterConfig).map(function(delay, i2) {
      var configTransition = afterConfig[delay];
      var resolvedTransition = isString(configTransition) ? {
        target: configTransition
      } : configTransition;
      var resolvedDelay = !isNaN(+delay) ? +delay : delay;
      var eventType = mutateEntryExit(resolvedDelay, i2);
      return toArray(resolvedTransition).map(function(transition) {
        return __assign$1(__assign$1({}, transition), {
          event: eventType,
          delay: resolvedDelay
        });
      });
    }));
    return delayedTransitions.map(function(delayedTransition) {
      var delay = delayedTransition.delay;
      return __assign$1(__assign$1({}, _this.formatTransition(delayedTransition)), {
        delay
      });
    });
  };
  StateNode2.prototype.getStateNodes = function(state) {
    var _a2;
    var _this = this;
    if (!state) {
      return [];
    }
    var stateValue = state instanceof State ? state.value : toStateValue(state, this.delimiter);
    if (isString(stateValue)) {
      var initialStateValue = this.getStateNode(stateValue).initial;
      return initialStateValue !== void 0 ? this.getStateNodes((_a2 = {}, _a2[stateValue] = initialStateValue, _a2)) : [this, this.states[stateValue]];
    }
    var subStateKeys = Object.keys(stateValue);
    var subStateNodes = [this];
    subStateNodes.push.apply(subStateNodes, __spreadArray([], __read(flatten(subStateKeys.map(function(subStateKey) {
      return _this.getStateNode(subStateKey).getStateNodes(stateValue[subStateKey]);
    }))), false));
    return subStateNodes;
  };
  StateNode2.prototype.handles = function(event) {
    var eventType = getEventType(event);
    return this.events.includes(eventType);
  };
  StateNode2.prototype.resolveState = function(state) {
    var stateFromConfig = state instanceof State ? state : State.create(state);
    var configuration = Array.from(getConfiguration([], this.getStateNodes(stateFromConfig.value)));
    return new State(__assign$1(__assign$1({}, stateFromConfig), {
      value: this.resolve(stateFromConfig.value),
      configuration,
      done: isInFinalState(configuration, this),
      tags: getTagsFromConfiguration(configuration),
      machine: this.machine
    }));
  };
  StateNode2.prototype.transitionLeafNode = function(stateValue, state, _event) {
    var stateNode = this.getStateNode(stateValue);
    var next = stateNode.next(state, _event);
    if (!next || !next.transitions.length) {
      return this.next(state, _event);
    }
    return next;
  };
  StateNode2.prototype.transitionCompoundNode = function(stateValue, state, _event) {
    var subStateKeys = Object.keys(stateValue);
    var stateNode = this.getStateNode(subStateKeys[0]);
    var next = stateNode._transition(stateValue[subStateKeys[0]], state, _event);
    if (!next || !next.transitions.length) {
      return this.next(state, _event);
    }
    return next;
  };
  StateNode2.prototype.transitionParallelNode = function(stateValue, state, _event) {
    var e_2, _a2;
    var transitionMap = {};
    try {
      for (var _b = __values(Object.keys(stateValue)), _c = _b.next(); !_c.done; _c = _b.next()) {
        var subStateKey = _c.value;
        var subStateValue = stateValue[subStateKey];
        if (!subStateValue) {
          continue;
        }
        var subStateNode = this.getStateNode(subStateKey);
        var next = subStateNode._transition(subStateValue, state, _event);
        if (next) {
          transitionMap[subStateKey] = next;
        }
      }
    } catch (e_2_1) {
      e_2 = {
        error: e_2_1
      };
    } finally {
      try {
        if (_c && !_c.done && (_a2 = _b.return))
          _a2.call(_b);
      } finally {
        if (e_2)
          throw e_2.error;
      }
    }
    var stateTransitions = Object.keys(transitionMap).map(function(key) {
      return transitionMap[key];
    });
    var enabledTransitions = flatten(stateTransitions.map(function(st) {
      return st.transitions;
    }));
    var willTransition = stateTransitions.some(function(st) {
      return st.transitions.length > 0;
    });
    if (!willTransition) {
      return this.next(state, _event);
    }
    var entryNodes = flatten(stateTransitions.map(function(t2) {
      return t2.entrySet;
    }));
    var configuration = flatten(Object.keys(transitionMap).map(function(key) {
      return transitionMap[key].configuration;
    }));
    return {
      transitions: enabledTransitions,
      entrySet: entryNodes,
      exitSet: flatten(stateTransitions.map(function(t2) {
        return t2.exitSet;
      })),
      configuration,
      source: state,
      actions: flatten(Object.keys(transitionMap).map(function(key) {
        return transitionMap[key].actions;
      }))
    };
  };
  StateNode2.prototype._transition = function(stateValue, state, _event) {
    if (isString(stateValue)) {
      return this.transitionLeafNode(stateValue, state, _event);
    }
    if (Object.keys(stateValue).length === 1) {
      return this.transitionCompoundNode(stateValue, state, _event);
    }
    return this.transitionParallelNode(stateValue, state, _event);
  };
  StateNode2.prototype.getTransitionData = function(state, event) {
    return this._transition(state.value, state, toSCXMLEvent(event));
  };
  StateNode2.prototype.next = function(state, _event) {
    var e_3, _a2;
    var _this = this;
    var eventName = _event.name;
    var actions = [];
    var nextStateNodes = [];
    var selectedTransition;
    try {
      for (var _b = __values(this.getCandidates(eventName)), _c = _b.next(); !_c.done; _c = _b.next()) {
        var candidate = _c.value;
        var cond = candidate.cond, stateIn = candidate.in;
        var resolvedContext = state.context;
        var isInState = stateIn ? isString(stateIn) && isStateId(stateIn) ? state.matches(toStateValue(this.getStateNodeById(stateIn).path, this.delimiter)) : matchesState(toStateValue(stateIn, this.delimiter), path(this.path.slice(0, -2))(state.value)) : true;
        var guardPassed = false;
        try {
          guardPassed = !cond || evaluateGuard(this.machine, cond, resolvedContext, _event, state);
        } catch (err) {
          throw new Error("Unable to evaluate guard '".concat(cond.name || cond.type, "' in transition for event '").concat(eventName, "' in state node '").concat(this.id, "':\n").concat(err.message));
        }
        if (guardPassed && isInState) {
          if (candidate.target !== void 0) {
            nextStateNodes = candidate.target;
          }
          actions.push.apply(actions, __spreadArray([], __read(candidate.actions), false));
          selectedTransition = candidate;
          break;
        }
      }
    } catch (e_3_1) {
      e_3 = {
        error: e_3_1
      };
    } finally {
      try {
        if (_c && !_c.done && (_a2 = _b.return))
          _a2.call(_b);
      } finally {
        if (e_3)
          throw e_3.error;
      }
    }
    if (!selectedTransition) {
      return void 0;
    }
    if (!nextStateNodes.length) {
      return {
        transitions: [selectedTransition],
        entrySet: [],
        exitSet: [],
        configuration: state.value ? [this] : [],
        source: state,
        actions
      };
    }
    var allNextStateNodes = flatten(nextStateNodes.map(function(stateNode) {
      return _this.getRelativeStateNodes(stateNode, state.historyValue);
    }));
    var isInternal = !!selectedTransition.internal;
    var reentryNodes = [];
    if (!isInternal) {
      nextStateNodes.forEach(function(targetNode) {
        reentryNodes.push.apply(reentryNodes, __spreadArray([], __read(_this.getExternalReentryNodes(targetNode)), false));
      });
    }
    return {
      transitions: [selectedTransition],
      entrySet: reentryNodes,
      exitSet: isInternal ? [] : [this],
      configuration: allNextStateNodes,
      source: state,
      actions
    };
  };
  StateNode2.prototype.getExternalReentryNodes = function(targetNode) {
    var nodes = [];
    var _a2 = __read(targetNode.order > this.order ? [targetNode, this] : [this, targetNode], 2), marker = _a2[0], possibleAncestor = _a2[1];
    while (marker && marker !== possibleAncestor) {
      nodes.push(marker);
      marker = marker.parent;
    }
    if (marker !== possibleAncestor) {
      return [];
    }
    nodes.push(possibleAncestor);
    return nodes;
  };
  StateNode2.prototype.getActions = function(resolvedConfig, isDone, transition, currentContext, _event, prevState, predictableExec) {
    var e_4, _a2, e_5, _b;
    var _this = this;
    var prevConfig = getConfiguration([], prevState ? this.getStateNodes(prevState.value) : [this]);
    try {
      for (var resolvedConfig_1 = __values(resolvedConfig), resolvedConfig_1_1 = resolvedConfig_1.next(); !resolvedConfig_1_1.done; resolvedConfig_1_1 = resolvedConfig_1.next()) {
        var sn = resolvedConfig_1_1.value;
        if (!has(prevConfig, sn) || has(transition.entrySet, sn.parent) && !has(transition.entrySet, sn)) {
          transition.entrySet.push(sn);
        }
      }
    } catch (e_4_1) {
      e_4 = {
        error: e_4_1
      };
    } finally {
      try {
        if (resolvedConfig_1_1 && !resolvedConfig_1_1.done && (_a2 = resolvedConfig_1.return))
          _a2.call(resolvedConfig_1);
      } finally {
        if (e_4)
          throw e_4.error;
      }
    }
    try {
      for (var prevConfig_1 = __values(prevConfig), prevConfig_1_1 = prevConfig_1.next(); !prevConfig_1_1.done; prevConfig_1_1 = prevConfig_1.next()) {
        var sn = prevConfig_1_1.value;
        if (!has(resolvedConfig, sn) || has(transition.exitSet, sn.parent)) {
          transition.exitSet.push(sn);
        }
      }
    } catch (e_5_1) {
      e_5 = {
        error: e_5_1
      };
    } finally {
      try {
        if (prevConfig_1_1 && !prevConfig_1_1.done && (_b = prevConfig_1.return))
          _b.call(prevConfig_1);
      } finally {
        if (e_5)
          throw e_5.error;
      }
    }
    var doneEvents = flatten(transition.entrySet.map(function(sn2) {
      var events = [];
      if (sn2.type !== "final") {
        return events;
      }
      var parent = sn2.parent;
      if (!parent.parent) {
        return events;
      }
      events.push(
        done(sn2.id, sn2.doneData),
        done(parent.id, sn2.doneData ? mapContext(sn2.doneData, currentContext, _event) : void 0)
      );
      var grandparent = parent.parent;
      if (grandparent.type === "parallel") {
        if (getChildren(grandparent).every(function(parentNode) {
          return isInFinalState(transition.configuration, parentNode);
        })) {
          events.push(done(grandparent.id));
        }
      }
      return events;
    }));
    transition.exitSet.sort(function(a2, b2) {
      return b2.order - a2.order;
    });
    transition.entrySet.sort(function(a2, b2) {
      return a2.order - b2.order;
    });
    var entryStates = new Set(transition.entrySet);
    var exitStates = new Set(transition.exitSet);
    var entryActions = Array.from(entryStates).map(function(stateNode) {
      var entryActions2 = stateNode.onEntry;
      var invokeActions = stateNode.activities.map(function(activity) {
        return start(activity);
      });
      return toActionObjects(predictableExec ? __spreadArray(__spreadArray([], __read(entryActions2), false), __read(invokeActions), false) : __spreadArray(__spreadArray([], __read(invokeActions), false), __read(entryActions2), false), _this.machine.options.actions);
    }).concat([doneEvents.map(raise)]);
    var exitActions = Array.from(exitStates).map(function(stateNode) {
      return toActionObjects(__spreadArray(__spreadArray([], __read(stateNode.onExit), false), __read(stateNode.activities.map(function(activity) {
        return stop(activity);
      })), false), _this.machine.options.actions);
    });
    var actions = exitActions.concat([toActionObjects(transition.actions, this.machine.options.actions)]).concat(entryActions);
    if (isDone) {
      var stopActions = toActionObjects(flatten(__spreadArray([], __read(resolvedConfig), false).sort(function(a2, b2) {
        return b2.order - a2.order;
      }).map(function(stateNode) {
        return stateNode.onExit;
      })), this.machine.options.actions).filter(function(action) {
        return action.type !== raise$1 && (action.type !== send$1 || !!action.to && action.to !== SpecialTargets.Internal);
      });
      return actions.concat([stopActions]);
    }
    return actions;
  };
  StateNode2.prototype.transition = function(state, event, context, exec) {
    if (state === void 0) {
      state = this.initialState;
    }
    var _event = toSCXMLEvent(event);
    var currentState;
    if (state instanceof State) {
      currentState = context === void 0 ? state : this.resolveState(State.from(state, context));
    } else {
      var resolvedStateValue = isString(state) ? this.resolve(pathToStateValue(this.getResolvedPath(state))) : this.resolve(state);
      var resolvedContext = context !== null && context !== void 0 ? context : this.machine.context;
      currentState = this.resolveState(State.from(resolvedStateValue, resolvedContext));
    }
    if (this.strict) {
      if (!this.events.includes(_event.name) && !isBuiltInEvent(_event.name)) {
        throw new Error("Machine '".concat(this.id, "' does not accept event '").concat(_event.name, "'"));
      }
    }
    var stateTransition = this._transition(currentState.value, currentState, _event) || {
      transitions: [],
      configuration: [],
      entrySet: [],
      exitSet: [],
      source: currentState,
      actions: []
    };
    var prevConfig = getConfiguration([], this.getStateNodes(currentState.value));
    var resolvedConfig = stateTransition.configuration.length ? getConfiguration(prevConfig, stateTransition.configuration) : prevConfig;
    stateTransition.configuration = __spreadArray([], __read(resolvedConfig), false);
    return this.resolveTransition(stateTransition, currentState, currentState.context, exec, _event);
  };
  StateNode2.prototype.resolveRaisedTransition = function(state, _event, originalEvent, predictableExec) {
    var _a2;
    var currentActions = state.actions;
    state = this.transition(state, _event, void 0, predictableExec);
    state._event = originalEvent;
    state.event = originalEvent.data;
    (_a2 = state.actions).unshift.apply(_a2, __spreadArray([], __read(currentActions), false));
    return state;
  };
  StateNode2.prototype.resolveTransition = function(stateTransition, currentState, context, predictableExec, _event) {
    var e_6, _a2, e_7, _b;
    var _this = this;
    if (_event === void 0) {
      _event = initEvent;
    }
    var configuration = stateTransition.configuration;
    var willTransition = !currentState || stateTransition.transitions.length > 0;
    var resolvedConfiguration = willTransition ? stateTransition.configuration : currentState ? currentState.configuration : [];
    var isDone = isInFinalState(resolvedConfiguration, this);
    var resolvedStateValue = willTransition ? getValue$2(this.machine, configuration) : void 0;
    var historyValue = currentState ? currentState.historyValue ? currentState.historyValue : stateTransition.source ? this.machine.historyValue(currentState.value) : void 0 : void 0;
    var actionBlocks = this.getActions(new Set(resolvedConfiguration), isDone, stateTransition, context, _event, currentState, predictableExec);
    var activities = currentState ? __assign$1({}, currentState.activities) : {};
    try {
      for (var actionBlocks_1 = __values(actionBlocks), actionBlocks_1_1 = actionBlocks_1.next(); !actionBlocks_1_1.done; actionBlocks_1_1 = actionBlocks_1.next()) {
        var block = actionBlocks_1_1.value;
        try {
          for (var block_1 = (e_7 = void 0, __values(block)), block_1_1 = block_1.next(); !block_1_1.done; block_1_1 = block_1.next()) {
            var action = block_1_1.value;
            if (action.type === start$1) {
              activities[action.activity.id || action.activity.type] = action;
            } else if (action.type === stop$1) {
              activities[action.activity.id || action.activity.type] = false;
            }
          }
        } catch (e_7_1) {
          e_7 = {
            error: e_7_1
          };
        } finally {
          try {
            if (block_1_1 && !block_1_1.done && (_b = block_1.return))
              _b.call(block_1);
          } finally {
            if (e_7)
              throw e_7.error;
          }
        }
      }
    } catch (e_6_1) {
      e_6 = {
        error: e_6_1
      };
    } finally {
      try {
        if (actionBlocks_1_1 && !actionBlocks_1_1.done && (_a2 = actionBlocks_1.return))
          _a2.call(actionBlocks_1);
      } finally {
        if (e_6)
          throw e_6.error;
      }
    }
    var _c = __read(resolveActions(this, currentState, context, _event, actionBlocks, predictableExec, this.machine.config.predictableActionArguments || this.machine.config.preserveActionOrder), 2), resolvedActions = _c[0], updatedContext = _c[1];
    var _d = __read(partition(resolvedActions, function(action2) {
      return action2.type === raise$1 || action2.type === send$1 && action2.to === SpecialTargets.Internal;
    }), 2), raisedEvents = _d[0], nonRaisedActions = _d[1];
    var invokeActions = resolvedActions.filter(function(action2) {
      var _a3;
      return action2.type === start$1 && ((_a3 = action2.activity) === null || _a3 === void 0 ? void 0 : _a3.type) === invoke;
    });
    var children2 = invokeActions.reduce(function(acc, action2) {
      acc[action2.activity.id] = createInvocableActor(action2.activity, _this.machine, updatedContext, _event);
      return acc;
    }, currentState ? __assign$1({}, currentState.children) : {});
    var nextState = new State({
      value: resolvedStateValue || currentState.value,
      context: updatedContext,
      _event,
      _sessionid: currentState ? currentState._sessionid : null,
      historyValue: resolvedStateValue ? historyValue ? updateHistoryValue(historyValue, resolvedStateValue) : void 0 : currentState ? currentState.historyValue : void 0,
      history: !resolvedStateValue || stateTransition.source ? currentState : void 0,
      actions: resolvedStateValue ? nonRaisedActions : [],
      activities: resolvedStateValue ? activities : currentState ? currentState.activities : {},
      events: [],
      configuration: resolvedConfiguration,
      transitions: stateTransition.transitions,
      children: children2,
      done: isDone,
      tags: getTagsFromConfiguration(resolvedConfiguration),
      machine: this
    });
    var didUpdateContext = context !== updatedContext;
    nextState.changed = _event.name === update || didUpdateContext;
    var history = nextState.history;
    if (history) {
      delete history.history;
    }
    var hasAlwaysTransitions = !isDone && (this._transient || configuration.some(function(stateNode) {
      return stateNode._transient;
    }));
    if (!willTransition && (!hasAlwaysTransitions || _event.name === NULL_EVENT)) {
      return nextState;
    }
    var maybeNextState = nextState;
    if (!isDone) {
      if (hasAlwaysTransitions) {
        maybeNextState = this.resolveRaisedTransition(maybeNextState, {
          type: nullEvent
        }, _event, predictableExec);
      }
      while (raisedEvents.length) {
        var raisedEvent = raisedEvents.shift();
        maybeNextState = this.resolveRaisedTransition(maybeNextState, raisedEvent._event, _event, predictableExec);
      }
    }
    var changed = maybeNextState.changed || (history ? !!maybeNextState.actions.length || didUpdateContext || typeof history.value !== typeof maybeNextState.value || !stateValuesEqual(maybeNextState.value, history.value) : void 0);
    maybeNextState.changed = changed;
    maybeNextState.history = history;
    return maybeNextState;
  };
  StateNode2.prototype.getStateNode = function(stateKey) {
    if (isStateId(stateKey)) {
      return this.machine.getStateNodeById(stateKey);
    }
    if (!this.states) {
      throw new Error("Unable to retrieve child state '".concat(stateKey, "' from '").concat(this.id, "'; no child states exist."));
    }
    var result = this.states[stateKey];
    if (!result) {
      throw new Error("Child state '".concat(stateKey, "' does not exist on '").concat(this.id, "'"));
    }
    return result;
  };
  StateNode2.prototype.getStateNodeById = function(stateId) {
    var resolvedStateId = isStateId(stateId) ? stateId.slice(STATE_IDENTIFIER.length) : stateId;
    if (resolvedStateId === this.id) {
      return this;
    }
    var stateNode = this.machine.idMap[resolvedStateId];
    if (!stateNode) {
      throw new Error("Child state node '#".concat(resolvedStateId, "' does not exist on machine '").concat(this.id, "'"));
    }
    return stateNode;
  };
  StateNode2.prototype.getStateNodeByPath = function(statePath) {
    if (typeof statePath === "string" && isStateId(statePath)) {
      try {
        return this.getStateNodeById(statePath.slice(1));
      } catch (e2) {
      }
    }
    var arrayStatePath = toStatePath(statePath, this.delimiter).slice();
    var currentStateNode = this;
    while (arrayStatePath.length) {
      var key = arrayStatePath.shift();
      if (!key.length) {
        break;
      }
      currentStateNode = currentStateNode.getStateNode(key);
    }
    return currentStateNode;
  };
  StateNode2.prototype.resolve = function(stateValue) {
    var _a2;
    var _this = this;
    if (!stateValue) {
      return this.initialStateValue || EMPTY_OBJECT;
    }
    switch (this.type) {
      case "parallel":
        return mapValues(this.initialStateValue, function(subStateValue, subStateKey) {
          return subStateValue ? _this.getStateNode(subStateKey).resolve(stateValue[subStateKey] || subStateValue) : EMPTY_OBJECT;
        });
      case "compound":
        if (isString(stateValue)) {
          var subStateNode = this.getStateNode(stateValue);
          if (subStateNode.type === "parallel" || subStateNode.type === "compound") {
            return _a2 = {}, _a2[stateValue] = subStateNode.initialStateValue, _a2;
          }
          return stateValue;
        }
        if (!Object.keys(stateValue).length) {
          return this.initialStateValue || {};
        }
        return mapValues(stateValue, function(subStateValue, subStateKey) {
          return subStateValue ? _this.getStateNode(subStateKey).resolve(subStateValue) : EMPTY_OBJECT;
        });
      default:
        return stateValue || EMPTY_OBJECT;
    }
  };
  StateNode2.prototype.getResolvedPath = function(stateIdentifier) {
    if (isStateId(stateIdentifier)) {
      var stateNode = this.machine.idMap[stateIdentifier.slice(STATE_IDENTIFIER.length)];
      if (!stateNode) {
        throw new Error("Unable to find state node '".concat(stateIdentifier, "'"));
      }
      return stateNode.path;
    }
    return toStatePath(stateIdentifier, this.delimiter);
  };
  Object.defineProperty(StateNode2.prototype, "initialStateValue", {
    get: function() {
      var _a2;
      if (this.__cache.initialStateValue) {
        return this.__cache.initialStateValue;
      }
      var initialStateValue;
      if (this.type === "parallel") {
        initialStateValue = mapFilterValues(this.states, function(state) {
          return state.initialStateValue || EMPTY_OBJECT;
        }, function(stateNode) {
          return !(stateNode.type === "history");
        });
      } else if (this.initial !== void 0) {
        if (!this.states[this.initial]) {
          throw new Error("Initial state '".concat(this.initial, "' not found on '").concat(this.key, "'"));
        }
        initialStateValue = isLeafNode(this.states[this.initial]) ? this.initial : (_a2 = {}, _a2[this.initial] = this.states[this.initial].initialStateValue, _a2);
      } else {
        initialStateValue = {};
      }
      this.__cache.initialStateValue = initialStateValue;
      return this.__cache.initialStateValue;
    },
    enumerable: false,
    configurable: true
  });
  StateNode2.prototype.getInitialState = function(stateValue, context) {
    this._init();
    var configuration = this.getStateNodes(stateValue);
    return this.resolveTransition({
      configuration,
      entrySet: configuration,
      exitSet: [],
      transitions: [],
      source: void 0,
      actions: []
    }, void 0, context !== null && context !== void 0 ? context : this.machine.context, void 0);
  };
  Object.defineProperty(StateNode2.prototype, "initialState", {
    get: function() {
      var initialStateValue = this.initialStateValue;
      if (!initialStateValue) {
        throw new Error("Cannot retrieve initial state from simple state '".concat(this.id, "'."));
      }
      return this.getInitialState(initialStateValue);
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(StateNode2.prototype, "target", {
    get: function() {
      var target;
      if (this.type === "history") {
        var historyConfig = this.config;
        if (isString(historyConfig.target)) {
          target = isStateId(historyConfig.target) ? pathToStateValue(this.machine.getStateNodeById(historyConfig.target).path.slice(this.path.length - 1)) : historyConfig.target;
        } else {
          target = historyConfig.target;
        }
      }
      return target;
    },
    enumerable: false,
    configurable: true
  });
  StateNode2.prototype.getRelativeStateNodes = function(relativeStateId, historyValue, resolve) {
    if (resolve === void 0) {
      resolve = true;
    }
    return resolve ? relativeStateId.type === "history" ? relativeStateId.resolveHistory(historyValue) : relativeStateId.initialStateNodes : [relativeStateId];
  };
  Object.defineProperty(StateNode2.prototype, "initialStateNodes", {
    get: function() {
      var _this = this;
      if (isLeafNode(this)) {
        return [this];
      }
      if (this.type === "compound" && !this.initial) {
        return [this];
      }
      var initialStateNodePaths = toStatePaths(this.initialStateValue);
      return flatten(initialStateNodePaths.map(function(initialPath) {
        return _this.getFromRelativePath(initialPath);
      }));
    },
    enumerable: false,
    configurable: true
  });
  StateNode2.prototype.getFromRelativePath = function(relativePath) {
    if (!relativePath.length) {
      return [this];
    }
    var _a2 = __read(relativePath), stateKey = _a2[0], childStatePath = _a2.slice(1);
    if (!this.states) {
      throw new Error("Cannot retrieve subPath '".concat(stateKey, "' from node with no states"));
    }
    var childStateNode = this.getStateNode(stateKey);
    if (childStateNode.type === "history") {
      return childStateNode.resolveHistory();
    }
    if (!this.states[stateKey]) {
      throw new Error("Child state '".concat(stateKey, "' does not exist on '").concat(this.id, "'"));
    }
    return this.states[stateKey].getFromRelativePath(childStatePath);
  };
  StateNode2.prototype.historyValue = function(relativeStateValue) {
    if (!Object.keys(this.states).length) {
      return void 0;
    }
    return {
      current: relativeStateValue || this.initialStateValue,
      states: mapFilterValues(this.states, function(stateNode, key) {
        if (!relativeStateValue) {
          return stateNode.historyValue();
        }
        var subStateValue = isString(relativeStateValue) ? void 0 : relativeStateValue[key];
        return stateNode.historyValue(subStateValue || stateNode.initialStateValue);
      }, function(stateNode) {
        return !stateNode.history;
      })
    };
  };
  StateNode2.prototype.resolveHistory = function(historyValue) {
    var _this = this;
    if (this.type !== "history") {
      return [this];
    }
    var parent = this.parent;
    if (!historyValue) {
      var historyTarget = this.target;
      return historyTarget ? flatten(toStatePaths(historyTarget).map(function(relativeChildPath) {
        return parent.getFromRelativePath(relativeChildPath);
      })) : parent.initialStateNodes;
    }
    var subHistoryValue = nestedPath(parent.path, "states")(historyValue).current;
    if (isString(subHistoryValue)) {
      return [parent.getStateNode(subHistoryValue)];
    }
    return flatten(toStatePaths(subHistoryValue).map(function(subStatePath) {
      return _this.history === "deep" ? parent.getFromRelativePath(subStatePath) : [parent.states[subStatePath[0]]];
    }));
  };
  Object.defineProperty(StateNode2.prototype, "stateIds", {
    get: function() {
      var _this = this;
      var childStateIds = flatten(Object.keys(this.states).map(function(stateKey) {
        return _this.states[stateKey].stateIds;
      }));
      return [this.id].concat(childStateIds);
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(StateNode2.prototype, "events", {
    get: function() {
      var e_8, _a2, e_9, _b;
      if (this.__cache.events) {
        return this.__cache.events;
      }
      var states = this.states;
      var events = new Set(this.ownEvents);
      if (states) {
        try {
          for (var _c = __values(Object.keys(states)), _d = _c.next(); !_d.done; _d = _c.next()) {
            var stateId = _d.value;
            var state = states[stateId];
            if (state.states) {
              try {
                for (var _e = (e_9 = void 0, __values(state.events)), _f = _e.next(); !_f.done; _f = _e.next()) {
                  var event_1 = _f.value;
                  events.add("".concat(event_1));
                }
              } catch (e_9_1) {
                e_9 = {
                  error: e_9_1
                };
              } finally {
                try {
                  if (_f && !_f.done && (_b = _e.return))
                    _b.call(_e);
                } finally {
                  if (e_9)
                    throw e_9.error;
                }
              }
            }
          }
        } catch (e_8_1) {
          e_8 = {
            error: e_8_1
          };
        } finally {
          try {
            if (_d && !_d.done && (_a2 = _c.return))
              _a2.call(_c);
          } finally {
            if (e_8)
              throw e_8.error;
          }
        }
      }
      return this.__cache.events = Array.from(events);
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(StateNode2.prototype, "ownEvents", {
    get: function() {
      var events = new Set(this.transitions.filter(function(transition) {
        return !(!transition.target && !transition.actions.length && transition.internal);
      }).map(function(transition) {
        return transition.eventType;
      }));
      return Array.from(events);
    },
    enumerable: false,
    configurable: true
  });
  StateNode2.prototype.resolveTarget = function(_target) {
    var _this = this;
    if (_target === void 0) {
      return void 0;
    }
    return _target.map(function(target) {
      if (!isString(target)) {
        return target;
      }
      var isInternalTarget = target[0] === _this.delimiter;
      if (isInternalTarget && !_this.parent) {
        return _this.getStateNodeByPath(target.slice(1));
      }
      var resolvedTarget = isInternalTarget ? _this.key + target : target;
      if (_this.parent) {
        try {
          var targetStateNode = _this.parent.getStateNodeByPath(resolvedTarget);
          return targetStateNode;
        } catch (err) {
          throw new Error("Invalid transition definition for state node '".concat(_this.id, "':\n").concat(err.message));
        }
      } else {
        return _this.getStateNodeByPath(resolvedTarget);
      }
    });
  };
  StateNode2.prototype.formatTransition = function(transitionConfig) {
    var _this = this;
    var normalizedTarget = normalizeTarget(transitionConfig.target);
    var internal = "internal" in transitionConfig ? transitionConfig.internal : normalizedTarget ? normalizedTarget.some(function(_target) {
      return isString(_target) && _target[0] === _this.delimiter;
    }) : true;
    var guards = this.machine.options.guards;
    var target = this.resolveTarget(normalizedTarget);
    var transition = __assign$1(__assign$1({}, transitionConfig), {
      actions: toActionObjects(toArray(transitionConfig.actions)),
      cond: toGuard(transitionConfig.cond, guards),
      target,
      source: this,
      internal,
      eventType: transitionConfig.event,
      toJSON: function() {
        return __assign$1(__assign$1({}, transition), {
          target: transition.target ? transition.target.map(function(t2) {
            return "#".concat(t2.id);
          }) : void 0,
          source: "#".concat(_this.id)
        });
      }
    });
    return transition;
  };
  StateNode2.prototype.formatTransitions = function() {
    var e_10, _a2;
    var _this = this;
    var onConfig;
    if (!this.config.on) {
      onConfig = [];
    } else if (Array.isArray(this.config.on)) {
      onConfig = this.config.on;
    } else {
      var _b = this.config.on, _c = WILDCARD, _d = _b[_c], wildcardConfigs = _d === void 0 ? [] : _d, strictTransitionConfigs_1 = __rest$1(_b, [typeof _c === "symbol" ? _c : _c + ""]);
      onConfig = flatten(Object.keys(strictTransitionConfigs_1).map(function(key) {
        var transitionConfigArray = toTransitionConfigArray(key, strictTransitionConfigs_1[key]);
        return transitionConfigArray;
      }).concat(toTransitionConfigArray(WILDCARD, wildcardConfigs)));
    }
    var eventlessConfig = this.config.always ? toTransitionConfigArray("", this.config.always) : [];
    var doneConfig = this.config.onDone ? toTransitionConfigArray(String(done(this.id)), this.config.onDone) : [];
    var invokeConfig = flatten(this.invoke.map(function(invokeDef) {
      var settleTransitions = [];
      if (invokeDef.onDone) {
        settleTransitions.push.apply(settleTransitions, __spreadArray([], __read(toTransitionConfigArray(String(doneInvoke(invokeDef.id)), invokeDef.onDone)), false));
      }
      if (invokeDef.onError) {
        settleTransitions.push.apply(settleTransitions, __spreadArray([], __read(toTransitionConfigArray(String(error(invokeDef.id)), invokeDef.onError)), false));
      }
      return settleTransitions;
    }));
    var delayedTransitions = this.after;
    var formattedTransitions = flatten(__spreadArray(__spreadArray(__spreadArray(__spreadArray([], __read(doneConfig), false), __read(invokeConfig), false), __read(onConfig), false), __read(eventlessConfig), false).map(function(transitionConfig) {
      return toArray(transitionConfig).map(function(transition) {
        return _this.formatTransition(transition);
      });
    }));
    try {
      for (var delayedTransitions_1 = __values(delayedTransitions), delayedTransitions_1_1 = delayedTransitions_1.next(); !delayedTransitions_1_1.done; delayedTransitions_1_1 = delayedTransitions_1.next()) {
        var delayedTransition = delayedTransitions_1_1.value;
        formattedTransitions.push(delayedTransition);
      }
    } catch (e_10_1) {
      e_10 = {
        error: e_10_1
      };
    } finally {
      try {
        if (delayedTransitions_1_1 && !delayedTransitions_1_1.done && (_a2 = delayedTransitions_1.return))
          _a2.call(delayedTransitions_1);
      } finally {
        if (e_10)
          throw e_10.error;
      }
    }
    return formattedTransitions;
  };
  return StateNode2;
}();
var warned = false;
function createMachine(config, options) {
  if (!IS_PRODUCTION && !config.predictableActionArguments && !warned) {
    warned = true;
    console.warn("It is highly recommended to set `predictableActionArguments` to `true` when using `createMachine`. https://xstate.js.org/docs/guides/actions.html");
  }
  return new StateNode(config, options);
}
var assign = assign$1, sendUpdate = sendUpdate$1, forwardTo = forwardTo$1;
const { assign: o$2, stop: s$1 } = r$1, n$1 = (e2) => s$1(e2), i$2 = o$2({ attributeToVerify: (e2) => {
} }), u = o$2({ challengeName: (e2) => {
} }), m = o$2({ requiredAttributes: (e2) => {
} }), l = o$2({ remoteError: (e2) => "" }), d = o$2({ formValues: (e2) => ({}) }), c = o$2({ touched: (e2) => ({}) }), p$1 = o$2({ unverifiedContactMethods: (e2) => {
} }), f$1 = o$2({ username: (e2) => {
} }), v$1 = o$2({ validationError: (e2) => ({}) }), h = o$2({ totpSecretCode: (e2, r2) => r2.data }), g$1 = o$2({ challengeName: (e2, r2) => {
  var t2;
  return null === (t2 = r2.data) || void 0 === t2 ? void 0 : t2.challengeName;
} }), b = o$2({ requiredAttributes: (e2, r2) => {
  var t2, a2;
  return null === (a2 = null === (t2 = r2.data) || void 0 === t2 ? void 0 : t2.challengeParam) || void 0 === a2 ? void 0 : a2.requiredAttributes;
} }), V = o$2({ redirectIntent: (e2) => "confirmPasswordReset" }), j$1 = o$2({ redirectIntent: (e2) => "confirmSignUp" }), y$1 = o$2({ authAttributes: (e2, r2) => {
  var t2, a2;
  const [o2] = e2.loginMechanisms;
  return { username: null !== (t2 = e2.formValues[o2]) && void 0 !== t2 ? t2 : e2.formValues.username, password: null === (a2 = e2.formValues) || void 0 === a2 ? void 0 : a2.password };
} }), O$1 = o$2({ validationError: (e2, r2) => r2.data }), _$1 = o$2({ remoteError: (e2, r2) => {
  var t2;
  return "NoUserPoolError" === r2.data.name ? "Configuration error (see console) \u2013 please contact the administrator" : (null === (t2 = r2.data) || void 0 === t2 ? void 0 : t2.message) || r2.data;
} }), w = o$2({ unverifiedContactMethods: (e2, r2) => r2.data.unverified }), A = o$2({ user: (e2, r2) => r2.data.user || r2.data }), C = o$2({ username: (e2, r2) => {
  let { formValues: { username: t2, country_code: a2 } } = e2;
  return a2 && (t2 = `${a2}${t2}`), t2;
} }), E = o$2({ codeDeliveryDetails: (e2, r2) => r2.data.codeDeliveryDetails }), N = o$2({ authAttributes: (e2, r2) => ({ username: e2.formValues.username }) }), $ = o$2({ formValues: (e2, r2) => {
  const { name: t2, value: a2 } = r2.data;
  return Object.assign(Object.assign({}, e2.formValues), { [t2]: a2 });
} }), D = o$2({ formValues: (e2, r2) => {
  const t2 = Object.assign(Object.assign({}, e2.formValues), r2.data);
  return p$2(t2, "password");
} }), M = o$2({ touched: (e2, r2) => {
  const { name: t2 } = r2.data;
  return Object.assign(Object.assign({}, e2.touched), { [`${t2}`]: true });
} }), P = (t2) => __awaiter(void 0, void 0, void 0, function* () {
  const { username: e2 } = t2;
  return yield Auth.forgotPassword(e2);
}), q = o$2({ formValues: (e2, r2) => {
  var t2;
  const [a2 = "username"] = e2.loginMechanisms;
  if (!e2.formValues.phone_number && "phone_number" !== a2)
    return e2.formValues;
  const { formValues: o2, country_code: s2 } = e2, n2 = o2.phone_number ? "phone_number" : "username", i2 = `${null !== (t2 = o2.country_code) && void 0 !== t2 ? t2 : s2}${o2[n2]}`.replace(/[^A-Z0-9+]/gi, ""), u2 = Object.assign(Object.assign({}, o2), { [n2]: i2 });
  return delete u2.country_code, u2;
} });
var isArray$9 = Array.isArray;
var isArray_1 = isArray$9;
var freeGlobal$1 = typeof commonjsGlobal == "object" && commonjsGlobal && commonjsGlobal.Object === Object && commonjsGlobal;
var _freeGlobal = freeGlobal$1;
var freeGlobal = _freeGlobal;
var freeSelf = typeof self == "object" && self && self.Object === Object && self;
var root$8 = freeGlobal || freeSelf || Function("return this")();
var _root = root$8;
var root$7 = _root;
var Symbol$5 = root$7.Symbol;
var _Symbol = Symbol$5;
var Symbol$4 = _Symbol;
var objectProto$e = Object.prototype;
var hasOwnProperty$b = objectProto$e.hasOwnProperty;
var nativeObjectToString$1 = objectProto$e.toString;
var symToStringTag$1 = Symbol$4 ? Symbol$4.toStringTag : void 0;
function getRawTag$1(value) {
  var isOwn = hasOwnProperty$b.call(value, symToStringTag$1), tag = value[symToStringTag$1];
  try {
    value[symToStringTag$1] = void 0;
    var unmasked = true;
  } catch (e2) {
  }
  var result = nativeObjectToString$1.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag$1] = tag;
    } else {
      delete value[symToStringTag$1];
    }
  }
  return result;
}
var _getRawTag = getRawTag$1;
var objectProto$d = Object.prototype;
var nativeObjectToString = objectProto$d.toString;
function objectToString$1(value) {
  return nativeObjectToString.call(value);
}
var _objectToString = objectToString$1;
var Symbol$3 = _Symbol, getRawTag = _getRawTag, objectToString = _objectToString;
var nullTag = "[object Null]", undefinedTag = "[object Undefined]";
var symToStringTag = Symbol$3 ? Symbol$3.toStringTag : void 0;
function baseGetTag$6(value) {
  if (value == null) {
    return value === void 0 ? undefinedTag : nullTag;
  }
  return symToStringTag && symToStringTag in Object(value) ? getRawTag(value) : objectToString(value);
}
var _baseGetTag = baseGetTag$6;
function isObjectLike$7(value) {
  return value != null && typeof value == "object";
}
var isObjectLike_1 = isObjectLike$7;
var baseGetTag$5 = _baseGetTag, isObjectLike$6 = isObjectLike_1;
var symbolTag$1 = "[object Symbol]";
function isSymbol$3(value) {
  return typeof value == "symbol" || isObjectLike$6(value) && baseGetTag$5(value) == symbolTag$1;
}
var isSymbol_1 = isSymbol$3;
var isArray$8 = isArray_1, isSymbol$2 = isSymbol_1;
var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, reIsPlainProp = /^\w*$/;
function isKey$3(value, object) {
  if (isArray$8(value)) {
    return false;
  }
  var type = typeof value;
  if (type == "number" || type == "symbol" || type == "boolean" || value == null || isSymbol$2(value)) {
    return true;
  }
  return reIsPlainProp.test(value) || !reIsDeepProp.test(value) || object != null && value in Object(object);
}
var _isKey = isKey$3;
function isObject$9(value) {
  var type = typeof value;
  return value != null && (type == "object" || type == "function");
}
var isObject_1 = isObject$9;
var baseGetTag$4 = _baseGetTag, isObject$8 = isObject_1;
var asyncTag = "[object AsyncFunction]", funcTag$1 = "[object Function]", genTag = "[object GeneratorFunction]", proxyTag = "[object Proxy]";
function isFunction$3(value) {
  if (!isObject$8(value)) {
    return false;
  }
  var tag = baseGetTag$4(value);
  return tag == funcTag$1 || tag == genTag || tag == asyncTag || tag == proxyTag;
}
var isFunction_1 = isFunction$3;
var root$6 = _root;
var coreJsData$1 = root$6["__core-js_shared__"];
var _coreJsData = coreJsData$1;
var coreJsData = _coreJsData;
var maskSrcKey = function() {
  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || "");
  return uid ? "Symbol(src)_1." + uid : "";
}();
function isMasked$1(func) {
  return !!maskSrcKey && maskSrcKey in func;
}
var _isMasked = isMasked$1;
var funcProto$2 = Function.prototype;
var funcToString$2 = funcProto$2.toString;
function toSource$2(func) {
  if (func != null) {
    try {
      return funcToString$2.call(func);
    } catch (e2) {
    }
    try {
      return func + "";
    } catch (e2) {
    }
  }
  return "";
}
var _toSource = toSource$2;
var isFunction$2 = isFunction_1, isMasked = _isMasked, isObject$7 = isObject_1, toSource$1 = _toSource;
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
var reIsHostCtor = /^\[object .+?Constructor\]$/;
var funcProto$1 = Function.prototype, objectProto$c = Object.prototype;
var funcToString$1 = funcProto$1.toString;
var hasOwnProperty$a = objectProto$c.hasOwnProperty;
var reIsNative = RegExp(
  "^" + funcToString$1.call(hasOwnProperty$a).replace(reRegExpChar, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
);
function baseIsNative$1(value) {
  if (!isObject$7(value) || isMasked(value)) {
    return false;
  }
  var pattern = isFunction$2(value) ? reIsNative : reIsHostCtor;
  return pattern.test(toSource$1(value));
}
var _baseIsNative = baseIsNative$1;
function getValue$1(object, key) {
  return object == null ? void 0 : object[key];
}
var _getValue = getValue$1;
var baseIsNative = _baseIsNative, getValue = _getValue;
function getNative$7(object, key) {
  var value = getValue(object, key);
  return baseIsNative(value) ? value : void 0;
}
var _getNative = getNative$7;
var getNative$6 = _getNative;
var nativeCreate$4 = getNative$6(Object, "create");
var _nativeCreate = nativeCreate$4;
var nativeCreate$3 = _nativeCreate;
function hashClear$1() {
  this.__data__ = nativeCreate$3 ? nativeCreate$3(null) : {};
  this.size = 0;
}
var _hashClear = hashClear$1;
function hashDelete$1(key) {
  var result = this.has(key) && delete this.__data__[key];
  this.size -= result ? 1 : 0;
  return result;
}
var _hashDelete = hashDelete$1;
var nativeCreate$2 = _nativeCreate;
var HASH_UNDEFINED$2 = "__lodash_hash_undefined__";
var objectProto$b = Object.prototype;
var hasOwnProperty$9 = objectProto$b.hasOwnProperty;
function hashGet$1(key) {
  var data = this.__data__;
  if (nativeCreate$2) {
    var result = data[key];
    return result === HASH_UNDEFINED$2 ? void 0 : result;
  }
  return hasOwnProperty$9.call(data, key) ? data[key] : void 0;
}
var _hashGet = hashGet$1;
var nativeCreate$1 = _nativeCreate;
var objectProto$a = Object.prototype;
var hasOwnProperty$8 = objectProto$a.hasOwnProperty;
function hashHas$1(key) {
  var data = this.__data__;
  return nativeCreate$1 ? data[key] !== void 0 : hasOwnProperty$8.call(data, key);
}
var _hashHas = hashHas$1;
var nativeCreate = _nativeCreate;
var HASH_UNDEFINED$1 = "__lodash_hash_undefined__";
function hashSet$1(key, value) {
  var data = this.__data__;
  this.size += this.has(key) ? 0 : 1;
  data[key] = nativeCreate && value === void 0 ? HASH_UNDEFINED$1 : value;
  return this;
}
var _hashSet = hashSet$1;
var hashClear = _hashClear, hashDelete = _hashDelete, hashGet = _hashGet, hashHas = _hashHas, hashSet = _hashSet;
function Hash$1(entries) {
  var index2 = -1, length = entries == null ? 0 : entries.length;
  this.clear();
  while (++index2 < length) {
    var entry = entries[index2];
    this.set(entry[0], entry[1]);
  }
}
Hash$1.prototype.clear = hashClear;
Hash$1.prototype["delete"] = hashDelete;
Hash$1.prototype.get = hashGet;
Hash$1.prototype.has = hashHas;
Hash$1.prototype.set = hashSet;
var _Hash = Hash$1;
function listCacheClear$1() {
  this.__data__ = [];
  this.size = 0;
}
var _listCacheClear = listCacheClear$1;
function eq$5(value, other) {
  return value === other || value !== value && other !== other;
}
var eq_1 = eq$5;
var eq$4 = eq_1;
function assocIndexOf$4(array, key) {
  var length = array.length;
  while (length--) {
    if (eq$4(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}
var _assocIndexOf = assocIndexOf$4;
var assocIndexOf$3 = _assocIndexOf;
var arrayProto = Array.prototype;
var splice = arrayProto.splice;
function listCacheDelete$1(key) {
  var data = this.__data__, index2 = assocIndexOf$3(data, key);
  if (index2 < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index2 == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index2, 1);
  }
  --this.size;
  return true;
}
var _listCacheDelete = listCacheDelete$1;
var assocIndexOf$2 = _assocIndexOf;
function listCacheGet$1(key) {
  var data = this.__data__, index2 = assocIndexOf$2(data, key);
  return index2 < 0 ? void 0 : data[index2][1];
}
var _listCacheGet = listCacheGet$1;
var assocIndexOf$1 = _assocIndexOf;
function listCacheHas$1(key) {
  return assocIndexOf$1(this.__data__, key) > -1;
}
var _listCacheHas = listCacheHas$1;
var assocIndexOf = _assocIndexOf;
function listCacheSet$1(key, value) {
  var data = this.__data__, index2 = assocIndexOf(data, key);
  if (index2 < 0) {
    ++this.size;
    data.push([key, value]);
  } else {
    data[index2][1] = value;
  }
  return this;
}
var _listCacheSet = listCacheSet$1;
var listCacheClear = _listCacheClear, listCacheDelete = _listCacheDelete, listCacheGet = _listCacheGet, listCacheHas = _listCacheHas, listCacheSet = _listCacheSet;
function ListCache$4(entries) {
  var index2 = -1, length = entries == null ? 0 : entries.length;
  this.clear();
  while (++index2 < length) {
    var entry = entries[index2];
    this.set(entry[0], entry[1]);
  }
}
ListCache$4.prototype.clear = listCacheClear;
ListCache$4.prototype["delete"] = listCacheDelete;
ListCache$4.prototype.get = listCacheGet;
ListCache$4.prototype.has = listCacheHas;
ListCache$4.prototype.set = listCacheSet;
var _ListCache = ListCache$4;
var getNative$5 = _getNative, root$5 = _root;
var Map$4 = getNative$5(root$5, "Map");
var _Map = Map$4;
var Hash = _Hash, ListCache$3 = _ListCache, Map$3 = _Map;
function mapCacheClear$1() {
  this.size = 0;
  this.__data__ = {
    "hash": new Hash(),
    "map": new (Map$3 || ListCache$3)(),
    "string": new Hash()
  };
}
var _mapCacheClear = mapCacheClear$1;
function isKeyable$1(value) {
  var type = typeof value;
  return type == "string" || type == "number" || type == "symbol" || type == "boolean" ? value !== "__proto__" : value === null;
}
var _isKeyable = isKeyable$1;
var isKeyable = _isKeyable;
function getMapData$4(map, key) {
  var data = map.__data__;
  return isKeyable(key) ? data[typeof key == "string" ? "string" : "hash"] : data.map;
}
var _getMapData = getMapData$4;
var getMapData$3 = _getMapData;
function mapCacheDelete$1(key) {
  var result = getMapData$3(this, key)["delete"](key);
  this.size -= result ? 1 : 0;
  return result;
}
var _mapCacheDelete = mapCacheDelete$1;
var getMapData$2 = _getMapData;
function mapCacheGet$1(key) {
  return getMapData$2(this, key).get(key);
}
var _mapCacheGet = mapCacheGet$1;
var getMapData$1 = _getMapData;
function mapCacheHas$1(key) {
  return getMapData$1(this, key).has(key);
}
var _mapCacheHas = mapCacheHas$1;
var getMapData = _getMapData;
function mapCacheSet$1(key, value) {
  var data = getMapData(this, key), size = data.size;
  data.set(key, value);
  this.size += data.size == size ? 0 : 1;
  return this;
}
var _mapCacheSet = mapCacheSet$1;
var mapCacheClear = _mapCacheClear, mapCacheDelete = _mapCacheDelete, mapCacheGet = _mapCacheGet, mapCacheHas = _mapCacheHas, mapCacheSet = _mapCacheSet;
function MapCache$3(entries) {
  var index2 = -1, length = entries == null ? 0 : entries.length;
  this.clear();
  while (++index2 < length) {
    var entry = entries[index2];
    this.set(entry[0], entry[1]);
  }
}
MapCache$3.prototype.clear = mapCacheClear;
MapCache$3.prototype["delete"] = mapCacheDelete;
MapCache$3.prototype.get = mapCacheGet;
MapCache$3.prototype.has = mapCacheHas;
MapCache$3.prototype.set = mapCacheSet;
var _MapCache = MapCache$3;
var MapCache$2 = _MapCache;
var FUNC_ERROR_TEXT = "Expected a function";
function memoize$1(func, resolver) {
  if (typeof func != "function" || resolver != null && typeof resolver != "function") {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  var memoized = function() {
    var args = arguments, key = resolver ? resolver.apply(this, args) : args[0], cache = memoized.cache;
    if (cache.has(key)) {
      return cache.get(key);
    }
    var result = func.apply(this, args);
    memoized.cache = cache.set(key, result) || cache;
    return result;
  };
  memoized.cache = new (memoize$1.Cache || MapCache$2)();
  return memoized;
}
memoize$1.Cache = MapCache$2;
var memoize_1 = memoize$1;
var memoize = memoize_1;
var MAX_MEMOIZE_SIZE = 500;
function memoizeCapped$1(func) {
  var result = memoize(func, function(key) {
    if (cache.size === MAX_MEMOIZE_SIZE) {
      cache.clear();
    }
    return key;
  });
  var cache = result.cache;
  return result;
}
var _memoizeCapped = memoizeCapped$1;
var memoizeCapped = _memoizeCapped;
var rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
var reEscapeChar = /\\(\\)?/g;
var stringToPath$1 = memoizeCapped(function(string) {
  var result = [];
  if (string.charCodeAt(0) === 46) {
    result.push("");
  }
  string.replace(rePropName, function(match, number, quote, subString) {
    result.push(quote ? subString.replace(reEscapeChar, "$1") : number || match);
  });
  return result;
});
var _stringToPath = stringToPath$1;
function arrayMap$2(array, iteratee) {
  var index2 = -1, length = array == null ? 0 : array.length, result = Array(length);
  while (++index2 < length) {
    result[index2] = iteratee(array[index2], index2, array);
  }
  return result;
}
var _arrayMap = arrayMap$2;
var Symbol$2 = _Symbol, arrayMap$1 = _arrayMap, isArray$7 = isArray_1, isSymbol$1 = isSymbol_1;
var INFINITY$1 = 1 / 0;
var symbolProto$1 = Symbol$2 ? Symbol$2.prototype : void 0, symbolToString = symbolProto$1 ? symbolProto$1.toString : void 0;
function baseToString$1(value) {
  if (typeof value == "string") {
    return value;
  }
  if (isArray$7(value)) {
    return arrayMap$1(value, baseToString$1) + "";
  }
  if (isSymbol$1(value)) {
    return symbolToString ? symbolToString.call(value) : "";
  }
  var result = value + "";
  return result == "0" && 1 / value == -INFINITY$1 ? "-0" : result;
}
var _baseToString = baseToString$1;
var baseToString = _baseToString;
function toString$1(value) {
  return value == null ? "" : baseToString(value);
}
var toString_1 = toString$1;
var isArray$6 = isArray_1, isKey$2 = _isKey, stringToPath = _stringToPath, toString = toString_1;
function castPath$4(value, object) {
  if (isArray$6(value)) {
    return value;
  }
  return isKey$2(value, object) ? [value] : stringToPath(toString(value));
}
var _castPath = castPath$4;
var isSymbol = isSymbol_1;
var INFINITY = 1 / 0;
function toKey$5(value) {
  if (typeof value == "string" || isSymbol(value)) {
    return value;
  }
  var result = value + "";
  return result == "0" && 1 / value == -INFINITY ? "-0" : result;
}
var _toKey = toKey$5;
var castPath$3 = _castPath, toKey$4 = _toKey;
function baseGet$3(object, path2) {
  path2 = castPath$3(path2, object);
  var index2 = 0, length = path2.length;
  while (object != null && index2 < length) {
    object = object[toKey$4(path2[index2++])];
  }
  return index2 && index2 == length ? object : void 0;
}
var _baseGet = baseGet$3;
var baseGet$2 = _baseGet;
function get$1(object, path2, defaultValue) {
  var result = object == null ? void 0 : baseGet$2(object, path2);
  return result === void 0 ? defaultValue : result;
}
var get_1 = get$1;
var ListCache$2 = _ListCache;
function stackClear$1() {
  this.__data__ = new ListCache$2();
  this.size = 0;
}
var _stackClear = stackClear$1;
function stackDelete$1(key) {
  var data = this.__data__, result = data["delete"](key);
  this.size = data.size;
  return result;
}
var _stackDelete = stackDelete$1;
function stackGet$1(key) {
  return this.__data__.get(key);
}
var _stackGet = stackGet$1;
function stackHas$1(key) {
  return this.__data__.has(key);
}
var _stackHas = stackHas$1;
var ListCache$1 = _ListCache, Map$2 = _Map, MapCache$1 = _MapCache;
var LARGE_ARRAY_SIZE = 200;
function stackSet$1(key, value) {
  var data = this.__data__;
  if (data instanceof ListCache$1) {
    var pairs = data.__data__;
    if (!Map$2 || pairs.length < LARGE_ARRAY_SIZE - 1) {
      pairs.push([key, value]);
      this.size = ++data.size;
      return this;
    }
    data = this.__data__ = new MapCache$1(pairs);
  }
  data.set(key, value);
  this.size = data.size;
  return this;
}
var _stackSet = stackSet$1;
var ListCache = _ListCache, stackClear = _stackClear, stackDelete = _stackDelete, stackGet = _stackGet, stackHas = _stackHas, stackSet = _stackSet;
function Stack$3(entries) {
  var data = this.__data__ = new ListCache(entries);
  this.size = data.size;
}
Stack$3.prototype.clear = stackClear;
Stack$3.prototype["delete"] = stackDelete;
Stack$3.prototype.get = stackGet;
Stack$3.prototype.has = stackHas;
Stack$3.prototype.set = stackSet;
var _Stack = Stack$3;
var getNative$4 = _getNative;
var defineProperty$2 = function() {
  try {
    var func = getNative$4(Object, "defineProperty");
    func({}, "", {});
    return func;
  } catch (e2) {
  }
}();
var _defineProperty = defineProperty$2;
var defineProperty$1 = _defineProperty;
function baseAssignValue$3(object, key, value) {
  if (key == "__proto__" && defineProperty$1) {
    defineProperty$1(object, key, {
      "configurable": true,
      "enumerable": true,
      "value": value,
      "writable": true
    });
  } else {
    object[key] = value;
  }
}
var _baseAssignValue = baseAssignValue$3;
var baseAssignValue$2 = _baseAssignValue, eq$3 = eq_1;
function assignMergeValue$2(object, key, value) {
  if (value !== void 0 && !eq$3(object[key], value) || value === void 0 && !(key in object)) {
    baseAssignValue$2(object, key, value);
  }
}
var _assignMergeValue = assignMergeValue$2;
function createBaseFor$1(fromRight) {
  return function(object, iteratee, keysFunc) {
    var index2 = -1, iterable = Object(object), props = keysFunc(object), length = props.length;
    while (length--) {
      var key = props[fromRight ? length : ++index2];
      if (iteratee(iterable[key], key, iterable) === false) {
        break;
      }
    }
    return object;
  };
}
var _createBaseFor = createBaseFor$1;
var createBaseFor = _createBaseFor;
var baseFor$1 = createBaseFor();
var _baseFor = baseFor$1;
var _cloneBuffer = { exports: {} };
(function(module, exports) {
  var root2 = _root;
  var freeExports = exports && !exports.nodeType && exports;
  var freeModule = freeExports && true && module && !module.nodeType && module;
  var moduleExports = freeModule && freeModule.exports === freeExports;
  var Buffer = moduleExports ? root2.Buffer : void 0, allocUnsafe = Buffer ? Buffer.allocUnsafe : void 0;
  function cloneBuffer2(buffer, isDeep) {
    if (isDeep) {
      return buffer.slice();
    }
    var length = buffer.length, result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);
    buffer.copy(result);
    return result;
  }
  module.exports = cloneBuffer2;
})(_cloneBuffer, _cloneBuffer.exports);
var root$4 = _root;
var Uint8Array$3 = root$4.Uint8Array;
var _Uint8Array = Uint8Array$3;
var Uint8Array$2 = _Uint8Array;
function cloneArrayBuffer$1(arrayBuffer) {
  var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
  new Uint8Array$2(result).set(new Uint8Array$2(arrayBuffer));
  return result;
}
var _cloneArrayBuffer = cloneArrayBuffer$1;
var cloneArrayBuffer = _cloneArrayBuffer;
function cloneTypedArray$1(typedArray, isDeep) {
  var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
  return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
}
var _cloneTypedArray = cloneTypedArray$1;
function copyArray$1(source, array) {
  var index2 = -1, length = source.length;
  array || (array = Array(length));
  while (++index2 < length) {
    array[index2] = source[index2];
  }
  return array;
}
var _copyArray = copyArray$1;
var isObject$6 = isObject_1;
var objectCreate = Object.create;
var baseCreate$1 = function() {
  function object() {
  }
  return function(proto) {
    if (!isObject$6(proto)) {
      return {};
    }
    if (objectCreate) {
      return objectCreate(proto);
    }
    object.prototype = proto;
    var result = new object();
    object.prototype = void 0;
    return result;
  };
}();
var _baseCreate = baseCreate$1;
function overArg$2(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}
var _overArg = overArg$2;
var overArg$1 = _overArg;
var getPrototype$3 = overArg$1(Object.getPrototypeOf, Object);
var _getPrototype = getPrototype$3;
var objectProto$9 = Object.prototype;
function isPrototype$3(value) {
  var Ctor = value && value.constructor, proto = typeof Ctor == "function" && Ctor.prototype || objectProto$9;
  return value === proto;
}
var _isPrototype = isPrototype$3;
var baseCreate = _baseCreate, getPrototype$2 = _getPrototype, isPrototype$2 = _isPrototype;
function initCloneObject$1(object) {
  return typeof object.constructor == "function" && !isPrototype$2(object) ? baseCreate(getPrototype$2(object)) : {};
}
var _initCloneObject = initCloneObject$1;
var baseGetTag$3 = _baseGetTag, isObjectLike$5 = isObjectLike_1;
var argsTag$2 = "[object Arguments]";
function baseIsArguments$1(value) {
  return isObjectLike$5(value) && baseGetTag$3(value) == argsTag$2;
}
var _baseIsArguments = baseIsArguments$1;
var baseIsArguments = _baseIsArguments, isObjectLike$4 = isObjectLike_1;
var objectProto$8 = Object.prototype;
var hasOwnProperty$7 = objectProto$8.hasOwnProperty;
var propertyIsEnumerable$1 = objectProto$8.propertyIsEnumerable;
var isArguments$3 = baseIsArguments(function() {
  return arguments;
}()) ? baseIsArguments : function(value) {
  return isObjectLike$4(value) && hasOwnProperty$7.call(value, "callee") && !propertyIsEnumerable$1.call(value, "callee");
};
var isArguments_1 = isArguments$3;
var MAX_SAFE_INTEGER$1 = 9007199254740991;
function isLength$3(value) {
  return typeof value == "number" && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER$1;
}
var isLength_1 = isLength$3;
var isFunction$1 = isFunction_1, isLength$2 = isLength_1;
function isArrayLike$4(value) {
  return value != null && isLength$2(value.length) && !isFunction$1(value);
}
var isArrayLike_1 = isArrayLike$4;
var isArrayLike$3 = isArrayLike_1, isObjectLike$3 = isObjectLike_1;
function isArrayLikeObject$1(value) {
  return isObjectLike$3(value) && isArrayLike$3(value);
}
var isArrayLikeObject_1 = isArrayLikeObject$1;
var isBuffer$3 = { exports: {} };
function stubFalse() {
  return false;
}
var stubFalse_1 = stubFalse;
(function(module, exports) {
  var root2 = _root, stubFalse2 = stubFalse_1;
  var freeExports = exports && !exports.nodeType && exports;
  var freeModule = freeExports && true && module && !module.nodeType && module;
  var moduleExports = freeModule && freeModule.exports === freeExports;
  var Buffer = moduleExports ? root2.Buffer : void 0;
  var nativeIsBuffer = Buffer ? Buffer.isBuffer : void 0;
  var isBuffer2 = nativeIsBuffer || stubFalse2;
  module.exports = isBuffer2;
})(isBuffer$3, isBuffer$3.exports);
var baseGetTag$2 = _baseGetTag, getPrototype$1 = _getPrototype, isObjectLike$2 = isObjectLike_1;
var objectTag$3 = "[object Object]";
var funcProto = Function.prototype, objectProto$7 = Object.prototype;
var funcToString = funcProto.toString;
var hasOwnProperty$6 = objectProto$7.hasOwnProperty;
var objectCtorString = funcToString.call(Object);
function isPlainObject$1(value) {
  if (!isObjectLike$2(value) || baseGetTag$2(value) != objectTag$3) {
    return false;
  }
  var proto = getPrototype$1(value);
  if (proto === null) {
    return true;
  }
  var Ctor = hasOwnProperty$6.call(proto, "constructor") && proto.constructor;
  return typeof Ctor == "function" && Ctor instanceof Ctor && funcToString.call(Ctor) == objectCtorString;
}
var isPlainObject_1 = isPlainObject$1;
var baseGetTag$1 = _baseGetTag, isLength$1 = isLength_1, isObjectLike$1 = isObjectLike_1;
var argsTag$1 = "[object Arguments]", arrayTag$1 = "[object Array]", boolTag$1 = "[object Boolean]", dateTag$1 = "[object Date]", errorTag$1 = "[object Error]", funcTag = "[object Function]", mapTag$2 = "[object Map]", numberTag$1 = "[object Number]", objectTag$2 = "[object Object]", regexpTag$1 = "[object RegExp]", setTag$2 = "[object Set]", stringTag$1 = "[object String]", weakMapTag$1 = "[object WeakMap]";
var arrayBufferTag$1 = "[object ArrayBuffer]", dataViewTag$2 = "[object DataView]", float32Tag = "[object Float32Array]", float64Tag = "[object Float64Array]", int8Tag = "[object Int8Array]", int16Tag = "[object Int16Array]", int32Tag = "[object Int32Array]", uint8Tag = "[object Uint8Array]", uint8ClampedTag = "[object Uint8ClampedArray]", uint16Tag = "[object Uint16Array]", uint32Tag = "[object Uint32Array]";
var typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] = typedArrayTags[int8Tag] = typedArrayTags[int16Tag] = typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] = typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] = typedArrayTags[uint32Tag] = true;
typedArrayTags[argsTag$1] = typedArrayTags[arrayTag$1] = typedArrayTags[arrayBufferTag$1] = typedArrayTags[boolTag$1] = typedArrayTags[dataViewTag$2] = typedArrayTags[dateTag$1] = typedArrayTags[errorTag$1] = typedArrayTags[funcTag] = typedArrayTags[mapTag$2] = typedArrayTags[numberTag$1] = typedArrayTags[objectTag$2] = typedArrayTags[regexpTag$1] = typedArrayTags[setTag$2] = typedArrayTags[stringTag$1] = typedArrayTags[weakMapTag$1] = false;
function baseIsTypedArray$1(value) {
  return isObjectLike$1(value) && isLength$1(value.length) && !!typedArrayTags[baseGetTag$1(value)];
}
var _baseIsTypedArray = baseIsTypedArray$1;
function baseUnary$1(func) {
  return function(value) {
    return func(value);
  };
}
var _baseUnary = baseUnary$1;
var _nodeUtil = { exports: {} };
(function(module, exports) {
  var freeGlobal2 = _freeGlobal;
  var freeExports = exports && !exports.nodeType && exports;
  var freeModule = freeExports && true && module && !module.nodeType && module;
  var moduleExports = freeModule && freeModule.exports === freeExports;
  var freeProcess = moduleExports && freeGlobal2.process;
  var nodeUtil2 = function() {
    try {
      var types = freeModule && freeModule.require && freeModule.require("util").types;
      if (types) {
        return types;
      }
      return freeProcess && freeProcess.binding && freeProcess.binding("util");
    } catch (e2) {
    }
  }();
  module.exports = nodeUtil2;
})(_nodeUtil, _nodeUtil.exports);
var baseIsTypedArray = _baseIsTypedArray, baseUnary = _baseUnary, nodeUtil = _nodeUtil.exports;
var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
var isTypedArray$3 = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
var isTypedArray_1 = isTypedArray$3;
function safeGet$2(object, key) {
  if (key === "constructor" && typeof object[key] === "function") {
    return;
  }
  if (key == "__proto__") {
    return;
  }
  return object[key];
}
var _safeGet = safeGet$2;
var baseAssignValue$1 = _baseAssignValue, eq$2 = eq_1;
var objectProto$6 = Object.prototype;
var hasOwnProperty$5 = objectProto$6.hasOwnProperty;
function assignValue$2(object, key, value) {
  var objValue = object[key];
  if (!(hasOwnProperty$5.call(object, key) && eq$2(objValue, value)) || value === void 0 && !(key in object)) {
    baseAssignValue$1(object, key, value);
  }
}
var _assignValue = assignValue$2;
var assignValue$1 = _assignValue, baseAssignValue = _baseAssignValue;
function copyObject$1(source, props, object, customizer) {
  var isNew = !object;
  object || (object = {});
  var index2 = -1, length = props.length;
  while (++index2 < length) {
    var key = props[index2];
    var newValue = customizer ? customizer(object[key], source[key], key, object, source) : void 0;
    if (newValue === void 0) {
      newValue = source[key];
    }
    if (isNew) {
      baseAssignValue(object, key, newValue);
    } else {
      assignValue$1(object, key, newValue);
    }
  }
  return object;
}
var _copyObject = copyObject$1;
function baseTimes$1(n2, iteratee) {
  var index2 = -1, result = Array(n2);
  while (++index2 < n2) {
    result[index2] = iteratee(index2);
  }
  return result;
}
var _baseTimes = baseTimes$1;
var MAX_SAFE_INTEGER = 9007199254740991;
var reIsUint = /^(?:0|[1-9]\d*)$/;
function isIndex$4(value, length) {
  var type = typeof value;
  length = length == null ? MAX_SAFE_INTEGER : length;
  return !!length && (type == "number" || type != "symbol" && reIsUint.test(value)) && (value > -1 && value % 1 == 0 && value < length);
}
var _isIndex = isIndex$4;
var baseTimes = _baseTimes, isArguments$2 = isArguments_1, isArray$5 = isArray_1, isBuffer$2 = isBuffer$3.exports, isIndex$3 = _isIndex, isTypedArray$2 = isTypedArray_1;
var objectProto$5 = Object.prototype;
var hasOwnProperty$4 = objectProto$5.hasOwnProperty;
function arrayLikeKeys$2(value, inherited) {
  var isArr = isArray$5(value), isArg = !isArr && isArguments$2(value), isBuff = !isArr && !isArg && isBuffer$2(value), isType = !isArr && !isArg && !isBuff && isTypedArray$2(value), skipIndexes = isArr || isArg || isBuff || isType, result = skipIndexes ? baseTimes(value.length, String) : [], length = result.length;
  for (var key in value) {
    if ((inherited || hasOwnProperty$4.call(value, key)) && !(skipIndexes && (key == "length" || isBuff && (key == "offset" || key == "parent") || isType && (key == "buffer" || key == "byteLength" || key == "byteOffset") || isIndex$3(key, length)))) {
      result.push(key);
    }
  }
  return result;
}
var _arrayLikeKeys = arrayLikeKeys$2;
function nativeKeysIn$1(object) {
  var result = [];
  if (object != null) {
    for (var key in Object(object)) {
      result.push(key);
    }
  }
  return result;
}
var _nativeKeysIn = nativeKeysIn$1;
var isObject$5 = isObject_1, isPrototype$1 = _isPrototype, nativeKeysIn = _nativeKeysIn;
var objectProto$4 = Object.prototype;
var hasOwnProperty$3 = objectProto$4.hasOwnProperty;
function baseKeysIn$1(object) {
  if (!isObject$5(object)) {
    return nativeKeysIn(object);
  }
  var isProto = isPrototype$1(object), result = [];
  for (var key in object) {
    if (!(key == "constructor" && (isProto || !hasOwnProperty$3.call(object, key)))) {
      result.push(key);
    }
  }
  return result;
}
var _baseKeysIn = baseKeysIn$1;
var arrayLikeKeys$1 = _arrayLikeKeys, baseKeysIn = _baseKeysIn, isArrayLike$2 = isArrayLike_1;
function keysIn$3(object) {
  return isArrayLike$2(object) ? arrayLikeKeys$1(object, true) : baseKeysIn(object);
}
var keysIn_1 = keysIn$3;
var copyObject = _copyObject, keysIn$2 = keysIn_1;
function toPlainObject$1(value) {
  return copyObject(value, keysIn$2(value));
}
var toPlainObject_1 = toPlainObject$1;
var assignMergeValue$1 = _assignMergeValue, cloneBuffer = _cloneBuffer.exports, cloneTypedArray = _cloneTypedArray, copyArray = _copyArray, initCloneObject = _initCloneObject, isArguments$1 = isArguments_1, isArray$4 = isArray_1, isArrayLikeObject = isArrayLikeObject_1, isBuffer$1 = isBuffer$3.exports, isFunction = isFunction_1, isObject$4 = isObject_1, isPlainObject = isPlainObject_1, isTypedArray$1 = isTypedArray_1, safeGet$1 = _safeGet, toPlainObject = toPlainObject_1;
function baseMergeDeep$1(object, source, key, srcIndex, mergeFunc, customizer, stack) {
  var objValue = safeGet$1(object, key), srcValue = safeGet$1(source, key), stacked = stack.get(srcValue);
  if (stacked) {
    assignMergeValue$1(object, key, stacked);
    return;
  }
  var newValue = customizer ? customizer(objValue, srcValue, key + "", object, source, stack) : void 0;
  var isCommon = newValue === void 0;
  if (isCommon) {
    var isArr = isArray$4(srcValue), isBuff = !isArr && isBuffer$1(srcValue), isTyped = !isArr && !isBuff && isTypedArray$1(srcValue);
    newValue = srcValue;
    if (isArr || isBuff || isTyped) {
      if (isArray$4(objValue)) {
        newValue = objValue;
      } else if (isArrayLikeObject(objValue)) {
        newValue = copyArray(objValue);
      } else if (isBuff) {
        isCommon = false;
        newValue = cloneBuffer(srcValue, true);
      } else if (isTyped) {
        isCommon = false;
        newValue = cloneTypedArray(srcValue, true);
      } else {
        newValue = [];
      }
    } else if (isPlainObject(srcValue) || isArguments$1(srcValue)) {
      newValue = objValue;
      if (isArguments$1(objValue)) {
        newValue = toPlainObject(objValue);
      } else if (!isObject$4(objValue) || isFunction(objValue)) {
        newValue = initCloneObject(srcValue);
      }
    } else {
      isCommon = false;
    }
  }
  if (isCommon) {
    stack.set(srcValue, newValue);
    mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
    stack["delete"](srcValue);
  }
  assignMergeValue$1(object, key, newValue);
}
var _baseMergeDeep = baseMergeDeep$1;
var Stack$2 = _Stack, assignMergeValue = _assignMergeValue, baseFor = _baseFor, baseMergeDeep = _baseMergeDeep, isObject$3 = isObject_1, keysIn$1 = keysIn_1, safeGet = _safeGet;
function baseMerge$1(object, source, srcIndex, customizer, stack) {
  if (object === source) {
    return;
  }
  baseFor(source, function(srcValue, key) {
    stack || (stack = new Stack$2());
    if (isObject$3(srcValue)) {
      baseMergeDeep(object, source, key, srcIndex, baseMerge$1, customizer, stack);
    } else {
      var newValue = customizer ? customizer(safeGet(object, key), srcValue, key + "", object, source, stack) : void 0;
      if (newValue === void 0) {
        newValue = srcValue;
      }
      assignMergeValue(object, key, newValue);
    }
  }, keysIn$1);
}
var _baseMerge = baseMerge$1;
function identity$3(value) {
  return value;
}
var identity_1 = identity$3;
function apply$1(func, thisArg, args) {
  switch (args.length) {
    case 0:
      return func.call(thisArg);
    case 1:
      return func.call(thisArg, args[0]);
    case 2:
      return func.call(thisArg, args[0], args[1]);
    case 3:
      return func.call(thisArg, args[0], args[1], args[2]);
  }
  return func.apply(thisArg, args);
}
var _apply = apply$1;
var apply = _apply;
var nativeMax = Math.max;
function overRest$1(func, start2, transform) {
  start2 = nativeMax(start2 === void 0 ? func.length - 1 : start2, 0);
  return function() {
    var args = arguments, index2 = -1, length = nativeMax(args.length - start2, 0), array = Array(length);
    while (++index2 < length) {
      array[index2] = args[start2 + index2];
    }
    index2 = -1;
    var otherArgs = Array(start2 + 1);
    while (++index2 < start2) {
      otherArgs[index2] = args[index2];
    }
    otherArgs[start2] = transform(array);
    return apply(func, this, otherArgs);
  };
}
var _overRest = overRest$1;
function constant$1(value) {
  return function() {
    return value;
  };
}
var constant_1 = constant$1;
var constant = constant_1, defineProperty = _defineProperty, identity$2 = identity_1;
var baseSetToString$1 = !defineProperty ? identity$2 : function(func, string) {
  return defineProperty(func, "toString", {
    "configurable": true,
    "enumerable": false,
    "value": constant(string),
    "writable": true
  });
};
var _baseSetToString = baseSetToString$1;
var HOT_COUNT = 800, HOT_SPAN = 16;
var nativeNow = Date.now;
function shortOut$1(func) {
  var count = 0, lastCalled = 0;
  return function() {
    var stamp = nativeNow(), remaining = HOT_SPAN - (stamp - lastCalled);
    lastCalled = stamp;
    if (remaining > 0) {
      if (++count >= HOT_COUNT) {
        return arguments[0];
      }
    } else {
      count = 0;
    }
    return func.apply(void 0, arguments);
  };
}
var _shortOut = shortOut$1;
var baseSetToString = _baseSetToString, shortOut = _shortOut;
var setToString$1 = shortOut(baseSetToString);
var _setToString = setToString$1;
var identity$1 = identity_1, overRest = _overRest, setToString = _setToString;
function baseRest$1(func, start2) {
  return setToString(overRest(func, start2, identity$1), func + "");
}
var _baseRest = baseRest$1;
var eq$1 = eq_1, isArrayLike$1 = isArrayLike_1, isIndex$2 = _isIndex, isObject$2 = isObject_1;
function isIterateeCall$1(value, index2, object) {
  if (!isObject$2(object)) {
    return false;
  }
  var type = typeof index2;
  if (type == "number" ? isArrayLike$1(object) && isIndex$2(index2, object.length) : type == "string" && index2 in object) {
    return eq$1(object[index2], value);
  }
  return false;
}
var _isIterateeCall = isIterateeCall$1;
var baseRest = _baseRest, isIterateeCall = _isIterateeCall;
function createAssigner$1(assigner) {
  return baseRest(function(object, sources) {
    var index2 = -1, length = sources.length, customizer = length > 1 ? sources[length - 1] : void 0, guard = length > 2 ? sources[2] : void 0;
    customizer = assigner.length > 3 && typeof customizer == "function" ? (length--, customizer) : void 0;
    if (guard && isIterateeCall(sources[0], sources[1], guard)) {
      customizer = length < 3 ? void 0 : customizer;
      length = 1;
    }
    object = Object(object);
    while (++index2 < length) {
      var source = sources[index2];
      if (source) {
        assigner(object, source, index2, customizer);
      }
    }
    return object;
  });
}
var _createAssigner = createAssigner$1;
var baseMerge = _baseMerge, createAssigner = _createAssigner;
var merge = createAssigner(function(object, source, srcIndex) {
  baseMerge(object, source, srcIndex);
});
var merge_1 = merge;
function r(t2) {
  return null != t2 && !Array.isArray(t2) && "object" == typeof t2;
}
function n(t2) {
  return "string" == typeof t2 || "object" == typeof t2 && "[object String]" === Object.prototype.toString.call(t2);
}
function e$1(t2) {
  return r(t2) && "[object Map]" === Object.prototype.toString.call(t2);
}
function o$1(t2) {
  return r(t2) && "[object Set]" === Object.prototype.toString.call(t2);
}
function i$1(t2) {
  if (null == t2)
    return true;
  if (r(t2) && (e$1(t2) || o$1(t2)))
    return !t2.size;
  if (r(t2) && (n(t2) || Array.isArray(t2)))
    return !t2.length;
  for (const r2 in t2)
    if (s(t2, r2))
      return false;
  return true;
}
function s(t2, r2) {
  return null != t2 && Object.prototype.hasOwnProperty.call(t2, r2);
}
const e = (e2, m2, s2, t2) => __awaiter(void 0, void 0, void 0, function* () {
  const o2 = yield Promise.all(t2.map((o3) => o3(e2, m2, s2))), l2 = merge_1({}, ...o2);
  return i$1(l2) ? Promise.resolve() : Promise.reject(l2);
});
const o = { getAmplifyConfig() {
  return __awaiter(this, void 0, void 0, function* () {
    return Amplify.configure();
  });
}, getCurrentUser() {
  return __awaiter(this, void 0, void 0, function* () {
    return Auth.currentAuthenticatedUser();
  });
}, handleSignUp(t2) {
  return __awaiter(this, void 0, void 0, function* () {
    return Auth.signUp(Object.assign(Object.assign({}, t2), { autoSignIn: { enabled: true } }));
  });
}, handleSignIn({ username: t2, password: n2 }) {
  return __awaiter(this, void 0, void 0, function* () {
    return Auth.signIn(t2, n2);
  });
}, handleConfirmSignIn({ user: t2, code: n2, mfaType: o2 }) {
  return __awaiter(this, void 0, void 0, function* () {
    return Auth.confirmSignIn(t2, n2, o2);
  });
}, handleConfirmSignUp({ username: t2, code: n2 }) {
  return __awaiter(this, void 0, void 0, function* () {
    return yield Auth.confirmSignUp(t2, n2);
  });
}, handleForgotPasswordSubmit({ username: t2, code: n2, password: o2 }) {
  return __awaiter(this, void 0, void 0, function* () {
    return Auth.forgotPasswordSubmit(t2, n2, o2);
  });
}, handleForgotPassword(t2) {
  return __awaiter(this, void 0, void 0, function* () {
    return Auth.forgotPassword(t2);
  });
}, validateCustomSignUp(t2, s2) {
  return __awaiter(this, void 0, void 0, function* () {
  });
}, validateFormPassword(t2, s2, o2) {
  return __awaiter(this, void 0, void 0, function* () {
    const { password: r2 } = t2, { password: e2 } = s2;
    if (!e2 || !o2)
      return null;
    const i2 = [], a2 = +(null == o2 ? void 0 : o2.passwordPolicyMinLength);
    r2.length < a2 && i2.push(`Password must have at least ${a2} characters`);
    const u2 = null == o2 ? void 0 : o2.passwordPolicyCharacters;
    return null == u2 || u2.forEach((t3) => {
      switch (t3) {
        case "REQUIRES_LOWERCASE":
          /[a-z]/.test(r2) || i2.push("Password must have lower case letters");
          break;
        case "REQUIRES_UPPERCASE":
          /[A-Z]/.test(r2) || i2.push("Password must have upper case letters");
          break;
        case "REQUIRES_NUMBERS":
          /[0-9]/.test(r2) || i2.push("Password must have numbers");
          break;
        case "REQUIRES_SYMBOLS":
          h$1(r2) || i2.push("Password must have special characters");
      }
    }), 0 !== i2.length ? { password: i2 } : null;
  });
}, validateConfirmPassword(t2, s2) {
  return __awaiter(this, void 0, void 0, function* () {
    const { password: r2, confirm_password: n2 } = t2, { confirm_password: o2, password: e2 } = s2;
    return r2 || n2 ? (r2 || n2) && r2 !== n2 && (o2 && e2 || (null == r2 ? void 0 : r2.length) >= 6 && (null == n2 ? void 0 : n2.length) >= 6) ? { confirm_password: "Your passwords must match" } : void 0 : null;
  });
}, validatePreferredUsername(t2, s2) {
  return __awaiter(this, void 0, void 0, function* () {
  });
} };
const _ = ["SMS_MFA", "SOFTWARE_TOKEN_MFA"], F = (e2) => get_1(e2, "data.challengeName"), O = (e2, t2) => e2 === t2, j = (e2) => _.includes(e2);
function k({ services: n2 }) {
  return createMachine({ initial: "init", id: "signInActor", predictableActionArguments: true, states: { init: { always: [{ target: "autoSignIn.submit", cond: "shouldAutoSubmit" }, { target: "autoSignIn", cond: "shouldAutoSignIn" }, { target: "signIn" }] }, signIn: { initial: "edit", exit: ["clearFormValues", "clearTouched"], states: { edit: { entry: "sendUpdate", on: { SUBMIT: { actions: "handleSubmit", target: "submit" }, CHANGE: { actions: "handleInput" }, FEDERATED_SIGN_IN: "federatedSignIn" } }, federatedSignIn: { tags: ["pending"], entry: ["sendUpdate", "clearError"], invoke: { src: "federatedSignIn", onError: { actions: "setRemoteError" } } }, submit: { tags: ["pending"], entry: ["parsePhoneNumber", "clearError", "sendUpdate"], invoke: { src: "signIn", onDone: [{ cond: "shouldSetupTOTP", actions: ["setUser", "setChallengeName"], target: "#signInActor.setupTOTP" }, { cond: "shouldConfirmSignIn", actions: ["setUser", "setChallengeName"], target: "#signInActor.confirmSignIn" }, { cond: "shouldForceChangePassword", actions: ["setUser", "setChallengeName", "setRequiredAttributes"], target: "#signInActor.forceNewPassword" }, { actions: "setUser", target: "verifying" }], onError: [{ cond: "shouldRedirectToConfirmSignUp", actions: ["setCredentials", "setConfirmSignUpIntent"], target: "rejected" }, { cond: "shouldRedirectToConfirmResetPassword", actions: ["setUsernameAuthAttributes", "setConfirmResetPasswordIntent"], target: "rejected" }, { actions: "setRemoteError", target: "edit" }] } }, verifying: { tags: ["pending"], entry: ["clearError", "sendUpdate"], invoke: { src: "checkVerifiedContact", onDone: [{ cond: "shouldRequestVerification", target: "#signInActor.verifyUser", actions: "setUnverifiedContactMethods" }, { target: "resolved" }], onError: { actions: "setRemoteError", target: "edit" } } }, resolved: { always: "#signInActor.resolved" }, rejected: { always: "#signInActor.rejected" } } }, autoSignIn: { initial: "pending", states: { pending: { tags: ["pending"], entry: ["clearError", "sendUpdate"], on: { AUTO_SIGN_IN: [{ cond: "shouldSetupTOTP", actions: ["setUser", "setChallengeName"], target: "#signInActor.setupTOTP" }, { cond: "shouldConfirmSignIn", actions: ["setUser", "setChallengeName"], target: "#signInActor.confirmSignIn" }, { cond: "shouldForceChangePassword", actions: ["setUser", "setChallengeName", "setRequiredAttributes"], target: "#signInActor.forceNewPassword" }, { actions: "setUser", target: "#signInActor.resolved" }], AUTO_SIGN_IN_FAILURE: { actions: "setRemoteError", target: "pending" } } }, submit: { tags: ["pending"], entry: ["clearError", "sendUpdate"], invoke: { src: "signIn", onDone: [{ cond: "shouldSetupTOTP", actions: ["setUser", "setChallengeName"], target: "#signInActor.setupTOTP" }, { cond: "shouldConfirmSignIn", actions: ["setUser", "setChallengeName"], target: "#signInActor.confirmSignIn" }, { cond: "shouldForceChangePassword", actions: ["setUser", "setChallengeName", "setRequiredAttributes"], target: "#signInActor.forceNewPassword" }, { actions: "setUser", target: "#signInActor.resolved" }], onError: { actions: "setRemoteError", target: "#signInActor.signIn" } } }, resolved: { always: "#signInActor.resolved" }, rejected: { always: "#signInActor.rejected" } } }, confirmSignIn: { initial: "edit", exit: ["clearFormValues", "clearError", "clearTouched"], states: { edit: { entry: "sendUpdate", on: { SUBMIT: { actions: "handleSubmit", target: "submit" }, SIGN_IN: "#signInActor.signIn", CHANGE: { actions: "handleInput" } } }, submit: { tags: ["pending"], entry: ["clearError", "sendUpdate"], invoke: { src: "confirmSignIn", onDone: { target: "#signInActor.resolved", actions: ["setUser", "clearChallengeName", "clearRequiredAttributes"] }, onError: { target: "edit", actions: "setRemoteError" } } } } }, forceNewPassword: { type: "parallel", exit: ["clearFormValues", "clearError", "clearTouched"], states: { validation: { initial: "pending", states: { pending: { invoke: { src: "validateFields", onDone: { target: "valid", actions: "clearValidationError" }, onError: { target: "invalid", actions: "setFieldErrors" } } }, valid: { entry: "sendUpdate" }, invalid: { entry: "sendUpdate" } }, on: { SIGN_IN: "#signInActor.signIn", CHANGE: { actions: "handleInput", target: ".pending" }, BLUR: { actions: "handleBlur", target: ".pending" } } }, submit: { initial: "idle", entry: "clearError", states: { idle: { entry: "sendUpdate", on: { SUBMIT: { actions: "handleSubmit", target: "validate" } } }, validate: { entry: "sendUpdate", invoke: { src: "validateFields", onDone: { target: "pending", actions: "clearValidationError" }, onError: { target: "idle", actions: "setFieldErrors" } } }, pending: { tags: ["pending"], entry: ["sendUpdate", "clearError"], invoke: { src: "forceNewPassword", onDone: [{ cond: "shouldConfirmSignIn", actions: ["setUser", "setChallengeName"], target: "#signInActor.confirmSignIn" }, { cond: "shouldSetupTOTP", actions: ["setUser", "setChallengeName"], target: "#signInActor.setupTOTP" }, { target: "resolved", actions: ["setUser", "setCredentials"] }], onError: { target: "idle", actions: "setRemoteError" } } }, resolved: { type: "final", always: "#signInActor.resolved" } } } } }, setupTOTP: { initial: "getTotpSecretCode", exit: ["clearFormValues", "clearError", "clearTouched"], states: { getTotpSecretCode: { invoke: { src: "getTotpSecretCode", onDone: { target: "edit", actions: "setTotpSecretCode" }, onError: { target: "edit", actions: "setRemoteError" } } }, edit: { entry: "sendUpdate", on: { SUBMIT: { actions: "handleSubmit", target: "submit" }, SIGN_IN: "#signInActor.signIn", CHANGE: { actions: "handleInput" } } }, submit: { tags: ["pending"], entry: ["sendUpdate", "clearError"], invoke: { src: "verifyTotpToken", onDone: { actions: ["clearChallengeName", "clearRequiredAttributes"], target: "#signInActor.resolved" }, onError: { actions: "setRemoteError", target: "edit" } } } } }, verifyUser: { initial: "edit", exit: ["clearFormValues", "clearError", "clearTouched"], states: { edit: { entry: "sendUpdate", on: { SUBMIT: { actions: "handleSubmit", target: "submit" }, SKIP: "#signInActor.resolved", CHANGE: { actions: "handleInput" } } }, submit: { tags: ["pending"], entry: "clearError", invoke: { src: "verifyUser", onDone: { target: "#signInActor.confirmVerifyUser" }, onError: { actions: "setRemoteError", target: "edit" } } } } }, confirmVerifyUser: { initial: "edit", exit: ["clearFormValues", "clearError", "clearUnverifiedContactMethods", "clearAttributeToVerify", "clearTouched"], states: { edit: { entry: "sendUpdate", on: { SUBMIT: { actions: "handleSubmit", target: "submit" }, SKIP: "#signInActor.resolved", CHANGE: { actions: "handleInput" } } }, submit: { tags: ["pending"], entry: "clearError", invoke: { src: "confirmVerifyUser", onDone: { target: "#signInActor.resolved" }, onError: { actions: "setRemoteError", target: "edit" } } } } }, resolved: { type: "final", data: (e2) => ({ user: e2.user }) }, rejected: { type: "final", data: (e2, t2) => ({ intent: e2.redirectIntent, authAttributes: e2.authAttributes }) } } }, { actions: { clearAttributeToVerify: i$2, clearChallengeName: u, clearRequiredAttributes: m, clearError: l, clearFormValues: d, clearTouched: c, clearUnverifiedContactMethods: p$1, clearValidationError: v$1, handleInput: $, handleSubmit: D, handleBlur: M, parsePhoneNumber: q, setChallengeName: g$1, setConfirmResetPasswordIntent: V, setConfirmSignUpIntent: j$1, setRequiredAttributes: b, setCredentials: y$1, setFieldErrors: O$1, setRemoteError: _$1, setTotpSecretCode: h, setUnverifiedContactMethods: w, setUser: A, setUsernameAuthAttributes: N, sendUpdate: sendUpdate() }, guards: { shouldAutoSignIn: (e2) => "autoSignIn" === (null == e2 ? void 0 : e2.intent), shouldAutoSubmit: (e2) => "autoSignInSubmit" === (null == e2 ? void 0 : e2.intent), shouldConfirmSignIn: (e2, t2) => j(F(t2)), shouldForceChangePassword: (e2, t2) => O(F(t2), "NEW_PASSWORD_REQUIRED"), shouldRedirectToConfirmResetPassword: (e2, t2) => "PasswordResetRequiredException" === t2.data.code, shouldRedirectToConfirmSignUp: (e2, t2) => "UserNotConfirmedException" === t2.data.code, shouldRequestVerification: (e2, t2) => {
    const { unverified: r2, verified: n3 } = t2.data;
    return i$1(n3) && !i$1(r2);
  }, shouldSetupTOTP: (e2, t2) => O(F(t2), "MFA_SETUP") }, services: { signIn(t2) {
    return __awaiter(this, void 0, void 0, function* () {
      const { authAttributes: e2 = {}, formValues: r2 = {} } = t2, o2 = Object.assign(Object.assign({}, e2), r2), { username: i2, password: s2 } = o2;
      return yield n2.handleSignIn({ username: i2, password: s2 });
    });
  }, confirmSignIn(t2) {
    return __awaiter(this, void 0, void 0, function* () {
      const { challengeName: e2, user: o2 } = t2, { confirmation_code: i2 } = t2.formValues, s2 = j(e2) ? e2 : void 0;
      return yield n2.handleConfirmSignIn({ user: o2, code: i2, mfaType: s2 }), yield Auth.currentAuthenticatedUser();
    });
  }, forceNewPassword(n3) {
    return __awaiter(this, void 0, void 0, function* () {
      const { user: e2, formValues: o2 } = n3;
      let i2, { password: s2, confirm_password: a2, phone_number: d2, country_code: c2 } = o2, l2 = __rest$2(o2, ["password", "confirm_password", "phone_number", "country_code"]);
      d2 && (i2 = `${c2}${d2}`.replace(/[^A-Z0-9+]/gi, ""), l2 = Object.assign(Object.assign({}, l2), { phone_number: i2 }));
      try {
        const t2 = yield Auth.completeNewPassword(e2, s2, l2);
        return t2.challengeName ? t2 : Auth.currentAuthenticatedUser();
      } catch (e3) {
        return Promise.reject(e3);
      }
    });
  }, getTotpSecretCode(t2) {
    return __awaiter(this, void 0, void 0, function* () {
      const { user: e2 } = t2;
      return Auth.setupTOTP(e2);
    });
  }, verifyTotpToken(t2) {
    return __awaiter(this, void 0, void 0, function* () {
      const { formValues: e2, user: n3 } = t2, { confirmation_code: o2 } = e2;
      return Auth.verifyTotpToken(n3, o2);
    });
  }, federatedSignIn(t2, n3) {
    return __awaiter(this, void 0, void 0, function* () {
      const { provider: e2 } = n3.data;
      return yield Auth.federatedSignIn({ provider: e2 });
    });
  }, checkVerifiedContact(t2) {
    return __awaiter(this, void 0, void 0, function* () {
      const { user: e2 } = t2;
      return yield Auth.verifiedContact(e2);
    });
  }, verifyUser(t2) {
    return __awaiter(this, void 0, void 0, function* () {
      const { unverifiedAttr: e2 } = t2.formValues, n3 = yield Auth.verifyCurrentUserAttribute(e2);
      return t2.attributeToVerify = e2, n3;
    });
  }, confirmVerifyUser(t2) {
    return __awaiter(this, void 0, void 0, function* () {
      const { attributeToVerify: e2 } = t2, { confirmation_code: n3 } = t2.formValues;
      return yield Auth.verifyCurrentUserAttributeSubmit(e2, n3);
    });
  }, validateFields(t2) {
    return __awaiter(this, void 0, void 0, function* () {
      return e(t2.formValues, t2.touched, t2.passwordSettings, [o.validateFormPassword, o.validateConfirmPassword]);
    });
  } } });
}
const i = createMachine({ initial: "pending", id: "signOutActor", predictableActionArguments: true, states: { pending: { tags: ["pending"], invoke: { src: "signOut", onDone: "resolved", onError: "rejected" } }, resolved: { type: "final" }, rejected: { type: "final" } } }, { services: { signOut: () => Auth.signOut() } });
function f({ services: f2 }) {
  return createMachine({ id: "resetPasswordActor", initial: "init", predictableActionArguments: true, states: { init: { always: [{ target: "confirmResetPassword", cond: "shouldAutoConfirmReset", actions: "resendCode" }, { target: "resetPassword" }] }, resetPassword: { initial: "edit", exit: ["clearFormValues", "clearError", "clearTouched"], states: { edit: { entry: "sendUpdate", on: { SUBMIT: { actions: "handleSubmit", target: "submit" }, CHANGE: { actions: "handleInput" }, BLUR: { actions: "handleBlur" } } }, submit: { tags: ["pending"], entry: ["sendUpdate", "setUsername", "clearError"], invoke: { src: "resetPassword", onDone: { target: "#resetPasswordActor.confirmResetPassword" }, onError: { actions: ["setRemoteError"], target: "edit" } } } } }, confirmResetPassword: { type: "parallel", exit: ["clearFormValues", "clearError", "clearUsername", "clearTouched"], states: { validation: { initial: "pending", states: { pending: { invoke: { src: "validateFields", onDone: { target: "valid", actions: "clearValidationError" }, onError: { target: "invalid", actions: "setFieldErrors" } } }, valid: { entry: "sendUpdate" }, invalid: { entry: "sendUpdate" } }, on: { CHANGE: { actions: "handleInput", target: ".pending" }, BLUR: { actions: "handleBlur", target: ".pending" } } }, submission: { initial: "idle", states: { idle: { entry: "sendUpdate", on: { SUBMIT: { actions: "handleSubmit", target: "validate" }, RESEND: "resendCode", CHANGE: { actions: "handleInput" }, BLUR: { actions: "handleBlur" } } }, validate: { entry: "sendUpdate", invoke: { src: "validateFields", onDone: { target: "pending", actions: "clearValidationError" }, onError: { target: "idle", actions: "setFieldErrors" } } }, resendCode: { tags: ["pending"], entry: ["clearError", "sendUpdate"], invoke: { src: "resetPassword", onDone: { target: "idle" }, onError: { actions: "setRemoteError", target: "idle" } } }, pending: { tags: ["pending"], entry: ["clearError", "sendUpdate"], invoke: { src: "confirmResetPassword", onDone: { actions: "clearUsername", target: "#resetPasswordActor.resolved" }, onError: { actions: "setRemoteError", target: "idle" } } } } } } }, resolved: { type: "final" } } }, { actions: { clearError: l, clearFormValues: d, clearTouched: c, clearUsername: f$1, clearValidationError: v$1, handleInput: $, handleSubmit: D, handleBlur: M, resendCode: P, setFieldErrors: O$1, setRemoteError: _$1, setUsername: C, sendUpdate: sendUpdate() }, guards: { shouldAutoConfirmReset: (e2, r2) => !(!e2.intent || "confirmPasswordReset" !== e2.intent) }, services: { resetPassword(r2) {
    return __awaiter(this, void 0, void 0, function* () {
      const { username: e2 } = r2;
      return f2.handleForgotPassword(e2);
    });
  }, confirmResetPassword(r2) {
    return __awaiter(this, void 0, void 0, function* () {
      const { username: e2 } = r2, { confirmation_code: t2, password: s2 } = r2.formValues;
      return f2.handleForgotPasswordSubmit({ username: e2, code: t2, password: s2 });
    });
  }, validateFields(r2, t2) {
    return __awaiter(this, void 0, void 0, function* () {
      return e(r2.formValues, r2.touched, r2.passwordSettings, [o.validateFormPassword, o.validateConfirmPassword]);
    });
  } } });
}
var HASH_UNDEFINED = "__lodash_hash_undefined__";
function setCacheAdd$1(value) {
  this.__data__.set(value, HASH_UNDEFINED);
  return this;
}
var _setCacheAdd = setCacheAdd$1;
function setCacheHas$1(value) {
  return this.__data__.has(value);
}
var _setCacheHas = setCacheHas$1;
var MapCache = _MapCache, setCacheAdd = _setCacheAdd, setCacheHas = _setCacheHas;
function SetCache$1(values) {
  var index2 = -1, length = values == null ? 0 : values.length;
  this.__data__ = new MapCache();
  while (++index2 < length) {
    this.add(values[index2]);
  }
}
SetCache$1.prototype.add = SetCache$1.prototype.push = setCacheAdd;
SetCache$1.prototype.has = setCacheHas;
var _SetCache = SetCache$1;
function arraySome$1(array, predicate) {
  var index2 = -1, length = array == null ? 0 : array.length;
  while (++index2 < length) {
    if (predicate(array[index2], index2, array)) {
      return true;
    }
  }
  return false;
}
var _arraySome = arraySome$1;
function cacheHas$1(cache, key) {
  return cache.has(key);
}
var _cacheHas = cacheHas$1;
var SetCache = _SetCache, arraySome = _arraySome, cacheHas = _cacheHas;
var COMPARE_PARTIAL_FLAG$5 = 1, COMPARE_UNORDERED_FLAG$3 = 2;
function equalArrays$2(array, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG$5, arrLength = array.length, othLength = other.length;
  if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
    return false;
  }
  var arrStacked = stack.get(array);
  var othStacked = stack.get(other);
  if (arrStacked && othStacked) {
    return arrStacked == other && othStacked == array;
  }
  var index2 = -1, result = true, seen = bitmask & COMPARE_UNORDERED_FLAG$3 ? new SetCache() : void 0;
  stack.set(array, other);
  stack.set(other, array);
  while (++index2 < arrLength) {
    var arrValue = array[index2], othValue = other[index2];
    if (customizer) {
      var compared = isPartial ? customizer(othValue, arrValue, index2, other, array, stack) : customizer(arrValue, othValue, index2, array, other, stack);
    }
    if (compared !== void 0) {
      if (compared) {
        continue;
      }
      result = false;
      break;
    }
    if (seen) {
      if (!arraySome(other, function(othValue2, othIndex) {
        if (!cacheHas(seen, othIndex) && (arrValue === othValue2 || equalFunc(arrValue, othValue2, bitmask, customizer, stack))) {
          return seen.push(othIndex);
        }
      })) {
        result = false;
        break;
      }
    } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
      result = false;
      break;
    }
  }
  stack["delete"](array);
  stack["delete"](other);
  return result;
}
var _equalArrays = equalArrays$2;
function mapToArray$1(map) {
  var index2 = -1, result = Array(map.size);
  map.forEach(function(value, key) {
    result[++index2] = [key, value];
  });
  return result;
}
var _mapToArray = mapToArray$1;
function setToArray$1(set) {
  var index2 = -1, result = Array(set.size);
  set.forEach(function(value) {
    result[++index2] = value;
  });
  return result;
}
var _setToArray = setToArray$1;
var Symbol$1 = _Symbol, Uint8Array$1 = _Uint8Array, eq = eq_1, equalArrays$1 = _equalArrays, mapToArray = _mapToArray, setToArray = _setToArray;
var COMPARE_PARTIAL_FLAG$4 = 1, COMPARE_UNORDERED_FLAG$2 = 2;
var boolTag = "[object Boolean]", dateTag = "[object Date]", errorTag = "[object Error]", mapTag$1 = "[object Map]", numberTag = "[object Number]", regexpTag = "[object RegExp]", setTag$1 = "[object Set]", stringTag = "[object String]", symbolTag = "[object Symbol]";
var arrayBufferTag = "[object ArrayBuffer]", dataViewTag$1 = "[object DataView]";
var symbolProto = Symbol$1 ? Symbol$1.prototype : void 0, symbolValueOf = symbolProto ? symbolProto.valueOf : void 0;
function equalByTag$1(object, other, tag, bitmask, customizer, equalFunc, stack) {
  switch (tag) {
    case dataViewTag$1:
      if (object.byteLength != other.byteLength || object.byteOffset != other.byteOffset) {
        return false;
      }
      object = object.buffer;
      other = other.buffer;
    case arrayBufferTag:
      if (object.byteLength != other.byteLength || !equalFunc(new Uint8Array$1(object), new Uint8Array$1(other))) {
        return false;
      }
      return true;
    case boolTag:
    case dateTag:
    case numberTag:
      return eq(+object, +other);
    case errorTag:
      return object.name == other.name && object.message == other.message;
    case regexpTag:
    case stringTag:
      return object == other + "";
    case mapTag$1:
      var convert = mapToArray;
    case setTag$1:
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG$4;
      convert || (convert = setToArray);
      if (object.size != other.size && !isPartial) {
        return false;
      }
      var stacked = stack.get(object);
      if (stacked) {
        return stacked == other;
      }
      bitmask |= COMPARE_UNORDERED_FLAG$2;
      stack.set(object, other);
      var result = equalArrays$1(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
      stack["delete"](object);
      return result;
    case symbolTag:
      if (symbolValueOf) {
        return symbolValueOf.call(object) == symbolValueOf.call(other);
      }
  }
  return false;
}
var _equalByTag = equalByTag$1;
function arrayPush$2(array, values) {
  var index2 = -1, length = values.length, offset = array.length;
  while (++index2 < length) {
    array[offset + index2] = values[index2];
  }
  return array;
}
var _arrayPush = arrayPush$2;
var arrayPush$1 = _arrayPush, isArray$3 = isArray_1;
function baseGetAllKeys$2(object, keysFunc, symbolsFunc) {
  var result = keysFunc(object);
  return isArray$3(object) ? result : arrayPush$1(result, symbolsFunc(object));
}
var _baseGetAllKeys = baseGetAllKeys$2;
function arrayFilter$1(array, predicate) {
  var index2 = -1, length = array == null ? 0 : array.length, resIndex = 0, result = [];
  while (++index2 < length) {
    var value = array[index2];
    if (predicate(value, index2, array)) {
      result[resIndex++] = value;
    }
  }
  return result;
}
var _arrayFilter = arrayFilter$1;
function stubArray$2() {
  return [];
}
var stubArray_1 = stubArray$2;
var arrayFilter = _arrayFilter, stubArray$1 = stubArray_1;
var objectProto$3 = Object.prototype;
var propertyIsEnumerable = objectProto$3.propertyIsEnumerable;
var nativeGetSymbols$1 = Object.getOwnPropertySymbols;
var getSymbols$2 = !nativeGetSymbols$1 ? stubArray$1 : function(object) {
  if (object == null) {
    return [];
  }
  object = Object(object);
  return arrayFilter(nativeGetSymbols$1(object), function(symbol) {
    return propertyIsEnumerable.call(object, symbol);
  });
};
var _getSymbols = getSymbols$2;
var overArg = _overArg;
var nativeKeys$1 = overArg(Object.keys, Object);
var _nativeKeys = nativeKeys$1;
var isPrototype = _isPrototype, nativeKeys = _nativeKeys;
var objectProto$2 = Object.prototype;
var hasOwnProperty$2 = objectProto$2.hasOwnProperty;
function baseKeys$1(object) {
  if (!isPrototype(object)) {
    return nativeKeys(object);
  }
  var result = [];
  for (var key in Object(object)) {
    if (hasOwnProperty$2.call(object, key) && key != "constructor") {
      result.push(key);
    }
  }
  return result;
}
var _baseKeys = baseKeys$1;
var arrayLikeKeys = _arrayLikeKeys, baseKeys = _baseKeys, isArrayLike = isArrayLike_1;
function keys$2(object) {
  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
}
var keys_1 = keys$2;
var baseGetAllKeys$1 = _baseGetAllKeys, getSymbols$1 = _getSymbols, keys$1 = keys_1;
function getAllKeys$1(object) {
  return baseGetAllKeys$1(object, keys$1, getSymbols$1);
}
var _getAllKeys = getAllKeys$1;
var getAllKeys = _getAllKeys;
var COMPARE_PARTIAL_FLAG$3 = 1;
var objectProto$1 = Object.prototype;
var hasOwnProperty$1 = objectProto$1.hasOwnProperty;
function equalObjects$1(object, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG$3, objProps = getAllKeys(object), objLength = objProps.length, othProps = getAllKeys(other), othLength = othProps.length;
  if (objLength != othLength && !isPartial) {
    return false;
  }
  var index2 = objLength;
  while (index2--) {
    var key = objProps[index2];
    if (!(isPartial ? key in other : hasOwnProperty$1.call(other, key))) {
      return false;
    }
  }
  var objStacked = stack.get(object);
  var othStacked = stack.get(other);
  if (objStacked && othStacked) {
    return objStacked == other && othStacked == object;
  }
  var result = true;
  stack.set(object, other);
  stack.set(other, object);
  var skipCtor = isPartial;
  while (++index2 < objLength) {
    key = objProps[index2];
    var objValue = object[key], othValue = other[key];
    if (customizer) {
      var compared = isPartial ? customizer(othValue, objValue, key, other, object, stack) : customizer(objValue, othValue, key, object, other, stack);
    }
    if (!(compared === void 0 ? objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack) : compared)) {
      result = false;
      break;
    }
    skipCtor || (skipCtor = key == "constructor");
  }
  if (result && !skipCtor) {
    var objCtor = object.constructor, othCtor = other.constructor;
    if (objCtor != othCtor && ("constructor" in object && "constructor" in other) && !(typeof objCtor == "function" && objCtor instanceof objCtor && typeof othCtor == "function" && othCtor instanceof othCtor)) {
      result = false;
    }
  }
  stack["delete"](object);
  stack["delete"](other);
  return result;
}
var _equalObjects = equalObjects$1;
var getNative$3 = _getNative, root$3 = _root;
var DataView$1 = getNative$3(root$3, "DataView");
var _DataView = DataView$1;
var getNative$2 = _getNative, root$2 = _root;
var Promise$2 = getNative$2(root$2, "Promise");
var _Promise = Promise$2;
var getNative$1 = _getNative, root$1 = _root;
var Set$2 = getNative$1(root$1, "Set");
var _Set = Set$2;
var getNative = _getNative, root = _root;
var WeakMap$1 = getNative(root, "WeakMap");
var _WeakMap = WeakMap$1;
var DataView = _DataView, Map$1 = _Map, Promise$1 = _Promise, Set$1 = _Set, WeakMap = _WeakMap, baseGetTag = _baseGetTag, toSource = _toSource;
var mapTag = "[object Map]", objectTag$1 = "[object Object]", promiseTag = "[object Promise]", setTag = "[object Set]", weakMapTag = "[object WeakMap]";
var dataViewTag = "[object DataView]";
var dataViewCtorString = toSource(DataView), mapCtorString = toSource(Map$1), promiseCtorString = toSource(Promise$1), setCtorString = toSource(Set$1), weakMapCtorString = toSource(WeakMap);
var getTag$1 = baseGetTag;
if (DataView && getTag$1(new DataView(new ArrayBuffer(1))) != dataViewTag || Map$1 && getTag$1(new Map$1()) != mapTag || Promise$1 && getTag$1(Promise$1.resolve()) != promiseTag || Set$1 && getTag$1(new Set$1()) != setTag || WeakMap && getTag$1(new WeakMap()) != weakMapTag) {
  getTag$1 = function(value) {
    var result = baseGetTag(value), Ctor = result == objectTag$1 ? value.constructor : void 0, ctorString = Ctor ? toSource(Ctor) : "";
    if (ctorString) {
      switch (ctorString) {
        case dataViewCtorString:
          return dataViewTag;
        case mapCtorString:
          return mapTag;
        case promiseCtorString:
          return promiseTag;
        case setCtorString:
          return setTag;
        case weakMapCtorString:
          return weakMapTag;
      }
    }
    return result;
  };
}
var _getTag = getTag$1;
var Stack$1 = _Stack, equalArrays = _equalArrays, equalByTag = _equalByTag, equalObjects = _equalObjects, getTag = _getTag, isArray$2 = isArray_1, isBuffer = isBuffer$3.exports, isTypedArray = isTypedArray_1;
var COMPARE_PARTIAL_FLAG$2 = 1;
var argsTag = "[object Arguments]", arrayTag = "[object Array]", objectTag = "[object Object]";
var objectProto = Object.prototype;
var hasOwnProperty = objectProto.hasOwnProperty;
function baseIsEqualDeep$1(object, other, bitmask, customizer, equalFunc, stack) {
  var objIsArr = isArray$2(object), othIsArr = isArray$2(other), objTag = objIsArr ? arrayTag : getTag(object), othTag = othIsArr ? arrayTag : getTag(other);
  objTag = objTag == argsTag ? objectTag : objTag;
  othTag = othTag == argsTag ? objectTag : othTag;
  var objIsObj = objTag == objectTag, othIsObj = othTag == objectTag, isSameTag = objTag == othTag;
  if (isSameTag && isBuffer(object)) {
    if (!isBuffer(other)) {
      return false;
    }
    objIsArr = true;
    objIsObj = false;
  }
  if (isSameTag && !objIsObj) {
    stack || (stack = new Stack$1());
    return objIsArr || isTypedArray(object) ? equalArrays(object, other, bitmask, customizer, equalFunc, stack) : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
  }
  if (!(bitmask & COMPARE_PARTIAL_FLAG$2)) {
    var objIsWrapped = objIsObj && hasOwnProperty.call(object, "__wrapped__"), othIsWrapped = othIsObj && hasOwnProperty.call(other, "__wrapped__");
    if (objIsWrapped || othIsWrapped) {
      var objUnwrapped = objIsWrapped ? object.value() : object, othUnwrapped = othIsWrapped ? other.value() : other;
      stack || (stack = new Stack$1());
      return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
    }
  }
  if (!isSameTag) {
    return false;
  }
  stack || (stack = new Stack$1());
  return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
}
var _baseIsEqualDeep = baseIsEqualDeep$1;
var baseIsEqualDeep = _baseIsEqualDeep, isObjectLike = isObjectLike_1;
function baseIsEqual$2(value, other, bitmask, customizer, stack) {
  if (value === other) {
    return true;
  }
  if (value == null || other == null || !isObjectLike(value) && !isObjectLike(other)) {
    return value !== value && other !== other;
  }
  return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual$2, stack);
}
var _baseIsEqual = baseIsEqual$2;
var Stack = _Stack, baseIsEqual$1 = _baseIsEqual;
var COMPARE_PARTIAL_FLAG$1 = 1, COMPARE_UNORDERED_FLAG$1 = 2;
function baseIsMatch$1(object, source, matchData, customizer) {
  var index2 = matchData.length, length = index2, noCustomizer = !customizer;
  if (object == null) {
    return !length;
  }
  object = Object(object);
  while (index2--) {
    var data = matchData[index2];
    if (noCustomizer && data[2] ? data[1] !== object[data[0]] : !(data[0] in object)) {
      return false;
    }
  }
  while (++index2 < length) {
    data = matchData[index2];
    var key = data[0], objValue = object[key], srcValue = data[1];
    if (noCustomizer && data[2]) {
      if (objValue === void 0 && !(key in object)) {
        return false;
      }
    } else {
      var stack = new Stack();
      if (customizer) {
        var result = customizer(objValue, srcValue, key, object, source, stack);
      }
      if (!(result === void 0 ? baseIsEqual$1(srcValue, objValue, COMPARE_PARTIAL_FLAG$1 | COMPARE_UNORDERED_FLAG$1, customizer, stack) : result)) {
        return false;
      }
    }
  }
  return true;
}
var _baseIsMatch = baseIsMatch$1;
var isObject$1 = isObject_1;
function isStrictComparable$2(value) {
  return value === value && !isObject$1(value);
}
var _isStrictComparable = isStrictComparable$2;
var isStrictComparable$1 = _isStrictComparable, keys = keys_1;
function getMatchData$1(object) {
  var result = keys(object), length = result.length;
  while (length--) {
    var key = result[length], value = object[key];
    result[length] = [key, value, isStrictComparable$1(value)];
  }
  return result;
}
var _getMatchData = getMatchData$1;
function matchesStrictComparable$2(key, srcValue) {
  return function(object) {
    if (object == null) {
      return false;
    }
    return object[key] === srcValue && (srcValue !== void 0 || key in Object(object));
  };
}
var _matchesStrictComparable = matchesStrictComparable$2;
var baseIsMatch = _baseIsMatch, getMatchData = _getMatchData, matchesStrictComparable$1 = _matchesStrictComparable;
function baseMatches$1(source) {
  var matchData = getMatchData(source);
  if (matchData.length == 1 && matchData[0][2]) {
    return matchesStrictComparable$1(matchData[0][0], matchData[0][1]);
  }
  return function(object) {
    return object === source || baseIsMatch(object, source, matchData);
  };
}
var _baseMatches = baseMatches$1;
function baseHasIn$1(object, key) {
  return object != null && key in Object(object);
}
var _baseHasIn = baseHasIn$1;
var castPath$2 = _castPath, isArguments = isArguments_1, isArray$1 = isArray_1, isIndex$1 = _isIndex, isLength = isLength_1, toKey$3 = _toKey;
function hasPath$1(object, path2, hasFunc) {
  path2 = castPath$2(path2, object);
  var index2 = -1, length = path2.length, result = false;
  while (++index2 < length) {
    var key = toKey$3(path2[index2]);
    if (!(result = object != null && hasFunc(object, key))) {
      break;
    }
    object = object[key];
  }
  if (result || ++index2 != length) {
    return result;
  }
  length = object == null ? 0 : object.length;
  return !!length && isLength(length) && isIndex$1(key, length) && (isArray$1(object) || isArguments(object));
}
var _hasPath = hasPath$1;
var baseHasIn = _baseHasIn, hasPath = _hasPath;
function hasIn$1(object, path2) {
  return object != null && hasPath(object, path2, baseHasIn);
}
var hasIn_1 = hasIn$1;
var baseIsEqual = _baseIsEqual, get = get_1, hasIn = hasIn_1, isKey$1 = _isKey, isStrictComparable = _isStrictComparable, matchesStrictComparable = _matchesStrictComparable, toKey$2 = _toKey;
var COMPARE_PARTIAL_FLAG = 1, COMPARE_UNORDERED_FLAG = 2;
function baseMatchesProperty$1(path2, srcValue) {
  if (isKey$1(path2) && isStrictComparable(srcValue)) {
    return matchesStrictComparable(toKey$2(path2), srcValue);
  }
  return function(object) {
    var objValue = get(object, path2);
    return objValue === void 0 && objValue === srcValue ? hasIn(object, path2) : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
  };
}
var _baseMatchesProperty = baseMatchesProperty$1;
function baseProperty$1(key) {
  return function(object) {
    return object == null ? void 0 : object[key];
  };
}
var _baseProperty = baseProperty$1;
var baseGet$1 = _baseGet;
function basePropertyDeep$1(path2) {
  return function(object) {
    return baseGet$1(object, path2);
  };
}
var _basePropertyDeep = basePropertyDeep$1;
var baseProperty = _baseProperty, basePropertyDeep = _basePropertyDeep, isKey = _isKey, toKey$1 = _toKey;
function property$1(path2) {
  return isKey(path2) ? baseProperty(toKey$1(path2)) : basePropertyDeep(path2);
}
var property_1 = property$1;
var baseMatches = _baseMatches, baseMatchesProperty = _baseMatchesProperty, identity = identity_1, isArray = isArray_1, property = property_1;
function baseIteratee$1(value) {
  if (typeof value == "function") {
    return value;
  }
  if (value == null) {
    return identity;
  }
  if (typeof value == "object") {
    return isArray(value) ? baseMatchesProperty(value[0], value[1]) : baseMatches(value);
  }
  return property(value);
}
var _baseIteratee = baseIteratee$1;
var assignValue = _assignValue, castPath$1 = _castPath, isIndex = _isIndex, isObject = isObject_1, toKey = _toKey;
function baseSet$1(object, path2, value, customizer) {
  if (!isObject(object)) {
    return object;
  }
  path2 = castPath$1(path2, object);
  var index2 = -1, length = path2.length, lastIndex = length - 1, nested = object;
  while (nested != null && ++index2 < length) {
    var key = toKey(path2[index2]), newValue = value;
    if (key === "__proto__" || key === "constructor" || key === "prototype") {
      return object;
    }
    if (index2 != lastIndex) {
      var objValue = nested[key];
      newValue = customizer ? customizer(objValue, key, nested) : void 0;
      if (newValue === void 0) {
        newValue = isObject(objValue) ? objValue : isIndex(path2[index2 + 1]) ? [] : {};
      }
    }
    assignValue(nested, key, newValue);
    nested = nested[key];
  }
  return object;
}
var _baseSet = baseSet$1;
var baseGet = _baseGet, baseSet = _baseSet, castPath = _castPath;
function basePickBy$1(object, paths, predicate) {
  var index2 = -1, length = paths.length, result = {};
  while (++index2 < length) {
    var path2 = paths[index2], value = baseGet(object, path2);
    if (predicate(value, path2)) {
      baseSet(result, castPath(path2, object), value);
    }
  }
  return result;
}
var _basePickBy = basePickBy$1;
var arrayPush = _arrayPush, getPrototype = _getPrototype, getSymbols = _getSymbols, stubArray = stubArray_1;
var nativeGetSymbols = Object.getOwnPropertySymbols;
var getSymbolsIn$1 = !nativeGetSymbols ? stubArray : function(object) {
  var result = [];
  while (object) {
    arrayPush(result, getSymbols(object));
    object = getPrototype(object);
  }
  return result;
};
var _getSymbolsIn = getSymbolsIn$1;
var baseGetAllKeys = _baseGetAllKeys, getSymbolsIn = _getSymbolsIn, keysIn = keysIn_1;
function getAllKeysIn$1(object) {
  return baseGetAllKeys(object, keysIn, getSymbolsIn);
}
var _getAllKeysIn = getAllKeysIn$1;
var arrayMap = _arrayMap, baseIteratee = _baseIteratee, basePickBy = _basePickBy, getAllKeysIn = _getAllKeysIn;
function pickBy(object, predicate) {
  if (object == null) {
    return {};
  }
  var props = arrayMap(getAllKeysIn(object), function(prop) {
    return [prop];
  });
  predicate = baseIteratee(predicate);
  return basePickBy(object, props, function(value, path2) {
    return predicate(value, path2[0]);
  });
}
var pickBy_1 = pickBy;
function y({ services: y2 }) {
  return createMachine({ id: "signUpActor", initial: "init", predictableActionArguments: true, states: { init: { always: [{ target: "confirmSignUp", cond: "shouldInitConfirmSignUp" }, { target: "signUp" }] }, signUp: { type: "parallel", exit: ["clearError", "clearFormValues", "clearTouched"], states: { validation: { initial: "pending", states: { pending: { invoke: { src: "validateSignUp", onDone: { target: "valid", actions: "clearValidationError" }, onError: { target: "invalid", actions: "setFieldErrors" } } }, valid: { entry: "sendUpdate" }, invalid: { entry: "sendUpdate" } }, on: { CHANGE: { actions: "handleInput", target: ".pending" }, BLUR: { actions: "handleBlur", target: ".pending" } } }, submission: { initial: "idle", states: { idle: { entry: "sendUpdate", on: { SUBMIT: { actions: "handleSubmit", target: "validate" }, FEDERATED_SIGN_IN: "federatedSignIn" } }, federatedSignIn: { tags: ["pending"], entry: ["sendUpdate", "clearError"], invoke: { src: "federatedSignIn", onDone: "#signUpActor.resolved", onError: { actions: "setRemoteError" } } }, validate: { entry: "sendUpdate", invoke: { src: "validateSignUp", onDone: { target: "pending", actions: "clearValidationError" }, onError: { target: "idle", actions: "setFieldErrors" } } }, pending: { tags: ["pending"], entry: ["parsePhoneNumber", "sendUpdate", "clearError"], invoke: { src: "signUp", onDone: [{ cond: "shouldSkipConfirm", target: "skipConfirm", actions: ["setUser", "setCredentials"] }, { target: "resolved", actions: ["setUser", "setCredentials", "setCodeDeliveryDetails"] }], onError: { target: "idle", actions: "setRemoteError" } } }, skipConfirm: { always: { target: "#signUpActor.resolved", actions: "setAutoSignInIntent" } }, resolved: { type: "final", always: "#signUpActor.confirmSignUp" } } } } }, confirmSignUp: { initial: "edit", states: { edit: { entry: "sendUpdate", on: { SUBMIT: { actions: "handleSubmit", target: "submit" }, CHANGE: { actions: "handleInput" }, BLUR: { actions: "handleBlur" }, RESEND: "resend" } }, resend: { tags: ["pending"], entry: "sendUpdate", invoke: { src: "resendConfirmationCode", onDone: { target: "edit" }, onError: [{ target: "#signUpActor.resolved", actions: "setAutoSignInIntent", cond: "isUserAlreadyConfirmed" }, { target: "edit", actions: "setRemoteError" }] } }, submit: { tags: ["pending"], entry: ["sendUpdate", "clearError"], invoke: { src: "confirmSignUp", onDone: { target: "#signUpActor.resolved", actions: "setAutoSignInIntent" }, onError: { target: "edit", actions: "setRemoteError" } } } } }, resolved: { type: "final", data: (e2, t2) => {
    const { username: r2, password: i2 } = e2.authAttributes;
    return { user: get_1(t2, "data.user") || e2.user, authAttributes: { username: r2, password: i2 }, intent: e2.intent };
  } } } }, { guards: { isUserAlreadyConfirmed: (e2, t2) => "User is already confirmed." === t2.data.message, shouldInitConfirmSignUp: (e2) => e2.intent && "confirmSignUp" === e2.intent, shouldSkipConfirm: (e2, t2) => t2.data.userConfirmed }, actions: { clearError: l, clearFormValues: d, clearTouched: c, clearValidationError: v$1, handleInput: $, handleSubmit: D, handleBlur: M, parsePhoneNumber: q, setCredentials: y$1, setFieldErrors: O$1, setRemoteError: _$1, setCodeDeliveryDetails: E, setUser: A, sendUpdate: sendUpdate(), setAutoSignInIntent: assign({ intent: (e2) => "confirmSignUp" === (null == e2 ? void 0 : e2.intent) ? "autoSignInSubmit" : "autoSignIn" }) }, services: { confirmSignUp(t2, r2) {
    return __awaiter(this, void 0, void 0, function* () {
      const { user: e2, authAttributes: r3, formValues: i2 } = t2, { confirmation_code: a2 } = i2, s2 = get_1(e2, "username") || get_1(r3, "username");
      return yield y2.handleConfirmSignUp({ username: s2, code: a2 });
    });
  }, resendConfirmationCode(r2, i2) {
    return __awaiter(this, void 0, void 0, function* () {
      const { user: e2, authAttributes: i3 } = r2, a2 = get_1(e2, "username") || get_1(i3, "username");
      return Auth.resendSignUp(a2);
    });
  }, federatedSignIn(n2, r2) {
    return __awaiter(this, void 0, void 0, function* () {
      const { provider: e2 } = r2.data;
      return yield Auth.federatedSignIn({ provider: e2 });
    });
  }, signUp(t2, n2) {
    return __awaiter(this, void 0, void 0, function* () {
      const { formValues: e2, loginMechanisms: n3 } = t2, [i2 = "username"] = n3, { [i2]: a2, password: s2 } = e2, o2 = pickBy_1(e2, (e3, t3) => {
        switch (t3) {
          case "address":
          case "birthdate":
          case "email":
          case "family_name":
          case "gender":
          case "given_name":
          case "locale":
          case "middle_name":
          case "name":
          case "nickname":
          case "phone_number":
          case "picture":
          case "preferred_username":
          case "profile":
          case "updated_at":
          case "website":
          case "zoneinfo":
            return true;
          default:
            return t3.startsWith("custom:");
        }
      });
      return yield y2.handleSignUp({ username: a2, password: s2, attributes: o2 });
    });
  }, validateSignUp(t2, n2) {
    return __awaiter(this, void 0, void 0, function* () {
      return e(t2.formValues, t2.touched, t2.passwordSettings, [y2.validateFormPassword, y2.validateConfirmPassword, y2.validatePreferredUsername, y2.validateCustomSignUp]);
    });
  } } });
}
const { choose: g } = r$1;
function v() {
  return createMachine({ id: "authenticator", initial: "idle", context: { user: void 0, config: {}, services: o, actorRef: void 0, hasSetup: false }, predictableActionArguments: true, states: { idle: { invoke: { src: "getCurrentUser", onDone: { actions: "setUser", target: "authenticated" }, onError: { target: "setup" } } }, setup: { initial: "waitConfig", states: { waitConfig: { on: { INIT: { actions: ["configure", "setHasSetup"], target: "applyConfig" } } }, applyConfig: { invoke: { src: "getAmplifyConfig", onDone: { actions: "applyAmplifyConfig", target: "goToInitialState" } } }, goToInitialState: { always: [{ target: "#authenticator.signUp", cond: "isInitialStateSignUp" }, { target: "#authenticator.resetPassword", cond: "isInitialStateResetPassword" }, { target: "#authenticator.signIn" }] } } }, signIn: { initial: "spawnActor", states: { spawnActor: { always: { actions: "spawnSignInActor", target: "runActor" } }, runActor: { entry: "clearActorDoneData", exit: "stopSignInActor" } }, on: { SIGN_UP: "signUp", RESET_PASSWORD: "resetPassword", "done.invoke.signInActor": [{ target: "signUp", actions: "setActorDoneData", cond: "shouldRedirectToSignUp" }, { target: "resetPassword", actions: "setActorDoneData", cond: "shouldRedirectToResetPassword" }, { target: "authenticated", actions: "setActorDoneData" }] } }, signUp: { initial: "spawnActor", states: { spawnActor: { always: { actions: "spawnSignUpActor", target: "runActor" } }, runActor: { entry: "clearActorDoneData", exit: "stopSignUpActor" }, autoSignIn: { invoke: { src: "getCurrentUser", onDone: "#authenticator.authenticated", onError: "#authenticator.setup.goToInitialState" } } }, on: { SIGN_IN: "signIn", "done.invoke.signUpActor": { target: "#authenticator.signIn", actions: "setActorDoneData", cond: "shouldAutoSignIn" } } }, resetPassword: { initial: "spawnActor", states: { spawnActor: { always: { actions: "spawnResetPasswordActor", target: "runActor" } }, runActor: { entry: "clearActorDoneData", exit: "stopResetPasswordActor" } }, on: { SIGN_IN: "signIn", "done.invoke.resetPasswordActor": { target: "signIn", actions: "setActorDoneData" } } }, signOut: { initial: "spawnActor", states: { spawnActor: { always: { actions: "spawnSignOutActor", target: "runActor" } }, runActor: { entry: "clearActorDoneData", exit: ["stopSignOutActor", "clearUser"] } }, on: { "done.invoke.signOutActor": [{ target: "setup", cond: "shouldSetup" }, { target: "setup.goToInitialState" }] } }, authenticated: { initial: "idle", states: { idle: { on: { TOKEN_REFRESH: "refreshUser" } }, refreshUser: { invoke: { src: "getCurrentUser", onDone: { actions: "setUser", target: "idle" }, onError: { target: "#authenticator.signOut" } } } }, on: { SIGN_OUT: "signOut" } } }, on: { CHANGE: { actions: "forwardToActor" }, BLUR: { actions: "forwardToActor" }, SUBMIT: { actions: "forwardToActor" }, FEDERATED_SIGN_IN: { actions: "forwardToActor" }, AUTO_SIGN_IN: { actions: "forwardToActor" }, RESEND: { actions: "forwardToActor" }, SIGN_IN: { actions: "forwardToActor" }, SKIP: { actions: "forwardToActor" } } }, { actions: { forwardToActor: g([{ cond: "hasActor", actions: forwardTo((t2) => t2.actorRef) }]), setUser: assign({ user: (t2, o2) => o2.data }), setActorDoneData: assign({ actorDoneData: (t2, o2) => {
    var i2, n2;
    return { authAttributes: Object.assign({}, null === (i2 = o2.data) || void 0 === i2 ? void 0 : i2.authAttributes), intent: null === (n2 = o2.data) || void 0 === n2 ? void 0 : n2.intent };
  }, user: (t2, o2) => {
    var i2;
    return null === (i2 = o2.data) || void 0 === i2 ? void 0 : i2.user;
  } }), clearUser: assign({ user: void 0 }), clearActorDoneData: assign({ actorDoneData: void 0 }), applyAmplifyConfig: assign({ config(t2, o2) {
    var i2, n2, e2, r2, s2, a2, c2, d2, u2;
    const l2 = null !== (n2 = null === (i2 = o2.data.aws_cognito_username_attributes) || void 0 === i2 ? void 0 : i2.map((t3) => t3.toLowerCase())) && void 0 !== n2 ? n2 : [], g2 = null !== (r2 = null === (e2 = o2.data.aws_cognito_verification_mechanisms) || void 0 === e2 ? void 0 : e2.map((t3) => t3.toLowerCase())) && void 0 !== r2 ? r2 : [], v2 = null !== (a2 = null === (s2 = o2.data.aws_cognito_signup_attributes) || void 0 === s2 ? void 0 : s2.map((t3) => t3.toLowerCase())) && void 0 !== a2 ? a2 : [], A2 = null !== (d2 = null === (c2 = o2.data.aws_cognito_social_providers) || void 0 === c2 ? void 0 : c2.map((t3) => t3.toLowerCase())) && void 0 !== d2 ? d2 : [], f2 = o2.data.aws_cognito_password_protection_settings || {};
    0 === l2.length && l2.push("username");
    const { loginMechanisms: w2, signUpAttributes: S, socialProviders: m2, initialState: h2, formFields: D2 } = t2.config;
    return { loginMechanisms: null != w2 ? w2 : l2, formFields: null !== (u2 = p(D2)) && void 0 !== u2 ? u2 : {}, passwordSettings: f2, signUpAttributes: null != S ? S : Array.from(/* @__PURE__ */ new Set([...g2, ...v2])), socialProviders: null != m2 ? m2 : A2.sort(), initialState: h2 };
  } }), spawnSignInActor: assign({ actorRef: (t2, o2) => {
    var i2, n2, r2, s2, c2, d2, u2;
    const { services: l2 } = t2, g2 = k({ services: l2 }).withContext({ authAttributes: null !== (n2 = null === (i2 = t2.actorDoneData) || void 0 === i2 ? void 0 : i2.authAttributes) && void 0 !== n2 ? n2 : {}, user: t2.user, intent: null === (r2 = t2.actorDoneData) || void 0 === r2 ? void 0 : r2.intent, country_code: "+1", formValues: {}, touched: {}, validationError: {}, passwordSettings: null === (s2 = t2.config) || void 0 === s2 ? void 0 : s2.passwordSettings, loginMechanisms: null === (c2 = t2.config) || void 0 === c2 ? void 0 : c2.loginMechanisms, socialProviders: null === (d2 = t2.config) || void 0 === d2 ? void 0 : d2.socialProviders, formFields: null === (u2 = t2.config) || void 0 === u2 ? void 0 : u2.formFields });
    return spawn(g2, { name: "signInActor" });
  } }), spawnSignUpActor: assign({ actorRef: (t2, o2) => {
    var i2, n2, r2, s2, a2, c2, d2;
    const { services: u2 } = t2, g2 = y({ services: u2 }).withContext({ authAttributes: null !== (n2 = null === (i2 = t2.actorDoneData) || void 0 === i2 ? void 0 : i2.authAttributes) && void 0 !== n2 ? n2 : {}, country_code: "+1", intent: null === (r2 = t2.actorDoneData) || void 0 === r2 ? void 0 : r2.intent, formValues: {}, touched: {}, validationError: {}, loginMechanisms: null === (s2 = t2.config) || void 0 === s2 ? void 0 : s2.loginMechanisms, socialProviders: null === (a2 = t2.config) || void 0 === a2 ? void 0 : a2.socialProviders, formFields: null === (c2 = t2.config) || void 0 === c2 ? void 0 : c2.formFields, passwordSettings: null === (d2 = t2.config) || void 0 === d2 ? void 0 : d2.passwordSettings });
    return spawn(g2, { name: "signUpActor" });
  } }), spawnResetPasswordActor: assign({ actorRef: (t2, o2) => {
    var i2, n2, r2, s2, a2;
    const { services: c2 } = t2, u2 = f({ services: c2 }).withContext({ formValues: {}, touched: {}, intent: null === (i2 = t2.actorDoneData) || void 0 === i2 ? void 0 : i2.intent, username: null === (r2 = null === (n2 = t2.actorDoneData) || void 0 === n2 ? void 0 : n2.authAttributes) || void 0 === r2 ? void 0 : r2.username, formFields: null === (s2 = t2.config) || void 0 === s2 ? void 0 : s2.formFields, validationError: {}, passwordSettings: null === (a2 = t2.config) || void 0 === a2 ? void 0 : a2.passwordSettings });
    return spawn(u2, { name: "resetPasswordActor" });
  } }), spawnSignOutActor: assign({ actorRef: (t2) => {
    const o2 = i.withContext({ user: t2.user });
    return spawn(o2, { name: "signOutActor" });
  } }), stopSignInActor: n$1("signInActor"), stopSignUpActor: n$1("signUpActor"), stopResetPasswordActor: n$1("resetPasswordActor"), stopSignOutActor: n$1("signOutActor"), configure: assign((o$12, i2) => {
    const n2 = i2.data, { services: e2 } = n2, r2 = __rest$2(n2, ["services"]);
    return { services: Object.assign(Object.assign({}, o), e2), config: r2 };
  }), setHasSetup: assign({ hasSetup: true }) }, guards: { isInitialStateSignUp: (t2) => "signUp" === t2.config.initialState, isInitialStateResetPassword: (t2) => "resetPassword" === t2.config.initialState, shouldRedirectToSignUp: (t2, o2) => {
    var i2;
    return "confirmSignUp" === (null === (i2 = o2.data) || void 0 === i2 ? void 0 : i2.intent);
  }, shouldRedirectToResetPassword: (t2, o2) => {
    var i2;
    return "confirmPasswordReset" === (null === (i2 = o2.data) || void 0 === i2 ? void 0 : i2.intent);
  }, shouldAutoSignIn: (t2, o2) => {
    var i2, n2;
    return "autoSignIn" === (null === (i2 = o2.data) || void 0 === i2 ? void 0 : i2.intent) || "autoSignInSubmit" === (null === (n2 = o2.data) || void 0 === n2 ? void 0 : n2.intent);
  }, shouldSetup: (t2) => false === t2.hasSetup, hasActor: (t2) => !!t2.actorRef }, services: { getCurrentUser: (t2, o2) => t2.services.getCurrentUser(), getAmplifyConfig: (t2, o2) => t2.services.getAmplifyConfig() } });
}
function p(t2) {
  return t2 && Object.keys(t2).forEach((o2) => {
    Object.keys(t2[o2]).forEach((i2) => {
      let n2 = t2[o2][i2];
      n2.required = n2.isRequired;
    });
  }), t2;
}
const _hoisted_1$a = {
  key: 0,
  class: "amplify-flex amplify-alert amplify-alert--error amplify-authenticator__base",
  "data-variation": "error",
  role: "alert"
};
const _hoisted_2$6 = { class: "amplify-flex amplify-authenticator__icon-wrapper" };
const _hoisted_3$5 = /* @__PURE__ */ createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  class: "amplify-icon",
  "aria-hidden": "true",
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, [
  /* @__PURE__ */ createElementVNode("path", { d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-2h2v2zm0-4h-2V7h2v6z" })
], -1);
const _hoisted_4$5 = /* @__PURE__ */ createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  class: "amplify-icon",
  "aria-hidden": "true",
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, [
  /* @__PURE__ */ createElementVNode("path", { d: "M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z" })
], -1);
const _sfc_main$w = {
  __name: "base-alert",
  setup(__props) {
    const show = ref(true);
    const dismissAriaLabel = b$2("Dismiss alert");
    function close() {
      show.value = false;
    }
    return (_ctx, _cache) => {
      const _component_amplify_button = _sfc_main$x;
      return show.value ? (openBlock(), createElementBlock("div", _hoisted_1$a, [
        createElementVNode("div", _hoisted_2$6, [
          _hoisted_3$5,
          createElementVNode("div", null, [
            renderSlot(_ctx.$slots, "default")
          ])
        ]),
        createVNode(_component_amplify_button, {
          class: "amplify-field-group__control amplify-alert__dismiss",
          "aria-label": unref(dismissAriaLabel),
          fullwidth: false,
          variation: "link",
          type: "button",
          onClick: close
        }, {
          default: withCtx(() => [
            _hoisted_4$5
          ]),
          _: 1
        }, 8, ["aria-label"])
      ])) : createCommentVNode("", true);
    };
  }
};
var _export_sfc = (sfc, props) => {
  const target = sfc.__vccOpts || sfc;
  for (const [key, val] of props) {
    target[key] = val;
  }
  return target;
};
const _sfc_main$v = {};
function _sfc_render$3(_ctx, _cache) {
  return openBlock(), createElementBlock("div", null, [
    renderSlot(_ctx.$slots, "default")
  ]);
}
var __unplugin_components_2 = /* @__PURE__ */ _export_sfc(_sfc_main$v, [["render", _sfc_render$3]]);
const _sfc_main$u = /* @__PURE__ */ defineComponent({
  __name: "base-form",
  setup(__props) {
    let mySlots = useSlots();
    return (_ctx, _cache) => {
      return renderSlot(_ctx.$slots, "formt", mergeProps(_ctx.$attrs, {
        slotData: unref(mySlots).default && unref(mySlots).default()
      }), () => [
        createElementVNode("form", mergeProps({ "data-amplify-form": "" }, _ctx.$attrs), [
          renderSlot(_ctx.$slots, "default")
        ], 16)
      ]);
    };
  }
});
const _sfc_main$t = /* @__PURE__ */ defineComponent({
  __name: "base-footer",
  setup(__props) {
    let mySlots = useSlots();
    return (_ctx, _cache) => {
      return renderSlot(_ctx.$slots, "footert", mergeProps(_ctx.$attrs, {
        slotData: unref(mySlots).default && unref(mySlots).default()
      }), () => [
        createElementVNode("footer", normalizeProps(guardReactiveProps(_ctx.$attrs)), [
          renderSlot(_ctx.$slots, "default")
        ], 16)
      ]);
    };
  }
});
function tryOnScopeDispose(fn) {
  if (getCurrentScope()) {
    onScopeDispose(fn);
    return true;
  }
  return false;
}
function createSharedComposable(composable) {
  let subscribers = 0;
  let state;
  let scope;
  const dispose = () => {
    subscribers -= 1;
    if (scope && subscribers <= 0) {
      scope.stop();
      state = void 0;
      scope = void 0;
    }
  };
  return (...args) => {
    subscribers += 1;
    if (!state) {
      scope = effectScope(true);
      state = scope.run(() => composable(...args));
    }
    tryOnScopeDispose(dispose);
    return state;
  };
}
var __assign = globalThis && globalThis.__assign || function() {
  __assign = Object.assign || function(t2) {
    for (var s2, i2 = 1, n2 = arguments.length; i2 < n2; i2++) {
      s2 = arguments[i2];
      for (var p2 in s2)
        if (Object.prototype.hasOwnProperty.call(s2, p2))
          t2[p2] = s2[p2];
    }
    return t2;
  };
  return __assign.apply(this, arguments);
};
var __rest = globalThis && globalThis.__rest || function(s2, e2) {
  var t2 = {};
  for (var p2 in s2)
    if (Object.prototype.hasOwnProperty.call(s2, p2) && e2.indexOf(p2) < 0)
      t2[p2] = s2[p2];
  if (s2 != null && typeof Object.getOwnPropertySymbols === "function")
    for (var i2 = 0, p2 = Object.getOwnPropertySymbols(s2); i2 < p2.length; i2++) {
      if (e2.indexOf(p2[i2]) < 0 && Object.prototype.propertyIsEnumerable.call(s2, p2[i2]))
        t2[p2[i2]] = s2[p2[i2]];
    }
  return t2;
};
function toObserver(nextHandler, errorHandler, completionHandler) {
  if (typeof nextHandler === "object") {
    return nextHandler;
  }
  var noop2 = function() {
    return void 0;
  };
  return {
    next: nextHandler,
    error: errorHandler || noop2,
    complete: completionHandler || noop2
  };
}
function useInterpret(getMachine, options, observerOrListener) {
  if (options === void 0) {
    options = {};
  }
  var machine = typeof getMachine === "function" ? getMachine() : getMachine;
  var context = options.context, guards = options.guards, actions = options.actions, activities = options.activities, services = options.services, delays = options.delays, rehydratedState = options.state, interpreterOptions = __rest(options, ["context", "guards", "actions", "activities", "services", "delays", "state"]);
  var machineConfig = {
    context,
    guards,
    actions,
    activities,
    services,
    delays
  };
  var machineWithConfig = machine.withConfig(machineConfig, function() {
    return __assign(__assign({}, machine.context), context);
  });
  var service2 = interpret(machineWithConfig, interpreterOptions).start(rehydratedState ? State.create(rehydratedState) : void 0);
  var sub;
  onMounted(function() {
    if (observerOrListener) {
      sub = service2.subscribe(toObserver(observerOrListener));
    }
  });
  onBeforeUnmount(function() {
    service2.stop();
    sub === null || sub === void 0 ? void 0 : sub.unsubscribe();
  });
  return service2;
}
function isActorWithState(actorRef) {
  return "state" in actorRef;
}
var noop = function() {
};
function defaultGetSnapshot(actorRef) {
  return "getSnapshot" in actorRef ? actorRef.getSnapshot() : isActorWithState(actorRef) ? actorRef.state : void 0;
}
function useActor(actorRef, getSnapshot) {
  if (getSnapshot === void 0) {
    getSnapshot = defaultGetSnapshot;
  }
  var actorRefRef = isRef(actorRef) ? actorRef : shallowRef(actorRef);
  var state = shallowRef(getSnapshot(actorRefRef.value));
  var send2 = function(event) {
    actorRefRef.value.send(event);
  };
  watch(actorRefRef, function(newActor, _2, onCleanup) {
    state.value = getSnapshot(newActor);
    var unsubscribe = newActor.subscribe({
      next: function(emitted) {
        return state.value = emitted;
      },
      error: noop,
      complete: noop
    }).unsubscribe;
    onCleanup(function() {
      return unsubscribe();
    });
  }, {
    immediate: true
  });
  return { state, send: send2 };
}
const facade = {
  error: "",
  hasValidationErrors: false,
  isPending: false,
  route: "",
  authStatus: "",
  user: "",
  validationErrors: [""],
  codeDeliveryDetails: {
    val: "",
    DeliveryMedium: ""
  },
  change: (data) => null,
  updateForm: (data) => null,
  updateBlur: (data) => null,
  resend: (data) => null,
  resendCode: (data) => null,
  signOut: (data) => null,
  federatedSignIn: (data) => null,
  toFederatedSignIn: (data) => null,
  resetPassword: (data) => null,
  toResetPassword: (data) => null,
  signIn: (data) => null,
  toSignIn: (data) => null,
  signUp: (data) => null,
  toSignUp: (data) => null,
  skip: (data) => null,
  skipVerification: (data) => null,
  submit: (data) => null,
  submitForm: (data) => null
};
const service = ref();
const useAuthenticatorValue = reactive({
  ...facade,
  send: "",
  state: ""
});
const useAuth = (serv) => {
  if (serv) {
    service.value = serv;
  }
  return useActor(service.value);
};
const useInternalAuthenticator = () => {
  createValues();
  watchEffect(() => {
    createValues();
  });
  return useAuthenticatorValue;
};
const useAuthenticator = useInternalAuthenticator;
function createValues() {
  if (!service.value)
    return;
  const { state, send: send2 } = useAuth();
  const facadeValues = s$4({ send: send2, state: state.value });
  for (const key of Object.keys(facade)) {
    useAuthenticatorValue[key] = facadeValues[key];
  }
  useAuthenticatorValue.send = send2;
  useAuthenticatorValue.state = state;
}
const _sfc_main$s = /* @__PURE__ */ defineComponent({
  __name: "federated-sign-in-button",
  props: {
    provider: String
  },
  setup(__props) {
    const props = __props;
    const { provider } = toRefs(props);
    const { send: send2 } = useAuth();
    const onClick = () => {
      send2({
        type: "FEDERATED_SIGN_IN",
        data: {
          provider: provider == null ? void 0 : provider.value
        }
      });
    };
    return (_ctx, _cache) => {
      const _component_base_wrapper = __unplugin_components_2;
      const _component_amplify_button = _sfc_main$x;
      return openBlock(), createBlock(_component_amplify_button, {
        class: "amplify-field-group__control federated-sign-in-button amplify-authenticator__font",
        fullwidth: false,
        style: { "font-weight": "normal" },
        type: "button",
        onClick
      }, {
        default: withCtx(() => [
          createVNode(_component_base_wrapper, { class: "amplify-flex federated-sign-in-button-row amplify-authenticator__sign-in-button-wrapper" }, {
            default: withCtx(() => [
              renderSlot(_ctx.$slots, "default")
            ]),
            _: 3
          })
        ]),
        _: 3
      });
    };
  }
});
const _hoisted_1$9 = /* @__PURE__ */ createElementVNode("svg", {
  "aria-label": "Amazon icon",
  class: "amplify-icon federated-sign-in-icon",
  viewBox: "0 0 248 268"
}, [
  /* @__PURE__ */ createElementVNode("path", {
    d: "M139.056521,147.024612 C133.548808,156.744524 124.782731,162.726926 115.087401,162.726926 C101.790721,162.726926 93.9937779,152.612964 93.9937779,137.68681 C93.9937779,108.224571 120.447551,102.879017 145.533369,102.879017 L145.533369,110.365976 C145.533369,123.831358 145.876354,135.063787 139.056521,147.024612 M207.206992,162.579655 C209.400505,165.692256 209.887066,169.437725 207.063416,171.770186 C199.996315,177.653081 187.429476,188.590967 180.513926,194.716661 L180.46208,194.621133 C178.176838,196.663031 174.862638,196.810303 172.27828,195.445057 C160.780281,185.9162 158.686473,181.494078 152.405048,172.403055 C133.405233,191.751331 119.909143,197.534719 95.309886,197.534719 C66.1281801,197.534719 43.4791563,179.599451 43.4791563,143.669212 C43.4791563,115.616003 58.6782107,96.5105248 80.4019706,87.1727225 C99.2063636,78.9096034 125.464714,77.4528107 145.533369,75.1641337 L145.533369,70.694248 C145.533369,62.4749122 146.167493,52.7510201 141.297893,45.6541312 C137.110277,39.2856386 129.018206,36.6586354 121.859376,36.6586354 C108.658413,36.6586354 96.9171331,43.4171982 94.0416364,57.4199213 C93.4593582,60.532522 91.1701278,63.5933787 88.003492,63.7406501 L54.4387473,60.1424518 C51.6150972,59.5095829 48.4484614,57.2248862 49.2740201,52.8982915 C56.9712583,12.2553679 93.7983558,0 126.732964,0 C143.587124,0 165.606011,4.47386604 178.902691,17.2148315 C195.760839,32.917146 194.149604,53.8694866 194.149604,76.6726704 L194.149604,130.542157 C194.149604,146.734049 200.87372,153.830938 207.206992,162.579655 Z M233.826346,208.038962 C230.467669,203.683255 211.550709,205.9821 203.056405,206.998432 C200.470662,207.321077 200.076227,205.042397 202.406981,203.404973 C217.475208,192.664928 242.201125,195.766353 245.081698,199.363845 C247.966255,202.981502 244.336653,228.071183 230.172839,240.049379 C228.001452,241.888455 225.929671,240.904388 226.89783,238.468418 C230.077218,230.430525 237.204944,212.418868 233.826346,208.038962 Z M126.768855,264 C74.0234043,264 42.0764048,241.955028 17.7852554,217.541992 C12.9733903,212.705982 6.71799208,206.295994 3.31151296,200.690918 C1.90227474,198.372135 5.59096074,195.021875 8.0442063,196.84375 C38.2390146,219.267578 82.1011654,239.538304 125.529506,239.538304 C154.819967,239.538304 191.046475,227.469543 220.66851,214.867659 C225.146771,212.966167 225.146771,219.180222 224.511585,221.060516 C224.183264,222.03242 209.514625,236.221149 189.247207,247.047411 C170.304273,257.166172 146.397132,264 126.768855,264 Z",
    fill: "#FF9900"
  })
], -1);
const _hoisted_2$5 = { class: "amplify-text amplify-authenticator__federated-text" };
const _hoisted_3$4 = /* @__PURE__ */ createElementVNode("svg", {
  "aria-label": "Apple icon",
  class: "amplify-icon federated-sign-in-icon",
  fill: "#000",
  preserveAspectRatio: "xMidYMid",
  stroke: "#000",
  strokeWidth: "0",
  viewBox: "0 0 1024 1024",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /* @__PURE__ */ createElementVNode("path", { d: "M747.4 535.7c-.4-68.2 30.5-119.6 92.9-157.5-34.9-50-87.7-77.5-157.3-82.8-65.9-5.2-138 38.4-164.4 38.4-27.9 0-91.7-36.6-141.9-36.6C273.1 298.8 163 379.8 163 544.6c0 48.7 8.9 99 26.7 150.8 23.8 68.2 109.6 235.3 199.1 232.6 46.8-1.1 79.9-33.2 140.8-33.2 59.1 0 89.7 33.2 141.9 33.2 90.3-1.3 167.9-153.2 190.5-221.6-121.1-57.1-114.6-167.2-114.6-170.7zm-105.1-305c50.7-60.2 46.1-115 44.6-134.7-44.8 2.6-96.6 30.5-126.1 64.8-32.5 36.8-51.6 82.3-47.5 133.6 48.4 3.7 92.6-21.2 129-63.7z" })
], -1);
const _hoisted_4$4 = { class: "amplify-text amplify-authenticator__federated-text" };
const _hoisted_5$2 = /* @__PURE__ */ createElementVNode("svg", {
  "aria-label": "Facebook icon",
  class: "amplify-icon federated-sign-in-icon",
  viewBox: "0 0 279 538"
}, [
  /* @__PURE__ */ createElementVNode("path", {
    d: "M82.3409742,538 L82.3409742,292.936652 L0,292.936652 L0,196.990154 L82.2410458,196.990154 L82.2410458,126.4295 C82.2410458,44.575144 132.205229,0 205.252865,0 C240.227794,0 270.306232,2.59855099 279,3.79788222 L279,89.2502322 L228.536175,89.2502322 C188.964542,89.2502322 181.270057,108.139699 181.270057,135.824262 L181.270057,196.89021 L276.202006,196.89021 L263.810888,292.836708 L181.16913,292.836708 L181.16913,538 L82.3409742,538 Z",
    fill: "#1877F2"
  })
], -1);
const _hoisted_6$2 = { class: "amplify-text amplify-authenticator__federated-text" };
const _hoisted_7$1 = /* @__PURE__ */ createElementVNode("svg", {
  "aria-label": "Google icon",
  class: "amplify-icon federated-sign-in-icon",
  viewBox: "0 0 256 262",
  xmlns: "http://www.w3.org/2000/svg",
  preserveAspectRatio: "xMidYMid"
}, [
  /* @__PURE__ */ createElementVNode("path", {
    d: "M255.878 133.451c0-10.734-.871-18.567-2.756-26.69H130.55v48.448h71.947c-1.45 12.04-9.283 30.172-26.69 42.356l-.244 1.622 38.755 30.023 2.685.268c24.659-22.774 38.875-56.282 38.875-96.027",
    fill: "#4285F4"
  }),
  /* @__PURE__ */ createElementVNode("path", {
    d: "M130.55 261.1c35.248 0 64.839-11.605 86.453-31.622l-41.196-31.913c-11.024 7.688-25.82 13.055-45.257 13.055-34.523 0-63.824-22.773-74.269-54.25l-1.531.13-40.298 31.187-.527 1.465C35.393 231.798 79.49 261.1 130.55 261.1",
    fill: "#34A853"
  }),
  /* @__PURE__ */ createElementVNode("path", {
    d: "M56.281 156.37c-2.756-8.123-4.351-16.827-4.351-25.82 0-8.994 1.595-17.697 4.206-25.82l-.073-1.73L15.26 71.312l-1.335.635C5.077 89.644 0 109.517 0 130.55s5.077 40.905 13.925 58.602l42.356-32.782",
    fill: "#FBBC05"
  }),
  /* @__PURE__ */ createElementVNode("path", {
    d: "M130.55 50.479c24.514 0 41.05 10.589 50.479 19.438l36.844-35.974C195.245 12.91 165.798 0 130.55 0 79.49 0 35.393 29.301 13.925 71.947l42.211 32.783c10.59-31.477 39.891-54.251 74.414-54.251",
    fill: "#EB4335"
  })
], -1);
const _hoisted_8$1 = { class: "amplify-text amplify-authenticator__federated-text" };
const _hoisted_9$1 = ["data-label"];
const _sfc_main$r = /* @__PURE__ */ defineComponent({
  __name: "federated-sign-in",
  setup(__props) {
    var _a2;
    const { state } = useAuth();
    const useAuthShared = createSharedComposable(useAuthenticator);
    const { route } = useAuthShared();
    const { value: { context } } = state;
    const socialProviders = (_a2 = context == null ? void 0 : context.config) == null ? void 0 : _a2.socialProviders;
    const includeAmazon = socialProviders == null ? void 0 : socialProviders.includes("amazon");
    const includeApple = socialProviders == null ? void 0 : socialProviders.includes("apple");
    const includeFacebook = socialProviders == null ? void 0 : socialProviders.includes("facebook");
    const includeGoogle = socialProviders == null ? void 0 : socialProviders.includes("google");
    const shouldShowFederatedSignIn = includeFacebook || includeGoogle || includeAmazon || includeApple;
    const { getSignInWithFederationText, getOrText } = n$2;
    const fp = computed(() => o$9);
    const signInWithAmazon = computed(() => getSignInWithFederationText(route, "amazon"));
    const signInWithApple = computed(() => getSignInWithFederationText(route, "apple"));
    const signInWithFacebook = computed(() => getSignInWithFederationText(route, "facebook"));
    const signInWithGoogle = computed(() => getSignInWithFederationText(route, "google"));
    const orText = computed(() => getOrText());
    return (_ctx, _cache) => {
      const _component_base_wrapper = __unplugin_components_2;
      return unref(shouldShowFederatedSignIn) ? (openBlock(), createBlock(_component_base_wrapper, {
        key: 0,
        class: "amplify-flex federated-sign-in-container amplify-authenticator__column amplify-authenticator__sign-in-base"
      }, {
        default: withCtx(() => [
          unref(includeAmazon) ? (openBlock(), createBlock(_sfc_main$s, {
            key: 0,
            provider: unref(fp).Amazon
          }, {
            default: withCtx(() => [
              _hoisted_1$9,
              createElementVNode("p", _hoisted_2$5, toDisplayString(unref(signInWithAmazon)), 1)
            ]),
            _: 1
          }, 8, ["provider"])) : createCommentVNode("", true),
          unref(includeApple) ? (openBlock(), createBlock(_sfc_main$s, {
            key: 1,
            provider: unref(fp).Apple
          }, {
            default: withCtx(() => [
              _hoisted_3$4,
              createElementVNode("p", _hoisted_4$4, toDisplayString(unref(signInWithApple)), 1)
            ]),
            _: 1
          }, 8, ["provider"])) : createCommentVNode("", true),
          unref(includeFacebook) ? (openBlock(), createBlock(_sfc_main$s, {
            key: 2,
            provider: unref(fp).Facebook
          }, {
            default: withCtx(() => [
              _hoisted_5$2,
              createElementVNode("p", _hoisted_6$2, toDisplayString(unref(signInWithFacebook)), 1)
            ]),
            _: 1
          }, 8, ["provider"])) : createCommentVNode("", true),
          unref(includeGoogle) ? (openBlock(), createBlock(_sfc_main$s, {
            key: 3,
            provider: unref(fp).Google
          }, {
            default: withCtx(() => [
              _hoisted_7$1,
              createElementVNode("p", _hoisted_8$1, toDisplayString(unref(signInWithGoogle)), 1)
            ]),
            _: 1
          }, 8, ["provider"])) : createCommentVNode("", true),
          createElementVNode("hr", {
            class: "amplify-divider amplify-divider--label amplify-divider--small",
            "aria-orientation": "horizontal",
            "data-size": "small",
            "data-label": unref(orText)
          }, null, 8, _hoisted_9$1)
        ]),
        _: 1
      })) : createCommentVNode("", true);
    };
  }
});
let nanoid = (size = 21) => {
  let id = "";
  let bytes = crypto.getRandomValues(new Uint8Array(size));
  while (size--) {
    let byte2 = bytes[size] & 63;
    if (byte2 < 36) {
      id += byte2.toString(36);
    } else if (byte2 < 62) {
      id += (byte2 - 26).toString(36).toUpperCase();
    } else if (byte2 < 63) {
      id += "_";
    } else {
      id += "-";
    }
  }
  return id;
};
const _sfc_main$q = {};
const _hoisted_1$8 = { "data-amplify-label": "" };
function _sfc_render$2(_ctx, _cache) {
  return openBlock(), createElementBlock("label", _hoisted_1$8, [
    renderSlot(_ctx.$slots, "default")
  ]);
}
var __unplugin_components_0 = /* @__PURE__ */ _export_sfc(_sfc_main$q, [["render", _sfc_render$2]]);
const _sfc_main$p = /* @__PURE__ */ defineComponent({
  __name: "base-input",
  emits: ["update:modelValue"],
  setup(__props, { emit }) {
    const onInput = (e2) => {
      emit("update:modelValue", e2.target.value);
    };
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("input", {
        onChange: _cache[0] || (_cache[0] = (event) => onInput(event)),
        "data-amplify-input": ""
      }, null, 32);
    };
  }
});
const _hoisted_1$7 = ["aria-label", "aria-checked"];
const _hoisted_2$4 = /* @__PURE__ */ createElementVNode("path", { d: "M12 4.5C7 4.5 2.73 7.61 1 12c1.73 4.39 6 7.5 11 7.5s9.27-3.11 11-7.5c-1.73-4.39-6-7.5-11-7.5zM12 17c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5zm0-8c-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3-1.34-3-3-3z" }, null, -1);
const _hoisted_3$3 = [
  _hoisted_2$4
];
const _hoisted_4$3 = /* @__PURE__ */ createElementVNode("path", {
  d: "M0 0h24v24H0zm0 0h24v24H0zm0 0h24v24H0zm0 0h24v24H0z",
  fill: "none"
}, null, -1);
const _hoisted_5$1 = /* @__PURE__ */ createElementVNode("path", { d: "M12 7c2.76 0 5 2.24 5 5 0 .65-.13 1.26-.36 1.83l2.92 2.92c1.51-1.26 2.7-2.89 3.43-4.75-1.73-4.39-6-7.5-11-7.5-1.4 0-2.74.25-3.98.7l2.16 2.16C10.74 7.13 11.35 7 12 7zM2 4.27l2.28 2.28.46.46C3.08 8.3 1.78 10.02 1 12c1.73 4.39 6 7.5 11 7.5 1.55 0 3.03-.3 4.38-.84l.42.42L19.73 22 21 20.73 3.27 3 2 4.27zM7.53 9.8l1.55 1.55c-.05.21-.08.43-.08.65 0 1.66 1.34 3 3 3 .22 0 .44-.03.65-.08l1.55 1.55c-.67.33-1.41.53-2.2.53-2.76 0-5-2.24-5-5 0-.79.2-1.53.53-2.2zm4.31-.78l3.15 3.15.02-.16c0-1.66-1.34-3-3-3l-.17.01z" }, null, -1);
const _hoisted_6$1 = [
  _hoisted_4$3,
  _hoisted_5$1
];
const __default__ = {
  inheritAttrs: false
};
const _sfc_main$o = /* @__PURE__ */ defineComponent({
  ...__default__,
  __name: "password-control",
  props: {
    name: null,
    label: null,
    autocomplete: { default: "new-password" },
    hasError: { type: Boolean, default: false },
    labelHidden: { type: Boolean },
    placeholder: null,
    required: { type: Boolean, default: true },
    describedBy: null
  },
  setup(__props) {
    var _a2;
    const props = __props;
    const showPassword = b$2("Show password");
    const hidePassword = b$2("Hide password");
    const showHideType = ref("password");
    const showHideLabel = ref(showPassword);
    const random = Math.floor(Math.random() * 999999);
    const { name, label, autocomplete, hasError, labelHidden, placeholder, required } = toRefs(props);
    let password = ref("");
    function togglePasswordText() {
      showHideLabel.value = showHideLabel.value === showPassword ? hidePassword : showPassword;
      showHideType.value = showHideType.value === "password" ? "text" : "password";
    }
    const placeholderValue = b$2((_a2 = placeholder == null ? void 0 : placeholder.value) != null ? _a2 : label.value);
    const labelValue = b$2(label.value);
    return (_ctx, _cache) => {
      const _component_base_label = __unplugin_components_0;
      const _component_base_input = _sfc_main$p;
      const _component_base_wrapper = __unplugin_components_2;
      return openBlock(), createBlock(_component_base_wrapper, {
        class: normalizeClass([
          unref(e$e).Flex,
          unref(e$e).Field,
          unref(e$e).TextField,
          unref(e$e).PasswordField,
          "amplify-authenticator__column"
        ])
      }, {
        default: withCtx(() => [
          createVNode(_component_base_label, {
            class: normalizeClass(["amplify-label", { "amplify-visually-hidden": unref(labelHidden) }]),
            for: "amplify-field-" + unref(random)
          }, {
            default: withCtx(() => [
              createTextVNode(toDisplayString(unref(labelValue)), 1)
            ]),
            _: 1
          }, 8, ["class", "for"]),
          createVNode(_component_base_wrapper, {
            class: normalizeClass([unref(e$e).Flex, unref(e$e).FieldGroup])
          }, {
            default: withCtx(() => [
              createVNode(_component_base_wrapper, {
                class: normalizeClass(unref(e$e).FieldGroupFieldWrapper)
              }, {
                default: withCtx(() => {
                  var _a3;
                  return [
                    createVNode(_component_base_input, mergeProps(_ctx.$attrs, {
                      modelValue: unref(password),
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => isRef(password) ? password.value = $event : password = $event),
                      class: [
                        unref(e$e).Input,
                        unref(e$e).FieldGroupControl
                      ],
                      id: "amplify-field-" + unref(random),
                      "data-amplify-password": "true",
                      name: unref(name),
                      autocomplete: unref(autocomplete),
                      required: (_a3 = unref(required)) != null ? _a3 : true,
                      placeholder: unref(placeholderValue),
                      type: showHideType.value,
                      "aria-invalid": unref(hasError),
                      "aria-describedBy": __props.describedBy
                    }), null, 16, ["modelValue", "class", "id", "name", "autocomplete", "required", "placeholder", "type", "aria-invalid", "aria-describedBy"])
                  ];
                }),
                _: 1
              }, 8, ["class"]),
              createVNode(_component_base_wrapper, {
                class: normalizeClass(unref(e$e).FieldGroupOuterEnd)
              }, {
                default: withCtx(() => [
                  createElementVNode("button", {
                    "aria-label": showHideLabel.value,
                    "aria-checked": showHideType.value !== "password",
                    class: normalizeClass([
                      unref(e$e).Button,
                      unref(e$e).FieldGroupControl,
                      unref(e$e).FieldShowPassword
                    ]),
                    "data-fullwidth": "false",
                    type: "button",
                    role: "switch",
                    onClick: togglePasswordText
                  }, [
                    showHideType.value === "password" ? (openBlock(), createElementBlock("svg", {
                      key: 0,
                      xmlns: "http://www.w3.org/2000/svg",
                      fill: "currentColor",
                      viewBox: "0 0 24 24",
                      class: normalizeClass(unref(e$e).Icon)
                    }, _hoisted_3$3, 2)) : (openBlock(), createElementBlock("svg", {
                      key: 1,
                      xmlns: "http://www.w3.org/2000/svg",
                      fill: "currentColor",
                      viewBox: "0 0 24 24",
                      class: normalizeClass(unref(e$e).Icon)
                    }, _hoisted_6$1, 2))
                  ], 10, _hoisted_1$7)
                ]),
                _: 1
              }, 8, ["class"])
            ]),
            _: 1
          }, 8, ["class"])
        ]),
        _: 1
      }, 8, ["class"]);
    };
  }
});
const _hoisted_1$6 = ["value", "selected"];
const _sfc_main$n = /* @__PURE__ */ defineComponent({
  __name: "base-select",
  props: {
    selectValue: { default: "" },
    options: null
  },
  emits: ["update:selectValue"],
  setup(__props, { emit }) {
    const props = __props;
    const { options, selectValue } = toRefs(props);
    const onChange = (e2) => {
      emit("update:selectValue", e2.target.value);
    };
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("select", {
        onChange: _cache[0] || (_cache[0] = (event) => onChange(event))
      }, [
        (openBlock(true), createElementBlock(Fragment, null, renderList(unref(options), (option, idx) => {
          return openBlock(), createElementBlock("option", {
            key: idx,
            value: option,
            selected: option == unref(selectValue) ? true : void 0
          }, toDisplayString(option), 9, _hoisted_1$6);
        }), 128))
      ], 32);
    };
  }
});
const _hoisted_1$5 = /* @__PURE__ */ createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  "data-size": "large",
  fill: "currentColor",
  viewBox: "0 0 24 24",
  class: "amplify-icon amplify-icon--large"
}, [
  /* @__PURE__ */ createElementVNode("path", { d: "M16.59 8.59L12 13.17 7.41 8.59 6 10l6 6 6-6z" })
], -1);
const _sfc_main$m = /* @__PURE__ */ defineComponent({
  __name: "alias-control",
  props: {
    label: { default: "Username" },
    name: { default: "username" },
    placeholder: { default: "" },
    autocomplete: { default: "" },
    labelHidden: { type: Boolean },
    required: { type: Boolean, default: true },
    dialCode: null,
    dialCodeList: null,
    type: { default: "text" },
    hasError: { type: Boolean },
    describedBy: null
  },
  setup(__props) {
    const props = __props;
    const { label, name, placeholder, autocomplete, labelHidden, required, dialCode, dialCodeList } = toRefs(props);
    const random = Math.floor(Math.random() * 999999);
    const randomPhone = Math.floor(Math.random() * 999999);
    return (_ctx, _cache) => {
      const _component_base_label = __unplugin_components_0;
      const _component_base_select = _sfc_main$n;
      const _component_base_wrapper = __unplugin_components_2;
      const _component_base_input = _sfc_main$p;
      return openBlock(), createBlock(_component_base_wrapper, { class: "amplify-flex amplify-field amplify-textfield amplify-phonenumberfield amplify-authenticator__column" }, {
        default: withCtx(() => [
          createVNode(_component_base_label, mergeProps({
            for: "amplify-field-" + unref(random),
            class: ["amplify-label", { "amplify-visually-hidden": unref(labelHidden) }]
          }, _ctx.$attrs), {
            default: withCtx(() => [
              createTextVNode(toDisplayString(unref(label)), 1)
            ]),
            _: 1
          }, 16, ["for", "class"]),
          createVNode(_component_base_wrapper, { class: "amplify-flex amplify-field-group" }, {
            default: withCtx(() => [
              createVNode(_component_base_wrapper, { class: "amplify-field-group__outer-start" }, {
                default: withCtx(() => [
                  __props.type === "tel" ? (openBlock(), createBlock(_component_base_wrapper, {
                    key: 0,
                    class: "amplify-flex amplify-field amplify-selectfield amplify-countrycodeselect amplify-dialcodeselect amplify-authenticator__column"
                  }, {
                    default: withCtx(() => [
                      createVNode(_component_base_label, mergeProps({
                        for: "amplify-field-" + unref(randomPhone),
                        class: "amplify-label amplify-visually-hidden"
                      }, _ctx.$attrs), {
                        default: withCtx(() => [
                          createTextVNode(toDisplayString("Country Code"))
                        ]),
                        _: 1
                      }, 16, ["for"]),
                      createVNode(_component_base_wrapper, { class: "amplify-select__wrapper" }, {
                        default: withCtx(() => [
                          createVNode(_component_base_select, {
                            class: "amplify-select amplify-field-group__control",
                            id: "amplify-field-" + unref(randomPhone),
                            autocomplete: "tel-country-code",
                            "aria-label": "country code",
                            name: "country_code",
                            options: unref(dialCodeList),
                            "select-value": unref(dialCode)
                          }, null, 8, ["id", "options", "select-value"]),
                          createVNode(_component_base_wrapper, { class: "amplify-flex amplify-select__icon-wrapper amplify-authenticator__icon-wrapper" }, {
                            default: withCtx(() => [
                              _hoisted_1$5
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })) : createCommentVNode("", true)
                ]),
                _: 1
              }),
              createVNode(_component_base_wrapper, { class: "amplify-field-group__field-wrapper" }, {
                default: withCtx(() => {
                  var _a2;
                  return [
                    createVNode(_component_base_input, {
                      class: "amplify-input amplify-field-group__control",
                      id: "amplify-field-" + unref(random),
                      autocomplete: unref(autocomplete),
                      name: unref(name),
                      required: (_a2 = unref(required)) != null ? _a2 : true,
                      type: __props.type,
                      placeholder: unref(placeholder),
                      "aria-invalid": __props.hasError,
                      "aria-describedBy": __props.describedBy
                    }, null, 8, ["id", "autocomplete", "name", "required", "type", "placeholder", "aria-invalid", "aria-describedBy"])
                  ];
                }),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      });
    };
  }
});
const _hoisted_1$4 = ["id"];
const _sfc_main$l = /* @__PURE__ */ defineComponent({
  __name: "base-form-field",
  props: {
    name: { default: "" },
    formField: { default: () => ({}) }
  },
  setup(__props) {
    const props = __props;
    const { name, formField } = toRefs(props);
    const useAuthShared = createSharedComposable(useAuthenticator);
    const { validationErrors } = toRefs(useAuthShared());
    const { type } = formField.value;
    const isPasswordField = type === "password";
    const errorId = nanoid(12);
    const errors = computed(() => s$3(validationErrors.value[name.value]));
    const hasError = computed(() => {
      var _a2;
      return ((_a2 = errors.value) == null ? void 0 : _a2.length) > 0;
    });
    const ariaDescribedBy = computed(() => hasError.value ? errorId : void 0);
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock(Fragment, null, [
        isPasswordField ? (openBlock(), createBlock(_sfc_main$o, {
          key: 0,
          name: unref(name),
          label: unref(formField).label,
          placeholder: unref(formField).placeholder,
          required: unref(formField).isRequired,
          "label-hidden": unref(formField).labelHidden,
          autocomplete: unref(formField).autocomplete,
          hasError: unref(hasError),
          describedBy: unref(ariaDescribedBy)
        }, null, 8, ["name", "label", "placeholder", "required", "label-hidden", "autocomplete", "hasError", "describedBy"])) : (openBlock(), createBlock(_sfc_main$m, {
          key: 1,
          name: unref(name),
          label: unref(formField).label,
          placeholder: unref(formField).placeholder,
          required: unref(formField).isRequired,
          "label-hidden": unref(formField).labelHidden,
          autocomplete: unref(formField).autocomplete,
          "dial-code": unref(formField).dialCode,
          "dial-code-list": unref(formField).dialCodeList,
          type: unref(formField).type,
          hasError: unref(hasError),
          describedBy: unref(ariaDescribedBy)
        }, null, 8, ["name", "label", "placeholder", "required", "label-hidden", "autocomplete", "dial-code", "dial-code-list", "type", "hasError", "describedBy"])),
        unref(hasError) ? (openBlock(), createElementBlock("div", {
          key: 2,
          id: unref(ariaDescribedBy)
        }, [
          (openBlock(true), createElementBlock(Fragment, null, renderList(unref(errors), (error2, idx) => {
            return openBlock(), createElementBlock("p", {
              key: idx,
              role: "alert",
              "data-variation": "error",
              class: "amplify-text amplify-text--error"
            }, toDisplayString(unref(b$2)(error2)), 1);
          }), 128))
        ], 8, _hoisted_1$4)) : createCommentVNode("", true)
      ], 64);
    };
  }
});
const _sfc_main$k = /* @__PURE__ */ defineComponent({
  __name: "base-form-fields",
  props: {
    route: null
  },
  setup(__props) {
    const props = __props;
    const { route } = toRefs(props);
    const { state } = useAuth();
    let formFields = [];
    onBeforeMount(() => {
      formFields = b$1(route.value, state.value);
    });
    return (_ctx, _cache) => {
      return openBlock(true), createElementBlock(Fragment, null, renderList(unref(formFields), ([name, formField]) => {
        return openBlock(), createBlock(_sfc_main$l, {
          name,
          key: name,
          formField
        }, null, 8, ["name", "formField"]);
      }), 128);
    };
  }
});
const _hoisted_1$3 = /* @__PURE__ */ createElementVNode("legend", { class: "amplify-visually-hidden" }, "Sign in", -1);
const _hoisted_2$3 = { "data-amplify-footer": "" };
const _sfc_main$j = /* @__PURE__ */ defineComponent({
  __name: "sign-in",
  emits: [
    "signInSubmit",
    "forgotPasswordClicked",
    "createAccountClicked"
  ],
  setup(__props, { emit }) {
    const useAuthShared = createSharedComposable(useAuthenticator);
    const props = useAuthShared();
    const attrs = useAttrs();
    const { getForgotPasswordText, getSignInText, getSigningInText } = n$2;
    const forgotYourPasswordLink = computed(() => getForgotPasswordText());
    const signInButtonText = computed(() => getSignInText());
    const signIngButtonText = computed(() => getSigningInText());
    const { state, send: send2 } = useAuth();
    const actorState = computed(() => t$1(state.value));
    const onInput = (e2) => {
      const { name, value } = e2.target;
      send2({
        type: "CHANGE",
        data: { name, value }
      });
    };
    const onSignInSubmit = (e2) => {
      if (attrs == null ? void 0 : attrs.onSignInSubmit) {
        emit("signInSubmit", e2);
      } else {
        submit(e2);
      }
    };
    const submit = (e2) => {
      props.submitForm(t(e2));
    };
    const onForgotPasswordClicked = () => {
      if (attrs == null ? void 0 : attrs.onForgotPasswordClicked) {
        emit("forgotPasswordClicked");
      } else {
        send2({ type: "RESET_PASSWORD" });
      }
    };
    return (_ctx, _cache) => {
      const _component_base_field_set = _sfc_main$y;
      const _component_base_alert = _sfc_main$w;
      const _component_amplify_button = _sfc_main$x;
      const _component_base_wrapper = __unplugin_components_2;
      const _component_base_form = _sfc_main$u;
      const _component_base_footer = _sfc_main$t;
      return renderSlot(_ctx.$slots, "signInSlotI", normalizeProps(guardReactiveProps(_ctx.$attrs)), () => [
        renderSlot(_ctx.$slots, "header"),
        createVNode(_component_base_wrapper, normalizeProps(guardReactiveProps(_ctx.$attrs)), {
          default: withCtx(() => [
            createVNode(_component_base_form, {
              "data-amplify-authenticator-signin": "",
              onInput,
              onSubmit: withModifiers(onSignInSubmit, ["prevent"]),
              method: "post"
            }, {
              formt: withCtx(({ slotData }) => [
                renderSlot(_ctx.$slots, "form", {
                  info: slotData,
                  onSignInSubmit,
                  onInput,
                  onForgotPasswordClicked
                })
              ]),
              default: withCtx(() => [
                createVNode(_sfc_main$r),
                createVNode(_component_base_wrapper, { class: "amplify-flex amplify-authenticator__column" }, {
                  default: withCtx(() => [
                    createVNode(_component_base_field_set, {
                      disabled: unref(actorState).matches("signIn.submit"),
                      class: "amplify-flex amplify-authenticator__column"
                    }, {
                      fieldSetI: withCtx(({ slotData }) => [
                        renderSlot(_ctx.$slots, "signin-fields", { info: slotData })
                      ]),
                      default: withCtx(() => [
                        _hoisted_1$3,
                        createVNode(_sfc_main$k, { route: "signIn" })
                      ]),
                      _: 3
                    }, 8, ["disabled"]),
                    unref(actorState).context.remoteError ? (openBlock(), createBlock(_component_base_alert, { key: 0 }, {
                      default: withCtx(() => [
                        createTextVNode(toDisplayString(unref(b$2)(unref(actorState).context.remoteError)), 1)
                      ]),
                      _: 1
                    })) : createCommentVNode("", true),
                    createVNode(_component_amplify_button, {
                      disabled: unref(actorState).matches("signIn.submit"),
                      class: "amplify-field-group__control amplify-authenticator__font",
                      fullwidth: true,
                      loading: false,
                      variation: "primary"
                    }, {
                      default: withCtx(() => [
                        createTextVNode(toDisplayString(unref(actorState).matches("signIn.submit") ? unref(signIngButtonText) : unref(signInButtonText)), 1)
                      ]),
                      _: 1
                    }, 8, ["disabled"])
                  ]),
                  _: 3
                })
              ]),
              _: 3
            }, 8, ["onSubmit"])
          ]),
          _: 3
        }, 16),
        createVNode(_component_base_footer, null, {
          default: withCtx(() => [
            renderSlot(_ctx.$slots, "footer", {}, () => [
              createElementVNode("div", _hoisted_2$3, [
                createVNode(_component_amplify_button, {
                  onClick: onForgotPasswordClicked,
                  class: "amplify-field-group__control amplify-authenticator__font",
                  variation: "link",
                  fullwidth: true,
                  size: "small",
                  style: { "font-weight": "normal" },
                  type: "button"
                }, {
                  default: withCtx(() => [
                    createTextVNode(toDisplayString(unref(forgotYourPasswordLink)), 1)
                  ]),
                  _: 1
                })
              ])
            ])
          ]),
          _: 3
        })
      ]);
    };
  }
});
const _sfc_main$i = /* @__PURE__ */ defineComponent({
  __name: "authenticator-sign-up-form-fields",
  setup(__props) {
    return (_ctx, _cache) => {
      return openBlock(), createBlock(_sfc_main$k, { route: "signUp" });
    };
  }
});
const _sfc_main$h = /* @__PURE__ */ defineComponent({
  __name: "sign-up",
  emits: ["signUpSubmit"],
  setup(__props, { emit }) {
    const useAuthShared = createSharedComposable(useAuthenticator);
    const facadeValues = useAuthShared();
    const props = useAuthShared();
    const { hasValidationErrors, isPending, error: error2 } = toRefs(facadeValues);
    const attrs = useAttrs();
    const { getCreateAccountText } = n$2;
    const createAccountLabel = computed(() => getCreateAccountText());
    const onInput = (e2) => {
      let { checked, name, type, value } = e2.target;
      if (type === "checkbox" && !checked)
        value = void 0;
      props.updateForm({ name, value });
    };
    function onBlur(e2) {
      const { name } = e2.target;
      props.updateBlur({ name });
    }
    const onSignUpSubmit = (e2) => {
      if (attrs == null ? void 0 : attrs.onSignUpSubmit) {
        emit("signUpSubmit", e2);
      } else {
        submit(e2);
      }
    };
    const submit = (e2) => {
      props.submitForm(t(e2));
    };
    return (_ctx, _cache) => {
      const _component_base_field_set = _sfc_main$y;
      const _component_base_alert = _sfc_main$w;
      const _component_amplify_button = _sfc_main$x;
      const _component_base_wrapper = __unplugin_components_2;
      const _component_base_form = _sfc_main$u;
      const _component_base_footer = _sfc_main$t;
      return renderSlot(_ctx.$slots, "signUpSlotI", normalizeProps(guardReactiveProps(_ctx.$attrs)), () => [
        renderSlot(_ctx.$slots, "header"),
        createVNode(_component_base_wrapper, normalizeProps(guardReactiveProps(_ctx.$attrs)), {
          default: withCtx(() => [
            createVNode(_component_base_form, {
              onInput,
              onBlurCapture: onBlur,
              onSubmit: withModifiers(onSignUpSubmit, ["prevent"])
            }, {
              default: withCtx(() => [
                createVNode(_sfc_main$r),
                createVNode(_component_base_wrapper, { class: "amplify-flex amplify-authenticator__column" }, {
                  default: withCtx(() => [
                    createVNode(_component_base_field_set, {
                      class: "amplify-flex amplify-authenticator__column",
                      disabled: unref(isPending)
                    }, {
                      fieldSetI: withCtx(({ slotData }) => [
                        renderSlot(_ctx.$slots, "signup-fields", { info: slotData })
                      ]),
                      default: withCtx(() => [
                        createVNode(_sfc_main$i)
                      ]),
                      _: 3
                    }, 8, ["disabled"]),
                    unref(error2) ? (openBlock(), createBlock(_component_base_alert, { key: 0 }, {
                      default: withCtx(() => [
                        createTextVNode(toDisplayString(unref(b$2)(unref(error2))), 1)
                      ]),
                      _: 1
                    })) : createCommentVNode("", true),
                    createVNode(_component_amplify_button, {
                      class: "amplify-field-group__control amplify-authenticator__font",
                      fullwidth: true,
                      loading: false,
                      variation: "primary",
                      style: { "border-radius": "0px", "font-weight": "normal" },
                      disabled: unref(isPending) || unref(hasValidationErrors)
                    }, {
                      default: withCtx(() => [
                        createTextVNode(toDisplayString(unref(createAccountLabel)), 1)
                      ]),
                      _: 1
                    }, 8, ["disabled"])
                  ]),
                  _: 3
                })
              ]),
              _: 3
            }, 8, ["onSubmit"])
          ]),
          _: 3
        }, 16),
        createVNode(_component_base_footer, null, {
          default: withCtx(() => [
            renderSlot(_ctx.$slots, "footer")
          ]),
          _: 3
        })
      ]);
    };
  }
});
const _sfc_main$g = /* @__PURE__ */ defineComponent({
  __name: "base-two-tab-item",
  props: {
    label: null,
    id: null,
    active: { type: Boolean, default: false }
  },
  setup(__props) {
    const props = __props;
    const { active, id, label } = toRefs(props);
    return (_ctx, _cache) => {
      const _component_base_wrapper = __unplugin_components_2;
      return openBlock(), createBlock(_component_base_wrapper, {
        tabindex: unref(active) ? 0 : -1,
        "data-state": unref(active) ? "active" : "inactive",
        "aria-selected": unref(active) ? "true" : "false",
        "aria-controls": `radix-id-${unref(id)}-8-content-0`,
        id: `radix-id-${unref(id)}-8-trigger-0`,
        "data-orientation": "horizontal",
        role: "tab",
        class: "amplify-tabs-item",
        "data-spacing": "equal",
        "data-radix-collection-item": ""
      }, {
        default: withCtx(() => [
          createTextVNode(toDisplayString(unref(label)), 1)
        ]),
        _: 1
      }, 8, ["tabindex", "data-state", "aria-selected", "aria-controls", "id"]);
    };
  }
});
const _sfc_main$f = {};
function _sfc_render$1(_ctx, _cache) {
  const _component_base_wrapper = __unplugin_components_2;
  return openBlock(), createBlock(_component_base_wrapper, {
    tabindex: "0",
    "aria-orientation": "horizontal",
    "data-orientation": "horizontal",
    class: "amplify-authenticator__tabs",
    role: "tablist"
  }, {
    default: withCtx(() => [
      createVNode(_component_base_wrapper, {
        class: "amplify-flex amplify-tabs amplify-authenticator__tabs-wrapper",
        "data-indicator-position": "top"
      }, {
        default: withCtx(() => [
          renderSlot(_ctx.$slots, "default")
        ]),
        _: 3
      })
    ]),
    _: 3
  });
}
var __unplugin_components_1 = /* @__PURE__ */ _export_sfc(_sfc_main$f, [["render", _sfc_render$1]]);
const _sfc_main$e = defineComponent({
  props: {
    level: {
      type: Number,
      default: 1
    }
  },
  inheritAttrs: false,
  setup(props, { slots, attrs }) {
    var _a2, _b;
    const defaultSlot = slots.default ? slots.default() : [];
    const headingI = slots.headingI ? slots.headingI() : [];
    const headerClass = `${attrs.class || ""} amplify-heading--${props.level}`;
    if (((_b = (_a2 = headingI[0]) == null ? void 0 : _a2.children) == null ? void 0 : _b.length) === 0) {
      headingI[0].children = [
        h$2(`h${props.level}`, { ...attrs, class: headerClass }, [defaultSlot])
      ];
    } else {
      return () => h$2(`h${props.level}`, { "data-amplify-heading": "", ...attrs, class: headerClass }, [
        headingI[0] ? h$2(headingI[0].children[0]) : h$2(defaultSlot[0])
      ]);
    }
    return () => headingI;
  }
});
const _sfc_main$d = {};
function _sfc_render(_ctx, _cache) {
  return renderSlot(_ctx.$slots, "textI", normalizeProps(guardReactiveProps(_ctx.$attrs)), () => [
    createElementVNode("span", mergeProps(_ctx.$attrs, { "data-amplify-text": "" }), [
      renderSlot(_ctx.$slots, "default")
    ], 16)
  ]);
}
var __unplugin_components_3 = /* @__PURE__ */ _export_sfc(_sfc_main$d, [["render", _sfc_render]]);
const _sfc_main$c = /* @__PURE__ */ defineComponent({
  __name: "confirm-sign-up",
  emits: ["confirmSignUpSubmit", "lostCodeClicked"],
  setup(__props, { emit }) {
    const attrs = useAttrs();
    const useAuthShared = createSharedComposable(useAuthenticator);
    const { isPending, error: error2, codeDeliveryDetails } = toRefs(useAuthShared());
    const { submitForm, updateForm, resendCode } = useAuthShared();
    const { getDeliveryMethodText, getDeliveryMessageText, getResendCodeText, getConfirmText } = n$2;
    const confirmSignUpHeading = computed(() => getDeliveryMethodText(codeDeliveryDetails.value));
    const resendCodeText = computed(() => getResendCodeText());
    const confirmText = computed(() => getConfirmText());
    const subtitleText = computed(() => getDeliveryMessageText(codeDeliveryDetails.value));
    const onInput = (e2) => {
      const { name, value } = e2.target;
      updateForm({ name, value });
    };
    const onConfirmSignUpSubmit = (e2) => {
      if (attrs == null ? void 0 : attrs.onConfirmSignUpSubmit) {
        emit("confirmSignUpSubmit", e2);
      } else {
        submit(e2);
      }
    };
    const submit = (e2) => {
      submitForm(t(e2));
    };
    const onLostCodeClicked = () => {
      if (attrs == null ? void 0 : attrs.onLostCodeClicked) {
        emit("lostCodeClicked");
      } else {
        resendCode();
      }
    };
    return (_ctx, _cache) => {
      const _component_base_heading = _sfc_main$e;
      const _component_base_text = __unplugin_components_3;
      const _component_base_field_set = _sfc_main$y;
      const _component_base_alert = _sfc_main$w;
      const _component_amplify_button = _sfc_main$x;
      const _component_base_footer = _sfc_main$t;
      const _component_base_wrapper = __unplugin_components_2;
      const _component_base_form = _sfc_main$u;
      return renderSlot(_ctx.$slots, "confirmSignUpSlotI", normalizeProps(guardReactiveProps(_ctx.$attrs)), () => [
        createVNode(_component_base_wrapper, normalizeProps(guardReactiveProps(_ctx.$attrs)), {
          default: withCtx(() => [
            createVNode(_component_base_form, {
              onInput,
              onSubmit: withModifiers(onConfirmSignUpSubmit, ["prevent"])
            }, {
              default: withCtx(() => [
                createVNode(_component_base_wrapper, { class: "amplify-flex amplify-authenticator__column" }, {
                  default: withCtx(() => [
                    renderSlot(_ctx.$slots, "header", {}, () => [
                      createVNode(_component_base_heading, {
                        class: "amplify-heading amplify-authenticator__heading",
                        level: 3
                      }, {
                        default: withCtx(() => [
                          createTextVNode(toDisplayString(unref(confirmSignUpHeading)), 1)
                        ]),
                        _: 1
                      })
                    ]),
                    createVNode(_component_base_text, { class: "amplify-authenticator__subtitle" }, {
                      default: withCtx(() => [
                        createTextVNode(toDisplayString(unref(subtitleText)), 1)
                      ]),
                      _: 1
                    }),
                    createVNode(_component_base_field_set, {
                      class: "amplify-flex amplify-authenticator__column",
                      disabled: unref(isPending)
                    }, {
                      default: withCtx(() => [
                        createVNode(_sfc_main$k, { route: "confirmSignUp" })
                      ]),
                      _: 1
                    }, 8, ["disabled"]),
                    createVNode(_component_base_footer, { class: "amplify-flex amplify-authenticator__column" }, {
                      default: withCtx(() => [
                        unref(error2) ? (openBlock(), createBlock(_component_base_alert, { key: 0 }, {
                          default: withCtx(() => [
                            createTextVNode(toDisplayString(unref(b$2)(unref(error2))), 1)
                          ]),
                          _: 1
                        })) : createCommentVNode("", true),
                        createVNode(_component_amplify_button, {
                          class: "amplify-field-group__control amplify-authenticator__font",
                          fullwidth: false,
                          loading: false,
                          variation: "primary",
                          type: "submit",
                          disabled: unref(isPending)
                        }, {
                          default: withCtx(() => [
                            createTextVNode(toDisplayString(unref(confirmText)), 1)
                          ]),
                          _: 1
                        }, 8, ["disabled"]),
                        createVNode(_component_amplify_button, {
                          class: "amplify-field-group__control amplify-authenticator__font",
                          fullwidth: false,
                          variation: "default",
                          style: { "font-weight": "normal" },
                          type: "button",
                          onClick: withModifiers(onLostCodeClicked, ["prevent"])
                        }, {
                          default: withCtx(() => [
                            createTextVNode(toDisplayString(unref(resendCodeText)), 1)
                          ]),
                          _: 1
                        }, 8, ["onClick"]),
                        renderSlot(_ctx.$slots, "footer", {
                          onConfirmSignUpSubmit,
                          onLostCodeClicked
                        })
                      ]),
                      _: 3
                    })
                  ]),
                  _: 3
                })
              ]),
              _: 3
            }, 8, ["onSubmit"])
          ]),
          _: 3
        }, 16)
      ]);
    };
  }
});
const _sfc_main$b = /* @__PURE__ */ defineComponent({
  __name: "confirm-sign-in",
  emits: ["confirmSignInSubmit", "backToSignInClicked"],
  setup(__props, { emit }) {
    const attrs = useAttrs();
    const { state, send: send2 } = useAuth();
    const useAuthShared = createSharedComposable(useAuthenticator);
    const props = useAuthShared();
    const actorState = computed(() => t$1(state.value));
    const challengeName = actorState.value.context.challengeName;
    const { getBackToSignInText, getConfirmText, getChallengeText } = n$2;
    const confirmSignInHeading = computed(() => getChallengeText(challengeName));
    const backSignInText = computed(() => getBackToSignInText());
    const confirmText = computed(() => getConfirmText());
    const onInput = (e2) => {
      const { name, value } = e2.target;
      send2({
        type: "CHANGE",
        data: { name, value }
      });
    };
    const onConfirmSignInSubmit = (e2) => {
      if (attrs == null ? void 0 : attrs.onConfirmSignInSubmit) {
        emit("confirmSignInSubmit", e2);
      } else {
        submit(e2);
      }
    };
    const submit = (e2) => {
      props.submitForm(t(e2));
    };
    const onBackToSignInClicked = () => {
      if (attrs == null ? void 0 : attrs.onBackToSignInClicked) {
        emit("backToSignInClicked");
      } else {
        send2({
          type: "SIGN_IN"
        });
      }
    };
    return (_ctx, _cache) => {
      const _component_base_heading = _sfc_main$e;
      const _component_base_wrapper = __unplugin_components_2;
      const _component_base_alert = _sfc_main$w;
      const _component_amplify_button = _sfc_main$x;
      const _component_base_footer = _sfc_main$t;
      const _component_base_field_set = _sfc_main$y;
      const _component_base_form = _sfc_main$u;
      return renderSlot(_ctx.$slots, "confirmSignInSlotI", normalizeProps(guardReactiveProps(_ctx.$attrs)), () => [
        createVNode(_component_base_wrapper, normalizeProps(guardReactiveProps(_ctx.$attrs)), {
          default: withCtx(() => [
            createVNode(_component_base_form, {
              "data-amplify-authenticator-confirmsignin": "",
              onInput,
              onSubmit: withModifiers(onConfirmSignInSubmit, ["prevent"])
            }, {
              default: withCtx(() => [
                createVNode(_component_base_field_set, {
                  class: "amplify-flex amplify-authenticator__column",
                  disabled: unref(actorState).matches("confirmSignIn.pending")
                }, {
                  default: withCtx(() => [
                    renderSlot(_ctx.$slots, "header", {}, () => [
                      createVNode(_component_base_heading, {
                        level: 3,
                        class: "amplify-heading"
                      }, {
                        default: withCtx(() => [
                          createTextVNode(toDisplayString(unref(confirmSignInHeading)), 1)
                        ]),
                        _: 1
                      })
                    ]),
                    createVNode(_component_base_wrapper, { class: "amplify-flex amplify-authenticator__column" }, {
                      default: withCtx(() => [
                        createVNode(_sfc_main$k, { route: "confirmSignIn" })
                      ]),
                      _: 1
                    }),
                    createVNode(_component_base_footer, { class: "amplify-flex amplify-authenticator__column" }, {
                      default: withCtx(() => {
                        var _a2, _b;
                        return [
                          ((_b = (_a2 = unref(actorState)) == null ? void 0 : _a2.context) == null ? void 0 : _b.remoteError) ? (openBlock(), createBlock(_component_base_alert, { key: 0 }, {
                            default: withCtx(() => {
                              var _a3, _b2;
                              return [
                                createTextVNode(toDisplayString(unref(b$2)((_b2 = (_a3 = unref(actorState)) == null ? void 0 : _a3.context) == null ? void 0 : _b2.remoteError)), 1)
                              ];
                            }),
                            _: 1
                          })) : createCommentVNode("", true),
                          createVNode(_component_amplify_button, {
                            class: "amplify-field-group__control amplify-authenticator__font",
                            fullwidth: false,
                            loading: false,
                            variation: "primary",
                            style: { "font-weight": "normal" },
                            disabled: unref(actorState).matches("confirmSignIn.pending")
                          }, {
                            default: withCtx(() => [
                              createTextVNode(toDisplayString(unref(confirmText)), 1)
                            ]),
                            _: 1
                          }, 8, ["disabled"]),
                          createVNode(_component_amplify_button, {
                            class: "amplify-field-group__control amplify-authenticator__font",
                            fullwidth: false,
                            size: "small",
                            variation: "link",
                            style: { "font-weight": "normal" },
                            type: "button",
                            onClick: withModifiers(onBackToSignInClicked, ["prevent"])
                          }, {
                            default: withCtx(() => [
                              createTextVNode(toDisplayString(unref(backSignInText)), 1)
                            ]),
                            _: 1
                          }, 8, ["onClick"]),
                          renderSlot(_ctx.$slots, "footer", {
                            onBackToSignInClicked,
                            onConfirmSignInSubmit
                          })
                        ];
                      }),
                      _: 3
                    })
                  ]),
                  _: 3
                }, 8, ["disabled"])
              ]),
              _: 3
            }, 8, ["onSubmit"])
          ]),
          _: 3
        }, 16)
      ]);
    };
  }
});
var browser = {};
var canPromise$1 = function() {
  return typeof Promise === "function" && Promise.prototype && Promise.prototype.then;
};
var qrcode = {};
var utils$1 = {};
let toSJISFunction;
const CODEWORDS_COUNT = [
  0,
  26,
  44,
  70,
  100,
  134,
  172,
  196,
  242,
  292,
  346,
  404,
  466,
  532,
  581,
  655,
  733,
  815,
  901,
  991,
  1085,
  1156,
  1258,
  1364,
  1474,
  1588,
  1706,
  1828,
  1921,
  2051,
  2185,
  2323,
  2465,
  2611,
  2761,
  2876,
  3034,
  3196,
  3362,
  3532,
  3706
];
utils$1.getSymbolSize = function getSymbolSize(version2) {
  if (!version2)
    throw new Error('"version" cannot be null or undefined');
  if (version2 < 1 || version2 > 40)
    throw new Error('"version" should be in range from 1 to 40');
  return version2 * 4 + 17;
};
utils$1.getSymbolTotalCodewords = function getSymbolTotalCodewords(version2) {
  return CODEWORDS_COUNT[version2];
};
utils$1.getBCHDigit = function(data) {
  let digit = 0;
  while (data !== 0) {
    digit++;
    data >>>= 1;
  }
  return digit;
};
utils$1.setToSJISFunction = function setToSJISFunction(f2) {
  if (typeof f2 !== "function") {
    throw new Error('"toSJISFunc" is not a valid function.');
  }
  toSJISFunction = f2;
};
utils$1.isKanjiModeEnabled = function() {
  return typeof toSJISFunction !== "undefined";
};
utils$1.toSJIS = function toSJIS(kanji2) {
  return toSJISFunction(kanji2);
};
var errorCorrectionLevel = {};
(function(exports) {
  exports.L = { bit: 1 };
  exports.M = { bit: 0 };
  exports.Q = { bit: 3 };
  exports.H = { bit: 2 };
  function fromString(string) {
    if (typeof string !== "string") {
      throw new Error("Param is not a string");
    }
    const lcStr = string.toLowerCase();
    switch (lcStr) {
      case "l":
      case "low":
        return exports.L;
      case "m":
      case "medium":
        return exports.M;
      case "q":
      case "quartile":
        return exports.Q;
      case "h":
      case "high":
        return exports.H;
      default:
        throw new Error("Unknown EC Level: " + string);
    }
  }
  exports.isValid = function isValid2(level) {
    return level && typeof level.bit !== "undefined" && level.bit >= 0 && level.bit < 4;
  };
  exports.from = function from(value, defaultValue) {
    if (exports.isValid(value)) {
      return value;
    }
    try {
      return fromString(value);
    } catch (e2) {
      return defaultValue;
    }
  };
})(errorCorrectionLevel);
function BitBuffer$1() {
  this.buffer = [];
  this.length = 0;
}
BitBuffer$1.prototype = {
  get: function(index2) {
    const bufIndex = Math.floor(index2 / 8);
    return (this.buffer[bufIndex] >>> 7 - index2 % 8 & 1) === 1;
  },
  put: function(num, length) {
    for (let i2 = 0; i2 < length; i2++) {
      this.putBit((num >>> length - i2 - 1 & 1) === 1);
    }
  },
  getLengthInBits: function() {
    return this.length;
  },
  putBit: function(bit) {
    const bufIndex = Math.floor(this.length / 8);
    if (this.buffer.length <= bufIndex) {
      this.buffer.push(0);
    }
    if (bit) {
      this.buffer[bufIndex] |= 128 >>> this.length % 8;
    }
    this.length++;
  }
};
var bitBuffer = BitBuffer$1;
function BitMatrix$1(size) {
  if (!size || size < 1) {
    throw new Error("BitMatrix size must be defined and greater than 0");
  }
  this.size = size;
  this.data = new Uint8Array(size * size);
  this.reservedBit = new Uint8Array(size * size);
}
BitMatrix$1.prototype.set = function(row, col, value, reserved) {
  const index2 = row * this.size + col;
  this.data[index2] = value;
  if (reserved)
    this.reservedBit[index2] = true;
};
BitMatrix$1.prototype.get = function(row, col) {
  return this.data[row * this.size + col];
};
BitMatrix$1.prototype.xor = function(row, col, value) {
  this.data[row * this.size + col] ^= value;
};
BitMatrix$1.prototype.isReserved = function(row, col) {
  return this.reservedBit[row * this.size + col];
};
var bitMatrix = BitMatrix$1;
var alignmentPattern = {};
(function(exports) {
  const getSymbolSize3 = utils$1.getSymbolSize;
  exports.getRowColCoords = function getRowColCoords(version2) {
    if (version2 === 1)
      return [];
    const posCount = Math.floor(version2 / 7) + 2;
    const size = getSymbolSize3(version2);
    const intervals = size === 145 ? 26 : Math.ceil((size - 13) / (2 * posCount - 2)) * 2;
    const positions = [size - 7];
    for (let i2 = 1; i2 < posCount - 1; i2++) {
      positions[i2] = positions[i2 - 1] - intervals;
    }
    positions.push(6);
    return positions.reverse();
  };
  exports.getPositions = function getPositions2(version2) {
    const coords = [];
    const pos = exports.getRowColCoords(version2);
    const posLength = pos.length;
    for (let i2 = 0; i2 < posLength; i2++) {
      for (let j2 = 0; j2 < posLength; j2++) {
        if (i2 === 0 && j2 === 0 || i2 === 0 && j2 === posLength - 1 || i2 === posLength - 1 && j2 === 0) {
          continue;
        }
        coords.push([pos[i2], pos[j2]]);
      }
    }
    return coords;
  };
})(alignmentPattern);
var finderPattern = {};
const getSymbolSize2 = utils$1.getSymbolSize;
const FINDER_PATTERN_SIZE = 7;
finderPattern.getPositions = function getPositions(version2) {
  const size = getSymbolSize2(version2);
  return [
    [0, 0],
    [size - FINDER_PATTERN_SIZE, 0],
    [0, size - FINDER_PATTERN_SIZE]
  ];
};
var maskPattern = {};
(function(exports) {
  exports.Patterns = {
    PATTERN000: 0,
    PATTERN001: 1,
    PATTERN010: 2,
    PATTERN011: 3,
    PATTERN100: 4,
    PATTERN101: 5,
    PATTERN110: 6,
    PATTERN111: 7
  };
  const PenaltyScores = {
    N1: 3,
    N2: 3,
    N3: 40,
    N4: 10
  };
  exports.isValid = function isValid2(mask) {
    return mask != null && mask !== "" && !isNaN(mask) && mask >= 0 && mask <= 7;
  };
  exports.from = function from(value) {
    return exports.isValid(value) ? parseInt(value, 10) : void 0;
  };
  exports.getPenaltyN1 = function getPenaltyN1(data) {
    const size = data.size;
    let points = 0;
    let sameCountCol = 0;
    let sameCountRow = 0;
    let lastCol = null;
    let lastRow = null;
    for (let row = 0; row < size; row++) {
      sameCountCol = sameCountRow = 0;
      lastCol = lastRow = null;
      for (let col = 0; col < size; col++) {
        let module = data.get(row, col);
        if (module === lastCol) {
          sameCountCol++;
        } else {
          if (sameCountCol >= 5)
            points += PenaltyScores.N1 + (sameCountCol - 5);
          lastCol = module;
          sameCountCol = 1;
        }
        module = data.get(col, row);
        if (module === lastRow) {
          sameCountRow++;
        } else {
          if (sameCountRow >= 5)
            points += PenaltyScores.N1 + (sameCountRow - 5);
          lastRow = module;
          sameCountRow = 1;
        }
      }
      if (sameCountCol >= 5)
        points += PenaltyScores.N1 + (sameCountCol - 5);
      if (sameCountRow >= 5)
        points += PenaltyScores.N1 + (sameCountRow - 5);
    }
    return points;
  };
  exports.getPenaltyN2 = function getPenaltyN2(data) {
    const size = data.size;
    let points = 0;
    for (let row = 0; row < size - 1; row++) {
      for (let col = 0; col < size - 1; col++) {
        const last = data.get(row, col) + data.get(row, col + 1) + data.get(row + 1, col) + data.get(row + 1, col + 1);
        if (last === 4 || last === 0)
          points++;
      }
    }
    return points * PenaltyScores.N2;
  };
  exports.getPenaltyN3 = function getPenaltyN3(data) {
    const size = data.size;
    let points = 0;
    let bitsCol = 0;
    let bitsRow = 0;
    for (let row = 0; row < size; row++) {
      bitsCol = bitsRow = 0;
      for (let col = 0; col < size; col++) {
        bitsCol = bitsCol << 1 & 2047 | data.get(row, col);
        if (col >= 10 && (bitsCol === 1488 || bitsCol === 93))
          points++;
        bitsRow = bitsRow << 1 & 2047 | data.get(col, row);
        if (col >= 10 && (bitsRow === 1488 || bitsRow === 93))
          points++;
      }
    }
    return points * PenaltyScores.N3;
  };
  exports.getPenaltyN4 = function getPenaltyN4(data) {
    let darkCount = 0;
    const modulesCount = data.data.length;
    for (let i2 = 0; i2 < modulesCount; i2++)
      darkCount += data.data[i2];
    const k2 = Math.abs(Math.ceil(darkCount * 100 / modulesCount / 5) - 10);
    return k2 * PenaltyScores.N4;
  };
  function getMaskAt(maskPattern2, i2, j2) {
    switch (maskPattern2) {
      case exports.Patterns.PATTERN000:
        return (i2 + j2) % 2 === 0;
      case exports.Patterns.PATTERN001:
        return i2 % 2 === 0;
      case exports.Patterns.PATTERN010:
        return j2 % 3 === 0;
      case exports.Patterns.PATTERN011:
        return (i2 + j2) % 3 === 0;
      case exports.Patterns.PATTERN100:
        return (Math.floor(i2 / 2) + Math.floor(j2 / 3)) % 2 === 0;
      case exports.Patterns.PATTERN101:
        return i2 * j2 % 2 + i2 * j2 % 3 === 0;
      case exports.Patterns.PATTERN110:
        return (i2 * j2 % 2 + i2 * j2 % 3) % 2 === 0;
      case exports.Patterns.PATTERN111:
        return (i2 * j2 % 3 + (i2 + j2) % 2) % 2 === 0;
      default:
        throw new Error("bad maskPattern:" + maskPattern2);
    }
  }
  exports.applyMask = function applyMask(pattern, data) {
    const size = data.size;
    for (let col = 0; col < size; col++) {
      for (let row = 0; row < size; row++) {
        if (data.isReserved(row, col))
          continue;
        data.xor(row, col, getMaskAt(pattern, row, col));
      }
    }
  };
  exports.getBestMask = function getBestMask(data, setupFormatFunc) {
    const numPatterns = Object.keys(exports.Patterns).length;
    let bestPattern = 0;
    let lowerPenalty = Infinity;
    for (let p2 = 0; p2 < numPatterns; p2++) {
      setupFormatFunc(p2);
      exports.applyMask(p2, data);
      const penalty = exports.getPenaltyN1(data) + exports.getPenaltyN2(data) + exports.getPenaltyN3(data) + exports.getPenaltyN4(data);
      exports.applyMask(p2, data);
      if (penalty < lowerPenalty) {
        lowerPenalty = penalty;
        bestPattern = p2;
      }
    }
    return bestPattern;
  };
})(maskPattern);
var errorCorrectionCode = {};
const ECLevel$1 = errorCorrectionLevel;
const EC_BLOCKS_TABLE = [
  1,
  1,
  1,
  1,
  1,
  1,
  1,
  1,
  1,
  1,
  2,
  2,
  1,
  2,
  2,
  4,
  1,
  2,
  4,
  4,
  2,
  4,
  4,
  4,
  2,
  4,
  6,
  5,
  2,
  4,
  6,
  6,
  2,
  5,
  8,
  8,
  4,
  5,
  8,
  8,
  4,
  5,
  8,
  11,
  4,
  8,
  10,
  11,
  4,
  9,
  12,
  16,
  4,
  9,
  16,
  16,
  6,
  10,
  12,
  18,
  6,
  10,
  17,
  16,
  6,
  11,
  16,
  19,
  6,
  13,
  18,
  21,
  7,
  14,
  21,
  25,
  8,
  16,
  20,
  25,
  8,
  17,
  23,
  25,
  9,
  17,
  23,
  34,
  9,
  18,
  25,
  30,
  10,
  20,
  27,
  32,
  12,
  21,
  29,
  35,
  12,
  23,
  34,
  37,
  12,
  25,
  34,
  40,
  13,
  26,
  35,
  42,
  14,
  28,
  38,
  45,
  15,
  29,
  40,
  48,
  16,
  31,
  43,
  51,
  17,
  33,
  45,
  54,
  18,
  35,
  48,
  57,
  19,
  37,
  51,
  60,
  19,
  38,
  53,
  63,
  20,
  40,
  56,
  66,
  21,
  43,
  59,
  70,
  22,
  45,
  62,
  74,
  24,
  47,
  65,
  77,
  25,
  49,
  68,
  81
];
const EC_CODEWORDS_TABLE = [
  7,
  10,
  13,
  17,
  10,
  16,
  22,
  28,
  15,
  26,
  36,
  44,
  20,
  36,
  52,
  64,
  26,
  48,
  72,
  88,
  36,
  64,
  96,
  112,
  40,
  72,
  108,
  130,
  48,
  88,
  132,
  156,
  60,
  110,
  160,
  192,
  72,
  130,
  192,
  224,
  80,
  150,
  224,
  264,
  96,
  176,
  260,
  308,
  104,
  198,
  288,
  352,
  120,
  216,
  320,
  384,
  132,
  240,
  360,
  432,
  144,
  280,
  408,
  480,
  168,
  308,
  448,
  532,
  180,
  338,
  504,
  588,
  196,
  364,
  546,
  650,
  224,
  416,
  600,
  700,
  224,
  442,
  644,
  750,
  252,
  476,
  690,
  816,
  270,
  504,
  750,
  900,
  300,
  560,
  810,
  960,
  312,
  588,
  870,
  1050,
  336,
  644,
  952,
  1110,
  360,
  700,
  1020,
  1200,
  390,
  728,
  1050,
  1260,
  420,
  784,
  1140,
  1350,
  450,
  812,
  1200,
  1440,
  480,
  868,
  1290,
  1530,
  510,
  924,
  1350,
  1620,
  540,
  980,
  1440,
  1710,
  570,
  1036,
  1530,
  1800,
  570,
  1064,
  1590,
  1890,
  600,
  1120,
  1680,
  1980,
  630,
  1204,
  1770,
  2100,
  660,
  1260,
  1860,
  2220,
  720,
  1316,
  1950,
  2310,
  750,
  1372,
  2040,
  2430
];
errorCorrectionCode.getBlocksCount = function getBlocksCount(version2, errorCorrectionLevel2) {
  switch (errorCorrectionLevel2) {
    case ECLevel$1.L:
      return EC_BLOCKS_TABLE[(version2 - 1) * 4 + 0];
    case ECLevel$1.M:
      return EC_BLOCKS_TABLE[(version2 - 1) * 4 + 1];
    case ECLevel$1.Q:
      return EC_BLOCKS_TABLE[(version2 - 1) * 4 + 2];
    case ECLevel$1.H:
      return EC_BLOCKS_TABLE[(version2 - 1) * 4 + 3];
    default:
      return void 0;
  }
};
errorCorrectionCode.getTotalCodewordsCount = function getTotalCodewordsCount(version2, errorCorrectionLevel2) {
  switch (errorCorrectionLevel2) {
    case ECLevel$1.L:
      return EC_CODEWORDS_TABLE[(version2 - 1) * 4 + 0];
    case ECLevel$1.M:
      return EC_CODEWORDS_TABLE[(version2 - 1) * 4 + 1];
    case ECLevel$1.Q:
      return EC_CODEWORDS_TABLE[(version2 - 1) * 4 + 2];
    case ECLevel$1.H:
      return EC_CODEWORDS_TABLE[(version2 - 1) * 4 + 3];
    default:
      return void 0;
  }
};
var polynomial = {};
var galoisField = {};
const EXP_TABLE = new Uint8Array(512);
const LOG_TABLE = new Uint8Array(256);
(function initTables() {
  let x2 = 1;
  for (let i2 = 0; i2 < 255; i2++) {
    EXP_TABLE[i2] = x2;
    LOG_TABLE[x2] = i2;
    x2 <<= 1;
    if (x2 & 256) {
      x2 ^= 285;
    }
  }
  for (let i2 = 255; i2 < 512; i2++) {
    EXP_TABLE[i2] = EXP_TABLE[i2 - 255];
  }
})();
galoisField.log = function log2(n2) {
  if (n2 < 1)
    throw new Error("log(" + n2 + ")");
  return LOG_TABLE[n2];
};
galoisField.exp = function exp(n2) {
  return EXP_TABLE[n2];
};
galoisField.mul = function mul(x2, y2) {
  if (x2 === 0 || y2 === 0)
    return 0;
  return EXP_TABLE[LOG_TABLE[x2] + LOG_TABLE[y2]];
};
(function(exports) {
  const GF = galoisField;
  exports.mul = function mul2(p1, p2) {
    const coeff = new Uint8Array(p1.length + p2.length - 1);
    for (let i2 = 0; i2 < p1.length; i2++) {
      for (let j2 = 0; j2 < p2.length; j2++) {
        coeff[i2 + j2] ^= GF.mul(p1[i2], p2[j2]);
      }
    }
    return coeff;
  };
  exports.mod = function mod(divident, divisor) {
    let result = new Uint8Array(divident);
    while (result.length - divisor.length >= 0) {
      const coeff = result[0];
      for (let i2 = 0; i2 < divisor.length; i2++) {
        result[i2] ^= GF.mul(divisor[i2], coeff);
      }
      let offset = 0;
      while (offset < result.length && result[offset] === 0)
        offset++;
      result = result.slice(offset);
    }
    return result;
  };
  exports.generateECPolynomial = function generateECPolynomial(degree) {
    let poly = new Uint8Array([1]);
    for (let i2 = 0; i2 < degree; i2++) {
      poly = exports.mul(poly, new Uint8Array([1, GF.exp(i2)]));
    }
    return poly;
  };
})(polynomial);
const Polynomial = polynomial;
function ReedSolomonEncoder$1(degree) {
  this.genPoly = void 0;
  this.degree = degree;
  if (this.degree)
    this.initialize(this.degree);
}
ReedSolomonEncoder$1.prototype.initialize = function initialize(degree) {
  this.degree = degree;
  this.genPoly = Polynomial.generateECPolynomial(this.degree);
};
ReedSolomonEncoder$1.prototype.encode = function encode(data) {
  if (!this.genPoly) {
    throw new Error("Encoder not initialized");
  }
  const paddedData = new Uint8Array(data.length + this.degree);
  paddedData.set(data);
  const remainder = Polynomial.mod(paddedData, this.genPoly);
  const start2 = this.degree - remainder.length;
  if (start2 > 0) {
    const buff = new Uint8Array(this.degree);
    buff.set(remainder, start2);
    return buff;
  }
  return remainder;
};
var reedSolomonEncoder = ReedSolomonEncoder$1;
var version = {};
var mode = {};
var versionCheck = {};
versionCheck.isValid = function isValid(version2) {
  return !isNaN(version2) && version2 >= 1 && version2 <= 40;
};
var regex = {};
const numeric = "[0-9]+";
const alphanumeric = "[A-Z $%*+\\-./:]+";
let kanji = "(?:[u3000-u303F]|[u3040-u309F]|[u30A0-u30FF]|[uFF00-uFFEF]|[u4E00-u9FAF]|[u2605-u2606]|[u2190-u2195]|u203B|[u2010u2015u2018u2019u2025u2026u201Cu201Du2225u2260]|[u0391-u0451]|[u00A7u00A8u00B1u00B4u00D7u00F7])+";
kanji = kanji.replace(/u/g, "\\u");
const byte = "(?:(?![A-Z0-9 $%*+\\-./:]|" + kanji + ")(?:.|[\r\n]))+";
regex.KANJI = new RegExp(kanji, "g");
regex.BYTE_KANJI = new RegExp("[^A-Z0-9 $%*+\\-./:]+", "g");
regex.BYTE = new RegExp(byte, "g");
regex.NUMERIC = new RegExp(numeric, "g");
regex.ALPHANUMERIC = new RegExp(alphanumeric, "g");
const TEST_KANJI = new RegExp("^" + kanji + "$");
const TEST_NUMERIC = new RegExp("^" + numeric + "$");
const TEST_ALPHANUMERIC = new RegExp("^[A-Z0-9 $%*+\\-./:]+$");
regex.testKanji = function testKanji(str) {
  return TEST_KANJI.test(str);
};
regex.testNumeric = function testNumeric(str) {
  return TEST_NUMERIC.test(str);
};
regex.testAlphanumeric = function testAlphanumeric(str) {
  return TEST_ALPHANUMERIC.test(str);
};
(function(exports) {
  const VersionCheck = versionCheck;
  const Regex = regex;
  exports.NUMERIC = {
    id: "Numeric",
    bit: 1 << 0,
    ccBits: [10, 12, 14]
  };
  exports.ALPHANUMERIC = {
    id: "Alphanumeric",
    bit: 1 << 1,
    ccBits: [9, 11, 13]
  };
  exports.BYTE = {
    id: "Byte",
    bit: 1 << 2,
    ccBits: [8, 16, 16]
  };
  exports.KANJI = {
    id: "Kanji",
    bit: 1 << 3,
    ccBits: [8, 10, 12]
  };
  exports.MIXED = {
    bit: -1
  };
  exports.getCharCountIndicator = function getCharCountIndicator(mode2, version2) {
    if (!mode2.ccBits)
      throw new Error("Invalid mode: " + mode2);
    if (!VersionCheck.isValid(version2)) {
      throw new Error("Invalid version: " + version2);
    }
    if (version2 >= 1 && version2 < 10)
      return mode2.ccBits[0];
    else if (version2 < 27)
      return mode2.ccBits[1];
    return mode2.ccBits[2];
  };
  exports.getBestModeForData = function getBestModeForData(dataStr) {
    if (Regex.testNumeric(dataStr))
      return exports.NUMERIC;
    else if (Regex.testAlphanumeric(dataStr))
      return exports.ALPHANUMERIC;
    else if (Regex.testKanji(dataStr))
      return exports.KANJI;
    else
      return exports.BYTE;
  };
  exports.toString = function toString2(mode2) {
    if (mode2 && mode2.id)
      return mode2.id;
    throw new Error("Invalid mode");
  };
  exports.isValid = function isValid2(mode2) {
    return mode2 && mode2.bit && mode2.ccBits;
  };
  function fromString(string) {
    if (typeof string !== "string") {
      throw new Error("Param is not a string");
    }
    const lcStr = string.toLowerCase();
    switch (lcStr) {
      case "numeric":
        return exports.NUMERIC;
      case "alphanumeric":
        return exports.ALPHANUMERIC;
      case "kanji":
        return exports.KANJI;
      case "byte":
        return exports.BYTE;
      default:
        throw new Error("Unknown mode: " + string);
    }
  }
  exports.from = function from(value, defaultValue) {
    if (exports.isValid(value)) {
      return value;
    }
    try {
      return fromString(value);
    } catch (e2) {
      return defaultValue;
    }
  };
})(mode);
(function(exports) {
  const Utils2 = utils$1;
  const ECCode2 = errorCorrectionCode;
  const ECLevel2 = errorCorrectionLevel;
  const Mode2 = mode;
  const VersionCheck = versionCheck;
  const G18 = 1 << 12 | 1 << 11 | 1 << 10 | 1 << 9 | 1 << 8 | 1 << 5 | 1 << 2 | 1 << 0;
  const G18_BCH = Utils2.getBCHDigit(G18);
  function getBestVersionForDataLength(mode2, length, errorCorrectionLevel2) {
    for (let currentVersion = 1; currentVersion <= 40; currentVersion++) {
      if (length <= exports.getCapacity(currentVersion, errorCorrectionLevel2, mode2)) {
        return currentVersion;
      }
    }
    return void 0;
  }
  function getReservedBitsCount(mode2, version2) {
    return Mode2.getCharCountIndicator(mode2, version2) + 4;
  }
  function getTotalBitsFromDataArray(segments2, version2) {
    let totalBits = 0;
    segments2.forEach(function(data) {
      const reservedBits = getReservedBitsCount(data.mode, version2);
      totalBits += reservedBits + data.getBitsLength();
    });
    return totalBits;
  }
  function getBestVersionForMixedData(segments2, errorCorrectionLevel2) {
    for (let currentVersion = 1; currentVersion <= 40; currentVersion++) {
      const length = getTotalBitsFromDataArray(segments2, currentVersion);
      if (length <= exports.getCapacity(currentVersion, errorCorrectionLevel2, Mode2.MIXED)) {
        return currentVersion;
      }
    }
    return void 0;
  }
  exports.from = function from(value, defaultValue) {
    if (VersionCheck.isValid(value)) {
      return parseInt(value, 10);
    }
    return defaultValue;
  };
  exports.getCapacity = function getCapacity(version2, errorCorrectionLevel2, mode2) {
    if (!VersionCheck.isValid(version2)) {
      throw new Error("Invalid QR Code version");
    }
    if (typeof mode2 === "undefined")
      mode2 = Mode2.BYTE;
    const totalCodewords = Utils2.getSymbolTotalCodewords(version2);
    const ecTotalCodewords = ECCode2.getTotalCodewordsCount(version2, errorCorrectionLevel2);
    const dataTotalCodewordsBits = (totalCodewords - ecTotalCodewords) * 8;
    if (mode2 === Mode2.MIXED)
      return dataTotalCodewordsBits;
    const usableBits = dataTotalCodewordsBits - getReservedBitsCount(mode2, version2);
    switch (mode2) {
      case Mode2.NUMERIC:
        return Math.floor(usableBits / 10 * 3);
      case Mode2.ALPHANUMERIC:
        return Math.floor(usableBits / 11 * 2);
      case Mode2.KANJI:
        return Math.floor(usableBits / 13);
      case Mode2.BYTE:
      default:
        return Math.floor(usableBits / 8);
    }
  };
  exports.getBestVersionForData = function getBestVersionForData(data, errorCorrectionLevel2) {
    let seg;
    const ecl = ECLevel2.from(errorCorrectionLevel2, ECLevel2.M);
    if (Array.isArray(data)) {
      if (data.length > 1) {
        return getBestVersionForMixedData(data, ecl);
      }
      if (data.length === 0) {
        return 1;
      }
      seg = data[0];
    } else {
      seg = data;
    }
    return getBestVersionForDataLength(seg.mode, seg.getLength(), ecl);
  };
  exports.getEncodedBits = function getEncodedBits2(version2) {
    if (!VersionCheck.isValid(version2) || version2 < 7) {
      throw new Error("Invalid QR Code version");
    }
    let d2 = version2 << 12;
    while (Utils2.getBCHDigit(d2) - G18_BCH >= 0) {
      d2 ^= G18 << Utils2.getBCHDigit(d2) - G18_BCH;
    }
    return version2 << 12 | d2;
  };
})(version);
var formatInfo = {};
const Utils$3 = utils$1;
const G15 = 1 << 10 | 1 << 8 | 1 << 5 | 1 << 4 | 1 << 2 | 1 << 1 | 1 << 0;
const G15_MASK = 1 << 14 | 1 << 12 | 1 << 10 | 1 << 4 | 1 << 1;
const G15_BCH = Utils$3.getBCHDigit(G15);
formatInfo.getEncodedBits = function getEncodedBits(errorCorrectionLevel2, mask) {
  const data = errorCorrectionLevel2.bit << 3 | mask;
  let d2 = data << 10;
  while (Utils$3.getBCHDigit(d2) - G15_BCH >= 0) {
    d2 ^= G15 << Utils$3.getBCHDigit(d2) - G15_BCH;
  }
  return (data << 10 | d2) ^ G15_MASK;
};
var segments = {};
const Mode$4 = mode;
function NumericData(data) {
  this.mode = Mode$4.NUMERIC;
  this.data = data.toString();
}
NumericData.getBitsLength = function getBitsLength(length) {
  return 10 * Math.floor(length / 3) + (length % 3 ? length % 3 * 3 + 1 : 0);
};
NumericData.prototype.getLength = function getLength() {
  return this.data.length;
};
NumericData.prototype.getBitsLength = function getBitsLength2() {
  return NumericData.getBitsLength(this.data.length);
};
NumericData.prototype.write = function write(bitBuffer2) {
  let i2, group, value;
  for (i2 = 0; i2 + 3 <= this.data.length; i2 += 3) {
    group = this.data.substr(i2, 3);
    value = parseInt(group, 10);
    bitBuffer2.put(value, 10);
  }
  const remainingNum = this.data.length - i2;
  if (remainingNum > 0) {
    group = this.data.substr(i2);
    value = parseInt(group, 10);
    bitBuffer2.put(value, remainingNum * 3 + 1);
  }
};
var numericData = NumericData;
const Mode$3 = mode;
const ALPHA_NUM_CHARS = [
  "0",
  "1",
  "2",
  "3",
  "4",
  "5",
  "6",
  "7",
  "8",
  "9",
  "A",
  "B",
  "C",
  "D",
  "E",
  "F",
  "G",
  "H",
  "I",
  "J",
  "K",
  "L",
  "M",
  "N",
  "O",
  "P",
  "Q",
  "R",
  "S",
  "T",
  "U",
  "V",
  "W",
  "X",
  "Y",
  "Z",
  " ",
  "$",
  "%",
  "*",
  "+",
  "-",
  ".",
  "/",
  ":"
];
function AlphanumericData(data) {
  this.mode = Mode$3.ALPHANUMERIC;
  this.data = data;
}
AlphanumericData.getBitsLength = function getBitsLength3(length) {
  return 11 * Math.floor(length / 2) + 6 * (length % 2);
};
AlphanumericData.prototype.getLength = function getLength2() {
  return this.data.length;
};
AlphanumericData.prototype.getBitsLength = function getBitsLength4() {
  return AlphanumericData.getBitsLength(this.data.length);
};
AlphanumericData.prototype.write = function write2(bitBuffer2) {
  let i2;
  for (i2 = 0; i2 + 2 <= this.data.length; i2 += 2) {
    let value = ALPHA_NUM_CHARS.indexOf(this.data[i2]) * 45;
    value += ALPHA_NUM_CHARS.indexOf(this.data[i2 + 1]);
    bitBuffer2.put(value, 11);
  }
  if (this.data.length % 2) {
    bitBuffer2.put(ALPHA_NUM_CHARS.indexOf(this.data[i2]), 6);
  }
};
var alphanumericData = AlphanumericData;
var encodeUtf8$1 = function encodeUtf8(input) {
  var result = [];
  var size = input.length;
  for (var index2 = 0; index2 < size; index2++) {
    var point = input.charCodeAt(index2);
    if (point >= 55296 && point <= 56319 && size > index2 + 1) {
      var second = input.charCodeAt(index2 + 1);
      if (second >= 56320 && second <= 57343) {
        point = (point - 55296) * 1024 + second - 56320 + 65536;
        index2 += 1;
      }
    }
    if (point < 128) {
      result.push(point);
      continue;
    }
    if (point < 2048) {
      result.push(point >> 6 | 192);
      result.push(point & 63 | 128);
      continue;
    }
    if (point < 55296 || point >= 57344 && point < 65536) {
      result.push(point >> 12 | 224);
      result.push(point >> 6 & 63 | 128);
      result.push(point & 63 | 128);
      continue;
    }
    if (point >= 65536 && point <= 1114111) {
      result.push(point >> 18 | 240);
      result.push(point >> 12 & 63 | 128);
      result.push(point >> 6 & 63 | 128);
      result.push(point & 63 | 128);
      continue;
    }
    result.push(239, 191, 189);
  }
  return new Uint8Array(result).buffer;
};
const encodeUtf82 = encodeUtf8$1;
const Mode$2 = mode;
function ByteData(data) {
  this.mode = Mode$2.BYTE;
  this.data = new Uint8Array(encodeUtf82(data));
}
ByteData.getBitsLength = function getBitsLength5(length) {
  return length * 8;
};
ByteData.prototype.getLength = function getLength3() {
  return this.data.length;
};
ByteData.prototype.getBitsLength = function getBitsLength6() {
  return ByteData.getBitsLength(this.data.length);
};
ByteData.prototype.write = function(bitBuffer2) {
  for (let i2 = 0, l2 = this.data.length; i2 < l2; i2++) {
    bitBuffer2.put(this.data[i2], 8);
  }
};
var byteData = ByteData;
const Mode$1 = mode;
const Utils$2 = utils$1;
function KanjiData(data) {
  this.mode = Mode$1.KANJI;
  this.data = data;
}
KanjiData.getBitsLength = function getBitsLength7(length) {
  return length * 13;
};
KanjiData.prototype.getLength = function getLength4() {
  return this.data.length;
};
KanjiData.prototype.getBitsLength = function getBitsLength8() {
  return KanjiData.getBitsLength(this.data.length);
};
KanjiData.prototype.write = function(bitBuffer2) {
  let i2;
  for (i2 = 0; i2 < this.data.length; i2++) {
    let value = Utils$2.toSJIS(this.data[i2]);
    if (value >= 33088 && value <= 40956) {
      value -= 33088;
    } else if (value >= 57408 && value <= 60351) {
      value -= 49472;
    } else {
      throw new Error(
        "Invalid SJIS character: " + this.data[i2] + "\nMake sure your charset is UTF-8"
      );
    }
    value = (value >>> 8 & 255) * 192 + (value & 255);
    bitBuffer2.put(value, 13);
  }
};
var kanjiData = KanjiData;
var dijkstra = { exports: {} };
(function(module) {
  var dijkstra2 = {
    single_source_shortest_paths: function(graph, s2, d2) {
      var predecessors = {};
      var costs = {};
      costs[s2] = 0;
      var open = dijkstra2.PriorityQueue.make();
      open.push(s2, 0);
      var closest, u2, v2, cost_of_s_to_u, adjacent_nodes, cost_of_e, cost_of_s_to_u_plus_cost_of_e, cost_of_s_to_v, first_visit;
      while (!open.empty()) {
        closest = open.pop();
        u2 = closest.value;
        cost_of_s_to_u = closest.cost;
        adjacent_nodes = graph[u2] || {};
        for (v2 in adjacent_nodes) {
          if (adjacent_nodes.hasOwnProperty(v2)) {
            cost_of_e = adjacent_nodes[v2];
            cost_of_s_to_u_plus_cost_of_e = cost_of_s_to_u + cost_of_e;
            cost_of_s_to_v = costs[v2];
            first_visit = typeof costs[v2] === "undefined";
            if (first_visit || cost_of_s_to_v > cost_of_s_to_u_plus_cost_of_e) {
              costs[v2] = cost_of_s_to_u_plus_cost_of_e;
              open.push(v2, cost_of_s_to_u_plus_cost_of_e);
              predecessors[v2] = u2;
            }
          }
        }
      }
      if (typeof d2 !== "undefined" && typeof costs[d2] === "undefined") {
        var msg = ["Could not find a path from ", s2, " to ", d2, "."].join("");
        throw new Error(msg);
      }
      return predecessors;
    },
    extract_shortest_path_from_predecessor_list: function(predecessors, d2) {
      var nodes = [];
      var u2 = d2;
      while (u2) {
        nodes.push(u2);
        predecessors[u2];
        u2 = predecessors[u2];
      }
      nodes.reverse();
      return nodes;
    },
    find_path: function(graph, s2, d2) {
      var predecessors = dijkstra2.single_source_shortest_paths(graph, s2, d2);
      return dijkstra2.extract_shortest_path_from_predecessor_list(
        predecessors,
        d2
      );
    },
    PriorityQueue: {
      make: function(opts) {
        var T2 = dijkstra2.PriorityQueue, t2 = {}, key;
        opts = opts || {};
        for (key in T2) {
          if (T2.hasOwnProperty(key)) {
            t2[key] = T2[key];
          }
        }
        t2.queue = [];
        t2.sorter = opts.sorter || T2.default_sorter;
        return t2;
      },
      default_sorter: function(a2, b2) {
        return a2.cost - b2.cost;
      },
      push: function(value, cost) {
        var item = { value, cost };
        this.queue.push(item);
        this.queue.sort(this.sorter);
      },
      pop: function() {
        return this.queue.shift();
      },
      empty: function() {
        return this.queue.length === 0;
      }
    }
  };
  {
    module.exports = dijkstra2;
  }
})(dijkstra);
(function(exports) {
  const Mode2 = mode;
  const NumericData2 = numericData;
  const AlphanumericData2 = alphanumericData;
  const ByteData2 = byteData;
  const KanjiData2 = kanjiData;
  const Regex = regex;
  const Utils2 = utils$1;
  const dijkstra$1 = dijkstra.exports;
  function getStringByteLength(str) {
    return unescape(encodeURIComponent(str)).length;
  }
  function getSegments(regex2, mode2, str) {
    const segments2 = [];
    let result;
    while ((result = regex2.exec(str)) !== null) {
      segments2.push({
        data: result[0],
        index: result.index,
        mode: mode2,
        length: result[0].length
      });
    }
    return segments2;
  }
  function getSegmentsFromString(dataStr) {
    const numSegs = getSegments(Regex.NUMERIC, Mode2.NUMERIC, dataStr);
    const alphaNumSegs = getSegments(Regex.ALPHANUMERIC, Mode2.ALPHANUMERIC, dataStr);
    let byteSegs;
    let kanjiSegs;
    if (Utils2.isKanjiModeEnabled()) {
      byteSegs = getSegments(Regex.BYTE, Mode2.BYTE, dataStr);
      kanjiSegs = getSegments(Regex.KANJI, Mode2.KANJI, dataStr);
    } else {
      byteSegs = getSegments(Regex.BYTE_KANJI, Mode2.BYTE, dataStr);
      kanjiSegs = [];
    }
    const segs = numSegs.concat(alphaNumSegs, byteSegs, kanjiSegs);
    return segs.sort(function(s1, s2) {
      return s1.index - s2.index;
    }).map(function(obj) {
      return {
        data: obj.data,
        mode: obj.mode,
        length: obj.length
      };
    });
  }
  function getSegmentBitsLength(length, mode2) {
    switch (mode2) {
      case Mode2.NUMERIC:
        return NumericData2.getBitsLength(length);
      case Mode2.ALPHANUMERIC:
        return AlphanumericData2.getBitsLength(length);
      case Mode2.KANJI:
        return KanjiData2.getBitsLength(length);
      case Mode2.BYTE:
        return ByteData2.getBitsLength(length);
    }
  }
  function mergeSegments(segs) {
    return segs.reduce(function(acc, curr) {
      const prevSeg = acc.length - 1 >= 0 ? acc[acc.length - 1] : null;
      if (prevSeg && prevSeg.mode === curr.mode) {
        acc[acc.length - 1].data += curr.data;
        return acc;
      }
      acc.push(curr);
      return acc;
    }, []);
  }
  function buildNodes(segs) {
    const nodes = [];
    for (let i2 = 0; i2 < segs.length; i2++) {
      const seg = segs[i2];
      switch (seg.mode) {
        case Mode2.NUMERIC:
          nodes.push([
            seg,
            { data: seg.data, mode: Mode2.ALPHANUMERIC, length: seg.length },
            { data: seg.data, mode: Mode2.BYTE, length: seg.length }
          ]);
          break;
        case Mode2.ALPHANUMERIC:
          nodes.push([
            seg,
            { data: seg.data, mode: Mode2.BYTE, length: seg.length }
          ]);
          break;
        case Mode2.KANJI:
          nodes.push([
            seg,
            { data: seg.data, mode: Mode2.BYTE, length: getStringByteLength(seg.data) }
          ]);
          break;
        case Mode2.BYTE:
          nodes.push([
            { data: seg.data, mode: Mode2.BYTE, length: getStringByteLength(seg.data) }
          ]);
      }
    }
    return nodes;
  }
  function buildGraph(nodes, version2) {
    const table = {};
    const graph = { start: {} };
    let prevNodeIds = ["start"];
    for (let i2 = 0; i2 < nodes.length; i2++) {
      const nodeGroup = nodes[i2];
      const currentNodeIds = [];
      for (let j2 = 0; j2 < nodeGroup.length; j2++) {
        const node = nodeGroup[j2];
        const key = "" + i2 + j2;
        currentNodeIds.push(key);
        table[key] = { node, lastCount: 0 };
        graph[key] = {};
        for (let n2 = 0; n2 < prevNodeIds.length; n2++) {
          const prevNodeId = prevNodeIds[n2];
          if (table[prevNodeId] && table[prevNodeId].node.mode === node.mode) {
            graph[prevNodeId][key] = getSegmentBitsLength(table[prevNodeId].lastCount + node.length, node.mode) - getSegmentBitsLength(table[prevNodeId].lastCount, node.mode);
            table[prevNodeId].lastCount += node.length;
          } else {
            if (table[prevNodeId])
              table[prevNodeId].lastCount = node.length;
            graph[prevNodeId][key] = getSegmentBitsLength(node.length, node.mode) + 4 + Mode2.getCharCountIndicator(node.mode, version2);
          }
        }
      }
      prevNodeIds = currentNodeIds;
    }
    for (let n2 = 0; n2 < prevNodeIds.length; n2++) {
      graph[prevNodeIds[n2]].end = 0;
    }
    return { map: graph, table };
  }
  function buildSingleSegment(data, modesHint) {
    let mode2;
    const bestMode = Mode2.getBestModeForData(data);
    mode2 = Mode2.from(modesHint, bestMode);
    if (mode2 !== Mode2.BYTE && mode2.bit < bestMode.bit) {
      throw new Error('"' + data + '" cannot be encoded with mode ' + Mode2.toString(mode2) + ".\n Suggested mode is: " + Mode2.toString(bestMode));
    }
    if (mode2 === Mode2.KANJI && !Utils2.isKanjiModeEnabled()) {
      mode2 = Mode2.BYTE;
    }
    switch (mode2) {
      case Mode2.NUMERIC:
        return new NumericData2(data);
      case Mode2.ALPHANUMERIC:
        return new AlphanumericData2(data);
      case Mode2.KANJI:
        return new KanjiData2(data);
      case Mode2.BYTE:
        return new ByteData2(data);
    }
  }
  exports.fromArray = function fromArray(array) {
    return array.reduce(function(acc, seg) {
      if (typeof seg === "string") {
        acc.push(buildSingleSegment(seg, null));
      } else if (seg.data) {
        acc.push(buildSingleSegment(seg.data, seg.mode));
      }
      return acc;
    }, []);
  };
  exports.fromString = function fromString(data, version2) {
    const segs = getSegmentsFromString(data, Utils2.isKanjiModeEnabled());
    const nodes = buildNodes(segs);
    const graph = buildGraph(nodes, version2);
    const path2 = dijkstra$1.find_path(graph.map, "start", "end");
    const optimizedSegs = [];
    for (let i2 = 1; i2 < path2.length - 1; i2++) {
      optimizedSegs.push(graph.table[path2[i2]].node);
    }
    return exports.fromArray(mergeSegments(optimizedSegs));
  };
  exports.rawSplit = function rawSplit(data) {
    return exports.fromArray(
      getSegmentsFromString(data, Utils2.isKanjiModeEnabled())
    );
  };
})(segments);
const Utils$1 = utils$1;
const ECLevel = errorCorrectionLevel;
const BitBuffer = bitBuffer;
const BitMatrix = bitMatrix;
const AlignmentPattern = alignmentPattern;
const FinderPattern = finderPattern;
const MaskPattern = maskPattern;
const ECCode = errorCorrectionCode;
const ReedSolomonEncoder = reedSolomonEncoder;
const Version = version;
const FormatInfo = formatInfo;
const Mode = mode;
const Segments = segments;
function setupFinderPattern(matrix, version2) {
  const size = matrix.size;
  const pos = FinderPattern.getPositions(version2);
  for (let i2 = 0; i2 < pos.length; i2++) {
    const row = pos[i2][0];
    const col = pos[i2][1];
    for (let r2 = -1; r2 <= 7; r2++) {
      if (row + r2 <= -1 || size <= row + r2)
        continue;
      for (let c2 = -1; c2 <= 7; c2++) {
        if (col + c2 <= -1 || size <= col + c2)
          continue;
        if (r2 >= 0 && r2 <= 6 && (c2 === 0 || c2 === 6) || c2 >= 0 && c2 <= 6 && (r2 === 0 || r2 === 6) || r2 >= 2 && r2 <= 4 && c2 >= 2 && c2 <= 4) {
          matrix.set(row + r2, col + c2, true, true);
        } else {
          matrix.set(row + r2, col + c2, false, true);
        }
      }
    }
  }
}
function setupTimingPattern(matrix) {
  const size = matrix.size;
  for (let r2 = 8; r2 < size - 8; r2++) {
    const value = r2 % 2 === 0;
    matrix.set(r2, 6, value, true);
    matrix.set(6, r2, value, true);
  }
}
function setupAlignmentPattern(matrix, version2) {
  const pos = AlignmentPattern.getPositions(version2);
  for (let i2 = 0; i2 < pos.length; i2++) {
    const row = pos[i2][0];
    const col = pos[i2][1];
    for (let r2 = -2; r2 <= 2; r2++) {
      for (let c2 = -2; c2 <= 2; c2++) {
        if (r2 === -2 || r2 === 2 || c2 === -2 || c2 === 2 || r2 === 0 && c2 === 0) {
          matrix.set(row + r2, col + c2, true, true);
        } else {
          matrix.set(row + r2, col + c2, false, true);
        }
      }
    }
  }
}
function setupVersionInfo(matrix, version2) {
  const size = matrix.size;
  const bits = Version.getEncodedBits(version2);
  let row, col, mod;
  for (let i2 = 0; i2 < 18; i2++) {
    row = Math.floor(i2 / 3);
    col = i2 % 3 + size - 8 - 3;
    mod = (bits >> i2 & 1) === 1;
    matrix.set(row, col, mod, true);
    matrix.set(col, row, mod, true);
  }
}
function setupFormatInfo(matrix, errorCorrectionLevel2, maskPattern2) {
  const size = matrix.size;
  const bits = FormatInfo.getEncodedBits(errorCorrectionLevel2, maskPattern2);
  let i2, mod;
  for (i2 = 0; i2 < 15; i2++) {
    mod = (bits >> i2 & 1) === 1;
    if (i2 < 6) {
      matrix.set(i2, 8, mod, true);
    } else if (i2 < 8) {
      matrix.set(i2 + 1, 8, mod, true);
    } else {
      matrix.set(size - 15 + i2, 8, mod, true);
    }
    if (i2 < 8) {
      matrix.set(8, size - i2 - 1, mod, true);
    } else if (i2 < 9) {
      matrix.set(8, 15 - i2 - 1 + 1, mod, true);
    } else {
      matrix.set(8, 15 - i2 - 1, mod, true);
    }
  }
  matrix.set(size - 8, 8, 1, true);
}
function setupData(matrix, data) {
  const size = matrix.size;
  let inc = -1;
  let row = size - 1;
  let bitIndex = 7;
  let byteIndex = 0;
  for (let col = size - 1; col > 0; col -= 2) {
    if (col === 6)
      col--;
    while (true) {
      for (let c2 = 0; c2 < 2; c2++) {
        if (!matrix.isReserved(row, col - c2)) {
          let dark = false;
          if (byteIndex < data.length) {
            dark = (data[byteIndex] >>> bitIndex & 1) === 1;
          }
          matrix.set(row, col - c2, dark);
          bitIndex--;
          if (bitIndex === -1) {
            byteIndex++;
            bitIndex = 7;
          }
        }
      }
      row += inc;
      if (row < 0 || size <= row) {
        row -= inc;
        inc = -inc;
        break;
      }
    }
  }
}
function createData(version2, errorCorrectionLevel2, segments2) {
  const buffer = new BitBuffer();
  segments2.forEach(function(data) {
    buffer.put(data.mode.bit, 4);
    buffer.put(data.getLength(), Mode.getCharCountIndicator(data.mode, version2));
    data.write(buffer);
  });
  const totalCodewords = Utils$1.getSymbolTotalCodewords(version2);
  const ecTotalCodewords = ECCode.getTotalCodewordsCount(version2, errorCorrectionLevel2);
  const dataTotalCodewordsBits = (totalCodewords - ecTotalCodewords) * 8;
  if (buffer.getLengthInBits() + 4 <= dataTotalCodewordsBits) {
    buffer.put(0, 4);
  }
  while (buffer.getLengthInBits() % 8 !== 0) {
    buffer.putBit(0);
  }
  const remainingByte = (dataTotalCodewordsBits - buffer.getLengthInBits()) / 8;
  for (let i2 = 0; i2 < remainingByte; i2++) {
    buffer.put(i2 % 2 ? 17 : 236, 8);
  }
  return createCodewords(buffer, version2, errorCorrectionLevel2);
}
function createCodewords(bitBuffer2, version2, errorCorrectionLevel2) {
  const totalCodewords = Utils$1.getSymbolTotalCodewords(version2);
  const ecTotalCodewords = ECCode.getTotalCodewordsCount(version2, errorCorrectionLevel2);
  const dataTotalCodewords = totalCodewords - ecTotalCodewords;
  const ecTotalBlocks = ECCode.getBlocksCount(version2, errorCorrectionLevel2);
  const blocksInGroup2 = totalCodewords % ecTotalBlocks;
  const blocksInGroup1 = ecTotalBlocks - blocksInGroup2;
  const totalCodewordsInGroup1 = Math.floor(totalCodewords / ecTotalBlocks);
  const dataCodewordsInGroup1 = Math.floor(dataTotalCodewords / ecTotalBlocks);
  const dataCodewordsInGroup2 = dataCodewordsInGroup1 + 1;
  const ecCount = totalCodewordsInGroup1 - dataCodewordsInGroup1;
  const rs = new ReedSolomonEncoder(ecCount);
  let offset = 0;
  const dcData = new Array(ecTotalBlocks);
  const ecData = new Array(ecTotalBlocks);
  let maxDataSize = 0;
  const buffer = new Uint8Array(bitBuffer2.buffer);
  for (let b2 = 0; b2 < ecTotalBlocks; b2++) {
    const dataSize = b2 < blocksInGroup1 ? dataCodewordsInGroup1 : dataCodewordsInGroup2;
    dcData[b2] = buffer.slice(offset, offset + dataSize);
    ecData[b2] = rs.encode(dcData[b2]);
    offset += dataSize;
    maxDataSize = Math.max(maxDataSize, dataSize);
  }
  const data = new Uint8Array(totalCodewords);
  let index2 = 0;
  let i2, r2;
  for (i2 = 0; i2 < maxDataSize; i2++) {
    for (r2 = 0; r2 < ecTotalBlocks; r2++) {
      if (i2 < dcData[r2].length) {
        data[index2++] = dcData[r2][i2];
      }
    }
  }
  for (i2 = 0; i2 < ecCount; i2++) {
    for (r2 = 0; r2 < ecTotalBlocks; r2++) {
      data[index2++] = ecData[r2][i2];
    }
  }
  return data;
}
function createSymbol(data, version2, errorCorrectionLevel2, maskPattern2) {
  let segments2;
  if (Array.isArray(data)) {
    segments2 = Segments.fromArray(data);
  } else if (typeof data === "string") {
    let estimatedVersion = version2;
    if (!estimatedVersion) {
      const rawSegments = Segments.rawSplit(data);
      estimatedVersion = Version.getBestVersionForData(rawSegments, errorCorrectionLevel2);
    }
    segments2 = Segments.fromString(data, estimatedVersion || 40);
  } else {
    throw new Error("Invalid data");
  }
  const bestVersion = Version.getBestVersionForData(segments2, errorCorrectionLevel2);
  if (!bestVersion) {
    throw new Error("The amount of data is too big to be stored in a QR Code");
  }
  if (!version2) {
    version2 = bestVersion;
  } else if (version2 < bestVersion) {
    throw new Error(
      "\nThe chosen QR Code version cannot contain this amount of data.\nMinimum version required to store current data is: " + bestVersion + ".\n"
    );
  }
  const dataBits = createData(version2, errorCorrectionLevel2, segments2);
  const moduleCount = Utils$1.getSymbolSize(version2);
  const modules = new BitMatrix(moduleCount);
  setupFinderPattern(modules, version2);
  setupTimingPattern(modules);
  setupAlignmentPattern(modules, version2);
  setupFormatInfo(modules, errorCorrectionLevel2, 0);
  if (version2 >= 7) {
    setupVersionInfo(modules, version2);
  }
  setupData(modules, dataBits);
  if (isNaN(maskPattern2)) {
    maskPattern2 = MaskPattern.getBestMask(
      modules,
      setupFormatInfo.bind(null, modules, errorCorrectionLevel2)
    );
  }
  MaskPattern.applyMask(maskPattern2, modules);
  setupFormatInfo(modules, errorCorrectionLevel2, maskPattern2);
  return {
    modules,
    version: version2,
    errorCorrectionLevel: errorCorrectionLevel2,
    maskPattern: maskPattern2,
    segments: segments2
  };
}
qrcode.create = function create(data, options) {
  if (typeof data === "undefined" || data === "") {
    throw new Error("No input text");
  }
  let errorCorrectionLevel2 = ECLevel.M;
  let version2;
  let mask;
  if (typeof options !== "undefined") {
    errorCorrectionLevel2 = ECLevel.from(options.errorCorrectionLevel, ECLevel.M);
    version2 = Version.from(options.version);
    mask = MaskPattern.from(options.maskPattern);
    if (options.toSJISFunc) {
      Utils$1.setToSJISFunction(options.toSJISFunc);
    }
  }
  return createSymbol(data, version2, errorCorrectionLevel2, mask);
};
var canvas = {};
var utils = {};
(function(exports) {
  function hex2rgba(hex) {
    if (typeof hex === "number") {
      hex = hex.toString();
    }
    if (typeof hex !== "string") {
      throw new Error("Color should be defined as hex string");
    }
    let hexCode = hex.slice().replace("#", "").split("");
    if (hexCode.length < 3 || hexCode.length === 5 || hexCode.length > 8) {
      throw new Error("Invalid hex color: " + hex);
    }
    if (hexCode.length === 3 || hexCode.length === 4) {
      hexCode = Array.prototype.concat.apply([], hexCode.map(function(c2) {
        return [c2, c2];
      }));
    }
    if (hexCode.length === 6)
      hexCode.push("F", "F");
    const hexValue = parseInt(hexCode.join(""), 16);
    return {
      r: hexValue >> 24 & 255,
      g: hexValue >> 16 & 255,
      b: hexValue >> 8 & 255,
      a: hexValue & 255,
      hex: "#" + hexCode.slice(0, 6).join("")
    };
  }
  exports.getOptions = function getOptions(options) {
    if (!options)
      options = {};
    if (!options.color)
      options.color = {};
    const margin = typeof options.margin === "undefined" || options.margin === null || options.margin < 0 ? 4 : options.margin;
    const width = options.width && options.width >= 21 ? options.width : void 0;
    const scale = options.scale || 4;
    return {
      width,
      scale: width ? 4 : scale,
      margin,
      color: {
        dark: hex2rgba(options.color.dark || "#000000ff"),
        light: hex2rgba(options.color.light || "#ffffffff")
      },
      type: options.type,
      rendererOpts: options.rendererOpts || {}
    };
  };
  exports.getScale = function getScale(qrSize, opts) {
    return opts.width && opts.width >= qrSize + opts.margin * 2 ? opts.width / (qrSize + opts.margin * 2) : opts.scale;
  };
  exports.getImageWidth = function getImageWidth(qrSize, opts) {
    const scale = exports.getScale(qrSize, opts);
    return Math.floor((qrSize + opts.margin * 2) * scale);
  };
  exports.qrToImageData = function qrToImageData(imgData, qr, opts) {
    const size = qr.modules.size;
    const data = qr.modules.data;
    const scale = exports.getScale(size, opts);
    const symbolSize = Math.floor((size + opts.margin * 2) * scale);
    const scaledMargin = opts.margin * scale;
    const palette = [opts.color.light, opts.color.dark];
    for (let i2 = 0; i2 < symbolSize; i2++) {
      for (let j2 = 0; j2 < symbolSize; j2++) {
        let posDst = (i2 * symbolSize + j2) * 4;
        let pxColor = opts.color.light;
        if (i2 >= scaledMargin && j2 >= scaledMargin && i2 < symbolSize - scaledMargin && j2 < symbolSize - scaledMargin) {
          const iSrc = Math.floor((i2 - scaledMargin) / scale);
          const jSrc = Math.floor((j2 - scaledMargin) / scale);
          pxColor = palette[data[iSrc * size + jSrc] ? 1 : 0];
        }
        imgData[posDst++] = pxColor.r;
        imgData[posDst++] = pxColor.g;
        imgData[posDst++] = pxColor.b;
        imgData[posDst] = pxColor.a;
      }
    }
  };
})(utils);
(function(exports) {
  const Utils2 = utils;
  function clearCanvas(ctx, canvas2, size) {
    ctx.clearRect(0, 0, canvas2.width, canvas2.height);
    if (!canvas2.style)
      canvas2.style = {};
    canvas2.height = size;
    canvas2.width = size;
    canvas2.style.height = size + "px";
    canvas2.style.width = size + "px";
  }
  function getCanvasElement() {
    try {
      return document.createElement("canvas");
    } catch (e2) {
      throw new Error("You need to specify a canvas element");
    }
  }
  exports.render = function render2(qrData, canvas2, options) {
    let opts = options;
    let canvasEl = canvas2;
    if (typeof opts === "undefined" && (!canvas2 || !canvas2.getContext)) {
      opts = canvas2;
      canvas2 = void 0;
    }
    if (!canvas2) {
      canvasEl = getCanvasElement();
    }
    opts = Utils2.getOptions(opts);
    const size = Utils2.getImageWidth(qrData.modules.size, opts);
    const ctx = canvasEl.getContext("2d");
    const image = ctx.createImageData(size, size);
    Utils2.qrToImageData(image.data, qrData, opts);
    clearCanvas(ctx, canvasEl, size);
    ctx.putImageData(image, 0, 0);
    return canvasEl;
  };
  exports.renderToDataURL = function renderToDataURL(qrData, canvas2, options) {
    let opts = options;
    if (typeof opts === "undefined" && (!canvas2 || !canvas2.getContext)) {
      opts = canvas2;
      canvas2 = void 0;
    }
    if (!opts)
      opts = {};
    const canvasEl = exports.render(qrData, canvas2, opts);
    const type = opts.type || "image/png";
    const rendererOpts = opts.rendererOpts || {};
    return canvasEl.toDataURL(type, rendererOpts.quality);
  };
})(canvas);
var svgTag = {};
const Utils = utils;
function getColorAttrib(color, attrib) {
  const alpha = color.a / 255;
  const str = attrib + '="' + color.hex + '"';
  return alpha < 1 ? str + " " + attrib + '-opacity="' + alpha.toFixed(2).slice(1) + '"' : str;
}
function svgCmd(cmd, x2, y2) {
  let str = cmd + x2;
  if (typeof y2 !== "undefined")
    str += " " + y2;
  return str;
}
function qrToPath(data, size, margin) {
  let path2 = "";
  let moveBy = 0;
  let newRow = false;
  let lineLength = 0;
  for (let i2 = 0; i2 < data.length; i2++) {
    const col = Math.floor(i2 % size);
    const row = Math.floor(i2 / size);
    if (!col && !newRow)
      newRow = true;
    if (data[i2]) {
      lineLength++;
      if (!(i2 > 0 && col > 0 && data[i2 - 1])) {
        path2 += newRow ? svgCmd("M", col + margin, 0.5 + row + margin) : svgCmd("m", moveBy, 0);
        moveBy = 0;
        newRow = false;
      }
      if (!(col + 1 < size && data[i2 + 1])) {
        path2 += svgCmd("h", lineLength);
        lineLength = 0;
      }
    } else {
      moveBy++;
    }
  }
  return path2;
}
svgTag.render = function render(qrData, options, cb) {
  const opts = Utils.getOptions(options);
  const size = qrData.modules.size;
  const data = qrData.modules.data;
  const qrcodesize = size + opts.margin * 2;
  const bg = !opts.color.light.a ? "" : "<path " + getColorAttrib(opts.color.light, "fill") + ' d="M0 0h' + qrcodesize + "v" + qrcodesize + 'H0z"/>';
  const path2 = "<path " + getColorAttrib(opts.color.dark, "stroke") + ' d="' + qrToPath(data, size, opts.margin) + '"/>';
  const viewBox = 'viewBox="0 0 ' + qrcodesize + " " + qrcodesize + '"';
  const width = !opts.width ? "" : 'width="' + opts.width + '" height="' + opts.width + '" ';
  const svgTag2 = '<svg xmlns="http://www.w3.org/2000/svg" ' + width + viewBox + ' shape-rendering="crispEdges">' + bg + path2 + "</svg>\n";
  if (typeof cb === "function") {
    cb(null, svgTag2);
  }
  return svgTag2;
};
const canPromise = canPromise$1;
const QRCode = qrcode;
const CanvasRenderer = canvas;
const SvgRenderer = svgTag;
function renderCanvas(renderFunc, canvas2, text, opts, cb) {
  const args = [].slice.call(arguments, 1);
  const argsNum = args.length;
  const isLastArgCb = typeof args[argsNum - 1] === "function";
  if (!isLastArgCb && !canPromise()) {
    throw new Error("Callback required as last argument");
  }
  if (isLastArgCb) {
    if (argsNum < 2) {
      throw new Error("Too few arguments provided");
    }
    if (argsNum === 2) {
      cb = text;
      text = canvas2;
      canvas2 = opts = void 0;
    } else if (argsNum === 3) {
      if (canvas2.getContext && typeof cb === "undefined") {
        cb = opts;
        opts = void 0;
      } else {
        cb = opts;
        opts = text;
        text = canvas2;
        canvas2 = void 0;
      }
    }
  } else {
    if (argsNum < 1) {
      throw new Error("Too few arguments provided");
    }
    if (argsNum === 1) {
      text = canvas2;
      canvas2 = opts = void 0;
    } else if (argsNum === 2 && !canvas2.getContext) {
      opts = text;
      text = canvas2;
      canvas2 = void 0;
    }
    return new Promise(function(resolve, reject) {
      try {
        const data = QRCode.create(text, opts);
        resolve(renderFunc(data, canvas2, opts));
      } catch (e2) {
        reject(e2);
      }
    });
  }
  try {
    const data = QRCode.create(text, opts);
    cb(null, renderFunc(data, canvas2, opts));
  } catch (e2) {
    cb(e2);
  }
}
browser.create = QRCode.create;
browser.toCanvas = renderCanvas.bind(null, CanvasRenderer.render);
browser.toDataURL = renderCanvas.bind(null, CanvasRenderer.renderToDataURL);
browser.toString = renderCanvas.bind(null, function(data, _2, opts) {
  return SvgRenderer.render(data, opts);
});
const _hoisted_1$2 = { key: 0 };
const _hoisted_2$2 = ["src"];
const _hoisted_3$2 = { "data-amplify-copy-tooltip": "" };
const _hoisted_4$2 = /* @__PURE__ */ createElementVNode("svg", {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /* @__PURE__ */ createElementVNode("path", { d: "M16 1H4C2.9 1 2 1.9 2 3V17H4V3H16V1ZM15 5H8C6.9 5 6.01 5.9 6.01 7L6 21C6 22.1 6.89 23 7.99 23H19C20.1 23 21 22.1 21 21V11L15 5ZM8 21V7H14V12H19V21H8Z" })
], -1);
const _sfc_main$a = /* @__PURE__ */ defineComponent({
  __name: "setup-totp",
  emits: ["confirmSetupTOTPSubmit", "backToSignInClicked"],
  setup(__props, { emit }) {
    var _a2, _b, _c;
    const logger = new Logger("SetupTOTP-logger");
    const useAuthShared = createSharedComposable(useAuthenticator);
    const props = useAuthShared();
    const attrs = useAttrs();
    const { state, send: send2 } = useAuth();
    const { value: { context } } = state;
    const actorState = computed(() => t$1(state.value));
    const { totpSecretCode, user } = actorState.value.context;
    const formOverrides = (_b = (_a2 = context == null ? void 0 : context.config) == null ? void 0 : _a2.formFields) == null ? void 0 : _b.setupTOTP;
    const { totpIssuer = "AWSCognito", totpUsername = user == null ? void 0 : user.username } = (_c = formOverrides == null ? void 0 : formOverrides["QR"]) != null ? _c : {};
    const totpCodeURL = typeof totpSecretCode === "string" && typeof totpUsername === "string" ? m$2(totpIssuer, totpUsername, totpSecretCode) : null;
    const qrCode = reactive({
      qrCodeImageSource: "",
      isLoading: true
    });
    const { getCopyText, getCopiedText, getBackToSignInText, getConfirmText } = n$2;
    const copyTextLabel = ref(getCopyText());
    function copyText() {
      if (typeof totpSecretCode === "string") {
        navigator.clipboard.writeText(totpSecretCode);
      }
      copyTextLabel.value = getCopiedText();
    }
    onMounted(async () => {
      if (!user || !totpCodeURL) {
        return;
      }
      try {
        qrCode.qrCodeImageSource = await browser.toDataURL(totpCodeURL);
      } catch (error2) {
        logger.error(error2);
      } finally {
        qrCode.isLoading = false;
      }
    });
    const backSignInText = computed(() => getBackToSignInText());
    const confirmText = computed(() => getConfirmText());
    const onInput = (e2) => {
      const { name, value } = e2.target;
      send2({ type: "CHANGE", data: { name, value } });
    };
    const onSetupTOTPSubmit = (e2) => {
      if (attrs == null ? void 0 : attrs.onConfirmSetupTOTPSubmit) {
        emit("confirmSetupTOTPSubmit", e2);
      } else {
        submit(e2);
      }
    };
    const submit = (e2) => {
      props.submitForm(t(e2));
    };
    const onBackToSignInClicked = () => {
      if (attrs == null ? void 0 : attrs.onBackToSignInClicked) {
        emit("backToSignInClicked");
      } else {
        send2({ type: "SIGN_IN" });
      }
    };
    return (_ctx, _cache) => {
      const _component_base_heading = _sfc_main$e;
      const _component_base_wrapper = __unplugin_components_2;
      const _component_base_alert = _sfc_main$w;
      const _component_amplify_button = _sfc_main$x;
      const _component_base_footer = _sfc_main$t;
      const _component_base_field_set = _sfc_main$y;
      const _component_base_form = _sfc_main$u;
      return renderSlot(_ctx.$slots, "confirmSetupTOTPI", normalizeProps(guardReactiveProps(_ctx.$attrs)), () => [
        createVNode(_component_base_wrapper, normalizeProps(guardReactiveProps(_ctx.$attrs)), {
          default: withCtx(() => [
            createVNode(_component_base_form, {
              "data-amplify-authenticator-setup-totp": "",
              onInput,
              onSubmit: withModifiers(onSetupTOTPSubmit, ["prevent"])
            }, {
              default: withCtx(() => [
                createVNode(_component_base_field_set, {
                  class: "amplify-flex amplify-authenticator__column",
                  disabled: unref(actorState).matches("confirmSignIn.pending")
                }, {
                  default: withCtx(() => [
                    createVNode(_component_base_wrapper, { class: "amplify-flex amplify-authenticator__column" }, {
                      default: withCtx(() => [
                        renderSlot(_ctx.$slots, "header", {}, () => [
                          createVNode(_component_base_heading, {
                            class: "amplify-heading",
                            level: 3
                          }, {
                            default: withCtx(() => [
                              createTextVNode(" Setup TOTP ")
                            ]),
                            _: 1
                          })
                        ]),
                        createVNode(_component_base_wrapper, { class: "amplify-flex amplify-authenticator__column" }, {
                          default: withCtx(() => [
                            qrCode.isLoading ? (openBlock(), createElementBlock("p", _hoisted_1$2, "Loading...")) : (openBlock(), createElementBlock("img", {
                              key: 1,
                              class: "amplify-image",
                              "data-amplify-qrcode": "",
                              src: qrCode.qrCodeImageSource,
                              alt: "qr code",
                              width: "228",
                              height: "228"
                            }, null, 8, _hoisted_2$2)),
                            createVNode(_component_base_wrapper, {
                              class: "amplify-flex",
                              "data-amplify-copy": ""
                            }, {
                              default: withCtx(() => [
                                createElementVNode("div", null, toDisplayString(unref(totpSecretCode)), 1),
                                createVNode(_component_base_wrapper, {
                                  "data-amplify-copy-svg": "",
                                  onClick: copyText
                                }, {
                                  default: withCtx(() => [
                                    createElementVNode("div", _hoisted_3$2, toDisplayString(copyTextLabel.value), 1),
                                    _hoisted_4$2
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }),
                            createVNode(_sfc_main$k, { route: "setupTOTP" })
                          ]),
                          _: 1
                        }),
                        createVNode(_component_base_footer, { class: "amplify-flex amplify-authenticator__column" }, {
                          default: withCtx(() => {
                            var _a3;
                            return [
                              ((_a3 = unref(actorState).context) == null ? void 0 : _a3.remoteError) ? (openBlock(), createBlock(_component_base_alert, { key: 0 }, {
                                default: withCtx(() => [
                                  createTextVNode(toDisplayString(unref(b$2)(unref(actorState).context.remoteError)), 1)
                                ]),
                                _: 1
                              })) : createCommentVNode("", true),
                              createVNode(_component_amplify_button, {
                                class: "amplify-field-group__control amplify-authenticator__font",
                                fullwidth: false,
                                loading: false,
                                variation: "primary",
                                type: "submit",
                                disabled: unref(actorState).matches("confirmSignIn.pending")
                              }, {
                                default: withCtx(() => [
                                  createTextVNode(toDisplayString(unref(confirmText)), 1)
                                ]),
                                _: 1
                              }, 8, ["disabled"]),
                              createVNode(_component_amplify_button, {
                                class: "amplify-field-group__control amplify-authenticator__font",
                                fullwidth: false,
                                size: "small",
                                variation: "link",
                                style: { "font-weight": "normal" },
                                type: "button",
                                onClick: withModifiers(onBackToSignInClicked, ["prevent"])
                              }, {
                                default: withCtx(() => [
                                  createTextVNode(toDisplayString(unref(backSignInText)), 1)
                                ]),
                                _: 1
                              }, 8, ["onClick"]),
                              renderSlot(_ctx.$slots, "footer", {
                                onBackToSignInClicked,
                                onSetupTOTPSubmit
                              })
                            ];
                          }),
                          _: 3
                        })
                      ]),
                      _: 3
                    })
                  ]),
                  _: 3
                }, 8, ["disabled"])
              ]),
              _: 3
            }, 8, ["onSubmit"])
          ]),
          _: 3
        }, 16)
      ]);
    };
  }
});
const _sfc_main$9 = /* @__PURE__ */ defineComponent({
  __name: "authenticator-force-new-password-form-fields",
  setup(__props) {
    return (_ctx, _cache) => {
      return openBlock(), createBlock(_sfc_main$k, { route: "forceNewPassword" });
    };
  }
});
const _sfc_main$8 = /* @__PURE__ */ defineComponent({
  __name: "force-new-password",
  emits: ["haveAccountClicked", "forceNewPasswordSubmit"],
  setup(__props, { emit }) {
    const attrs = useAttrs();
    const { state, send: send2 } = useAuth();
    const useAuthShared = createSharedComposable(useAuthenticator);
    const props = useAuthShared();
    const actorState = computed(() => t$1(state.value));
    const { getChangePasswordText, getChangingText, getBackToSignInText } = n$2;
    const changePasswordLabel = computed(() => getChangePasswordText());
    const changingPasswordLabel = computed(() => getChangingText());
    const backSignInText = computed(() => getBackToSignInText());
    const onHaveAccountClicked = () => {
      if (attrs == null ? void 0 : attrs.onHaveAccountClicked) {
        emit("haveAccountClicked");
      } else {
        send2({
          type: "SIGN_IN"
        });
      }
    };
    const onForceNewPasswordSubmit = (e2) => {
      if (attrs == null ? void 0 : attrs.onForceNewPasswordSubmit) {
        emit("forceNewPasswordSubmit", e2);
      } else {
        submit(e2);
      }
    };
    const submit = (e2) => {
      props.submitForm(t(e2));
    };
    const onInput = (e2) => {
      const { name, value } = e2.target;
      send2({
        type: "CHANGE",
        data: { name, value }
      });
    };
    function onBlur(e2) {
      const { name } = e2.target;
      props.updateBlur({ name });
    }
    return (_ctx, _cache) => {
      const _component_base_heading = _sfc_main$e;
      const _component_base_wrapper = __unplugin_components_2;
      const _component_base_alert = _sfc_main$w;
      const _component_amplify_button = _sfc_main$x;
      const _component_base_footer = _sfc_main$t;
      const _component_base_field_set = _sfc_main$y;
      const _component_base_form = _sfc_main$u;
      return renderSlot(_ctx.$slots, "forceNewPasswordI", normalizeProps(guardReactiveProps(_ctx.$attrs)), () => [
        createVNode(_component_base_wrapper, normalizeProps(guardReactiveProps(_ctx.$attrs)), {
          default: withCtx(() => [
            createVNode(_component_base_form, {
              "data-amplify-authenticator-forcenewpassword": "",
              onInput,
              onBlurCapture: onBlur,
              onSubmit: withModifiers(onForceNewPasswordSubmit, ["prevent"])
            }, {
              default: withCtx(() => [
                createVNode(_component_base_field_set, {
                  class: "amplify-flex amplify-authenticator__column",
                  disabled: unref(actorState).matches("forceNewPassword.pending")
                }, {
                  default: withCtx(() => [
                    renderSlot(_ctx.$slots, "header", {}, () => [
                      createVNode(_component_base_heading, {
                        level: 3,
                        class: "amplify-heading"
                      }, {
                        default: withCtx(() => [
                          createTextVNode(toDisplayString(unref(changePasswordLabel)), 1)
                        ]),
                        _: 1
                      })
                    ]),
                    createVNode(_component_base_wrapper, { class: "amplify-flex amplify-authenticator__column" }, {
                      default: withCtx(() => [
                        renderSlot(_ctx.$slots, "force-new-password-form-fields", {}, () => [
                          createVNode(_sfc_main$9)
                        ])
                      ]),
                      _: 3
                    }),
                    createVNode(_component_base_footer, { class: "amplify-flex amplify-authenticator__column" }, {
                      default: withCtx(() => [
                        unref(actorState).context.remoteError ? (openBlock(), createBlock(_component_base_alert, {
                          key: 0,
                          "data-ui-error": ""
                        }, {
                          default: withCtx(() => [
                            createTextVNode(toDisplayString(unref(b$2)(unref(actorState).context.remoteError)), 1)
                          ]),
                          _: 1
                        })) : createCommentVNode("", true),
                        createVNode(_component_amplify_button, {
                          class: "amplify-field-group__control amplify-authenticator__font",
                          fullwidth: false,
                          loading: false,
                          variation: "primary",
                          style: { "font-weight": "normal" },
                          disabled: unref(actorState).matches("signUp.submit")
                        }, {
                          default: withCtx(() => [
                            createTextVNode(toDisplayString(unref(actorState).matches("forceNewPassword.pending") ? unref(changingPasswordLabel) + "\u2026" : unref(changePasswordLabel)), 1)
                          ]),
                          _: 1
                        }, 8, ["disabled"]),
                        createVNode(_component_amplify_button, {
                          class: "amplify-field-group__control amplify-authenticator__font",
                          fullwidth: false,
                          size: "small",
                          variation: "link",
                          style: { "font-weight": "normal" },
                          type: "button",
                          onClick: withModifiers(onHaveAccountClicked, ["prevent"])
                        }, {
                          default: withCtx(() => [
                            createTextVNode(toDisplayString(unref(backSignInText)), 1)
                          ]),
                          _: 1
                        }, 8, ["onClick"]),
                        renderSlot(_ctx.$slots, "footer", {
                          onHaveAccountClicked,
                          onForceNewPasswordSubmit
                        })
                      ]),
                      _: 3
                    })
                  ]),
                  _: 3
                }, 8, ["disabled"])
              ]),
              _: 3
            }, 8, ["onSubmit"])
          ]),
          _: 3
        }, 16)
      ]);
    };
  }
});
const _sfc_main$7 = /* @__PURE__ */ defineComponent({
  __name: "reset-password",
  emits: ["resetPasswordSubmit", "backToSignInClicked"],
  setup(__props, { emit }) {
    const attrs = useAttrs();
    const useAuthShared = createSharedComposable(useAuthenticator);
    const { send: send2, submitForm } = useAuthShared();
    const { error: error2, isPending } = toRefs(useAuthShared());
    const { getBackToSignInText, getResetYourPasswordText, getSendCodeText } = n$2;
    const backSignInText = computed(() => getBackToSignInText());
    const resetPasswordHeading = computed(() => getResetYourPasswordText());
    const sendCodeText = computed(() => getSendCodeText());
    const onResetPasswordSubmit = (e2) => {
      if (attrs == null ? void 0 : attrs.onResetPasswordSubmit) {
        emit("resetPasswordSubmit", e2);
      } else {
        submit(e2);
      }
    };
    const submit = (e2) => {
      submitForm(t(e2));
    };
    const onInput = (e2) => {
      const { name, value } = e2.target;
      send2({
        type: "CHANGE",
        data: { name, value }
      });
    };
    const onBackToSignInClicked = () => {
      if (attrs == null ? void 0 : attrs.onBackToSignInClicked) {
        emit("backToSignInClicked");
      } else {
        send2({
          type: "SIGN_IN"
        });
      }
    };
    return (_ctx, _cache) => {
      const _component_base_heading = _sfc_main$e;
      const _component_base_field_set = _sfc_main$y;
      const _component_base_alert = _sfc_main$w;
      const _component_amplify_button = _sfc_main$x;
      const _component_base_footer = _sfc_main$t;
      const _component_base_wrapper = __unplugin_components_2;
      const _component_base_form = _sfc_main$u;
      return renderSlot(_ctx.$slots, "resetPasswordSlotI", normalizeProps(guardReactiveProps(_ctx.$attrs)), () => [
        createVNode(_component_base_form, mergeProps(_ctx.$attrs, {
          "data-amplify-authenticator-resetpassword": "",
          onInput,
          onSubmit: withModifiers(onResetPasswordSubmit, ["prevent"])
        }), {
          default: withCtx(() => [
            createVNode(_component_base_wrapper, { class: "amplify-flex amplify-authenticator__column" }, {
              default: withCtx(() => [
                renderSlot(_ctx.$slots, "header", {}, () => [
                  createVNode(_component_base_heading, {
                    class: "amplify-heading",
                    level: 3
                  }, {
                    default: withCtx(() => [
                      createTextVNode(toDisplayString(unref(resetPasswordHeading)), 1)
                    ]),
                    _: 1
                  })
                ]),
                createVNode(_component_base_field_set, {
                  class: "amplify-flex amplify-authenticator__column",
                  disabled: unref(isPending)
                }, {
                  default: withCtx(() => [
                    createVNode(_sfc_main$k, { route: "resetPassword" })
                  ]),
                  _: 1
                }, 8, ["disabled"]),
                createVNode(_component_base_footer, { class: "amplify-flex amplify-authenticator__column" }, {
                  default: withCtx(() => [
                    unref(error2) ? (openBlock(), createBlock(_component_base_alert, { key: 0 }, {
                      default: withCtx(() => [
                        createTextVNode(toDisplayString(unref(b$2)(unref(error2))), 1)
                      ]),
                      _: 1
                    })) : createCommentVNode("", true),
                    createVNode(_component_amplify_button, {
                      class: "amplify-field-group__control amplify-authenticator__font",
                      fullwidth: false,
                      variation: "primary",
                      type: "submit",
                      disabled: unref(isPending)
                    }, {
                      default: withCtx(() => [
                        createTextVNode(toDisplayString(unref(sendCodeText)), 1)
                      ]),
                      _: 1
                    }, 8, ["disabled"]),
                    createVNode(_component_amplify_button, {
                      class: "amplify-field-group__control amplify-authenticator__font",
                      fullwidth: false,
                      size: "small",
                      variation: "link",
                      style: { "font-weight": "normal" },
                      type: "button",
                      onClick: withModifiers(onBackToSignInClicked, ["prevent"])
                    }, {
                      default: withCtx(() => [
                        createTextVNode(toDisplayString(unref(backSignInText)), 1)
                      ]),
                      _: 1
                    }, 8, ["onClick"]),
                    renderSlot(_ctx.$slots, "footer", {
                      onBackToSignInClicked,
                      onResetPasswordSubmit
                    })
                  ]),
                  _: 3
                })
              ]),
              _: 3
            })
          ]),
          _: 3
        }, 16, ["onSubmit"])
      ]);
    };
  }
});
const _sfc_main$6 = /* @__PURE__ */ defineComponent({
  __name: "confirm-reset-password",
  emits: ["confirmResetPasswordSubmit", "backToSignInClicked"],
  setup(__props, { emit }) {
    const { state, send: send2 } = useAuth();
    const useAuthShared = createSharedComposable(useAuthenticator);
    const props = useAuthShared();
    const attrs = useAttrs();
    const actorState = computed(() => t$1(state.value));
    const { getResendCodeText, getResetYourPasswordText, getSubmitText } = n$2;
    const resendCodeText = computed(() => getResendCodeText());
    const confirmResetPasswordHeading = computed(() => getResetYourPasswordText());
    const confirmResetPasswordText = computed(() => getSubmitText());
    const onConfirmResetPasswordSubmit = (e2) => {
      if (attrs == null ? void 0 : attrs.onConfirmResetPasswordSubmit) {
        emit("confirmResetPasswordSubmit", e2);
      } else {
        submit(e2);
      }
    };
    const submit = (e2) => {
      props.submitForm(t(e2));
    };
    const onLostYourCodeClicked = () => {
      send2({
        type: "RESEND"
      });
    };
    const onInput = (e2) => {
      const { name, value } = e2.target;
      send2({
        type: "CHANGE",
        data: { name, value }
      });
    };
    function onBlur(e2) {
      const { name } = e2.target;
      props.updateBlur({ name });
    }
    return (_ctx, _cache) => {
      const _component_base_heading = _sfc_main$e;
      const _component_base_wrapper = __unplugin_components_2;
      const _component_base_alert = _sfc_main$w;
      const _component_amplify_button = _sfc_main$x;
      const _component_base_footer = _sfc_main$t;
      const _component_base_field_set = _sfc_main$y;
      const _component_base_form = _sfc_main$u;
      return renderSlot(_ctx.$slots, "confirmResetPasswordSlotI", normalizeProps(guardReactiveProps(_ctx.$attrs)), () => [
        createVNode(_component_base_wrapper, normalizeProps(guardReactiveProps(_ctx.$attrs)), {
          default: withCtx(() => [
            createVNode(_component_base_form, {
              "data-amplify-authenticator-confirmResetpassword": "",
              onInput,
              onBlurCapture: onBlur,
              onSubmit: withModifiers(onConfirmResetPasswordSubmit, ["prevent"])
            }, {
              default: withCtx(() => [
                createVNode(_component_base_field_set, {
                  class: "amplify-flex amplify-authenticator__column",
                  disabled: unref(actorState).matches("confirmResetPassword.pending")
                }, {
                  default: withCtx(() => [
                    renderSlot(_ctx.$slots, "header", {}, () => [
                      createVNode(_component_base_heading, {
                        class: "amplify-heading",
                        level: 3
                      }, {
                        default: withCtx(() => [
                          createTextVNode(toDisplayString(unref(confirmResetPasswordHeading)), 1)
                        ]),
                        _: 1
                      })
                    ]),
                    createVNode(_component_base_wrapper, { class: "amplify-flex amplify-authenticator__column" }, {
                      default: withCtx(() => [
                        createVNode(_sfc_main$k, { route: "confirmResetPassword" })
                      ]),
                      _: 1
                    }),
                    createVNode(_component_base_footer, { class: "amplify-flex amplify-authenticator__column" }, {
                      default: withCtx(() => {
                        var _a2, _b;
                        return [
                          ((_b = (_a2 = unref(actorState)) == null ? void 0 : _a2.context) == null ? void 0 : _b.remoteError) ? (openBlock(), createBlock(_component_base_alert, { key: 0 }, {
                            default: withCtx(() => {
                              var _a3, _b2;
                              return [
                                createTextVNode(toDisplayString(unref(b$2)((_b2 = (_a3 = unref(actorState)) == null ? void 0 : _a3.context) == null ? void 0 : _b2.remoteError)), 1)
                              ];
                            }),
                            _: 1
                          })) : createCommentVNode("", true),
                          createVNode(_component_amplify_button, {
                            class: "amplify-field-group__control amplify-authenticator__font",
                            variation: "primary",
                            fullwidth: false,
                            type: "submit",
                            disabled: unref(actorState).matches("confirmResetPassword.pending")
                          }, {
                            default: withCtx(() => [
                              createTextVNode(toDisplayString(unref(confirmResetPasswordText)), 1)
                            ]),
                            _: 1
                          }, 8, ["disabled"]),
                          createVNode(_component_amplify_button, {
                            class: "amplify-field-group__control amplify-authenticator__font",
                            variation: "link",
                            fullwidth: false,
                            size: "small",
                            type: "button",
                            onClick: withModifiers(onLostYourCodeClicked, ["prevent"])
                          }, {
                            default: withCtx(() => [
                              createTextVNode(toDisplayString(unref(resendCodeText)), 1)
                            ]),
                            _: 1
                          }, 8, ["onClick"]),
                          renderSlot(_ctx.$slots, "footer", {
                            onConfirmResetPasswordSubmit,
                            onLostYourCodeClicked
                          })
                        ];
                      }),
                      _: 3
                    })
                  ]),
                  _: 3
                }, 8, ["disabled"])
              ]),
              _: 3
            }, 8, ["onSubmit"])
          ]),
          _: 3
        }, 16)
      ]);
    };
  }
});
const _sfc_main$5 = /* @__PURE__ */ defineComponent({
  __name: "verify-user",
  emits: ["verifyUserSubmit", "skipClicked"],
  setup(__props, { emit }) {
    const useAuthShared = createSharedComposable(useAuthenticator);
    const props = useAuthShared();
    const attrs = useAttrs();
    const { state, send: send2 } = useAuth();
    const actorState = computed(() => t$1(state.value));
    const { unverifiedContactMethods } = actorState.value.context;
    const { getAccountRecoveryInfoText, getSkipText, getVerifyText, getVerifyContactText } = n$2;
    const verifyHeading = computed(() => getAccountRecoveryInfoText());
    const skipText = computed(() => getSkipText());
    const verifyText = computed(() => getVerifyText());
    const verifyContactText = computed(() => getVerifyContactText());
    const onInput = (e2) => {
      const { name, value } = e2.target;
      send2({
        type: "CHANGE",
        data: { name, value }
      });
    };
    const onVerifyUserSubmit = (e2) => {
      if (attrs == null ? void 0 : attrs.onVerifyUserSubmit) {
        emit("verifyUserSubmit", e2);
      } else {
        submit(e2);
      }
    };
    const submit = (e2) => {
      props.submitForm(t(e2));
    };
    const onSkipClicked = () => {
      if (attrs == null ? void 0 : attrs.onSkipClicked) {
        emit("skipClicked");
      } else {
        send2("SKIP");
      }
    };
    return (_ctx, _cache) => {
      const _component_base_heading = _sfc_main$e;
      const _component_base_label = __unplugin_components_0;
      const _component_base_input = _sfc_main$p;
      const _component_base_text = __unplugin_components_3;
      const _component_base_wrapper = __unplugin_components_2;
      const _component_base_alert = _sfc_main$w;
      const _component_amplify_button = _sfc_main$x;
      const _component_base_footer = _sfc_main$t;
      const _component_base_field_set = _sfc_main$y;
      const _component_base_form = _sfc_main$u;
      return renderSlot(_ctx.$slots, "verifyUserSlotI", {}, () => [
        createVNode(_component_base_wrapper, null, {
          default: withCtx(() => [
            createVNode(_component_base_form, {
              onInput,
              onSubmit: withModifiers(onVerifyUserSubmit, ["prevent"])
            }, {
              default: withCtx(() => [
                createVNode(_component_base_field_set, {
                  disabled: unref(actorState).matches("verifyUser.pending"),
                  class: "amplify-flex amplify-authenticator__column"
                }, {
                  default: withCtx(() => [
                    renderSlot(_ctx.$slots, "header", {}, () => [
                      createVNode(_component_base_heading, {
                        class: "amplify-heading",
                        level: 3
                      }, {
                        default: withCtx(() => [
                          createTextVNode(toDisplayString(unref(verifyHeading)), 1)
                        ]),
                        _: 1
                      })
                    ]),
                    createVNode(_component_base_wrapper, { class: "amplify-flex amplify-field amplify-radiogroupfield amplify-authenticator__column" }, {
                      default: withCtx(() => [
                        createVNode(_component_base_label, {
                          class: "amplify-visually-hidden amplify-label",
                          id: "amplify-field-493c"
                        }, {
                          default: withCtx(() => [
                            createTextVNode(toDisplayString(unref(verifyContactText)), 1)
                          ]),
                          _: 1
                        }),
                        createVNode(_component_base_wrapper, {
                          class: "amplify-flex amplify-field amplify-radiogroupfield amplify-authenticator__column",
                          "aria-labelledby": "amplify-field-493c"
                        }, {
                          default: withCtx(() => [
                            (openBlock(true), createElementBlock(Fragment, null, renderList(unref(unverifiedContactMethods), (value, key) => {
                              return openBlock(), createBlock(_component_base_label, {
                                class: "amplify-flex amplify-radio",
                                "data-amplify-verify-label": "",
                                id: "verify",
                                key: value
                              }, {
                                default: withCtx(() => [
                                  createVNode(_component_base_input, {
                                    class: "amplify-input amplify-field-group__control amplify-visually-hidden amplify-radio__input",
                                    "aria-invalid": "false",
                                    "data-amplify-verify-input": "",
                                    id: "verify",
                                    name: "unverifiedAttr",
                                    type: "radio",
                                    value: key
                                  }, null, 8, ["value"]),
                                  createVNode(_component_base_text, {
                                    class: "amplify-flex amplify-radio__button",
                                    "aria-hidden": "true"
                                  }),
                                  createVNode(_component_base_text, { class: "amplify-text amplify-radio__label" }, {
                                    default: withCtx(() => [
                                      createTextVNode(toDisplayString(unref(r$3)[key].label), 1)
                                    ]),
                                    _: 2
                                  }, 1024)
                                ]),
                                _: 2
                              }, 1024);
                            }), 128))
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    createVNode(_component_base_footer, { class: "amplify-flex amplify-authenticator__column" }, {
                      default: withCtx(() => {
                        var _a2, _b;
                        return [
                          ((_b = (_a2 = unref(actorState)) == null ? void 0 : _a2.context) == null ? void 0 : _b.remoteError) ? (openBlock(), createBlock(_component_base_alert, { key: 0 }, {
                            default: withCtx(() => {
                              var _a3;
                              return [
                                createTextVNode(toDisplayString(unref(b$2)((_a3 = unref(actorState)) == null ? void 0 : _a3.context.remoteError)), 1)
                              ];
                            }),
                            _: 1
                          })) : createCommentVNode("", true),
                          createVNode(_component_amplify_button, {
                            class: "amplify-field-group__control amplify-authenticator__font",
                            fullwidth: false,
                            variation: "primary",
                            type: "submit",
                            disabled: unref(actorState).matches("verifyUser.pending")
                          }, {
                            default: withCtx(() => [
                              createTextVNode(toDisplayString(unref(verifyText)), 1)
                            ]),
                            _: 1
                          }, 8, ["disabled"]),
                          createVNode(_component_amplify_button, {
                            class: "amplify-field-group__control amplify-authenticator__font",
                            fullwidth: false,
                            size: "small",
                            variation: "link",
                            style: { "font-weight": "normal" },
                            type: "button",
                            onClick: withModifiers(onSkipClicked, ["prevent"])
                          }, {
                            default: withCtx(() => [
                              createTextVNode(toDisplayString(unref(skipText)), 1)
                            ]),
                            _: 1
                          }, 8, ["onClick"]),
                          renderSlot(_ctx.$slots, "footer", {
                            onSkipClicked,
                            onVerifyUserSubmit
                          })
                        ];
                      }),
                      _: 3
                    })
                  ]),
                  _: 3
                }, 8, ["disabled"])
              ]),
              _: 3
            }, 8, ["onSubmit"])
          ]),
          _: 3
        })
      ]);
    };
  }
});
const _sfc_main$4 = /* @__PURE__ */ defineComponent({
  __name: "confirm-verify-user",
  emits: ["confirmVerifyUserSubmit", "skipClicked"],
  setup(__props, { emit }) {
    const useAuthShared = createSharedComposable(useAuthenticator);
    const props = useAuthShared();
    const attrs = useAttrs();
    const { state, send: send2 } = useAuth();
    const actorState = computed(() => t$1(state.value));
    const { getAccountRecoveryInfoText, getSkipText, getSubmitText } = n$2;
    const verifyHeading = computed(() => getAccountRecoveryInfoText());
    const skipText = computed(() => getSkipText());
    const submitText = computed(() => getSubmitText());
    const onInput = (e2) => {
      const { name, value } = e2.target;
      send2({
        type: "CHANGE",
        data: { name, value }
      });
    };
    const onConfirmVerifyUserSubmit = (e2) => {
      if (attrs == null ? void 0 : attrs.onConfirmVerifyUserSubmit) {
        emit("confirmVerifyUserSubmit", e2);
      } else {
        submit(e2);
      }
    };
    const submit = (e2) => {
      props.submitForm(t(e2));
    };
    const onSkipClicked = () => {
      if (attrs == null ? void 0 : attrs.onSkipClicked) {
        emit("skipClicked");
      } else {
        send2({
          type: "SKIP"
        });
      }
    };
    return (_ctx, _cache) => {
      const _component_base_heading = _sfc_main$e;
      const _component_base_wrapper = __unplugin_components_2;
      const _component_base_alert = _sfc_main$w;
      const _component_amplify_button = _sfc_main$x;
      const _component_base_footer = _sfc_main$t;
      const _component_base_field_set = _sfc_main$y;
      const _component_base_form = _sfc_main$u;
      return renderSlot(_ctx.$slots, "confirmVerifyUserSlotI", normalizeProps(guardReactiveProps(_ctx.$attrs)), () => [
        createVNode(_component_base_wrapper, normalizeProps(guardReactiveProps(_ctx.$attrs)), {
          default: withCtx(() => [
            createVNode(_component_base_form, {
              onInput,
              onSubmit: withModifiers(onConfirmVerifyUserSubmit, ["prevent"])
            }, {
              default: withCtx(() => [
                createVNode(_component_base_field_set, {
                  class: "amplify-flex amplify-authenticator__column",
                  disabled: unref(actorState).matches("confirmVerifyUser.pending")
                }, {
                  default: withCtx(() => [
                    renderSlot(_ctx.$slots, "header", {}, () => [
                      createVNode(_component_base_heading, {
                        level: 3,
                        class: "amplify-heading"
                      }, {
                        default: withCtx(() => [
                          createTextVNode(toDisplayString(unref(verifyHeading)), 1)
                        ]),
                        _: 1
                      })
                    ]),
                    createVNode(_component_base_wrapper, { class: "amplify-flex amplify-authenticator__column" }, {
                      default: withCtx(() => [
                        createVNode(_sfc_main$k, { route: "confirmVerifyUser" })
                      ]),
                      _: 1
                    }),
                    createVNode(_component_base_footer, { class: "amplify-flex amplify-authenticator__column" }, {
                      default: withCtx(() => {
                        var _a2, _b;
                        return [
                          ((_b = (_a2 = unref(actorState)) == null ? void 0 : _a2.context) == null ? void 0 : _b.remoteError) ? (openBlock(), createBlock(_component_base_alert, { key: 0 }, {
                            default: withCtx(() => {
                              var _a3;
                              return [
                                createTextVNode(toDisplayString(unref(b$2)((_a3 = unref(actorState)) == null ? void 0 : _a3.context.remoteError)), 1)
                              ];
                            }),
                            _: 1
                          })) : createCommentVNode("", true),
                          createVNode(_component_amplify_button, {
                            class: "amplify-field-group__control amplify-authenticator__font",
                            fullwidth: false,
                            variation: "primary",
                            type: "submit",
                            disabled: unref(actorState).matches("confirmVerifyUser.pending")
                          }, {
                            default: withCtx(() => [
                              createTextVNode(toDisplayString(unref(submitText)), 1)
                            ]),
                            _: 1
                          }, 8, ["disabled"]),
                          createVNode(_component_amplify_button, {
                            class: "amplify-field-group__control amplify-authenticator__font",
                            fullwidth: false,
                            size: "small",
                            variation: "link",
                            style: { "font-weight": "normal" },
                            type: "button",
                            onClick: withModifiers(onSkipClicked, ["prevent"])
                          }, {
                            default: withCtx(() => [
                              createTextVNode(toDisplayString(unref(skipText)), 1)
                            ]),
                            _: 1
                          }, 8, ["onClick"]),
                          renderSlot(_ctx.$slots, "footer", {
                            onSkipClicked,
                            onConfirmVerifyUserSubmit
                          })
                        ];
                      }),
                      _: 3
                    })
                  ]),
                  _: 3
                }, 8, ["disabled"])
              ]),
              _: 3
            }, 8, ["onSubmit"])
          ]),
          _: 3
        }, 16)
      ]);
    };
  }
});
const VERSION = "3.1.11";
const _hoisted_1$1 = ["data-variation"];
const _hoisted_2$1 = { "data-amplify-container": "" };
const _hoisted_3$1 = ["data-amplify-router-content"];
const _hoisted_4$1 = {
  key: 1,
  "data-amplify-router-content": ""
};
const _sfc_main$3 = /* @__PURE__ */ defineComponent({
  __name: "authenticator",
  props: {
    hideSignUp: { type: Boolean },
    initialState: null,
    loginMechanisms: null,
    services: null,
    signUpAttributes: null,
    variation: { default: "default" },
    socialProviders: null,
    formFields: null
  },
  emits: [
    "signInSubmit",
    "confirmSignUpSubmit",
    "resetPasswordSubmit",
    "confirmResetPasswordSubmit",
    "confirmSignInSubmit",
    "mSetupTOTPSubmit",
    "forceNewPasswordSubmit",
    "signUpSubmit",
    "verifyUserSubmit",
    "confirmVerifyUserSubmit"
  ],
  setup(__props, { emit }) {
    const props = __props;
    const attrs = useAttrs();
    const { initialState, loginMechanisms, variation, services, signUpAttributes, socialProviders, hideSignUp, formFields } = toRefs(props);
    const machine = v();
    const service2 = useInterpret(machine);
    let unsubscribeHub;
    let unsubscribeMachine;
    const { state, send: send2 } = useActor(service2);
    useAuth(service2);
    const hasInitialized = ref(false);
    unsubscribeMachine = service2.subscribe((newState) => {
      if (newState.matches("setup") && !hasInitialized.value) {
        send2({
          type: "INIT",
          data: {
            initialState: initialState == null ? void 0 : initialState.value,
            loginMechanisms: loginMechanisms == null ? void 0 : loginMechanisms.value,
            socialProviders: socialProviders == null ? void 0 : socialProviders.value,
            signUpAttributes: signUpAttributes == null ? void 0 : signUpAttributes.value,
            services: services == null ? void 0 : services.value,
            formFields: formFields == null ? void 0 : formFields.value
          }
        });
        hasInitialized.value = true;
      }
    }).unsubscribe;
    onMounted(() => {
      unsubscribeHub = u$1(service2);
      s$2({
        packageName: "@aws-amplify/ui-vue",
        version: VERSION
      });
    });
    onUnmounted(() => {
      if (unsubscribeHub)
        unsubscribeHub();
      if (unsubscribeMachine)
        unsubscribeMachine();
    });
    const actorState = computed(() => t$1(state.value));
    const signInComponent = ref();
    const signUpComponent = ref();
    const confirmSignUpComponent = ref();
    const confirmSignInComponent = ref();
    const confirmSetupTOTPComponent = ref();
    const forceNewPasswordComponent = ref();
    const resetPasswordComponent = ref();
    const confirmResetPasswordComponent = ref();
    const verifyUserComponent = ref();
    const confirmVerifyUserComponent = ref();
    const { getSignInTabText, getSignUpTabText } = n$2;
    const signInLabel = computed(() => getSignInTabText());
    const createAccountLabel = computed(() => getSignUpTabText());
    const onSignInSubmitI = (e2) => {
      var _a2;
      if (attrs == null ? void 0 : attrs.onSignInSubmit) {
        emit("signInSubmit", e2);
      } else {
        (_a2 = signInComponent.value) == null ? void 0 : _a2.submit(e2);
      }
    };
    const onConfirmSignUpSubmitI = (e2) => {
      if (attrs == null ? void 0 : attrs.onConfirmSignUpSubmit) {
        emit("confirmSignUpSubmit", e2);
      } else {
        confirmSignUpComponent.value.submit(e2);
      }
    };
    const onResetPasswordSubmitI = (e2) => {
      if (attrs == null ? void 0 : attrs.onResetPasswordSubmit) {
        emit("resetPasswordSubmit", e2);
      } else {
        resetPasswordComponent.value.submit(e2);
      }
    };
    const onConfirmResetPasswordSubmitI = (e2) => {
      if (attrs == null ? void 0 : attrs.onConfirmResetPasswordSubmit) {
        emit("confirmResetPasswordSubmit", e2);
      } else {
        confirmResetPasswordComponent.value.submit(e2);
      }
    };
    const onConfirmSignInSubmitI = (e2) => {
      if (attrs == null ? void 0 : attrs.onConfirmSignInSubmit) {
        emit("confirmSignInSubmit", e2);
      } else {
        confirmSignInComponent.value.submit(e2);
      }
    };
    const onConfirmSetupTOTPSubmitI = (e2) => {
      if (attrs == null ? void 0 : attrs.onForceNewPasswordSubmit) {
        emit("mSetupTOTPSubmit", e2);
      } else {
        confirmSetupTOTPComponent.value.submit(e2);
      }
    };
    const onForceNewPasswordSubmitI = (e2) => {
      if (attrs == null ? void 0 : attrs.onForceNewPasswordSubmit) {
        emit("forceNewPasswordSubmit", e2);
      } else {
        forceNewPasswordComponent.value.submit(e2);
      }
    };
    const onSignUpSubmitI = (e2) => {
      if (attrs == null ? void 0 : attrs.onSignUpSubmit) {
        emit("signUpSubmit", e2);
      } else {
        signUpComponent.value.submit();
      }
    };
    const onVerifyUserSubmitI = (e2) => {
      if (attrs == null ? void 0 : attrs.onVerifyUserSubmit) {
        emit("verifyUserSubmit", e2);
      } else {
        verifyUserComponent.value.submit(e2);
      }
    };
    const onConfirmVerifyUserSubmitI = (e2) => {
      if (attrs == null ? void 0 : attrs.onConfirmVerifyUserSubmit) {
        emit("confirmVerifyUserSubmit", e2);
      } else {
        confirmVerifyUserComponent.value.submit(e2);
      }
    };
    const user = ref(null);
    const signOut = ref();
    watch(() => state.value.context, () => {
      const { user: u2, signOut: s2 } = s$4({
        send: send2,
        state: state.value
      });
      user.value = u2;
      signOut.value = s2;
    });
    const hasTabs = computed(() => {
      var _a2, _b;
      return ((_a2 = actorState.value) == null ? void 0 : _a2.matches("signIn")) || ((_b = actorState.value) == null ? void 0 : _b.matches("signUp"));
    });
    const hasRouteComponent = computed(() => {
      var _a2;
      return !(state.value.matches("authenticated") || state.value.matches("idle") || state.value.matches("setup") || state.value.matches("signOut") || ((_a2 = actorState.value) == null ? void 0 : _a2.matches("autoSignIn")));
    });
    return (_ctx, _cache) => {
      var _a2, _b, _c, _d, _e, _f, _g, _h, _i, _j, _k, _l;
      const _component_base_two_tab_item = _sfc_main$g;
      const _component_base_two_tabs = __unplugin_components_1;
      return openBlock(), createElementBlock(Fragment, null, [
        unref(hasRouteComponent) ? (openBlock(), createElementBlock("div", mergeProps({ key: 0 }, _ctx.$attrs, {
          "data-amplify-authenticator": "",
          "data-variation": unref(variation)
        }), [
          createElementVNode("div", _hoisted_2$1, [
            renderSlot(_ctx.$slots, "header"),
            createElementVNode("div", {
              "data-amplify-router": "",
              "data-amplify-router-content": unref(hasTabs) ? void 0 : ""
            }, [
              unref(hasTabs) && !unref(hideSignUp) ? (openBlock(), createBlock(_component_base_two_tabs, { key: 0 }, {
                default: withCtx(() => {
                  var _a3, _b2;
                  return [
                    createVNode(_component_base_two_tab_item, {
                      active: (_a3 = unref(actorState)) == null ? void 0 : _a3.matches("signIn"),
                      id: 44472,
                      label: unref(signInLabel),
                      onClick: _cache[0] || (_cache[0] = ($event) => unref(send2)("SIGN_IN"))
                    }, null, 8, ["active", "label"]),
                    createVNode(_component_base_two_tab_item, {
                      active: (_b2 = unref(actorState)) == null ? void 0 : _b2.matches("signUp"),
                      id: 44471,
                      label: unref(createAccountLabel),
                      onClick: _cache[1] || (_cache[1] = ($event) => unref(send2)("SIGN_UP"))
                    }, null, 8, ["active", "label"])
                  ];
                }),
                _: 1
              })) : createCommentVNode("", true),
              unref(hasTabs) ? (openBlock(), createElementBlock("div", _hoisted_4$1, [
                ((_a2 = unref(actorState)) == null ? void 0 : _a2.matches("signIn")) ? (openBlock(), createBlock(_sfc_main$j, {
                  key: 0,
                  onSignInSubmit: onSignInSubmitI,
                  ref_key: "signInComponent",
                  ref: signInComponent
                }, {
                  signInSlotI: withCtx(() => [
                    renderSlot(_ctx.$slots, "sign-in")
                  ]),
                  form: withCtx(({ info, onSignInSubmit, onForgotPasswordClicked, onInput }) => [
                    renderSlot(_ctx.$slots, "sign-in-form", {
                      info,
                      onInput,
                      onSignInSubmit,
                      onForgotPasswordClicked
                    })
                  ]),
                  header: withCtx(() => [
                    renderSlot(_ctx.$slots, "sign-in-header")
                  ]),
                  footer: withCtx(() => [
                    renderSlot(_ctx.$slots, "sign-in-footer")
                  ]),
                  _: 3
                }, 512)) : createCommentVNode("", true),
                ((_b = unref(actorState)) == null ? void 0 : _b.matches("signUp")) && !unref(hideSignUp) ? (openBlock(), createBlock(_sfc_main$h, {
                  key: 1,
                  onSignUpSubmit: onSignUpSubmitI,
                  ref_key: "signUpComponent",
                  ref: signUpComponent
                }, {
                  signUpSlotI: withCtx(() => [
                    renderSlot(_ctx.$slots, "sign-up")
                  ]),
                  header: withCtx(() => [
                    renderSlot(_ctx.$slots, "sign-up-header")
                  ]),
                  "signup-fields": withCtx(({ info }) => [
                    renderSlot(_ctx.$slots, "sign-up-fields", { info })
                  ]),
                  footer: withCtx(() => [
                    renderSlot(_ctx.$slots, "sign-up-footer")
                  ]),
                  _: 3
                }, 512)) : createCommentVNode("", true)
              ])) : createCommentVNode("", true),
              ((_c = unref(actorState)) == null ? void 0 : _c.matches("confirmSignUp")) ? (openBlock(), createBlock(_sfc_main$c, {
                key: 2,
                onConfirmSignUpSubmit: onConfirmSignUpSubmitI,
                ref_key: "confirmSignUpComponent",
                ref: confirmSignUpComponent
              }, {
                confirmSignUpSlotI: withCtx(() => [
                  renderSlot(_ctx.$slots, "confirm-sign-up")
                ]),
                header: withCtx(() => [
                  renderSlot(_ctx.$slots, "confirm-sign-up-header")
                ]),
                footer: withCtx(({ onConfirmSignUpSubmit, onLostCodeClicked }) => [
                  renderSlot(_ctx.$slots, "confirm-sign-up-footer", {
                    onConfirmSignUpSubmit,
                    onLostCodeClicked
                  })
                ]),
                _: 3
              }, 512)) : createCommentVNode("", true),
              ((_d = unref(actorState)) == null ? void 0 : _d.matches("resetPassword")) ? (openBlock(), createBlock(_sfc_main$7, {
                key: 3,
                onResetPasswordSubmit: onResetPasswordSubmitI,
                ref_key: "resetPasswordComponent",
                ref: resetPasswordComponent
              }, {
                resetPasswordSlotI: withCtx(() => [
                  renderSlot(_ctx.$slots, "reset-password")
                ]),
                header: withCtx(() => [
                  renderSlot(_ctx.$slots, "reset-password-header")
                ]),
                footer: withCtx(({ onResetPasswordSubmit, onBackToSignInClicked }) => [
                  renderSlot(_ctx.$slots, "reset-password-footer", {
                    onResetPasswordSubmit,
                    onBackToSignInClicked
                  })
                ]),
                _: 3
              }, 512)) : createCommentVNode("", true),
              ((_e = unref(actorState)) == null ? void 0 : _e.matches("confirmResetPassword")) ? (openBlock(), createBlock(_sfc_main$6, {
                key: 4,
                onConfirmResetPasswordSubmit: onConfirmResetPasswordSubmitI,
                ref_key: "confirmResetPasswordComponent",
                ref: confirmResetPasswordComponent
              }, {
                confirmResetPasswordSlotI: withCtx(() => [
                  renderSlot(_ctx.$slots, "confirm-reset-password")
                ]),
                header: withCtx(() => [
                  renderSlot(_ctx.$slots, "confirm-reset-password-header")
                ]),
                footer: withCtx(({ onConfirmResetPasswordSubmit, onLostYourCodeClicked }) => [
                  renderSlot(_ctx.$slots, "confirm-reset-password-footer", {
                    onConfirmResetPasswordSubmit,
                    onLostYourCodeClicked
                  })
                ]),
                _: 3
              }, 512)) : createCommentVNode("", true),
              ((_f = unref(actorState)) == null ? void 0 : _f.matches("confirmSignIn")) ? (openBlock(), createBlock(_sfc_main$b, {
                key: 5,
                onConfirmSignInSubmit: onConfirmSignInSubmitI,
                ref_key: "confirmSignInComponent",
                ref: confirmSignInComponent
              }, {
                confirmSignInSlotI: withCtx(() => [
                  renderSlot(_ctx.$slots, "confirm-sign-in")
                ]),
                header: withCtx(() => [
                  renderSlot(_ctx.$slots, "confirm-sign-in-header")
                ]),
                footer: withCtx(({ onConfirmSignInSubmit, onBackToSignInClicked }) => [
                  renderSlot(_ctx.$slots, "confirm-sign-in-footer", {
                    onConfirmSignInSubmit,
                    onBackToSignInClicked
                  })
                ]),
                _: 3
              }, 512)) : createCommentVNode("", true),
              ((_g = unref(actorState)) == null ? void 0 : _g.matches("setupTOTP.edit")) || ((_h = unref(actorState)) == null ? void 0 : _h.matches("setupTOTP.submit")) ? (openBlock(), createBlock(_sfc_main$a, {
                key: 6,
                onConfirmSetupTotpSubmit: onConfirmSetupTOTPSubmitI,
                ref_key: "confirmSetupTOTPComponent",
                ref: confirmSetupTOTPComponent
              }, {
                confirmSetupTOTPI: withCtx(() => [
                  renderSlot(_ctx.$slots, "setup-totp")
                ]),
                header: withCtx(() => [
                  renderSlot(_ctx.$slots, "setup-totp-header")
                ]),
                footer: withCtx(({ onSetupTOTPSubmit, onBackToSignInClicked }) => [
                  renderSlot(_ctx.$slots, "setup-totp-footer", {
                    onSetupTOTPSubmit,
                    onBackToSignInClicked
                  })
                ]),
                _: 3
              }, 512)) : createCommentVNode("", true),
              ((_i = unref(actorState)) == null ? void 0 : _i.matches("forceNewPassword")) ? (openBlock(), createBlock(_sfc_main$8, {
                key: 7,
                onForceNewPasswordSubmit: onForceNewPasswordSubmitI,
                ref_key: "forceNewPasswordComponent",
                ref: forceNewPasswordComponent
              }, {
                forceNewPasswordI: withCtx(() => [
                  renderSlot(_ctx.$slots, "force-new-password")
                ]),
                header: withCtx(() => [
                  renderSlot(_ctx.$slots, "force-new-password-header")
                ]),
                "force-new-password-form-fields": withCtx(() => [
                  renderSlot(_ctx.$slots, "force-new-password-form-fields")
                ]),
                footer: withCtx(({ onHaveAccountClicked, onForceNewPasswordSubmit }) => [
                  renderSlot(_ctx.$slots, "force-new-password-footer", {
                    onForceNewPasswordSubmit,
                    onBackToSignInClicked: onHaveAccountClicked
                  })
                ]),
                _: 3
              }, 512)) : createCommentVNode("", true),
              ((_j = unref(actorState)) == null ? void 0 : _j.matches("verifyUser")) ? (openBlock(), createBlock(_sfc_main$5, {
                key: 8,
                onVerifyUserSubmit: onVerifyUserSubmitI,
                ref_key: "verifyUserComponent",
                ref: verifyUserComponent
              }, {
                verifyUserSlotI: withCtx(() => [
                  renderSlot(_ctx.$slots, "verify-user")
                ]),
                header: withCtx(() => [
                  renderSlot(_ctx.$slots, "verify-user-header")
                ]),
                footer: withCtx(({ onVerifyUserSubmit, onSkipClicked }) => [
                  renderSlot(_ctx.$slots, "verify-user-footer", {
                    onVerifyUserSubmit,
                    onSkipClicked
                  })
                ]),
                _: 3
              }, 512)) : createCommentVNode("", true),
              ((_k = unref(actorState)) == null ? void 0 : _k.matches("confirmVerifyUser")) ? (openBlock(), createBlock(_sfc_main$4, {
                key: 9,
                onConfirmVerifyUserSubmit: onConfirmVerifyUserSubmitI,
                ref_key: "confirmVerifyUserComponent",
                ref: confirmVerifyUserComponent
              }, {
                confirmVerifyUserSlotI: withCtx(() => [
                  renderSlot(_ctx.$slots, "confirm-verify-user")
                ]),
                header: withCtx(() => [
                  renderSlot(_ctx.$slots, "confirm-verify-user-header")
                ]),
                footer: withCtx(({ onConfirmVerifyUserSubmit, onSkipClicked }) => [
                  renderSlot(_ctx.$slots, "confirm-verify-user-footer", {
                    onConfirmVerifyUserSubmit,
                    onSkipClicked
                  })
                ]),
                _: 3
              }, 512)) : createCommentVNode("", true)
            ], 8, _hoisted_3$1),
            renderSlot(_ctx.$slots, "footer")
          ])
        ], 16, _hoisted_1$1)) : createCommentVNode("", true),
        ((_l = unref(state)) == null ? void 0 : _l.matches("authenticated")) ? renderSlot(_ctx.$slots, "default", {
          key: 1,
          user: user.value,
          state: unref(state),
          signOut: signOut.value,
          send: unref(send2)
        }) : createCommentVNode("", true)
      ], 64);
    };
  }
});
const _sfc_main$2 = defineComponent({
  props: {
    info: {
      type: Object
    }
  },
  setup(props) {
    return () => props.info;
  }
});
const _sfc_main$1 = /* @__PURE__ */ defineComponent({
  __name: "amplify-text-field",
  props: {
    label: { default: "" },
    id: { default: "" },
    autocomplete: { default: "" },
    placeholder: { default: "" },
    required: { type: Boolean, default: true },
    disabled: { type: Boolean, default: false },
    name: { default: "" },
    type: { default: "text" },
    hideLabel: { type: Boolean, default: true }
  },
  setup(__props) {
    const props = __props;
    const { label, id, autocomplete, placeholder, required, name, type } = toRefs(props);
    return (_ctx, _cache) => {
      const _component_base_label = __unplugin_components_0;
      const _component_base_input = _sfc_main$p;
      const _component_base_wrapper = __unplugin_components_2;
      return openBlock(), createElementBlock(Fragment, null, [
        createVNode(_component_base_label, {
          class: normalizeClass(["amplify-label", { "amplify-visually-hidden": __props.hideLabel }]),
          for: unref(id)
        }, {
          default: withCtx(() => [
            createTextVNode(toDisplayString(unref(label)), 1)
          ]),
          _: 1
        }, 8, ["class", "for"]),
        createVNode(_component_base_wrapper, { class: "amplify-field-group__field-wrapper" }, {
          default: withCtx(() => [
            createVNode(_component_base_input, {
              class: "amplify-input amplify-field-group__control",
              id: unref(id),
              "aria-invalid": "false",
              autocomplete: unref(autocomplete),
              placeholder: unref(placeholder),
              required: unref(required),
              name: unref(name),
              disabled: __props.disabled,
              type: unref(type)
            }, null, 8, ["id", "autocomplete", "placeholder", "required", "name", "disabled", "type"])
          ]),
          _: 1
        })
      ], 64);
    };
  }
});
const _hoisted_1 = { class: "amplify-flex amplify-field amplify-checkboxfield" };
const _hoisted_2 = { class: "amplify-flex amplify-checkbox" };
const _hoisted_3 = { class: "amplify-visually-hidden" };
const _hoisted_4 = ["data-error", "data-checked"];
const _hoisted_5 = ["data-checked"];
const _hoisted_6 = /* @__PURE__ */ createElementVNode("path", { d: "M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z" }, null, -1);
const _hoisted_7 = [
  _hoisted_6
];
const _hoisted_8 = /* @__PURE__ */ createElementVNode("span", { class: "amplify-text amplify-checkbox__label" }, " I agree with the Terms & Conditions", -1);
const _hoisted_9 = {
  key: 0,
  class: "amplify-text amplify-field__error-message"
};
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "amplify-check-box",
  props: {
    errorMessage: { default: "" }
  },
  setup(__props) {
    const props = __props;
    const checked = ref(false);
    const { errorMessage } = toRefs(props);
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", _hoisted_1, [
        createElementVNode("label", _hoisted_2, [
          createElementVNode("span", _hoisted_3, [
            createElementVNode("input", {
              onClick: _cache[0] || (_cache[0] = ($event) => checked.value = !checked.value),
              class: "amplify-input amplify-field-group__control amplify-checkbox__input",
              "aria-invalid": "false",
              type: "checkbox",
              name: "acknowledgement",
              value: "yes"
            })
          ]),
          createElementVNode("span", {
            class: normalizeClass(["amplify-flex amplify-checkbox__button", {
              "amplify-checkbox__button--error": !checked.value
            }]),
            "aria-hidden": "true",
            "data-focus": "false",
            "data-error": !checked.value,
            "data-checked": checked.value
          }, [
            (openBlock(), createElementBlock("svg", {
              xmlns: "http://www.w3.org/2000/svg",
              class: normalizeClass(["amplify-icon amplify-checkbox__icon", {
                "amplify-checkbox__icon--checked": checked.value
              }]),
              viewBox: "0 0 24 24",
              fill: "currentColor",
              "data-checked": checked.value
            }, _hoisted_7, 10, _hoisted_5))
          ], 10, _hoisted_4),
          _hoisted_8
        ]),
        !checked.value ? (openBlock(), createElementBlock("p", _hoisted_9, toDisplayString(unref(errorMessage)), 1)) : createCommentVNode("", true)
      ]);
    };
  }
});
var styles = "";
var index = {
  install: (app) => {
    app.component("SignIn", _sfc_main$j);
    app.component("SignUp", _sfc_main$h);
    app.component("FederatedSignIn", _sfc_main$r);
    app.component("Authenticator", _sfc_main$3);
    app.component("RenderInfo", _sfc_main$2);
    app.component("PasswordControl", _sfc_main$o);
    app.component("ForceNewPassword", _sfc_main$8);
    app.component("ResetPassword", _sfc_main$7);
    app.component("ConfirmResetPassword", _sfc_main$6);
    app.component("ConfirmSignUp", _sfc_main$c);
    app.component("ConfirmSignIn", _sfc_main$b);
    app.component("VerifyUser", _sfc_main$5);
    app.component("ConfirmVerifyUser", _sfc_main$4);
    app.component("AmplifyTextField", _sfc_main$1);
    app.component("AmplifyCheckBox", _sfc_main);
    app.component("AmplifyButton", _sfc_main$x);
    app.component("BaseFormField", _sfc_main$l);
    app.component("BaseFormFields", _sfc_main$k);
    app.component(
      "AuthenticatorSignUpFormFields",
      _sfc_main$i
    );
    app.component(
      "AuthenticatorForceNewPasswordFormFields",
      _sfc_main$9
    );
  }
};
export { _sfc_main$x as AmplifyButton, _sfc_main as AmplifyCheckBox, _sfc_main$1 as AmplifyTextField, _sfc_main$3 as Authenticator, _sfc_main$9 as AuthenticatorForceNewPasswordFormFields, _sfc_main$i as AuthenticatorSignUpFormFields, _sfc_main$6 as ConfirmResetPassword, _sfc_main$b as ConfirmSignIn, _sfc_main$c as ConfirmSignUp, _sfc_main$4 as ConfirmVerifyUser, _sfc_main$r as FederatedSignIn, _sfc_main$8 as ForceNewPassword, _sfc_main$o as PasswordControl, _sfc_main$2 as RenderInfo, _sfc_main$7 as ResetPassword, _sfc_main$j as SignIn, _sfc_main$h as SignUp, _sfc_main$5 as VerifyUser, index as default, w$1 as translations, useAuthenticator };
